
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4JDbp", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $b400565b9de87bc3$export$b2ad68b9bc407b80);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $i7RGj = parcelRequire("i7RGj");
const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});
parcelRegister("i7RGj", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $0e043a05e9b77ebf$export$ff983d2a2b6112ea);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lfOVK = parcelRequire("lfOVK");
const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $lfOVK.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("lfOVK", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $72cd6c8cfec5859a$export$2f62ee6831462844);

var $gwFzn = parcelRequire("gwFzn");
function $72cd6c8cfec5859a$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("gj7hi", function(module, exports) {

$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $cv8Bu = parcelRequire("cv8Bu");

var $cOrQJ = parcelRequire("cOrQJ");
const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $gwFzn.useRef)(null);
    const providedColorMode = (0, $cv8Bu.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $gwFzn.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $35pXk.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("cv8Bu", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $d32a212d6e794c84$export$ce91654eb9fea460);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $dh538 = parcelRequire("dh538");

var $8z9j5 = parcelRequire("8z9j5");
var $bRSdj = parcelRequire("bRSdj");
var $60yhz = parcelRequire("60yhz");
const $d32a212d6e794c84$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: (0, $dh538.fg)('platform-default-typography-modernized') ? 'typography-modernized' : undefined
    });
const $d32a212d6e794c84$var$ColorModeContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $d32a212d6e794c84$var$SetColorModeContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $d32a212d6e794c84$var$ThemeContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $d32a212d6e794c84$var$SetThemeContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
function $d32a212d6e794c84$export$ce91654eb9fea460() {
    const value = (0, $gwFzn.useContext)($d32a212d6e794c84$var$ColorModeContext);
    return value;
}
function $d32a212d6e794c84$export$20f3076712c8dfa() {
    const value = (0, $gwFzn.useContext)($d32a212d6e794c84$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $d32a212d6e794c84$export$e2afe7397c3d11c7() {
    const value = (0, $gwFzn.useContext)($d32a212d6e794c84$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $d32a212d6e794c84$export$93d4e7f90805808f() {
    const theme = (0, $gwFzn.useContext)($d32a212d6e794c84$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $gwFzn.useState)(theme || (0, $8z9j5.default)());
    (0, $gwFzn.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $60yhz.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return resolvedTheme;
}
function $d32a212d6e794c84$export$501aa0dcd5527a48() {
    const value = (0, $gwFzn.useContext)($d32a212d6e794c84$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $d32a212d6e794c84$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d32a212d6e794c84$var$prefersDarkModeMql = $d32a212d6e794c84$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d32a212d6e794c84$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d32a212d6e794c84$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $d32a212d6e794c84$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $gwFzn.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $gwFzn.useState)($d32a212d6e794c84$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $gwFzn.useState)(()=>({
            ...$d32a212d6e794c84$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $gwFzn.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d32a212d6e794c84$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $gwFzn.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $bRSdj.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!$d32a212d6e794c84$var$prefersDarkModeMql) return;
        const unbindListener = (0, $d8F95.bind)($d32a212d6e794c84$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($d32a212d6e794c84$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($d32a212d6e794c84$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($d32a212d6e794c84$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($d32a212d6e794c84$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $d32a212d6e794c84$export$2e2bcd8739ae039 = $d32a212d6e794c84$var$ThemeProvider;

});


parcelRegister("bpoON", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsQuery", () => $17d466086b1d89f6$export$7df92c2c6d389da3);

var $d2LG0 = parcelRequire("d2LG0");
const $17d466086b1d89f6$export$7df92c2c6d389da3 = (0, $d2LG0.default)`query BreadcrumbsQuery($spaceKey:String!$contentId:ID$skipContent:Boolean!){spaces(spaceKey:$spaceKey first:10){nodes{alias id name homepage{id}}}content(id:$contentId status:["current" "draft" "archived"])@skip(if:$skipContent){nodes{id type subType status title ancestors{id type subType title status}}}}`;

});

parcelRegister("e2cl6", function(module, exports) {

$parcel$export(module.exports, "RendererContentStateQuery", () => $04a93bdc56c089b3$export$6f731328c7af1575);

var $d2LG0 = parcelRequire("d2LG0");
const $04a93bdc56c089b3$export$6f731328c7af1575 = (0, $d2LG0.default)`query RendererContentState($contentId:ID!$isDraft:Boolean!$format:GraphQLDateFormat){singleContent(id:$contentId){id contentState(isDraft:$isDraft){id name color restrictionLevel}contentStateLastUpdated(format:$format){value}}}`;

});

parcelRegister("8SuT6", function(module, exports) {

$parcel$export(module.exports, "GraphQLDateFormat", () => $373e532e403842cf$export$939016c6bb497bec);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $373e532e403842cf$export$ae77e0661f173b68 = /*#__PURE__*/ function(ContentStateRestrictionLevel) {
    ContentStateRestrictionLevel["NONE"] = "NONE";
    ContentStateRestrictionLevel["PAGE_OWNER"] = "PAGE_OWNER";
    return ContentStateRestrictionLevel;
}({});
var $373e532e403842cf$export$939016c6bb497bec = /*#__PURE__*/ function(GraphQLDateFormat) {
    GraphQLDateFormat["GLOBAL"] = "GLOBAL";
    GraphQLDateFormat["MILLIS"] = "MILLIS";
    GraphQLDateFormat["USER"] = "USER";
    GraphQLDateFormat["USER_FRIENDLY"] = "USER_FRIENDLY";
    return GraphQLDateFormat;
}({});

});

parcelRegister("hpr9b", function(module, exports) {

$parcel$export(module.exports, "getWatchDialogQuery", () => $0010f8f7298777ae$export$7db5b17cce09ecf7);

var $6XxzN = parcelRequire("6XxzN");
const $0010f8f7298777ae$export$7db5b17cce09ecf7 = ()=>{
    return 0, $6XxzN.WatchDialogQueryWithWatchChildren;
};

});
parcelRegister("6XxzN", function(module, exports) {

$parcel$export(module.exports, "WatchDialogQueryWithWatchChildren", () => $51124c5b395b8390$export$ff412db8b959e059);

var $d2LG0 = parcelRequire("d2LG0");
const $51124c5b395b8390$export$ff412db8b959e059 = (0, $d2LG0.default)`query WatchDialogQueryWithWatchChildren($contentId:ID!){singleContent(id:$contentId){id ...WatchDialogContentFragmentWithWatchChildren}}fragment WatchDialogContentFragmentWithWatchChildren on Content{id currentUserIsWatching currentUserIsWatchingChildren currentUserHasAncestorWatchingChildren type space{id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}}`;

});


parcelRegister("3YpC9", function(module, exports) {

$parcel$export(module.exports, "PAGE_SEGMENT_MARK_PREFIX_START", () => $4dbe182ee19642b3$export$f59b3ea823fcdb3d);
$parcel$export(module.exports, "PAGE_SEGMENT_MARK_PREFIX_END", () => $4dbe182ee19642b3$export$a217b163593f51a);
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';

});

parcelRegister("lSOAM", function(module, exports) {

$parcel$export(module.exports, "isBMPageLoad", () => $2a47a9fc48674e91$export$9dede01b6f349441);
$parcel$export(module.exports, "hasBMPageLoadStarted", () => $2a47a9fc48674e91$export$cb339d0cd5cc821c);
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
$parcel$export(module.exports, "createConcurrentCustomMetric", () => $2a47a9fc48674e91$export$9db2e0f538bb10fa);
/* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");
var $kyiqo = parcelRequire("kyiqo");

var $64KID = parcelRequire("64KID");

var $i3c1S = parcelRequire("i3c1S");
const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;

});
parcelRegister("kyiqo", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54);

var $bCz2F = parcelRequire("bCz2F");

var $bs5rD = parcelRequire("bs5rD");
const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};

});
parcelRegister("bCz2F", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $bbc3e125622b0c90$export$370df09ecc3de059);

var $j4jXg = parcelRequire("j4jXg");

var $bs5rD = parcelRequire("bs5rD");
const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};

});
parcelRegister("bs5rD", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $d0aae4122f29b5ae$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $d0aae4122f29b5ae$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $d0aae4122f29b5ae$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $d0aae4122f29b5ae$export$4c00f665f0d4b443);

var $iuio5 = parcelRequire("iuio5");

var $boXf9 = parcelRequire("boXf9");

var $giQku = parcelRequire("giQku");

var $j4jXg = parcelRequire("j4jXg");
const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};

});
parcelRegister("iuio5", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $6456fd2c244bded5$export$efdd3e096bc27746);

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $4k3LC = parcelRequire("4k3LC");
class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("boXf9", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $b4ce8d24635e776a$export$3c51073271a9eac3);

var $h6RR2 = parcelRequire("h6RR2");

var $7RgFv = parcelRequire("7RgFv");

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $j4jXg = parcelRequire("j4jXg");

var $3znwT = parcelRequire("3znwT");

var $69Zr8 = parcelRequire("69Zr8");

var $e9ZCR = parcelRequire("e9ZCR");
class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("e9ZCR", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $fd3d2d441d340510$export$dc0d85d4d6503cd7);

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");
class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("giQku", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $4f83d9bff0211700$export$24c8bfcd77494cc1);

var $h6RR2 = parcelRequire("h6RR2");

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");

var $iuio5 = parcelRequire("iuio5");

var $69Zr8 = parcelRequire("69Zr8");
class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';

});




parcelRegister("i3c1S", function(module, exports) {

$parcel$export(module.exports, "getWaterfallTimings", () => $82eb5b0eb983d5b4$export$9dbd6bda36500fa9);

var $hZpML = parcelRequire("hZpML");

var $3YpC9 = parcelRequire("3YpC9");

var $6VdZc = parcelRequire("6VdZc");
// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}

});


parcelRegister("7gpC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9fb6b4b3bc4020$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gxtzC = parcelRequire("gxtzC");

var $3654r = parcelRequire("3654r");

var $6MlG5 = parcelRequire("6MlG5");
var $9wgn8 = parcelRequire("9wgn8");
var $cVrnQ = parcelRequire("cVrnQ");
var $hcDON = parcelRequire("hcDON");
const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzg15mc _1dk715mc _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $gwFzn.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $gwFzn.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $gwFzn.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $35pXk.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;

});
parcelRegister("6MlG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $71feb0a29953fded$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");

var $dh538 = parcelRequire("dh538");
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $gwFzn.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $gwFzn.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6Fdl.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;

});

parcelRegister("9wgn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("label", {
        className: (0, $35pXk.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syaz1fxt _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1lh4 _80om13gf",
            "_h5e31j9a _1nzsr01l _1esz1fvw _yp0j18hz _ay2wsyzs _d51u1d5g _phft1elr _1g1fmuej _l6wk1fvw _1dik18hz _1sfg1bqt _fpdjsyzs _1yjc1p6i _oaj11elr _1j3h1bqt _eawb5w2r _1rda5w2r _18q01lg7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "aria-hidden": true,
        className: (0, $35pXk.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("9EtP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $82c18ff824db72a8$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $gwFzn = parcelRequire("gwFzn");

var $gxtzC = parcelRequire("gxtzC");

var $dh538 = parcelRequire("dh538");
const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $82c18ff824db72a8$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const ourRef = (0, $gwFzn.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $gwFzn.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $gwFzn.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syaz1fxt _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1lh4 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjd1d5g _6zpvizbr _19k0syzs _1idr131l _1lep1lh4 _nmhq1fiz _1n388sxn _1luh1p6i _ndzbr01l _1vj0q049",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            (0, $dh538.fg)('platform_design_system_team_safari_input_fix') && $82c18ff824db72a8$var$fontStyles['large'],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $iAWao.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $iAWao.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;

});

parcelRegister("dojsn", function(module, exports) {

$parcel$export(module.exports, "ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS", () => $ae1f70413a471f37$export$cd507d828173423e);
const $ae1f70413a471f37$export$cd507d828173423e = {
    tourSeenAt: 'enhance-orientation-tour:tourSeenAt',
    hasDismissedTour: 'enhance-orientation-tour:hasDismissedTour',
    hasCompletedTour: 'enhance-orientation-tour:hasCompletedTour',
    hasSeenFinishNudge: 'enhance-orientation-tour:hasSeenFinishNudge'
};
const $ae1f70413a471f37$export$649eff0e68d213a7 = [
    ...Object.values($ae1f70413a471f37$export$cd507d828173423e)
];

});

parcelRegister("hXDOc", function(module, exports) {

$parcel$export(module.exports, "PreloadingMode", () => $b22e252a6b9677fd$export$3c7387d0e5ed624d);
$parcel$export(module.exports, "HoverPreloader", () => $b22e252a6b9677fd$export$16d0fec7f7c7ddfa);
$parcel$export(module.exports, "PreloadingPresets", () => $b22e252a6b9677fd$export$f5ad7b1003f136b2);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");
var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $gwFzn.useRef)(null);
    const preloadRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $gwFzn.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $gwFzn.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "hover-preloader",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown
    }, children));
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};

});

parcelRegister("dBcar", function(module, exports) {

$parcel$export(module.exports, "PEOPLE", () => $3c94963df51c0e13$export$f35f2899eb1390e3);
$parcel$export(module.exports, "FIRST_SPACE_SELECTED", () => $3c94963df51c0e13$export$1f72e9a162b3795b);
$parcel$export(module.exports, "HELP", () => $3c94963df51c0e13$export$da223e550b96c9d6);
$parcel$export(module.exports, "ONBOARDING_INTENTS", () => $3c94963df51c0e13$export$ffb6b379ff35f9e);
$parcel$export(module.exports, "ONBOARDING_INTENT_EXPERIENCES", () => $3c94963df51c0e13$export$49ac0bbeb4be0a06);
$parcel$export(module.exports, "ONBOARDING_REVERSE_TRIAL", () => $3c94963df51c0e13$export$6167e5b70dfd11d9);
$parcel$export(module.exports, "TEMPLATES_COLLECTION", () => $3c94963df51c0e13$export$49c044e5e3ccc2af);
$parcel$export(module.exports, "SPACE_GETTING_STARTED_TOUR_EXPERIENCES", () => $3c94963df51c0e13$export$dcbccfe8799c3c7b);
$parcel$export(module.exports, "PERSISTENT_INVITE", () => $3c94963df51c0e13$export$305c55ea55928edf);
$parcel$export(module.exports, "IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED", () => $3c94963df51c0e13$export$b99b309b286adebc);
$parcel$export(module.exports, "IS_NAV_4_SPACE_TOUR_DISMISSED", () => $3c94963df51c0e13$export$20b0548cf5859d6);
$parcel$export(module.exports, "IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED", () => $3c94963df51c0e13$export$4d93dfc1d8538d55);
$parcel$export(module.exports, "WHATS_NEW_IN_CONFLUENCE", () => $3c94963df51c0e13$export$7ed75560092630f6);
$parcel$export(module.exports, "MODERNIZE_CONFLUENCE_IPM_MODAL", () => $3c94963df51c0e13$export$cba7fd986c721ece);
$parcel$export(module.exports, "NTH_USER_SETUP_CONTENT_TYPE", () => $3c94963df51c0e13$export$d1ec748fb682ca97);
$parcel$export(module.exports, "PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED", () => $3c94963df51c0e13$export$1a3a43cef0acd011);
$parcel$export(module.exports, "FEATURE_DISCOVERY_CONTEXTUAL_CREATE_MENU_SUBTEXT", () => $3c94963df51c0e13$export$4d9719b9c3bbb6d3);
$parcel$export(module.exports, "ONBOARDING_EXPERIENCES", () => $3c94963df51c0e13$export$bfeb2da96277b623);
$parcel$export(module.exports, "COMPLETE", () => $3c94963df51c0e13$export$1660a2d7c2fff354);
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$bcc4454330a6e241 = 'isContentWrapperLabelsTourDismissed';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$cba7fd986c721ece = {
    HAS_DISMISSED_MODAL: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    HAS_DISMISSED_BANNER: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$4d9719b9c3bbb6d3 = {
    WAS_VARIANT_GROUP: 'contextual-create-menu-subtext:wasVariantGroup'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$bcc4454330a6e241}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;

});

parcelRegister("cg3Zk", function(module, exports) {

$parcel$export(module.exports, "RequestViewQuery", () => $742fdc50e083de17$export$6f580a57816cd596);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $742fdc50e083de17$export$6f580a57816cd596 = (0, $d2LG0.default)`query RequestViewQuery($id:ID!){singleContent(id:$id){id status links{webui}}user:confluence_atlassianUser(current:true){id confluence{roles{canBeSuperAdmin}}}}`;

});

parcelRegister("9NZgb", function(module, exports) {

$parcel$export(module.exports, "preloadDefaultAndSpaceClassificationLevels", () => $d311f103c5944a12$export$59f9358c70ea498f);

var $dYU3e = parcelRequire("dYU3e");

var $2Pqlt = parcelRequire("2Pqlt");
function $d311f103c5944a12$export$59f9358c70ea498f(spaceKey = '') {
    return (0, $dYU3e.query)({
        query: (0, $2Pqlt.DefaultAndSpaceClassificationLevelsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}

});

parcelRegister("fstZx", function(module, exports) {

$parcel$export(module.exports, "StarredSpacesQuery", () => $bb42a67b08b88af0$export$f89460d6594658f1);
$parcel$export(module.exports, "MyVisitedSpacesQuery", () => $bb42a67b08b88af0$export$73b0293722a8eb9f);
$parcel$export(module.exports, "MyVisitedSpacesWithCurrentSpaceQuery", () => $bb42a67b08b88af0$export$9fdae40747d95364);
$parcel$export(module.exports, "AnonymousSpacesQuery", () => $bb42a67b08b88af0$export$2e53cde7a8b8bbee);
$parcel$export(module.exports, "SearchSpacesQuery", () => $bb42a67b08b88af0$export$7c52f7af355ed457);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $bb42a67b08b88af0$export$f89460d6594658f1 = (0, $d2LG0.default)`query StarredSpacesQuery{spaces(favourite:true first:99 status:"current"){nodes{alias id name key icon{path}}}}`;
const $bb42a67b08b88af0$export$73b0293722a8eb9f = (0, $d2LG0.default)`query MyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias id name key icon{path}}}}}`;
const $bb42a67b08b88af0$export$9fdae40747d95364 = (0, $d2LG0.default)`query MyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias id name key icon{path}currentUser{isFavourited}}myVisitedSpaces(limit:26){nodes{spaces{alias id name key icon{path}}}}}`;
const $bb42a67b08b88af0$export$2e53cde7a8b8bbee = (0, $d2LG0.default)`query AnonymousSpacesQuery{spaces(first:10){nodes{alias id name key icon{path}}}}`;
const $bb42a67b08b88af0$export$7c52f7af355ed457 = (0, $d2LG0.default)`query SearchSpacesQuery($spaceNamePattern:String!$isLicensed:Boolean!){spaces(first:30 status:"current" spaceNamePattern:$spaceNamePattern){nodes{alias id name key icon{path}currentUser@include(if:$isLicensed){isFavourited}}}}`;

});

parcelRegister("h7lOC", function(module, exports) {

$parcel$export(module.exports, "AdminAnnouncementBannerQuery", () => $992086711e16ca63$export$36a90448b18e6499);

var $d2LG0 = parcelRequire("d2LG0");
const $992086711e16ca63$export$36a90448b18e6499 = (0, $d2LG0.default)`query AdminAnnouncementBannerQuery{adminAnnouncementBanner{id isDismissible content appearance title updatedAt}}`;

});

parcelRegister("cpPWT", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $375253a0664acfd5$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $375253a0664acfd5$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $375253a0664acfd5$export$89f8e1f623d8f5ac);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $375253a0664acfd5$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $375253a0664acfd5$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $375253a0664acfd5$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $375253a0664acfd5$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $gwFzn.createContext)($375253a0664acfd5$export$a28a0c048b24fc5a());
const $375253a0664acfd5$export$c7535f8ebc5b75a9 = $375253a0664acfd5$export$ea58328f3ceee4d4.Provider;
const $375253a0664acfd5$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)($375253a0664acfd5$export$c7535f8ebc5b75a9, {
            value: $375253a0664acfd5$export$a28a0c048b24fc5a(),
            children: children
        });
const $375253a0664acfd5$export$89f8e1f623d8f5ac = ()=>(0, $gwFzn.useContext)($375253a0664acfd5$export$ea58328f3ceee4d4);

});

parcelRegister("8rneB", function(module, exports) {

$parcel$export(module.exports, "getVersionNumber", () => $61659933fe71a4ee$export$d2d37cdca5b73056);
$parcel$export(module.exports, "getEmojiId", () => $61659933fe71a4ee$export$4f65bc4b6ab2638);
$parcel$export(module.exports, "sanitizeEmojiValue", () => $61659933fe71a4ee$export$7f77dde40cb9b60a);
$parcel$export(module.exports, "getEmojiPublishedProperty", () => $61659933fe71a4ee$export$1b37039eb4b94aa5);
$parcel$export(module.exports, "getEmojiDraftProperty", () => $61659933fe71a4ee$export$4d2921b7085d93bb);
$parcel$export(module.exports, "getEmojiFromPublishedPageProperties", () => $61659933fe71a4ee$export$f6641c501f8a1aee);
$parcel$export(module.exports, "getEmojiFromDraftPageProperties", () => $61659933fe71a4ee$export$e1cb12562674727b);
$parcel$export(module.exports, "getPublishedEmojiId", () => $61659933fe71a4ee$export$db0acf1152e62ad6);
$parcel$export(module.exports, "getEmojiValueFromContent", () => $61659933fe71a4ee$export$a5b3ff94c918547);
$parcel$export(module.exports, "getEmojiDraftFromProperties", () => $61659933fe71a4ee$export$bb520a2176fa2873);
$parcel$export(module.exports, "getEmojiPublishedFromProperties", () => $61659933fe71a4ee$export$fbf43d9e87015d93);
$parcel$export(module.exports, "getHasEmoji", () => $61659933fe71a4ee$export$b8852397200defa1);
$parcel$export(module.exports, "getHasEmojiPublished", () => $61659933fe71a4ee$export$53519180ca077ff2);
$parcel$export(module.exports, "getEmojiProvider", () => $61659933fe71a4ee$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getHasLiveDocsDefaultEmoji", () => $61659933fe71a4ee$export$efb819bf9c3235c7);

var $ibzAc = parcelRequire("ibzAc");

var $32x2E = parcelRequire("32x2E");

var $9wGTI = parcelRequire("9wGTI");

var $5amrO = parcelRequire("5amrO");
const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: property?.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    const nodes = (data?.content?.nodes?.[0] || data?.singleContent)?.[emojiFieldName]?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!(0, $9wGTI.fg)('live_pages_default_icon') || !data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};

});
parcelRegister("5amrO", function(module, exports) {

$parcel$export(module.exports, "EMOJI_TITLE_DRAFT_FIELD", () => $bb7cbab4663812b3$export$5a027b13986198b7);
$parcel$export(module.exports, "EMOJI_TITLE_PUBLISHED_FIELD", () => $bb7cbab4663812b3$export$b78a8db8f4546258);
$parcel$export(module.exports, "useEmojiStatusFieldName", () => $bb7cbab4663812b3$export$61509c1d76ea5fb2);
$parcel$export(module.exports, "convertEmojiFieldNameToPropertyKey", () => $bb7cbab4663812b3$export$28c62f1b367f9166);

var $3jwuS = parcelRequire("3jwuS");

var $99t4P = parcelRequire("99t4P");
const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    // whiteboards and live pages are always published, so return EMOJI_TITLE_PUBLISHED_FIELD
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};

});
parcelRegister("99t4P", function(module, exports) {

$parcel$export(module.exports, "isEmojiTitleEnabled", () => $6b4026d31beb25d0$export$f0410e068eb2ef9e);

var $9wGTI = parcelRequire("9wGTI");
const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};

});



parcelRegister("c7GB4", function(module, exports) {

$parcel$export(module.exports, "getIdFromConfluenceContentAri", () => $c96e0d62cf176fc6$export$84dfa7fadd8a006b);

var $ayhth = parcelRequire("ayhth");
var $gcKE7 = parcelRequire("gcKE7");
var $kgTLv = parcelRequire("kgTLv");
var $PWQud = parcelRequire("PWQud");
var $ixUm0 = parcelRequire("ixUm0");
var $iILKK = parcelRequire("iILKK");

var $1ggpj = parcelRequire("1ggpj");
const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $ixUm0.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $ayhth.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $iILKK.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $gcKE7.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $kgTLv.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $PWQud.ConfluenceFolderAri).parse(ari).folderId;
    }
};

});

parcelRegister("2YerA", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);

var $jCM2u = parcelRequire("jCM2u");

var $fqrVl = parcelRequire("fqrVl");

});
parcelRegister("jCM2u", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $32c19fce160b377b$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $32c19fce160b377b$export$6e7a10fe635a0dfc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5xIym = parcelRequire("5xIym");

var $5B9n6 = parcelRequire("5B9n6");

var $fqrVl = parcelRequire("fqrVl");
const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $gwFzn.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $gwFzn.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $gwFzn.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $gwFzn.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("5xIym", function(module, exports) {

$parcel$export(module.exports, "createAPIv0", () => $1eb0c594c750199f$export$9ff7368ac93fcf2d);
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("5B9n6", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $12de2f6721823415$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv1", () => $12de2f6721823415$export$8fd5792fc468459f);
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("fqrVl", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $4db9b154d66dd01a$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $4db9b154d66dd01a$export$da2d4f2f250d6f84);
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("49sr4", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("ctMWd")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("82BVR")).Targets);

var $ctMWd = parcelRequire("ctMWd");

var $82BVR = parcelRequire("82BVR");

});
parcelRegister("ctMWd", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => $0081b4f618dff6fe$export$a5e53d1dcbd6eb61);
class $0081b4f618dff6fe$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("82BVR", function(module, exports) {

$parcel$export(module.exports, "Targets", () => $49d7ae8ec7eae7d8$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $49d7ae8ec7eae7d8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand'
};

});


parcelRegister("koZ31", function(module, exports) {

$parcel$export(module.exports, "CoreInvitesSource", () => $6a2b9fa9e63188b2$export$1ba03842b7d3a654);
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["QSV2_INVITE_TEAMMATE_TASK"] = "quickstart-checklist.invite-teammate-v2";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    return CoreInvitesSource;
}({});

});

parcelRegister("3PXtn", function(module, exports) {

$parcel$export(module.exports, "BannerSpacer", () => $a5e2ea3da11107ff$export$6801ec5f8af8462d);
$parcel$export(module.exports, "BannerStateContainer", () => (parcelRequire("hrAmX")).BannerStateContainer);
$parcel$export(module.exports, "FloatingBannerStateContainer", () => (parcelRequire("1a6Dn")).FloatingBannerStateContainer);
$parcel$export(module.exports, "WithoutBanners", () => (parcelRequire("iSSAX")).WithoutBanners);
$parcel$export(module.exports, "BannerContext", () => (parcelRequire("jxpvN")).BannerContext);
$parcel$export(module.exports, "BannerContextProvider", () => (parcelRequire("6pwLK")).BannerContextProvider);

var $jmjWc = parcelRequire("jmjWc");

var $hrAmX = parcelRequire("hrAmX");

var $1a6Dn = parcelRequire("1a6Dn");

var $iSSAX = parcelRequire("iSSAX");

var $jxpvN = parcelRequire("jxpvN");

var $6pwLK = parcelRequire("6pwLK");

const $a5e2ea3da11107ff$export$6801ec5f8af8462d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "paSPC",
    name: "BannerSpacer",
    loader: async ()=>(await (parcelRequire("dMxv0"))).BannerSpacer
});

});
parcelRegister("hrAmX", function(module, exports) {

$parcel$export(module.exports, "findBanner", () => $6ee3834dea9f6c5c$export$f7df67e8f3ba0620);
$parcel$export(module.exports, "BannerStateContainer", () => $6ee3834dea9f6c5c$export$bbac707b3ebb5681);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");

var $1dnxO = parcelRequire("1dnxO");
const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $ipPpS.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        const navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = props.initialState?.banners || [];
    }
}

});

parcelRegister("1a6Dn", function(module, exports) {

$parcel$export(module.exports, "FloatingBannerStateContainer", () => $d3905c2d386f370c$export$c59406a16f2704a5);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");

var $hrAmX = parcelRequire("hrAmX");
class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $ipPpS.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}

});

parcelRegister("iSSAX", function(module, exports) {

$parcel$export(module.exports, "WithoutBanners", () => $52160d3a5a95f095$export$b78d9b9240bb4db3);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $1a6Dn = parcelRequire("1a6Dn");

var $hrAmX = parcelRequire("hrAmX");
const $52160d3a5a95f095$export$b78d9b9240bb4db3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Provider), {
        inject: [
            new (0, $hrAmX.BannerStateContainer)({
                hasTopNav: false
            }),
            new (0, $1a6Dn.FloatingBannerStateContainer)()
        ]
    }, children));

});

parcelRegister("jxpvN", function(module, exports) {

$parcel$export(module.exports, "BannerContext", () => $205998aae8e9bd72$export$60bd66ed7962b851);

var $gwFzn = parcelRequire("gwFzn");
const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';

});

parcelRegister("6pwLK", function(module, exports) {

$parcel$export(module.exports, "BannerContextProvider", () => $f91eb48475fb1f4e$export$fce08d0d9d687787);

var $gwFzn = parcelRequire("gwFzn");

var $5vi32 = parcelRequire("5vi32");

var $jxpvN = parcelRequire("jxpvN");
const $f91eb48475fb1f4e$export$fce08d0d9d687787 = ({ includeTopNav: includeTopNav, children: children })=>{
    const { includeTopNav: inheritedOrDefaultValue } = (0, $gwFzn.useContext)((0, $jxpvN.BannerContext));
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    if (typeof includeTopNav !== 'boolean') includeTopNav = isEmbeddedConfluence ? false : inheritedOrDefaultValue;
    const bannerContextValue = (0, $gwFzn.useMemo)(()=>({
            includeTopNav: includeTopNav
        }), [
        includeTopNav
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: bannerContextValue
    }, children);
};

});
parcelRegister("5vi32", function(module, exports) {

$parcel$export(module.exports, "useIsEmbeddedConfluence_DO_NOT_USE", () => $36802f16e927d19b$export$c850f609dc850980);

var $gwFzn = parcelRequire("gwFzn");

var $1iSzD = parcelRequire("1iSzD");

var $7zgzO = parcelRequire("7zgzO");
function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}

});


parcelRegister("dMxv0", function(module, exports) {

let $a089be472a66fb93$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a089be472a66fb93$var$load("iAaum"),
    $a089be472a66fb93$var$load("9mi9f")
]).then(()=>parcelRequire('HJnwX'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("ktUCG", function(module, exports) {

$parcel$export(module.exports, "EmojiTitleStateContainer", () => $122734ff4c4db131$export$c7d05d5ff2632978);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");

var $8rneB = parcelRequire("8rneB");
class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $ipPpS.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}

});

parcelRegister("8aF6s", function(module, exports) {

$parcel$export(module.exports, "useDialogs", () => $ff30daea9524db5f$export$f3af872d774d3d3f);
$parcel$export(module.exports, "useDialogsState", () => $ff30daea9524db5f$export$ecef86e74aed0d6b);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $gwFzn = parcelRequire("gwFzn");

var $2BAFx = parcelRequire("2BAFx");
const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $4ZoIm.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $iFWZA.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $gwFzn.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $iFWZA.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $gwFzn.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};

});

parcelRegister("jln20", function(module, exports) {

$parcel$export(module.exports, "useRightSidebarContext", () => $8facebd0ecb5e0ee$export$8c38c254c6602904);
$parcel$export(module.exports, "RightSidebarContextProvider", () => $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f);

var $gwFzn = parcelRequire("gwFzn");

var $2QMNQ = parcelRequire("2QMNQ");

var $aWwYt = parcelRequire("aWwYt");

var $9wGTI = parcelRequire("9wGTI");
function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $9wGTI.fg)('confluence_preview_panels')) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>(0, $gwFzn.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $gwFzn.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $gwFzn.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $2QMNQ.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $2QMNQ.useIsPreviewPanelOpen)();
    const contextValue = (0, $gwFzn.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("4o1RV", function(module, exports) {

$parcel$export(module.exports, "useNavigationPolicy", () => $f3bd82ae210529c7$export$57395cb9dce31159);

var $gwFzn = parcelRequire("gwFzn");

var $iV5Ic = parcelRequire("iV5Ic");

var $ihkY1 = parcelRequire("ihkY1");

var $kBW0t = parcelRequire("kBW0t");
function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    return (0, $gwFzn.useMemo)(()=>({
            routePolicy: routePolicy,
            ...shimUrl
        }), [
        routePolicy,
        shimUrl
    ]);
}

});
parcelRegister("ihkY1", function(module, exports) {

$parcel$export(module.exports, "useRoutePolicy", () => $477c5af85d2d7fb0$export$53e37724c6846f41);

var $gwFzn = parcelRequire("gwFzn");

var $1iSzD = parcelRequire("1iSzD");

var $iV5Ic = parcelRequire("iV5Ic");

var $cb6fO = parcelRequire("cb6fO");

var $9wGTI = parcelRequire("9wGTI");

var $kBW0t = parcelRequire("kBW0t");
function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const enableSpaTransitions = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const getEmbeddedConfluenceRoutePolicy = (0, $gwFzn.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
				 * Transition within the same window if the target route is navigating to the same content
				 * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
				 **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                        open(url, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url, forceReload);
                    else open(url, target);
                };
                /**
				 * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
				 * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
				 * tab, EP should not shim (rebase) it since the embedding product has already had a chance
				 * and they chose not to. On the other hand, if the embedding product does not tell EP to
				 * nagivate, EP can shim the url only when opening a new tab (some links might not have been
				 * shimmed, need to shim all links supposed to be shimmed as the last defense).
				 **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = (0, $9wGTI.fg)('embedded-confluence-spa-transition') ? [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId && !!enableSpaTransitions : false;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $gwFzn.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}

});
parcelRegister("kBW0t", function(module, exports) {

$parcel$export(module.exports, "useShimUrl", () => $734ea8da77496ad5$export$8ed0b067e5cd675d);

var $csnse = parcelRequire("csnse");

var $gwFzn = parcelRequire("gwFzn");

var $67L2Z = parcelRequire("67L2Z");

var $cb6fO = parcelRequire("cb6fO");
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    const shimUrl = (0, $gwFzn.useCallback)((urlToShim)=>{
        return $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimAdfUrls = (0, $gwFzn.useCallback)((adf)=>{
        if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
        const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($67L2Z)))(adf);
        $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        return adfClone;
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimHtmlUrls = (0, $gwFzn.useCallback)((html)=>{
        if (!shimTemplate || !html) return html;
        try {
            return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, 'text/html'), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
        } catch  {
            return html;
        }
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        }), [
        shimUrl,
        shimAdfUrls,
        shimHtmlUrls
    ]);
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // return true to maintain backwards compatibility for all spaces when no spaceKeyFilter is provided
    if (!spaceKeyFilter?.length) return true;
    // if there are space keys to filter, check if the url contains any of them
    return spaceKeyFilter.reduce((acc, spaceKey)=>acc || url.includes(`/spaces/${spaceKey}`), false);
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $csnse.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $csnse.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}

});



parcelRegister("9tntP", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $e12337ddb1a59fdd$export$12b6b072930fd68f);

var $hf8aJ = parcelRequire("hf8aJ");
class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}

});
parcelRegister("hf8aJ", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $41a6d457f373bb5d$export$c90b54e658fc4d7c);

var $9PTEZ = parcelRequire("9PTEZ");
function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}

});
parcelRegister("9PTEZ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $98d3e4a5bcf7dec9$export$d27a2b6293f7631c);
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("8lYIw", function(module, exports) {

$parcel$export(module.exports, "Link", () => $9673d4c78655a9a1$export$a6c7ac8248d6e38a);

var $gwFzn = parcelRequire("gwFzn");

var $7fpiF = parcelRequire("7fpiF");

var $7zgzO = parcelRequire("7zgzO");

var $dHSeC = parcelRequire("dHSeC");
const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { target: target, name: name, href: href = null, to: to = null, params: params = {} } = props;
    const routesContext = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: ""
    });
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    return match && target !== '_blank' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
        ...props,
        ref: ref,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: path
    });
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ path: path, ...parentProps }, ref)=>{
    const { children: children, className: className, target: target, testId: testId, style: style, id: id } = parentProps;
    const routesContext = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    const onAnchorLinkClick = (e)=>{
        // @ts-ignore this should probably be `e.currentTarget`
        onPageReload(e.target.getAttribute('href'), false);
        if (parentProps.onClick) parentProps.onClick(e);
    };
    const onAnchorContextMenuClick = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        href: path,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onAnchorLinkClick,
        onContextMenu: onAnchorContextMenuClick,
        target: target,
        id: id,
        rel: target === '_blank' ? 'noreferrer' : undefined,
        "data-testid": testId,
        ref: ref,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ match: match, ...parentProps }, ref)=>{
    const routesContext = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    const onMouseDownCapture = async ()=>preloadRoute(match);
    /**
   * Define the `onClick` handler for `react-router-dom`
   * [Link](https://github.com/ReactTraining/react-router/blob/346153e38365e6a88657ce2e4e5acada290fc430/packages/react-router-dom/modules/Link.js)
   * to make sure the SPA transition will go through RouteManager's push
   * method. Under the hood `RouteManager#push` still calls `history.push`, but
   * in addition it can reach out specified route policy if any. If not
   * eligible for SPA transition, then it will continue delegate to
   * react-router-dom Link to handle the click.
   */ const onClick = (event)=>{
        if (parentProps.onClick) parentProps.onClick(event);
        const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
        if (!event.defaultPrevented && details?.href) {
            event.preventDefault();
            routesContext.push(details.href);
        }
    };
    const onContextMenu = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7fpiF.Link), {
        to: `${match.pathname}${match.search}${match.hash}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onClick,
        onContextMenu: onContextMenu,
        onMouseDownCapture: onMouseDownCapture,
        innerRef: ref,
        id: id,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);
});

});

parcelRegister("2w2Hu", function(module, exports) {

$parcel$export(module.exports, "MustPreloadLoadableNames", () => $8cf96aaaf31dfd76$export$75ebf2388340a0ba);
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ var $8cf96aaaf31dfd76$export$75ebf2388340a0ba = /*#__PURE__*/ function(MustPreloadLoadableNames) {
    MustPreloadLoadableNames["ClassicRendererLoader"] = "ClassicRendererLoader";
    MustPreloadLoadableNames["ClassicEditorContextProviderLoader"] = "ClassicEditorContextProviderLoader";
    MustPreloadLoadableNames["NativeCollabLoader"] = "NativeCollabLoader";
    MustPreloadLoadableNames["FullPageEditorLoader"] = "FullPageEditorLoader";
    MustPreloadLoadableNames["ViewPageRouteComponentLoader"] = "ViewPageRouteComponentLoader";
    MustPreloadLoadableNames["LivePageComponentLoader"] = "LivePageComponentLoader";
    MustPreloadLoadableNames["EditorByLineArea"] = "EditorByLineArea";
    return MustPreloadLoadableNames;
}({});

});

parcelRegister("eqNP8", function(module, exports) {

$parcel$export(module.exports, "FullPageLoadingScreen", () => $94835ea6111c7010$export$fe2b6579564feee);
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9hlns = parcelRequire("9hlns");
const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqsw1n9t _154i1ssb _1ltv1ssb _t9ec1ooe _1pby1ap8",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_v5641p41 _1pbybfng _4t3i1osq _1bsb1osq _kqsw1n9t _1ltvidpf _154iidpf _bfhkvuon _tzy47u59 _1lww1yx9",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));

});

parcelRegister("1YXTQ", function(module, exports) {

$parcel$export(module.exports, "formatTimeAgo", () => $6f4eb0725770e50a$export$78ae3e68d8c394bc);
$parcel$export(module.exports, "StaticTimeAgo", () => $6f4eb0725770e50a$export$fc791eb9f9c39e49);
$parcel$export(module.exports, "TimeAgo", () => $6f4eb0725770e50a$export$9e4a631e7281406a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $kzzEb = parcelRequire("kzzEb");

var $87M7D = parcelRequire("87M7D");

var $bLJr5 = parcelRequire("bLJr5");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");
const $6f4eb0725770e50a$var$i18n = (0, $2nPZH.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    if (!(0, $9wGTI.fg)('confluence_frontend_use_timezone')) return undefined;
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, (/*@__PURE__*/$parcel$interopDefault($87M7D))).tz.guess();
                    // moment.tz.zone() returns null for invalid timezones, use UTC as fallback
                    return (0, (/*@__PURE__*/$parcel$interopDefault($87M7D))).tz.zone(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $bLJr5.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const formatter = new (0, (/*@__PURE__*/$parcel$interopDefault($kzzEb)))(locale, {
        units: $6f4eb0725770e50a$var$gradation[i].unit,
        style: 'numeric'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    return formatter.format(new Date(new Date().getTime() - Math.round(seconds / factor / granularity) * granularity * factor * 1000));
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $dBxQj.default)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $gwFzn.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $gwFzn.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};

});

parcelRegister("gllul", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $4b8c41a997ae9dfc$export$271f9f08425019c7);
$parcel$export(module.exports, "OverviewNotFound", () => $4b8c41a997ae9dfc$export$df359d26db880cab);
$parcel$export(module.exports, "ErrorPageComponent", () => (parcelRequire("auKqk")).ErrorPageComponent);

var $jmjWc = parcelRequire("jmjWc");


var $auKqk = parcelRequire("auKqk");

const $4b8c41a997ae9dfc$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-D6OT",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("d4zhb"))).NotFound
});

const $4b8c41a997ae9dfc$export$df359d26db880cab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "c9lnO",
    name: "OverviewNotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("akVRw"))).OverviewNotFound
});

});
parcelRegister("auKqk", function(module, exports) {

$parcel$export(module.exports, "ErrorPageComponent", () => $ae2504483138c997$export$8350f8038f1a598b);
/* ErrorPageComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $8dwdz = parcelRequire("8dwdz");

var $hhzGx = parcelRequire("hhzGx");
const $ae2504483138c997$var$ErrorContainerStyles = null;
const $ae2504483138c997$var$ErrorContainerMobileStyles = null;
const $ae2504483138c997$var$ErrorContainer = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "not-found-container",
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _bfhkvuon _4t3i10fc",
            isMobile && "_4t3i1kxc"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorPageWrapperStyles = null;
const $ae2504483138c997$var$ErrorPageWrapperMobileStyles = null;
const $ae2504483138c997$var$ErrorPageWrapper = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o _p12fcv93 _2lx2vrvc",
            isMobile && "_2lx21bp4"
        ])
    }, children);
};
const $ae2504483138c997$var$AlignContentStyles = null;
const $ae2504483138c997$var$AlignContentMobileStyles = null;
const $ae2504483138c997$var$AlignContent = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_18s81jfw _1wpz1h6o _y3gn1e5h",
            isMobile && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorTitleStyles = null;
const $ae2504483138c997$var$ErrorTitleMobileStyles = null;
const $ae2504483138c997$var$ErrorTitle = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("h1", {
        className: (0, $35pXk.default)([
            "_18s818rw _11c84xcc _k48pi7a9 _1bsbr5sb _syaz1fxt",
            isMobile && "_11c81c04 _1bsb96ou"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorMessageStyles = null;
const $ae2504483138c997$var$ErrorMessageMobileStyles = null;
const $ae2504483138c997$var$ErrorMessage = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_11c82smr _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _k48pi7a9 _syaz1fxt _p12fqxjr",
            isMobile && "_11c81ixg _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f96ou"
        ])
    }, children);
};
const $ae2504483138c997$var$ButtonContainerStyles = null;
const $ae2504483138c997$var$ButtonContainerMobileStyles = null;
const $ae2504483138c997$var$ButtonContainer = ({ isMobile: isMobile, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1e5h",
            isMobile && "_1bah1h6o"
        ])
    }, children);
};
const $ae2504483138c997$var$primaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250'
});
const $ae2504483138c997$var$mobilePrimaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200'
});
const $ae2504483138c997$var$secondaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250',
    marginLeft: 'space.200'
});
const $ae2504483138c997$var$mobileSecondaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200',
    marginLeft: 'space.100'
});
const $ae2504483138c997$var$childrenStyles = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$mobileChildrenStyles = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-74px`
    marginTop: '-74px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$export$8350f8038f1a598b = ({ errorImage: errorImage, errorImageDark: errorImageDark, errorTitle: errorTitle, errorMessage: errorMessage, primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, children: children })=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$ErrorContainer, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$ErrorPageWrapper, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile
    }, errorImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hhzGx.ErrorPageImage), {
        src: errorImage,
        srcDark: errorImageDark,
        isMobile: isMobile
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$ErrorTitle, {
        isMobile: isMobile
    }, errorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$ErrorMessage, {
        isMobile: isMobile
    }, errorMessage), (primaryButtonProps?.children || secondaryButtonProps?.children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ae2504483138c997$var$ButtonContainer, {
        isMobile: isMobile
    }, primaryButtonProps?.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isMobile ? $ae2504483138c997$var$mobilePrimaryButtonStyles : $ae2504483138c997$var$primaryButtonStyles
    }, 'href' in primaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "primary",
        ...primaryButtonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        ...primaryButtonProps
    })), secondaryButtonProps?.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isMobile ? $ae2504483138c997$var$mobileSecondaryButtonStyles : $ae2504483138c997$var$secondaryButtonStyles
    }, 'href' in secondaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "default",
        ...secondaryButtonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "default",
        ...secondaryButtonProps
    }))))), (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.count(children) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isMobile ? $ae2504483138c997$var$mobileChildrenStyles : $ae2504483138c997$var$childrenStyles
    }, children) : null);
};

});
parcelRegister("hhzGx", function(module, exports) {

$parcel$export(module.exports, "ErrorPageImage", () => $c32ae4d4c06d56af$export$9afbc24a6b683cb2);
/* ErrorPageImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gj7hi = parcelRequire("gj7hi");
const $c32ae4d4c06d56af$var$imageStylesMobile = null;
const $c32ae4d4c06d56af$var$imageStylesDesktop = null;
const $c32ae4d4c06d56af$var$imageStyles = null;
function $c32ae4d4c06d56af$export$9afbc24a6b683cb2({ src: src, srcDark: srcDark, isMobile: isMobile }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        alt: "",
        src: src,
        srcDark: srcDark || src,
        className: (0, $35pXk.default)([
            isMobile && "_1bsb118a",
            !isMobile && "_1bsbn7od",
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f261p"
        ])
    });
}

});


parcelRegister("d4zhb", function(module, exports) {

let $9847032c4522bd74$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9847032c4522bd74$var$load("iAaum"),
    $9847032c4522bd74$var$load("6vzdH"),
    $9847032c4522bd74$var$load("2Vzm6"),
    $9847032c4522bd74$var$load("2F69B"),
    $9847032c4522bd74$var$load("jRzT2"),
    $9847032c4522bd74$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("akVRw", function(module, exports) {

let $7868a7e33b221f62$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7868a7e33b221f62$var$load("iAaum"),
    $7868a7e33b221f62$var$load("6vzdH"),
    $7868a7e33b221f62$var$load("2Vzm6"),
    $7868a7e33b221f62$var$load("2F69B"),
    $7868a7e33b221f62$var$load("jRzT2"),
    $7868a7e33b221f62$var$load("bn8Oy")
]).then(()=>parcelRequire('bDiji'));

});


parcelRegister("2ZJmt", function(module, exports) {

$parcel$export(module.exports, "NavigationLockout", () => $caa92877b3f564cd$export$e2ddff3a4a4594f0);

var $jmjWc = parcelRequire("jmjWc");

const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("5GMot"))).NavigationLockout
});

});
parcelRegister("5GMot", function(module, exports) {

let $42466a016fde4abd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $42466a016fde4abd$var$load("l46gH"),
    $42466a016fde4abd$var$load("hwiu3")
]).then(()=>parcelRequire('jUOfU'));

});


parcelRegister("71GjD", function(module, exports) {

$parcel$export(module.exports, "FeatureCode", () => $9d2fac30cbee1d6f$export$661babcb078ff919);
$parcel$export(module.exports, "FEATURE_CODES_QUERY_PARAM", () => $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd);
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';

});

parcelRegister("lpPVE", function(module, exports) {

$parcel$export(module.exports, "generatePathWithFeatureCodesQueryParam", () => $d9de10c6417158bd$export$d347e131abf45bea);
$parcel$export(module.exports, "getFeatureCodes", () => $d9de10c6417158bd$export$3c2127388df02347);
$parcel$export(module.exports, "hideFeatureCodesQueryParam", () => $d9de10c6417158bd$export$241f453208292937);

var $9wGTI = parcelRequire("9wGTI");

var $71GjD = parcelRequire("71GjD");
const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};

});

parcelRegister("6CEg5", function(module, exports) {

$parcel$export(module.exports, "PerformanceStart", () => $dc6daeb5b2d3b455$export$616e8efc277d5c6);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $9eE57 = parcelRequire("9eE57");
class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $gwFzn.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};

});

parcelRegister("3GP6F", function(module, exports) {

$parcel$export(module.exports, "useFeatureCodesInURL", () => $9bc3195b956679d5$export$eddc138581adbc11);

var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $dPJCf = parcelRequire("dPJCf");

var $71GjD = parcelRequire("71GjD");
var $lpPVE = parcelRequire("lpPVE");

var $lpPVE = parcelRequire("lpPVE");
const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $4y1GY.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $gwFzn.useState)(queryParamsFeatureCodes);
    (0, $gwFzn.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};

});

parcelRegister("5q601", function(module, exports) {

$parcel$export(module.exports, "VIEW_EDIT_BUTTON_CLICKED_ACTION", () => $23ec6b91fddb9839$export$190611e0edbb22d5);
$parcel$export(module.exports, "EDIT_ROUTE_CHANGE_ACTION", () => $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e);
$parcel$export(module.exports, "EDIT_ROUTE_CHANGE_TO_FMP_ACTION", () => $23ec6b91fddb9839$export$caabe0b707a0bfac);
$parcel$export(module.exports, "TINY_SYNCHRONY_PLUGINS_LOAD_ACTION", () => $23ec6b91fddb9839$export$a5b3479b02282e8c);
$parcel$export(module.exports, "TINY_SYNCHRONY_CONTENT_FETCH_ACTION", () => $23ec6b91fddb9839$export$1787f4f7916eb601);
$parcel$export(module.exports, "EDIT_INTENT_EDIT_TTI_ACTION", () => $23ec6b91fddb9839$export$99c2e20685f1cd4e);
$parcel$export(module.exports, "EDIT_INTENT_EDIT_FMP_ACTION", () => $23ec6b91fddb9839$export$e04cfb21f00b2ad0);
$parcel$export(module.exports, "EMBEDDED_EDIT_TTI_ACTION", () => $23ec6b91fddb9839$export$1d8f87e0ed24898e);
$parcel$export(module.exports, "EMBEDDED_EDIT_FMP_ACTION", () => $23ec6b91fddb9839$export$16bdef2ba2fa4a5);
$parcel$export(module.exports, "EDIT_ROUTE_CHANGE_TO_TTI_ACTION", () => $23ec6b91fddb9839$export$4d09a02f749e3cc2);
$parcel$export(module.exports, "TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD", () => $23ec6b91fddb9839$export$c2bda34fe2c26f89);
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';

});

parcelRegister("7CeAz", function(module, exports) {

$parcel$export(module.exports, "useIsCompanyHubEnabled", () => $16ea73778f65e8da$export$1d4394ae12760637);

var $gwFzn = parcelRequire("gwFzn");

var $cEgMD = parcelRequire("cEgMD");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $1ytiN = parcelRequire("1ytiN");

var $8NC5Z = parcelRequire("8NC5Z");
const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};

});
parcelRegister("8NC5Z", function(module, exports) {

$parcel$export(module.exports, "useCompanyHubPremiumGate", () => $1de3a5511529eed3$export$f032b5e8b485da1d);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $7Sm4c = parcelRequire("7Sm4c");

var $euL71 = parcelRequire("euL71");

var $dIouf = parcelRequire("dIouf");

var $5ZqQS = parcelRequire("5ZqQS");

var $bQm3c = parcelRequire("bQm3c");
const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}`, {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $dIouf.isUnauthorizedError)(error) || (0, $dIouf.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $dIouf.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements.companyHub.isEntitled;
};

});


parcelRegister("lt6Lx", function(module, exports) {

$parcel$export(module.exports, "DocumentContentTitle", () => $5a5ab99dc3af9e56$export$8f4c40b84dd15d46);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $d5RCH = parcelRequire("d5RCH");

var $1ytiN = parcelRequire("1ytiN");

var $fPnFe = parcelRequire("fPnFe");

var $i2tcl = parcelRequire("i2tcl");
const $5a5ab99dc3af9e56$var$i18n = (0, $2nPZH.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false })=>{
    const intl = (0, $dBxQj.default)();
    const { siteTitle: siteTitle } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $fPnFe.getStreamInject)();
        inject(()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement('script', {
                dangerouslySetInnerHTML: {
                    __html: `document.title = "${(0, $i2tcl.sanitizeDataForSSR)(title)}";`
                }
            });
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};

});

parcelRegister("8MiHL", function(module, exports) {

$parcel$export(module.exports, "LazyRouteToRightEditor", () => $664150cfb8454085$export$325f108b642b51d);

var $jmjWc = parcelRequire("jmjWc");

const $664150cfb8454085$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EdgKX",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("7eH6C"))
});

});
parcelRegister("7eH6C", function(module, exports) {

let $544b4717bec8687b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $544b4717bec8687b$var$load("9BboF"),
    $544b4717bec8687b$var$load("ait7e")
]).then(()=>parcelRequire('ihMq7'));

});


parcelRegister("kE2cJ", function(module, exports) {

$parcel$export(module.exports, "Redirection", () => $14c2681824cc07d8$export$7b9b5b70059a466b);

var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

parcelRequire("fPnFe");

var $9wGTI = parcelRequire("9wGTI");

var $7zgzO = parcelRequire("7zgzO");
const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        return toUrl(name, {
            hash: getHash(),
            query: getQueryParams(),
            ...params,
            ...parsedUrl
        });
    };
    (0, $gwFzn.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange && (0, $9wGTI.fg)('confluence_skip_ssr_redirect_incorrect_slug')) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch (e) {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

});

parcelRegister("itlCX", function(module, exports) {

$parcel$export(module.exports, "RoleAssignmentPrincipalType", () => $d794298446e7cdbe$export$4e2d5448f3fd8728);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d794298446e7cdbe$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["TEAM"] = "TEAM";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});

});

parcelRegister("blHIE", function(module, exports) {

$parcel$export(module.exports, "SITE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE", () => $417c73981f03c9fe$export$52afaa4233d8bf05);
$parcel$export(module.exports, "SPACE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE", () => $417c73981f03c9fe$export$2500a5d38c35255);
$parcel$export(module.exports, "SPACE_ANALYTICS_PERMISSIONS_WEBITEM_ID", () => $417c73981f03c9fe$export$351ec89f008da8f3);
$parcel$export(module.exports, "SPACE_ANALYTICS_PERMISSIONS_MODERATE_WEBITEM_ID", () => $417c73981f03c9fe$export$4326b04000cd0b90);
// (Normally these contants' names would end with "_ANALYTICS_SOURCE" but then the names would be
//  things like "SPACE_ANALYTICS_ANALYTICS_SOURCE" and that's not readable)
const $417c73981f03c9fe$export$74d726d2df9893c7 = 'instanceAnalytics';
const $417c73981f03c9fe$export$52afaa4233d8bf05 = 'instanceAnalyticsPermissions';
const $417c73981f03c9fe$export$c88588c94e94d4fc = 'insights/spaceAnalytics';
const $417c73981f03c9fe$export$2500a5d38c35255 = 'spaceAnalyticsPermissions';
const $417c73981f03c9fe$export$351ec89f008da8f3 = 'com.addonengine.analytics__analytics-permissions-space-tools-tab';
const $417c73981f03c9fe$export$4326b04000cd0b90 = 'com.addonengine.analytics.moderate__analytics-permissions-space-tools-tab';

});

parcelRegister("49LNg", function(module, exports) {

$parcel$export(module.exports, "LazyConfigurationPage", () => $f97008ca473e410a$export$acaa2dba3cb8a594);
$parcel$export(module.exports, "LazyDefaultSpaceLogoConfigPage", () => $f97008ca473e410a$export$c666402e8e189c20);
$parcel$export(module.exports, "LazyHeaderAndFooterPage", () => $f97008ca473e410a$export$b15e4e022e4cf20b);
$parcel$export(module.exports, "LazyTemplatesAndBlueprintsPage", () => $f97008ca473e410a$export$eeb35ce919747456);
$parcel$export(module.exports, "LazyCodeMacroConfigurationPage", () => $f97008ca473e410a$export$d90af831494c8387);
$parcel$export(module.exports, "LazySecurityConfigurationPage", () => $f97008ca473e410a$export$a21466da6a7c3088);
$parcel$export(module.exports, "LazyApplicationNavigatorPage", () => $f97008ca473e410a$export$80059957d731c042);
$parcel$export(module.exports, "LazyTrashedSpacesPage", () => $f97008ca473e410a$export$db3288808f1d2cee);
$parcel$export(module.exports, "LazyImportSpacesPage", () => $f97008ca473e410a$export$2ed44b7640eeeaea);
$parcel$export(module.exports, "LazyJiraMacroRepairPage", () => $f97008ca473e410a$export$f522a213bf45cbaf);
$parcel$export(module.exports, "LazyMacroUsagePage", () => $f97008ca473e410a$export$93a51467d25d0499);
$parcel$export(module.exports, "LazyThemesPage", () => $f97008ca473e410a$export$39b0a52384de05d);
$parcel$export(module.exports, "LazyPdfExportPage", () => $f97008ca473e410a$export$def53ea7cb291102);
$parcel$export(module.exports, "LazyUserAccessPage", () => $f97008ca473e410a$export$d563a43e58d8e249);
$parcel$export(module.exports, "ADMIN_CONFIGURATION_ANALYTICS_SOURCE", () => (parcelRequire("go5PI")).ADMIN_CONFIGURATION_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE", () => (parcelRequire("87xWZ")).ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE", () => (parcelRequire("9VF1g")).ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE", () => (parcelRequire("kzcPl")).ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE", () => (parcelRequire("jPtik")).ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE", () => (parcelRequire("5vGLM")).ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE", () => (parcelRequire("dWfBt")).ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE", () => (parcelRequire("4l9JY")).ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE", () => (parcelRequire("434W4")).ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE", () => (parcelRequire("2i0P8")).ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_MACRO_USAGE_ANALYTICS_SOURCE", () => (parcelRequire("9JmJC")).ADMIN_MACRO_USAGE_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_THEMES_ANALYTICS_SOURCE", () => (parcelRequire("ft9Jc")).ADMIN_THEMES_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_PDF_EXPORT_ANALYTICS_SOURCE", () => (parcelRequire("fmC2G")).ADMIN_PDF_EXPORT_ANALYTICS_SOURCE);
$parcel$export(module.exports, "ADMIN_USER_ACCESS_ANALYTICS_SOURCE", () => (parcelRequire("l5PUQ")).ADMIN_USER_ACCESS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "handleGraphQLErrors", () => (parcelRequire("1qi64")).handleGraphQLErrors);

var $jmjWc = parcelRequire("jmjWc");

var $go5PI = parcelRequire("go5PI");

var $87xWZ = parcelRequire("87xWZ");

var $9VF1g = parcelRequire("9VF1g");

var $kzcPl = parcelRequire("kzcPl");

var $jPtik = parcelRequire("jPtik");

var $5vGLM = parcelRequire("5vGLM");

var $dWfBt = parcelRequire("dWfBt");

var $4l9JY = parcelRequire("4l9JY");

var $434W4 = parcelRequire("434W4");

var $2i0P8 = parcelRequire("2i0P8");

var $9JmJC = parcelRequire("9JmJC");

var $ft9Jc = parcelRequire("ft9Jc");

var $fmC2G = parcelRequire("fmC2G");

var $l5PUQ = parcelRequire("l5PUQ");

var $1qi64 = parcelRequire("1qi64");

const $f97008ca473e410a$export$acaa2dba3cb8a594 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vNDd6",
    name: "LazyConfigurationPage",
    loader: async ()=>(await (parcelRequire("hcgQ3"))).ConfigurationPage
});

const $f97008ca473e410a$export$c666402e8e189c20 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "B4DKt",
    name: "LazyDefaultSpaceLogoConfigPage",
    loader: async ()=>(await (parcelRequire("qmKXE"))).DefaultSpaceLogoConfigPage
});

const $f97008ca473e410a$export$b15e4e022e4cf20b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JeheJ",
    name: "LazyHeaderAndFooterPage",
    loader: async ()=>(await (parcelRequire("hBelT"))).HeaderAndFooterPage
});

const $f97008ca473e410a$export$eeb35ce919747456 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Hk0nR",
    name: "LazyTemplatesAndBlueprintsPage",
    loader: async ()=>(await (parcelRequire("2QLms"))).TemplatesAndBlueprintsPage
});

const $f97008ca473e410a$export$d90af831494c8387 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00NZZ",
    name: "LazyCodeMacroConfigurationPage",
    loader: async ()=>(await (parcelRequire("dgW4F"))).ConfigureCodeMacroPage
});

const $f97008ca473e410a$export$a21466da6a7c3088 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JVNGq",
    name: "LazySecurityConfigurationPage",
    loader: async ()=>(await (parcelRequire("924jR"))).SecurityConfigurationPage
});

const $f97008ca473e410a$export$80059957d731c042 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6RfuU",
    name: "LazyApplicationNavigatorPage",
    loader: async ()=>(await (parcelRequire("jsdxY"))).ApplicationNavigatorPage
});

const $f97008ca473e410a$export$db3288808f1d2cee = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mlw_c",
    name: "LazyTrashedSpacesPage",
    loader: async ()=>(await (parcelRequire("bHUR5"))).TrashedSpacesPage
});

const $f97008ca473e410a$export$2ed44b7640eeeaea = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xHqkg",
    name: "LazyImportSpacesPage",
    loader: async ()=>(await (parcelRequire("hlqlA"))).ImportSpacesPage
});

const $f97008ca473e410a$export$f522a213bf45cbaf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "O_hNj",
    name: "LazyJiraMacroRepairPage",
    loader: async ()=>(await (parcelRequire("fpXK4"))).JiraMacroRepairPage
});

const $f97008ca473e410a$export$93a51467d25d0499 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "F7J9c",
    name: "LazyMacroUsagePage",
    loader: async ()=>(await (parcelRequire("eOcNM"))).MacroUsagePage
});

const $f97008ca473e410a$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "txUot",
    name: "LazyThemesPage",
    loader: async ()=>(await (parcelRequire("hgcpx"))).ThemesPage
});

const $f97008ca473e410a$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mxKZk",
    name: "LazyPdfExportPage",
    loader: async ()=>(await (parcelRequire("dPsvC"))).PdfExportPage
});

const $f97008ca473e410a$export$d563a43e58d8e249 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "U1BdF",
    name: "LazyUserAccessPage",
    loader: async ()=>(await (parcelRequire("avThV"))).UserAccessPage
});

});
parcelRegister("go5PI", function(module, exports) {

$parcel$export(module.exports, "ADMIN_CONFIGURATION_ANALYTICS_SOURCE", () => $a85703dfa4960dc8$export$6efc679b5f68edbb);
$parcel$export(module.exports, "WIKI_LEARN_MORE_LINK", () => $a85703dfa4960dc8$export$29494bfe5045193);
$parcel$export(module.exports, "CONVERT_PAGES_LEARN_MORE_LINK", () => $a85703dfa4960dc8$export$68fe928f91262da7);
$parcel$export(module.exports, "DATE_TIME_FORMAT_LEARN_MORE_LINK", () => $a85703dfa4960dc8$export$d1b15eb7eed612ff);
$parcel$export(module.exports, "LANGUAGE_SUPPORT_DOC", () => $a85703dfa4960dc8$export$4facdf667af1c221);
$parcel$export(module.exports, "PRESENCE_LEARN_MORE_LINK", () => $a85703dfa4960dc8$export$c6b232dd07adf3e8);
const $a85703dfa4960dc8$export$6efc679b5f68edbb = 'adminConfiguration';
const $a85703dfa4960dc8$export$29494bfe5045193 = 'https://support.atlassian.com/confluence-cloud/docs/insert-confluence-wiki-markup/';
const $a85703dfa4960dc8$export$68fe928f91262da7 = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/';
const $a85703dfa4960dc8$export$d1b15eb7eed612ff = 'https://support.atlassian.com/confluence-cloud/docs/configure-time-and-date-formats/';
const $a85703dfa4960dc8$export$4facdf667af1c221 = 'https://confluence.atlassian.com/x/A41jL';
const $a85703dfa4960dc8$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';

});

parcelRegister("87xWZ", function(module, exports) {

$parcel$export(module.exports, "ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE", () => $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52);
$parcel$export(module.exports, "ALLOWED_LOGO_FILE_EXTENSIONS", () => $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a);
const $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52 = 'adminDefaultSpaceLogoConfig';
const $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a = [
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.webp'
];

});

parcelRegister("9VF1g", function(module, exports) {

$parcel$export(module.exports, "ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE", () => $3395fdb7c7788386$export$f57d5d3f8ce40ac2);
$parcel$export(module.exports, "ADMIN_MIGRATION_HEADER_AND_FOOTER_PATH_NAME", () => $3395fdb7c7788386$export$6dbb84b06e78ca9);
const $3395fdb7c7788386$export$f57d5d3f8ce40ac2 = 'adminHeaderAndFooterConfig';
const $3395fdb7c7788386$export$6dbb84b06e78ca9 = '/admin/header-and-footer';

});

parcelRegister("kzcPl", function(module, exports) {

$parcel$export(module.exports, "ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE", () => $a85fb93a41cf2970$export$e7cba70eb2004729);
$parcel$export(module.exports, "PATH_NAME", () => $a85fb93a41cf2970$export$59e8eaf2c1cf7d28);
$parcel$export(module.exports, "ADMIN_TEMPLATES_AND_BLUEPRINTS_SUB_EXPERIENCES", () => $a85fb93a41cf2970$export$8726b5b334ad0749);

var $irVI7 = parcelRequire("irVI7");
const $a85fb93a41cf2970$export$e7cba70eb2004729 = 'adminTemplatesAndBlueprints';
const $a85fb93a41cf2970$export$59e8eaf2c1cf7d28 = '/admin/templates-and-blueprints';
const $a85fb93a41cf2970$export$8726b5b334ad0749 = [
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE)
];

});

parcelRegister("jPtik", function(module, exports) {

$parcel$export(module.exports, "ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE", () => $877d602a9e3b74d4$export$3b900d9a0f807a35);
$parcel$export(module.exports, "DEFAULT_THEME_VALUE", () => $877d602a9e3b74d4$export$99fd23db6b16a233);
$parcel$export(module.exports, "DEFAULT_LANGUAGE_VALUE", () => $877d602a9e3b74d4$export$c73844cf6c80166);
const $877d602a9e3b74d4$export$3b900d9a0f807a35 = 'adminConfigureCodeMacro';
const $877d602a9e3b74d4$export$99fd23db6b16a233 = 'Confluence';
const $877d602a9e3b74d4$export$c73844cf6c80166 = 'Java';

});

parcelRegister("5vGLM", function(module, exports) {

$parcel$export(module.exports, "ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE", () => $18527396bdb04510$export$5ab36823e88567de);
$parcel$export(module.exports, "EXTERNAL_LINKS_LEARN_MORE_LINK", () => $18527396bdb04510$export$40326e81f7c56c6a);
$parcel$export(module.exports, "MAX_SAFE_JAVA_INTEGER", () => $18527396bdb04510$export$8802c1db742ad689);
const $18527396bdb04510$export$5ab36823e88567de = 'securityConfiguration';
const $18527396bdb04510$export$40326e81f7c56c6a = 'https://support.atlassian.com/confluence-cloud/docs/hide-external-links-from-search-engines/';
const $18527396bdb04510$export$8802c1db742ad689 = 2147483647;

});

parcelRegister("dWfBt", function(module, exports) {

$parcel$export(module.exports, "ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE", () => $3252933457ee5bfd$export$1c3a7fb1674ebcd2);
const $3252933457ee5bfd$export$1c3a7fb1674ebcd2 = 'adminApplicationNavigator';
const $3252933457ee5bfd$export$59e8eaf2c1cf7d28 = '/admin/application-navigator';

});

parcelRegister("4l9JY", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_START_INDEX", () => $bd0500c03ad06aff$export$eb9c69e3a09b9217);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bd0500c03ad06aff$export$5716e8bcb003888d);
$parcel$export(module.exports, "SPACE_STATUS_TRASHED", () => $bd0500c03ad06aff$export$717a6bceadab3608);
$parcel$export(module.exports, "POLL_INTERVAL_MS", () => $bd0500c03ad06aff$export$ee14340141c11674);
$parcel$export(module.exports, "ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE", () => $bd0500c03ad06aff$export$43b26519b9b8a3e);
// Server expects the "after" parameter as a string index
const $bd0500c03ad06aff$export$eb9c69e3a09b9217 = '-1';
const $bd0500c03ad06aff$export$5716e8bcb003888d = 20;
const $bd0500c03ad06aff$export$717a6bceadab3608 = 'trashed';
const $bd0500c03ad06aff$export$ee14340141c11674 = 5000;
const $bd0500c03ad06aff$export$43b26519b9b8a3e = 'adminTrashedSpaces';

});

parcelRegister("434W4", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_FILE_EXTENSIONS", () => $b6c44f979bbed03e$export$417e5fe1d0de6e47);
$parcel$export(module.exports, "IMPORT_STATUS_CHECK_POLL_INTERVAL_MS", () => $b6c44f979bbed03e$export$42f152cabc617ec2);
$parcel$export(module.exports, "ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE", () => $b6c44f979bbed03e$export$5f9abcd3ce58c0ab);
$parcel$export(module.exports, "MEDIA_AUTH_PROVIDER_FIVE_MIN_TIMEOUT", () => $b6c44f979bbed03e$export$61387ee612136e90);
$parcel$export(module.exports, "CLOUD_MIGRATION_ASSISTANT_LINK", () => $b6c44f979bbed03e$export$9e3220b2979f5262);
$parcel$export(module.exports, "EXPORT_HELP_LINK", () => $b6c44f979bbed03e$export$ebe1d3a4348867c4);
// XMLs or CSVs should be in a zip file
const $b6c44f979bbed03e$export$417e5fe1d0de6e47 = [
    '.zip'
];
const $b6c44f979bbed03e$export$42f152cabc617ec2 = 1500;
const $b6c44f979bbed03e$export$5f9abcd3ce58c0ab = 'adminImportSpaces';
const $b6c44f979bbed03e$export$61387ee612136e90 = 300000;
const $b6c44f979bbed03e$export$9e3220b2979f5262 = 'https://marketplace.atlassian.com/apps/1219672/cloud-migration-assistant-for-confluence';
const $b6c44f979bbed03e$export$ebe1d3a4348867c4 = 'https://confluence.atlassian.com/doc/export-content-to-word-pdf-html-and-xml-139475.html#ExportContenttoWord,PDF,HTMLandXML-ExportmultiplepagestoHTML,XML,orPDF';

});

parcelRegister("2i0P8", function(module, exports) {

$parcel$export(module.exports, "ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE", () => $ffc87555304a609f$export$8b897d36b093ccf1);
$parcel$export(module.exports, "POLL_INTERVAL_MS", () => $ffc87555304a609f$export$ee14340141c11674);
$parcel$export(module.exports, "APP_LINKS_URL", () => $ffc87555304a609f$export$765b83ed862a0ed);
const $ffc87555304a609f$export$8b897d36b093ccf1 = 'adminJiraMacroRepair';
const $ffc87555304a609f$export$ee14340141c11674 = 1000;
const $ffc87555304a609f$export$765b83ed862a0ed = '/wiki/plugins/servlet/applinks/listApplicationLinks';

});

parcelRegister("9JmJC", function(module, exports) {

$parcel$export(module.exports, "ADMIN_MACRO_USAGE_ANALYTICS_SOURCE", () => $3381874ada981275$export$4ad87fa408071f9e);
const $3381874ada981275$export$4ad87fa408071f9e = 'adminMacroUsage';

});

parcelRegister("ft9Jc", function(module, exports) {

$parcel$export(module.exports, "ADMIN_THEMES_ANALYTICS_SOURCE", () => $5b008143e5994a1d$export$5b9a48b5dd6a4ea2);
const $5b008143e5994a1d$export$5b9a48b5dd6a4ea2 = 'adminThemes';

});

parcelRegister("fmC2G", function(module, exports) {

$parcel$export(module.exports, "ADMIN_PDF_EXPORT_ANALYTICS_SOURCE", () => $2d4e85d5268f55f9$export$546ba186ec91e3c9);
$parcel$export(module.exports, "STYLESHEET_SUPPORT_DOC_URL", () => $2d4e85d5268f55f9$export$dec669626e46bbfe);
const $2d4e85d5268f55f9$export$546ba186ec91e3c9 = 'adminPdfExport';
const $2d4e85d5268f55f9$export$dec669626e46bbfe = 'https://support.atlassian.com/confluence-cloud/docs/customize-exports-to-pdf/';

});

parcelRegister("l5PUQ", function(module, exports) {

$parcel$export(module.exports, "ADMIN_USER_ACCESS_ANALYTICS_SOURCE", () => $794cae3221ca3442$export$ccc7dd6c48bfb65d);
$parcel$export(module.exports, "SPACE_PERMS_REPORT_POLL_INTERVAL_MS", () => $794cae3221ca3442$export$728435b9c77444c);
$parcel$export(module.exports, "PermissionResultType", () => $794cae3221ca3442$export$37d3310174fb25af);
const $794cae3221ca3442$export$ccc7dd6c48bfb65d = 'adminUserAccess';
const $794cae3221ca3442$export$728435b9c77444c = 500;
var $794cae3221ca3442$export$37d3310174fb25af = /*#__PURE__*/ function(PermissionResultType) {
    PermissionResultType["ALLOWED"] = "ALLOWED";
    PermissionResultType["DENIED"] = "DENIED";
    PermissionResultType["INHERITED"] = "INHERITED";
    PermissionResultType["IRRELEVANT"] = "IRRELEVANT";
    return PermissionResultType;
}({});

});

parcelRegister("1qi64", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLErrors", () => $d21c0c334b6e5f18$export$111dc1efdba9a9dc);
const $d21c0c334b6e5f18$export$111dc1efdba9a9dc = (errors, statusCodeHandler)=>{
    errors?.forEach((error)=>{
        if (!error) return;
        // If the error is coming from GraphQL service, extension is an object as typed in GraphQLError
        // If it's coming from Monolith, it's an array as typed in ConfluenceMutationErrorExtension
        const extension = Array.isArray(error.extensions) ? error.extensions[0] : error.extensions;
        if (extension && extension.statusCode && statusCodeHandler) {
            const errorHandler = statusCodeHandler[extension.statusCode];
            const customErrorMessage = typeof errorHandler === 'function' ? errorHandler(extension) : errorHandler;
            // errorHandler(extension) can return a ReactNode. In that case, we put that into "messageRichText".
            const finalErrorMessage = typeof customErrorMessage === 'string' ? customErrorMessage : error.message;
            const errorObject = new Error(finalErrorMessage);
            errorObject.isGraphQLError = true;
            errorObject.messageRichText = typeof customErrorMessage !== 'string' ? customErrorMessage : undefined;
            throw errorObject;
        }
        if (error.message) {
            const errorObject = new Error(error.message);
            errorObject.isGraphQLError = true;
            throw errorObject;
        }
        throw error;
    });
};

});

parcelRegister("hcgQ3", function(module, exports) {

let $c8509e6fcefb7b0f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c8509e6fcefb7b0f$var$load("iAaum"),
    $c8509e6fcefb7b0f$var$load("1ISAt"),
    $c8509e6fcefb7b0f$var$load("mKoWX"),
    $c8509e6fcefb7b0f$var$load("6vzdH"),
    $c8509e6fcefb7b0f$var$load("hIYCb"),
    $c8509e6fcefb7b0f$var$load("fNL1b"),
    $c8509e6fcefb7b0f$var$load("9MRDB"),
    $c8509e6fcefb7b0f$var$load("cxsa4"),
    $c8509e6fcefb7b0f$var$load("jRzT2"),
    $c8509e6fcefb7b0f$var$load("7VwsU"),
    $c8509e6fcefb7b0f$var$load("fsZ6i"),
    $c8509e6fcefb7b0f$var$load("eAnbE"),
    $c8509e6fcefb7b0f$var$load("hzK1f"),
    $c8509e6fcefb7b0f$var$load("fqrMn"),
    $c8509e6fcefb7b0f$var$load("fYi1a"),
    $c8509e6fcefb7b0f$var$load("bjzRn"),
    $c8509e6fcefb7b0f$var$load("8mzoy"),
    $c8509e6fcefb7b0f$var$load("7a9CL"),
    $c8509e6fcefb7b0f$var$load("ivQYH"),
    $c8509e6fcefb7b0f$var$load("8pE8S"),
    $c8509e6fcefb7b0f$var$load("9Bu2S"),
    $c8509e6fcefb7b0f$var$load("42vdC"),
    $c8509e6fcefb7b0f$var$load("P5iE2"),
    $c8509e6fcefb7b0f$var$load("6ACCg"),
    $c8509e6fcefb7b0f$var$load("kIjBt"),
    $c8509e6fcefb7b0f$var$load("c6MKV"),
    $c8509e6fcefb7b0f$var$load("aZinD"),
    $c8509e6fcefb7b0f$var$load("kjZZD"),
    $c8509e6fcefb7b0f$var$load("aGZFn"),
    $c8509e6fcefb7b0f$var$load("6qiXX"),
    $c8509e6fcefb7b0f$var$load("ffEVr"),
    $c8509e6fcefb7b0f$var$load("joJy8"),
    $c8509e6fcefb7b0f$var$load("aHE9G"),
    $c8509e6fcefb7b0f$var$load("7uWW8")
]).then(()=>parcelRequire('1c1P5'));

});

parcelRegister("qmKXE", function(module, exports) {

let $04f414c6f33ce75d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $04f414c6f33ce75d$var$load("iAaum"),
    $04f414c6f33ce75d$var$load("6vzdH"),
    $04f414c6f33ce75d$var$load("hIYCb"),
    $04f414c6f33ce75d$var$load("fNL1b"),
    $04f414c6f33ce75d$var$load("gfmXS"),
    $04f414c6f33ce75d$var$load("9MRDB"),
    $04f414c6f33ce75d$var$load("jRzT2"),
    $04f414c6f33ce75d$var$load("7VwsU"),
    $04f414c6f33ce75d$var$load("fsZ6i"),
    $04f414c6f33ce75d$var$load("eAnbE"),
    $04f414c6f33ce75d$var$load("hzK1f"),
    $04f414c6f33ce75d$var$load("fqrMn"),
    $04f414c6f33ce75d$var$load("fYi1a"),
    $04f414c6f33ce75d$var$load("bjzRn"),
    $04f414c6f33ce75d$var$load("8mzoy"),
    $04f414c6f33ce75d$var$load("7a9CL"),
    $04f414c6f33ce75d$var$load("ivQYH"),
    $04f414c6f33ce75d$var$load("8pE8S"),
    $04f414c6f33ce75d$var$load("9Bu2S"),
    $04f414c6f33ce75d$var$load("42vdC"),
    $04f414c6f33ce75d$var$load("P5iE2"),
    $04f414c6f33ce75d$var$load("6ACCg"),
    $04f414c6f33ce75d$var$load("kIjBt"),
    $04f414c6f33ce75d$var$load("ffEVr"),
    $04f414c6f33ce75d$var$load("c6MKV"),
    $04f414c6f33ce75d$var$load("joJy8"),
    $04f414c6f33ce75d$var$load("aHE9G"),
    $04f414c6f33ce75d$var$load("aZinD"),
    $04f414c6f33ce75d$var$load("hMzlw")
]).then(()=>parcelRequire('lkTIR'));

});

parcelRegister("hBelT", function(module, exports) {

let $cd010660c30e296e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cd010660c30e296e$var$load("iAaum"),
    $cd010660c30e296e$var$load("6vzdH"),
    $cd010660c30e296e$var$load("9MRDB"),
    $cd010660c30e296e$var$load("jRzT2"),
    $cd010660c30e296e$var$load("c6MKV"),
    $cd010660c30e296e$var$load("aZinD"),
    $cd010660c30e296e$var$load("joJy8"),
    $cd010660c30e296e$var$load("aHE9G"),
    $cd010660c30e296e$var$load("lh6fT")
]).then(()=>parcelRequire('f9aTe'));

});

parcelRegister("2QLms", function(module, exports) {

let $21352d079a47254d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $21352d079a47254d$var$load("iAaum"),
    $21352d079a47254d$var$load("jqXtk"),
    $21352d079a47254d$var$load("6vzdH"),
    $21352d079a47254d$var$load("koo1l"),
    $21352d079a47254d$var$load("ikem6"),
    $21352d079a47254d$var$load("cLErX"),
    $21352d079a47254d$var$load("hkGfe"),
    $21352d079a47254d$var$load("5B7oK"),
    $21352d079a47254d$var$load("9MRDB"),
    $21352d079a47254d$var$load("jRzT2"),
    $21352d079a47254d$var$load("h4Nf7"),
    $21352d079a47254d$var$load("lfEn7"),
    $21352d079a47254d$var$load("2BIkk"),
    $21352d079a47254d$var$load("lJxwk"),
    $21352d079a47254d$var$load("c6MKV"),
    $21352d079a47254d$var$load("aZinD"),
    $21352d079a47254d$var$load("ffEVr"),
    $21352d079a47254d$var$load("joJy8"),
    $21352d079a47254d$var$load("aHE9G"),
    $21352d079a47254d$var$load("8iU4E")
]).then(()=>parcelRequire('46IN4'));

});

parcelRegister("dgW4F", function(module, exports) {

let $9a99d14e8293ed82$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9a99d14e8293ed82$var$load("iAaum"),
    $9a99d14e8293ed82$var$load("6vzdH"),
    $9a99d14e8293ed82$var$load("9MRDB"),
    $9a99d14e8293ed82$var$load("jRzT2"),
    $9a99d14e8293ed82$var$load("c6MKV"),
    $9a99d14e8293ed82$var$load("aZinD"),
    $9a99d14e8293ed82$var$load("joJy8"),
    $9a99d14e8293ed82$var$load("aHE9G"),
    $9a99d14e8293ed82$var$load("lQHJf")
]).then(()=>parcelRequire('2nzCJ'));

});

parcelRegister("924jR", function(module, exports) {

let $6937a6b597424880$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6937a6b597424880$var$load("iAaum"),
    $6937a6b597424880$var$load("6vzdH"),
    $6937a6b597424880$var$load("9MRDB"),
    $6937a6b597424880$var$load("jRzT2"),
    $6937a6b597424880$var$load("5Smk7"),
    $6937a6b597424880$var$load("c6MKV"),
    $6937a6b597424880$var$load("aZinD"),
    $6937a6b597424880$var$load("joJy8"),
    $6937a6b597424880$var$load("aHE9G"),
    $6937a6b597424880$var$load("ffEVr"),
    $6937a6b597424880$var$load("lMnCe")
]).then(()=>parcelRequire('5XJaz'));

});

parcelRegister("jsdxY", function(module, exports) {

let $e29b23fb87d84e51$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e29b23fb87d84e51$var$load("iAaum"),
    $e29b23fb87d84e51$var$load("6vzdH"),
    $e29b23fb87d84e51$var$load("9MRDB"),
    $e29b23fb87d84e51$var$load("jRzT2"),
    $e29b23fb87d84e51$var$load("ikem6"),
    $e29b23fb87d84e51$var$load("c6MKV"),
    $e29b23fb87d84e51$var$load("aZinD"),
    $e29b23fb87d84e51$var$load("ffEVr"),
    $e29b23fb87d84e51$var$load("joJy8"),
    $e29b23fb87d84e51$var$load("aHE9G"),
    $e29b23fb87d84e51$var$load("kaFPr")
]).then(()=>parcelRequire('2C4l7'));

});

parcelRegister("bHUR5", function(module, exports) {

let $885fd02030f26037$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $885fd02030f26037$var$load("iAaum"),
    $885fd02030f26037$var$load("6vzdH"),
    $885fd02030f26037$var$load("ikem6"),
    $885fd02030f26037$var$load("2BIkk"),
    $885fd02030f26037$var$load("lJxwk"),
    $885fd02030f26037$var$load("cgwQl"),
    $885fd02030f26037$var$load("5YJ6r"),
    $885fd02030f26037$var$load("8Ttlq"),
    $885fd02030f26037$var$load("2DNIK"),
    $885fd02030f26037$var$load("9MRDB"),
    $885fd02030f26037$var$load("jRzT2"),
    $885fd02030f26037$var$load("aZinD"),
    $885fd02030f26037$var$load("avCUM"),
    $885fd02030f26037$var$load("aO7Ry"),
    $885fd02030f26037$var$load("ffEVr"),
    $885fd02030f26037$var$load("joJy8"),
    $885fd02030f26037$var$load("aHE9G"),
    $885fd02030f26037$var$load("3YiRE")
]).then(()=>parcelRequire('iR5x9'));

});

parcelRegister("hlqlA", function(module, exports) {

let $ca08d5daaf6176bf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ca08d5daaf6176bf$var$load("iAaum"),
    $ca08d5daaf6176bf$var$load("6vzdH"),
    $ca08d5daaf6176bf$var$load("7VwsU"),
    $ca08d5daaf6176bf$var$load("fsZ6i"),
    $ca08d5daaf6176bf$var$load("gfmXS"),
    $ca08d5daaf6176bf$var$load("9MRDB"),
    $ca08d5daaf6176bf$var$load("jRzT2"),
    $ca08d5daaf6176bf$var$load("c6MKV"),
    $ca08d5daaf6176bf$var$load("aZinD"),
    $ca08d5daaf6176bf$var$load("ffEVr"),
    $ca08d5daaf6176bf$var$load("joJy8"),
    $ca08d5daaf6176bf$var$load("aHE9G"),
    $ca08d5daaf6176bf$var$load("iOJdB")
]).then(()=>parcelRequire('452sv'));

});

parcelRegister("fpXK4", function(module, exports) {

let $b397885df9b4cb1b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b397885df9b4cb1b$var$load("iAaum"),
    $b397885df9b4cb1b$var$load("6vzdH"),
    $b397885df9b4cb1b$var$load("9MRDB"),
    $b397885df9b4cb1b$var$load("jRzT2"),
    $b397885df9b4cb1b$var$load("c6MKV"),
    $b397885df9b4cb1b$var$load("aZinD"),
    $b397885df9b4cb1b$var$load("ffEVr"),
    $b397885df9b4cb1b$var$load("joJy8"),
    $b397885df9b4cb1b$var$load("aHE9G"),
    $b397885df9b4cb1b$var$load("4Z5Uh")
]).then(()=>parcelRequire('f10rR'));

});

parcelRegister("eOcNM", function(module, exports) {

let $ac7faa6637f3f3db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ac7faa6637f3f3db$var$load("iAaum"),
    $ac7faa6637f3f3db$var$load("6vzdH"),
    $ac7faa6637f3f3db$var$load("9MRDB"),
    $ac7faa6637f3f3db$var$load("jRzT2"),
    $ac7faa6637f3f3db$var$load("ikem6"),
    $ac7faa6637f3f3db$var$load("ffEVr"),
    $ac7faa6637f3f3db$var$load("f4DD6")
]).then(()=>parcelRequire('6JHmj'));

});

parcelRegister("hgcpx", function(module, exports) {

let $c90d8ed9bc21c6b1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c90d8ed9bc21c6b1$var$load("iAaum"),
    $c90d8ed9bc21c6b1$var$load("6vzdH"),
    $c90d8ed9bc21c6b1$var$load("5Smk7"),
    $c90d8ed9bc21c6b1$var$load("9MRDB"),
    $c90d8ed9bc21c6b1$var$load("jRzT2"),
    $c90d8ed9bc21c6b1$var$load("joJy8"),
    $c90d8ed9bc21c6b1$var$load("aHE9G"),
    $c90d8ed9bc21c6b1$var$load("6KDUv")
]).then(()=>parcelRequire('iiqL3'));

});

parcelRegister("dPsvC", function(module, exports) {

let $a116271495ff9e79$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a116271495ff9e79$var$load("iAaum"),
    $a116271495ff9e79$var$load("6vzdH"),
    $a116271495ff9e79$var$load("9MRDB"),
    $a116271495ff9e79$var$load("jRzT2"),
    $a116271495ff9e79$var$load("c6MKV"),
    $a116271495ff9e79$var$load("aZinD"),
    $a116271495ff9e79$var$load("ffEVr"),
    $a116271495ff9e79$var$load("joJy8"),
    $a116271495ff9e79$var$load("aHE9G"),
    $a116271495ff9e79$var$load("9BxhS")
]).then(()=>parcelRequire('5JXtG'));

});

parcelRegister("avThV", function(module, exports) {

let $7a77afb4be6564fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7a77afb4be6564fe$var$load("1ISAt"),
    $7a77afb4be6564fe$var$load("mKoWX"),
    $7a77afb4be6564fe$var$load("jqXtk"),
    $7a77afb4be6564fe$var$load("6vzdH"),
    $7a77afb4be6564fe$var$load("8DoxJ"),
    $7a77afb4be6564fe$var$load("6gqpV"),
    $7a77afb4be6564fe$var$load("9MRDB"),
    $7a77afb4be6564fe$var$load("14XOE"),
    $7a77afb4be6564fe$var$load("cKXbf"),
    $7a77afb4be6564fe$var$load("jRzT2"),
    $7a77afb4be6564fe$var$load("koo1l"),
    $7a77afb4be6564fe$var$load("iQ0Jm"),
    $7a77afb4be6564fe$var$load("7sZmN"),
    $7a77afb4be6564fe$var$load("gLxW3"),
    $7a77afb4be6564fe$var$load("l4Ek9"),
    $7a77afb4be6564fe$var$load("h4Nf7"),
    $7a77afb4be6564fe$var$load("lfEn7"),
    $7a77afb4be6564fe$var$load("2BIkk"),
    $7a77afb4be6564fe$var$load("lJxwk"),
    $7a77afb4be6564fe$var$load("hKqxh"),
    $7a77afb4be6564fe$var$load("7sseo"),
    $7a77afb4be6564fe$var$load("dTsOE"),
    $7a77afb4be6564fe$var$load("kjZZD"),
    $7a77afb4be6564fe$var$load("c6MKV"),
    $7a77afb4be6564fe$var$load("aZinD"),
    $7a77afb4be6564fe$var$load("iAaum"),
    $7a77afb4be6564fe$var$load("ffEVr"),
    $7a77afb4be6564fe$var$load("joJy8"),
    $7a77afb4be6564fe$var$load("aHE9G"),
    $7a77afb4be6564fe$var$load("5mKg8")
]).then(()=>parcelRequire('fyrrY'));

});


parcelRegister("4NvKO", function(module, exports) {

$parcel$export(module.exports, "SpaceOverviewLoader", () => $ca9b65bd0903573c$export$de3a38bd9f6fbd0c);

var $jmjWc = parcelRequire("jmjWc");


const $ca9b65bd0903573c$export$de3a38bd9f6fbd0c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xds6M",
    name: "SpaceOverviewLoader",
    loader: async ()=>(await (parcelRequire("e21Cl"))).SpaceOverview
});

});
parcelRegister("e21Cl", function(module, exports) {

let $a37281cd1b1bef9b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a37281cd1b1bef9b$var$load("ceWcd"),
    $a37281cd1b1bef9b$var$load("7CYot"),
    $a37281cd1b1bef9b$var$load("1m9tW"),
    $a37281cd1b1bef9b$var$load("7J7Dl"),
    $a37281cd1b1bef9b$var$load("fKO1l"),
    $a37281cd1b1bef9b$var$load("iOXIX"),
    $a37281cd1b1bef9b$var$load("8RtpX"),
    $a37281cd1b1bef9b$var$load("8I0BV"),
    $a37281cd1b1bef9b$var$load("aQ2RW"),
    $a37281cd1b1bef9b$var$load("j8YcG"),
    $a37281cd1b1bef9b$var$load("jSQlw"),
    $a37281cd1b1bef9b$var$load("eVFYI"),
    $a37281cd1b1bef9b$var$load("iQFHB"),
    $a37281cd1b1bef9b$var$load("cP6Mx"),
    $a37281cd1b1bef9b$var$load("32ARE"),
    $a37281cd1b1bef9b$var$load("c62LN"),
    $a37281cd1b1bef9b$var$load("8t38R"),
    $a37281cd1b1bef9b$var$load("dkj9b"),
    $a37281cd1b1bef9b$var$load("4p9Qk"),
    $a37281cd1b1bef9b$var$load("3PQqe"),
    $a37281cd1b1bef9b$var$load("2XCZ0"),
    $a37281cd1b1bef9b$var$load("84iyu"),
    $a37281cd1b1bef9b$var$load("c2m9M"),
    $a37281cd1b1bef9b$var$load("esMxL"),
    $a37281cd1b1bef9b$var$load("5IuQb"),
    $a37281cd1b1bef9b$var$load("kdcrE"),
    $a37281cd1b1bef9b$var$load("k0Etr"),
    $a37281cd1b1bef9b$var$load("8fhzw"),
    $a37281cd1b1bef9b$var$load("9u4sz"),
    $a37281cd1b1bef9b$var$load("i3TSs"),
    $a37281cd1b1bef9b$var$load("gm70k"),
    $a37281cd1b1bef9b$var$load("5w3tp"),
    $a37281cd1b1bef9b$var$load("cKXbf"),
    $a37281cd1b1bef9b$var$load("4T4bq"),
    $a37281cd1b1bef9b$var$load("jPS1u"),
    $a37281cd1b1bef9b$var$load("3UR1K"),
    $a37281cd1b1bef9b$var$load("4Oj5y"),
    $a37281cd1b1bef9b$var$load("jRzT2"),
    $a37281cd1b1bef9b$var$load("lKccm"),
    $a37281cd1b1bef9b$var$load("dY7M5"),
    $a37281cd1b1bef9b$var$load("iBm1B"),
    $a37281cd1b1bef9b$var$load("2ZlZi"),
    $a37281cd1b1bef9b$var$load("gCIfF"),
    $a37281cd1b1bef9b$var$load("1ZAFx"),
    $a37281cd1b1bef9b$var$load("lm5in"),
    $a37281cd1b1bef9b$var$load("7gjV3"),
    $a37281cd1b1bef9b$var$load("koo1l"),
    $a37281cd1b1bef9b$var$load("b91tv"),
    $a37281cd1b1bef9b$var$load("k6XmX"),
    $a37281cd1b1bef9b$var$load("ftJgg"),
    $a37281cd1b1bef9b$var$load("l4Ek9"),
    $a37281cd1b1bef9b$var$load("fwbht"),
    $a37281cd1b1bef9b$var$load("h4Nf7"),
    $a37281cd1b1bef9b$var$load("lfEn7"),
    $a37281cd1b1bef9b$var$load("cdEjw"),
    $a37281cd1b1bef9b$var$load("ipK41"),
    $a37281cd1b1bef9b$var$load("2F69B"),
    $a37281cd1b1bef9b$var$load("gkMTK"),
    $a37281cd1b1bef9b$var$load("2eUdC"),
    $a37281cd1b1bef9b$var$load("leIbB"),
    $a37281cd1b1bef9b$var$load("8yyrA"),
    $a37281cd1b1bef9b$var$load("2BIkk"),
    $a37281cd1b1bef9b$var$load("lJxwk"),
    $a37281cd1b1bef9b$var$load("iZxBI"),
    $a37281cd1b1bef9b$var$load("58UdM"),
    $a37281cd1b1bef9b$var$load("aLgYQ"),
    $a37281cd1b1bef9b$var$load("4Qstt"),
    $a37281cd1b1bef9b$var$load("kVNpE"),
    $a37281cd1b1bef9b$var$load("5odbj"),
    $a37281cd1b1bef9b$var$load("i5Fj1"),
    $a37281cd1b1bef9b$var$load("931GG"),
    $a37281cd1b1bef9b$var$load("77Ha0"),
    $a37281cd1b1bef9b$var$load("hKqxh"),
    $a37281cd1b1bef9b$var$load("7sseo"),
    $a37281cd1b1bef9b$var$load("dTsOE"),
    $a37281cd1b1bef9b$var$load("g9CVe"),
    $a37281cd1b1bef9b$var$load("glQXz"),
    $a37281cd1b1bef9b$var$load("cgwQl"),
    $a37281cd1b1bef9b$var$load("5YJ6r"),
    $a37281cd1b1bef9b$var$load("5aY5g"),
    $a37281cd1b1bef9b$var$load("zogKQ"),
    $a37281cd1b1bef9b$var$load("9EpP2"),
    $a37281cd1b1bef9b$var$load("eFpF6"),
    $a37281cd1b1bef9b$var$load("1ISAt"),
    $a37281cd1b1bef9b$var$load("mKoWX"),
    $a37281cd1b1bef9b$var$load("hIYCb"),
    $a37281cd1b1bef9b$var$load("fNL1b"),
    $a37281cd1b1bef9b$var$load("1Zo7q"),
    $a37281cd1b1bef9b$var$load("ehDQZ"),
    $a37281cd1b1bef9b$var$load("2RP81"),
    $a37281cd1b1bef9b$var$load("5xdIv"),
    $a37281cd1b1bef9b$var$load("jo5F7"),
    $a37281cd1b1bef9b$var$load("aoOM9"),
    $a37281cd1b1bef9b$var$load("a9OJ4"),
    $a37281cd1b1bef9b$var$load("jdmfD"),
    $a37281cd1b1bef9b$var$load("7X7qq"),
    $a37281cd1b1bef9b$var$load("3yiZb"),
    $a37281cd1b1bef9b$var$load("jqXtk"),
    $a37281cd1b1bef9b$var$load("kGIBm"),
    $a37281cd1b1bef9b$var$load("69J1q"),
    $a37281cd1b1bef9b$var$load("eb06U"),
    $a37281cd1b1bef9b$var$load("cyGuT"),
    $a37281cd1b1bef9b$var$load("feuOx"),
    $a37281cd1b1bef9b$var$load("aZinD"),
    $a37281cd1b1bef9b$var$load("5TfXH"),
    $a37281cd1b1bef9b$var$load("kjZZD"),
    $a37281cd1b1bef9b$var$load("aGZFn"),
    $a37281cd1b1bef9b$var$load("6qah4"),
    $a37281cd1b1bef9b$var$load("iAaum"),
    $a37281cd1b1bef9b$var$load("ffEVr"),
    $a37281cd1b1bef9b$var$load("6vzdH"),
    $a37281cd1b1bef9b$var$load("1gUNx"),
    $a37281cd1b1bef9b$var$load("c6MKV"),
    $a37281cd1b1bef9b$var$load("b03Lm"),
    $a37281cd1b1bef9b$var$load("9ZnVA"),
    $a37281cd1b1bef9b$var$load("joJy8"),
    $a37281cd1b1bef9b$var$load("aHE9G"),
    $a37281cd1b1bef9b$var$load("cLErX"),
    $a37281cd1b1bef9b$var$load("hkGfe"),
    $a37281cd1b1bef9b$var$load("e66P8")
]).then(()=>parcelRequire('eiWUW'));

});


parcelRegister("ko9Ek", function(module, exports) {

$parcel$export(module.exports, "ViewPageRouteComponentLoader", () => $4cd8f2daf274114d$export$2312ebab360877df);

var $jmjWc = parcelRequire("jmjWc");

const $4cd8f2daf274114d$export$2312ebab360877df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HinAE",
    // Name is used in next/packages/view-page/src/index.ts must match
    name: "ViewPageRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("b3Jxr"))).ViewPageRouteComponent
});

});
parcelRegister("b3Jxr", function(module, exports) {

let $80d34c7ad5ec168a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $80d34c7ad5ec168a$var$load("7CYot"),
    $80d34c7ad5ec168a$var$load("1ISAt"),
    $80d34c7ad5ec168a$var$load("mKoWX"),
    $80d34c7ad5ec168a$var$load("7cc9v"),
    $80d34c7ad5ec168a$var$load("3xec3"),
    $80d34c7ad5ec168a$var$load("5IuQb"),
    $80d34c7ad5ec168a$var$load("afNiU"),
    $80d34c7ad5ec168a$var$load("FNKrB"),
    $80d34c7ad5ec168a$var$load("2RP81"),
    $80d34c7ad5ec168a$var$load("8RtpX"),
    $80d34c7ad5ec168a$var$load("8I0BV"),
    $80d34c7ad5ec168a$var$load("5xdIv"),
    $80d34c7ad5ec168a$var$load("jo5F7"),
    $80d34c7ad5ec168a$var$load("6aF03"),
    $80d34c7ad5ec168a$var$load("6gnFj"),
    $80d34c7ad5ec168a$var$load("ehUbM"),
    $80d34c7ad5ec168a$var$load("5w3tp"),
    $80d34c7ad5ec168a$var$load("aDgIB"),
    $80d34c7ad5ec168a$var$load("2F69B"),
    $80d34c7ad5ec168a$var$load("dY7M5"),
    $80d34c7ad5ec168a$var$load("c1PFV"),
    $80d34c7ad5ec168a$var$load("9WWVF"),
    $80d34c7ad5ec168a$var$load("aoOM9"),
    $80d34c7ad5ec168a$var$load("a9OJ4"),
    $80d34c7ad5ec168a$var$load("aQ2RW"),
    $80d34c7ad5ec168a$var$load("gCIfF"),
    $80d34c7ad5ec168a$var$load("jdmfD"),
    $80d34c7ad5ec168a$var$load("7X7qq"),
    $80d34c7ad5ec168a$var$load("3yiZb"),
    $80d34c7ad5ec168a$var$load("koo1l"),
    $80d34c7ad5ec168a$var$load("b91tv"),
    $80d34c7ad5ec168a$var$load("3KE3H"),
    $80d34c7ad5ec168a$var$load("domi7"),
    $80d34c7ad5ec168a$var$load("ikem6"),
    $80d34c7ad5ec168a$var$load("5Smk7"),
    $80d34c7ad5ec168a$var$load("fwbht"),
    $80d34c7ad5ec168a$var$load("h4Nf7"),
    $80d34c7ad5ec168a$var$load("lfEn7"),
    $80d34c7ad5ec168a$var$load("jqXtk"),
    $80d34c7ad5ec168a$var$load("kGIBm"),
    $80d34c7ad5ec168a$var$load("69J1q"),
    $80d34c7ad5ec168a$var$load("eb06U"),
    $80d34c7ad5ec168a$var$load("2BIkk"),
    $80d34c7ad5ec168a$var$load("lJxwk"),
    $80d34c7ad5ec168a$var$load("7VwsU"),
    $80d34c7ad5ec168a$var$load("fsZ6i"),
    $80d34c7ad5ec168a$var$load("eAnbE"),
    $80d34c7ad5ec168a$var$load("hS6TW"),
    $80d34c7ad5ec168a$var$load("77Ha0"),
    $80d34c7ad5ec168a$var$load("6nLV7"),
    $80d34c7ad5ec168a$var$load("hKqxh"),
    $80d34c7ad5ec168a$var$load("7sseo"),
    $80d34c7ad5ec168a$var$load("45SdR"),
    $80d34c7ad5ec168a$var$load("cyGuT"),
    $80d34c7ad5ec168a$var$load("dTsOE"),
    $80d34c7ad5ec168a$var$load("hzK1f"),
    $80d34c7ad5ec168a$var$load("fqrMn"),
    $80d34c7ad5ec168a$var$load("fYi1a"),
    $80d34c7ad5ec168a$var$load("bjzRn"),
    $80d34c7ad5ec168a$var$load("8mzoy"),
    $80d34c7ad5ec168a$var$load("7a9CL"),
    $80d34c7ad5ec168a$var$load("ivQYH"),
    $80d34c7ad5ec168a$var$load("8pE8S"),
    $80d34c7ad5ec168a$var$load("9Bu2S"),
    $80d34c7ad5ec168a$var$load("42vdC"),
    $80d34c7ad5ec168a$var$load("P5iE2"),
    $80d34c7ad5ec168a$var$load("6ACCg"),
    $80d34c7ad5ec168a$var$load("kIjBt"),
    $80d34c7ad5ec168a$var$load("8DoxJ"),
    $80d34c7ad5ec168a$var$load("6gqpV"),
    $80d34c7ad5ec168a$var$load("g9CVe"),
    $80d34c7ad5ec168a$var$load("feuOx"),
    $80d34c7ad5ec168a$var$load("1SiRe"),
    $80d34c7ad5ec168a$var$load("aZinD"),
    $80d34c7ad5ec168a$var$load("5TfXH"),
    $80d34c7ad5ec168a$var$load("12qzw"),
    $80d34c7ad5ec168a$var$load("cI7A0"),
    $80d34c7ad5ec168a$var$load("cgwQl"),
    $80d34c7ad5ec168a$var$load("5YJ6r"),
    $80d34c7ad5ec168a$var$load("kjZZD"),
    $80d34c7ad5ec168a$var$load("aGZFn"),
    $80d34c7ad5ec168a$var$load("hIYCb"),
    $80d34c7ad5ec168a$var$load("fNL1b"),
    $80d34c7ad5ec168a$var$load("5aY5g"),
    $80d34c7ad5ec168a$var$load("zogKQ"),
    $80d34c7ad5ec168a$var$load("fW5Fh"),
    $80d34c7ad5ec168a$var$load("6qiXX"),
    $80d34c7ad5ec168a$var$load("6qah4"),
    $80d34c7ad5ec168a$var$load("iAaum"),
    $80d34c7ad5ec168a$var$load("ffEVr"),
    $80d34c7ad5ec168a$var$load("6vzdH"),
    $80d34c7ad5ec168a$var$load("c6MKV"),
    $80d34c7ad5ec168a$var$load("b03Lm"),
    $80d34c7ad5ec168a$var$load("9ZnVA"),
    $80d34c7ad5ec168a$var$load("joJy8"),
    $80d34c7ad5ec168a$var$load("aHE9G"),
    $80d34c7ad5ec168a$var$load("cLErX"),
    $80d34c7ad5ec168a$var$load("hkGfe"),
    $80d34c7ad5ec168a$var$load("2dt2D")
]).then(()=>parcelRequire('bkGU6'));

});


parcelRegister("a9BSL", function(module, exports) {

$parcel$export(module.exports, "ViewPageLoader", () => $cc815d190cfd2b45$export$2bcf56c785109ac9);
$parcel$export(module.exports, "ViewPageLiteHeaderLoader", () => $cc815d190cfd2b45$export$f574cd97f97b4d34);
$parcel$export(module.exports, "ViewPageLiteLoader", () => $cc815d190cfd2b45$export$9a7f1112e3576698);

var $jmjWc = parcelRequire("jmjWc");
var $2w2Hu = parcelRequire("2w2Hu");

const $cc815d190cfd2b45$export$2bcf56c785109ac9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4y5Pz",
    name: "ViewPageLoader",
    loader: async ()=>(await (parcelRequire("4M17P"))).ViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});

const $cc815d190cfd2b45$export$f574cd97f97b4d34 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iZJXS",
    name: "ViewPageLiteHeaderLoader",
    loader: async ()=>(await (parcelRequire("97lre"))).ViewPageLiteHeader
});

const $cc815d190cfd2b45$export$9a7f1112e3576698 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZBqCT",
    name: "ViewPageLiteLoader",
    loader: async ()=>(await (parcelRequire("erLvA"))).ViewPageLite
});

});
parcelRegister("4M17P", function(module, exports) {

let $379c8494daf2dbb5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $379c8494daf2dbb5$var$load("ceWcd"),
    $379c8494daf2dbb5$var$load("7CYot"),
    $379c8494daf2dbb5$var$load("1m9tW"),
    $379c8494daf2dbb5$var$load("7J7Dl"),
    $379c8494daf2dbb5$var$load("iPz8n"),
    $379c8494daf2dbb5$var$load("8RtpX"),
    $379c8494daf2dbb5$var$load("8I0BV"),
    $379c8494daf2dbb5$var$load("aQ2RW"),
    $379c8494daf2dbb5$var$load("8Cixw"),
    $379c8494daf2dbb5$var$load("g7bcN"),
    $379c8494daf2dbb5$var$load("iwNdc"),
    $379c8494daf2dbb5$var$load("5RkYA"),
    $379c8494daf2dbb5$var$load("lSNJq"),
    $379c8494daf2dbb5$var$load("dJIkj"),
    $379c8494daf2dbb5$var$load("eVFYI"),
    $379c8494daf2dbb5$var$load("iQFHB"),
    $379c8494daf2dbb5$var$load("32ARE"),
    $379c8494daf2dbb5$var$load("c62LN"),
    $379c8494daf2dbb5$var$load("8t38R"),
    $379c8494daf2dbb5$var$load("dkj9b"),
    $379c8494daf2dbb5$var$load("4p9Qk"),
    $379c8494daf2dbb5$var$load("3PQqe"),
    $379c8494daf2dbb5$var$load("hRjg9"),
    $379c8494daf2dbb5$var$load("2XCZ0"),
    $379c8494daf2dbb5$var$load("84iyu"),
    $379c8494daf2dbb5$var$load("c2m9M"),
    $379c8494daf2dbb5$var$load("esMxL"),
    $379c8494daf2dbb5$var$load("5IuQb"),
    $379c8494daf2dbb5$var$load("kdcrE"),
    $379c8494daf2dbb5$var$load("k0Etr"),
    $379c8494daf2dbb5$var$load("aPxU2"),
    $379c8494daf2dbb5$var$load("8fhzw"),
    $379c8494daf2dbb5$var$load("7BrEE"),
    $379c8494daf2dbb5$var$load("3QAHI"),
    $379c8494daf2dbb5$var$load("4e15z"),
    $379c8494daf2dbb5$var$load("1jZDC"),
    $379c8494daf2dbb5$var$load("1wN7j"),
    $379c8494daf2dbb5$var$load("dTVzs"),
    $379c8494daf2dbb5$var$load("6aF03"),
    $379c8494daf2dbb5$var$load("3S9pV"),
    $379c8494daf2dbb5$var$load("9u4sz"),
    $379c8494daf2dbb5$var$load("i3TSs"),
    $379c8494daf2dbb5$var$load("gm70k"),
    $379c8494daf2dbb5$var$load("kCTMZ"),
    $379c8494daf2dbb5$var$load("5w3tp"),
    $379c8494daf2dbb5$var$load("cKXbf"),
    $379c8494daf2dbb5$var$load("2AOLi"),
    $379c8494daf2dbb5$var$load("4T4bq"),
    $379c8494daf2dbb5$var$load("jPS1u"),
    $379c8494daf2dbb5$var$load("3UR1K"),
    $379c8494daf2dbb5$var$load("4Oj5y"),
    $379c8494daf2dbb5$var$load("jRzT2"),
    $379c8494daf2dbb5$var$load("lKccm"),
    $379c8494daf2dbb5$var$load("dY7M5"),
    $379c8494daf2dbb5$var$load("2ZlZi"),
    $379c8494daf2dbb5$var$load("ckJgn"),
    $379c8494daf2dbb5$var$load("2u53D"),
    $379c8494daf2dbb5$var$load("eRWKD"),
    $379c8494daf2dbb5$var$load("7a4au"),
    $379c8494daf2dbb5$var$load("iB9CC"),
    $379c8494daf2dbb5$var$load("6OVfM"),
    $379c8494daf2dbb5$var$load("fiwvK"),
    $379c8494daf2dbb5$var$load("gCIfF"),
    $379c8494daf2dbb5$var$load("lPCqB"),
    $379c8494daf2dbb5$var$load("1ZAFx"),
    $379c8494daf2dbb5$var$load("bRD8g"),
    $379c8494daf2dbb5$var$load("lm5in"),
    $379c8494daf2dbb5$var$load("7gjV3"),
    $379c8494daf2dbb5$var$load("koo1l"),
    $379c8494daf2dbb5$var$load("b91tv"),
    $379c8494daf2dbb5$var$load("k6XmX"),
    $379c8494daf2dbb5$var$load("l4Ek9"),
    $379c8494daf2dbb5$var$load("fwbht"),
    $379c8494daf2dbb5$var$load("h4Nf7"),
    $379c8494daf2dbb5$var$load("lfEn7"),
    $379c8494daf2dbb5$var$load("cdEjw"),
    $379c8494daf2dbb5$var$load("ipK41"),
    $379c8494daf2dbb5$var$load("2F69B"),
    $379c8494daf2dbb5$var$load("gkMTK"),
    $379c8494daf2dbb5$var$load("bGaMz"),
    $379c8494daf2dbb5$var$load("2eUdC"),
    $379c8494daf2dbb5$var$load("leIbB"),
    $379c8494daf2dbb5$var$load("8yyrA"),
    $379c8494daf2dbb5$var$load("2BIkk"),
    $379c8494daf2dbb5$var$load("lJxwk"),
    $379c8494daf2dbb5$var$load("lHceO"),
    $379c8494daf2dbb5$var$load("7VwsU"),
    $379c8494daf2dbb5$var$load("fsZ6i"),
    $379c8494daf2dbb5$var$load("931GG"),
    $379c8494daf2dbb5$var$load("77Ha0"),
    $379c8494daf2dbb5$var$load("6nLV7"),
    $379c8494daf2dbb5$var$load("9MqiH"),
    $379c8494daf2dbb5$var$load("hKqxh"),
    $379c8494daf2dbb5$var$load("7sseo"),
    $379c8494daf2dbb5$var$load("8Sd4b"),
    $379c8494daf2dbb5$var$load("dTsOE"),
    $379c8494daf2dbb5$var$load("7jSfd"),
    $379c8494daf2dbb5$var$load("6ACCg"),
    $379c8494daf2dbb5$var$load("4HZlX"),
    $379c8494daf2dbb5$var$load("fe4be"),
    $379c8494daf2dbb5$var$load("kDqHr"),
    $379c8494daf2dbb5$var$load("8DoxJ"),
    $379c8494daf2dbb5$var$load("j87NQ"),
    $379c8494daf2dbb5$var$load("bZxqd"),
    $379c8494daf2dbb5$var$load("9gJO7"),
    $379c8494daf2dbb5$var$load("5rp59"),
    $379c8494daf2dbb5$var$load("6gqpV"),
    $379c8494daf2dbb5$var$load("g9CVe"),
    $379c8494daf2dbb5$var$load("aikvX"),
    $379c8494daf2dbb5$var$load("jrKPL"),
    $379c8494daf2dbb5$var$load("glQXz"),
    $379c8494daf2dbb5$var$load("12qzw"),
    $379c8494daf2dbb5$var$load("cI7A0"),
    $379c8494daf2dbb5$var$load("cgwQl"),
    $379c8494daf2dbb5$var$load("5YJ6r"),
    $379c8494daf2dbb5$var$load("5aY5g"),
    $379c8494daf2dbb5$var$load("zogKQ"),
    $379c8494daf2dbb5$var$load("fW5Fh"),
    $379c8494daf2dbb5$var$load("9EpP2"),
    $379c8494daf2dbb5$var$load("eFpF6"),
    $379c8494daf2dbb5$var$load("6qiXX"),
    $379c8494daf2dbb5$var$load("1ISAt"),
    $379c8494daf2dbb5$var$load("mKoWX"),
    $379c8494daf2dbb5$var$load("hIYCb"),
    $379c8494daf2dbb5$var$load("fNL1b"),
    $379c8494daf2dbb5$var$load("1Zo7q"),
    $379c8494daf2dbb5$var$load("ehDQZ"),
    $379c8494daf2dbb5$var$load("2RP81"),
    $379c8494daf2dbb5$var$load("5xdIv"),
    $379c8494daf2dbb5$var$load("jo5F7"),
    $379c8494daf2dbb5$var$load("aoOM9"),
    $379c8494daf2dbb5$var$load("a9OJ4"),
    $379c8494daf2dbb5$var$load("jdmfD"),
    $379c8494daf2dbb5$var$load("7X7qq"),
    $379c8494daf2dbb5$var$load("3yiZb"),
    $379c8494daf2dbb5$var$load("jqXtk"),
    $379c8494daf2dbb5$var$load("kGIBm"),
    $379c8494daf2dbb5$var$load("69J1q"),
    $379c8494daf2dbb5$var$load("eb06U"),
    $379c8494daf2dbb5$var$load("cyGuT"),
    $379c8494daf2dbb5$var$load("feuOx"),
    $379c8494daf2dbb5$var$load("aZinD"),
    $379c8494daf2dbb5$var$load("5TfXH"),
    $379c8494daf2dbb5$var$load("kjZZD"),
    $379c8494daf2dbb5$var$load("aGZFn"),
    $379c8494daf2dbb5$var$load("6qah4"),
    $379c8494daf2dbb5$var$load("iAaum"),
    $379c8494daf2dbb5$var$load("ffEVr"),
    $379c8494daf2dbb5$var$load("6vzdH"),
    $379c8494daf2dbb5$var$load("1gUNx"),
    $379c8494daf2dbb5$var$load("6Z8WE"),
    $379c8494daf2dbb5$var$load("c6MKV"),
    $379c8494daf2dbb5$var$load("b03Lm"),
    $379c8494daf2dbb5$var$load("9ZnVA"),
    $379c8494daf2dbb5$var$load("joJy8"),
    $379c8494daf2dbb5$var$load("aHE9G"),
    $379c8494daf2dbb5$var$load("cLErX"),
    $379c8494daf2dbb5$var$load("hkGfe"),
    $379c8494daf2dbb5$var$load("lxU5p")
]).then(()=>parcelRequire('bSweK'));

});

parcelRegister("97lre", function(module, exports) {

let $6a3565b4f556a1d2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6a3565b4f556a1d2$var$load("6vzdH"),
    $6a3565b4f556a1d2$var$load("lRtGG"),
    $6a3565b4f556a1d2$var$load("ffEVr"),
    $6a3565b4f556a1d2$var$load("kjZZD"),
    $6a3565b4f556a1d2$var$load("aGZFn"),
    $6a3565b4f556a1d2$var$load("7Xau5")
]).then(()=>parcelRequire('aUago'));

});

parcelRegister("erLvA", function(module, exports) {

let $a8487083f474cad8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a8487083f474cad8$var$load("ceWcd"),
    $a8487083f474cad8$var$load("7CYot"),
    $a8487083f474cad8$var$load("1m9tW"),
    $a8487083f474cad8$var$load("7J7Dl"),
    $a8487083f474cad8$var$load("eVFYI"),
    $a8487083f474cad8$var$load("8Cixw"),
    $a8487083f474cad8$var$load("iwNdc"),
    $a8487083f474cad8$var$load("dJIkj"),
    $a8487083f474cad8$var$load("iQFHB"),
    $a8487083f474cad8$var$load("32ARE"),
    $a8487083f474cad8$var$load("c62LN"),
    $a8487083f474cad8$var$load("8t38R"),
    $a8487083f474cad8$var$load("dkj9b"),
    $a8487083f474cad8$var$load("4p9Qk"),
    $a8487083f474cad8$var$load("3PQqe"),
    $a8487083f474cad8$var$load("2XCZ0"),
    $a8487083f474cad8$var$load("84iyu"),
    $a8487083f474cad8$var$load("c2m9M"),
    $a8487083f474cad8$var$load("esMxL"),
    $a8487083f474cad8$var$load("5IuQb"),
    $a8487083f474cad8$var$load("kdcrE"),
    $a8487083f474cad8$var$load("k0Etr"),
    $a8487083f474cad8$var$load("8fhzw"),
    $a8487083f474cad8$var$load("9u4sz"),
    $a8487083f474cad8$var$load("i3TSs"),
    $a8487083f474cad8$var$load("gm70k"),
    $a8487083f474cad8$var$load("5w3tp"),
    $a8487083f474cad8$var$load("cKXbf"),
    $a8487083f474cad8$var$load("2AOLi"),
    $a8487083f474cad8$var$load("4T4bq"),
    $a8487083f474cad8$var$load("jPS1u"),
    $a8487083f474cad8$var$load("3UR1K"),
    $a8487083f474cad8$var$load("4Oj5y"),
    $a8487083f474cad8$var$load("jRzT2"),
    $a8487083f474cad8$var$load("lKccm"),
    $a8487083f474cad8$var$load("dY7M5"),
    $a8487083f474cad8$var$load("2ZlZi"),
    $a8487083f474cad8$var$load("gCIfF"),
    $a8487083f474cad8$var$load("lm5in"),
    $a8487083f474cad8$var$load("7gjV3"),
    $a8487083f474cad8$var$load("koo1l"),
    $a8487083f474cad8$var$load("b91tv"),
    $a8487083f474cad8$var$load("l4Ek9"),
    $a8487083f474cad8$var$load("fwbht"),
    $a8487083f474cad8$var$load("h4Nf7"),
    $a8487083f474cad8$var$load("lfEn7"),
    $a8487083f474cad8$var$load("cdEjw"),
    $a8487083f474cad8$var$load("ipK41"),
    $a8487083f474cad8$var$load("2F69B"),
    $a8487083f474cad8$var$load("gkMTK"),
    $a8487083f474cad8$var$load("2eUdC"),
    $a8487083f474cad8$var$load("leIbB"),
    $a8487083f474cad8$var$load("8yyrA"),
    $a8487083f474cad8$var$load("2BIkk"),
    $a8487083f474cad8$var$load("lJxwk"),
    $a8487083f474cad8$var$load("7VwsU"),
    $a8487083f474cad8$var$load("fsZ6i"),
    $a8487083f474cad8$var$load("931GG"),
    $a8487083f474cad8$var$load("77Ha0"),
    $a8487083f474cad8$var$load("6nLV7"),
    $a8487083f474cad8$var$load("hKqxh"),
    $a8487083f474cad8$var$load("7sseo"),
    $a8487083f474cad8$var$load("dTsOE"),
    $a8487083f474cad8$var$load("8DoxJ"),
    $a8487083f474cad8$var$load("6gqpV"),
    $a8487083f474cad8$var$load("g9CVe"),
    $a8487083f474cad8$var$load("glQXz"),
    $a8487083f474cad8$var$load("12qzw"),
    $a8487083f474cad8$var$load("cI7A0"),
    $a8487083f474cad8$var$load("cgwQl"),
    $a8487083f474cad8$var$load("5YJ6r"),
    $a8487083f474cad8$var$load("5aY5g"),
    $a8487083f474cad8$var$load("zogKQ"),
    $a8487083f474cad8$var$load("fW5Fh"),
    $a8487083f474cad8$var$load("9EpP2"),
    $a8487083f474cad8$var$load("eFpF6"),
    $a8487083f474cad8$var$load("6qiXX"),
    $a8487083f474cad8$var$load("1ISAt"),
    $a8487083f474cad8$var$load("mKoWX"),
    $a8487083f474cad8$var$load("hIYCb"),
    $a8487083f474cad8$var$load("fNL1b"),
    $a8487083f474cad8$var$load("1Zo7q"),
    $a8487083f474cad8$var$load("ehDQZ"),
    $a8487083f474cad8$var$load("2RP81"),
    $a8487083f474cad8$var$load("5xdIv"),
    $a8487083f474cad8$var$load("jo5F7"),
    $a8487083f474cad8$var$load("aoOM9"),
    $a8487083f474cad8$var$load("a9OJ4"),
    $a8487083f474cad8$var$load("jdmfD"),
    $a8487083f474cad8$var$load("7X7qq"),
    $a8487083f474cad8$var$load("3yiZb"),
    $a8487083f474cad8$var$load("jqXtk"),
    $a8487083f474cad8$var$load("kGIBm"),
    $a8487083f474cad8$var$load("69J1q"),
    $a8487083f474cad8$var$load("eb06U"),
    $a8487083f474cad8$var$load("cyGuT"),
    $a8487083f474cad8$var$load("feuOx"),
    $a8487083f474cad8$var$load("aZinD"),
    $a8487083f474cad8$var$load("5TfXH"),
    $a8487083f474cad8$var$load("kjZZD"),
    $a8487083f474cad8$var$load("aGZFn"),
    $a8487083f474cad8$var$load("6qah4"),
    $a8487083f474cad8$var$load("iAaum"),
    $a8487083f474cad8$var$load("ffEVr"),
    $a8487083f474cad8$var$load("6vzdH"),
    $a8487083f474cad8$var$load("1gUNx"),
    $a8487083f474cad8$var$load("c6MKV"),
    $a8487083f474cad8$var$load("b03Lm"),
    $a8487083f474cad8$var$load("9ZnVA"),
    $a8487083f474cad8$var$load("joJy8"),
    $a8487083f474cad8$var$load("aHE9G"),
    $a8487083f474cad8$var$load("cLErX"),
    $a8487083f474cad8$var$load("hkGfe"),
    $a8487083f474cad8$var$load("h9zFU")
]).then(()=>parcelRequire('kcroh'));

});


parcelRegister("8ADNK", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $64108f424a3078f2$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $64108f424a3078f2$var$baseClamp;

});

parcelRegister("jzEl8", function(module, exports) {

$parcel$export(module.exports, "LegacyDOMBridge", () => $6cbcb1ce2cb81a03$export$a1d3010d20ec2131);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $9HkI0 = parcelRequire("9HkI0");
const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
class $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 extends (0, $gwFzn.PureComponent) {
    getLegacyElements() {
        const { rootNode: rootNode = window.document, selectors: selectors = [] } = this.props;
        if (!rootNode) return [];
        return Array.from(rootNode.querySelectorAll(selectors.join(',')));
    }
    getDomElementAttrsMap(domElement) {
        if (!domElement.hasAttributes()) return {};
        return Object.values(domElement.attributes).reduce((acc, attr)=>{
            acc[attr.name] = attr.value;
            return acc;
        }, {});
    }
    replaceDOMElementsWithPortal() {
        const { deleteExistingContent: deleteExistingContent, replacePlaceholderWith: replacePlaceholderWith, portalNode: portalNode } = this.props;
        this.workerInProgress = true;
        this.getLegacyElements().forEach((node)=>{
            const currentNodeAttrs = this.getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(portalNode, currentNodeAttrs);
                this.portals.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).createPortal(reactEl, targetNode));
            }
        });
        const attemptsLeft = this.state.attemptsLeft - 1;
        this.setState({
            attemptsLeft: attemptsLeft
        });
        if (attemptsLeft > 0) window.setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, this.props.retryDelay);
        else this.workerInProgress = false;
    }
    render() {
        if (this.state.attemptsLeft > 0 && !this.workerInProgress) setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, 0);
        return this.portals.map((item)=>item);
    }
    constructor(...args){
        super(...args);
        this.state = {
            attemptsLeft: this.props.attempts ?? 0
        };
        this.workerInProgress = false;
        this.portals = [];
    }
}
$6cbcb1ce2cb81a03$export$a1d3010d20ec2131.defaultProps = {
    attempts: 1,
    retryDelay: 50,
    deleteExistingContent: true
};

});

parcelRegister("7xVCs", function(module, exports) {

$parcel$export(module.exports, "PageTreeStateUpdater", () => $3c23582ca65aa05a$export$90a06df90d015db9);

var $atveb = parcelRequire("atveb");

var $ipPpS = parcelRequire("ipPpS");
class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $ipPpS.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}

});

parcelRegister("lQT6O", function(module, exports) {

var $9LdoD = parcelRequire("9LdoD");

var $iMZL3 = parcelRequire("iMZL3");

var $9lCvb = parcelRequire("9lCvb");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $fe8933c1f822db54$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $9lCvb(iteratee, 3);
    $iMZL3(object, function(value, key, object) {
        $9LdoD(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $fe8933c1f822db54$var$mapValues;

});

parcelRegister("9pS9R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6db0757f75190298$var$_react = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $6db0757f75190298$var$_baseNew = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6db0757f75190298$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6db0757f75190298$var$RefreshIcon = (props)=>/*#__PURE__*/ $6db0757f75190298$var$_react.default.createElement($6db0757f75190298$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$6db0757f75190298$var$RefreshIcon.displayName = 'RefreshIcon';
var $6db0757f75190298$var$_default = module.exports.default = $6db0757f75190298$var$RefreshIcon;

});

parcelRegister("iZRoG", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $afccce05c0d0956c$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $afccce05c0d0956c$var$styles = null; /**
                      * __Divider__
                      *
                      * A divider for use between menu sections.
                      */ 
const $afccce05c0d0956c$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("hr", {
        /**
                                  * The existing usage of these dividers is presentational,
                                  * so we are removing the separator semantics by default.
                                  *
                                  * In the future we may consider allowing opt-in separator semantics,
                                  * but it probably isn't necessary.
                                  */ role: "none",
        className: (0, $35pXk.default)([
            "_h7alglyw _179rglyw _mqm2zgxb _1bsb1osq"
        ])
    });

});

parcelRegister("3IZob", function(module, exports) {

$parcel$export(module.exports, "useDocChangeContext", () => $10e4e925e54c9160$export$82deeccbd0ef6b25);
$parcel$export(module.exports, "withDocChangeContext", () => $10e4e925e54c9160$export$9747c97496f7b432);

var $gwFzn = parcelRequire("gwFzn");
const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $gwFzn.useRef)(new Set());
    const handleDocChange = (0, $gwFzn.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $gwFzn.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $gwFzn.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $gwFzn.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $gwFzn.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de790aa34d87b38953e022081bae4952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("luv00", function(module, exports) {

$parcel$export(module.exports, "useSSRPlaceholderReplaceIdProp", () => $8a88875ffe13fd4c$export$30b62f74ca853d7d);

var $gwFzn = parcelRequire("gwFzn");

var $5nSna = parcelRequire("5nSna");
function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $gwFzn.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}

});

parcelRegister("keVvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");

var $e9OZ6 = parcelRequire("e9OZ6");

var $5cR9p = parcelRequire("5cR9p");
function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $gwFzn.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("e9OZ6", function(module, exports) {

$parcel$export(module.exports, "useMessages", () => $e1a1ee666860bb23$export$4d17e2d9c5348842);

var $gwFzn = parcelRequire("gwFzn");

var $hxPth = parcelRequire("hxPth");
const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $gwFzn.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $gwFzn.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("hxPth", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $b9a0da62d538b640$export$79618bef82c02d4c);
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("5cR9p", function(module, exports) {

$parcel$export(module.exports, "useSafeIntl", () => $1961b540cbe6be26$export$f752ac21ea3960a5);

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");
var $jaEJa = parcelRequire("jaEJa");
var $js7oX = parcelRequire("js7oX");

var $hxPth = parcelRequire("hxPth");
// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $jaEJa.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $gwFzn.useContext)((0, $js7oX.Context));
    if (!context) return (0, $hlhtG.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};

});


parcelRegister("kuzEc", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $cdfa7a8bb907606d$export$3f072f06b90c3985);
$parcel$export(module.exports, "componentMetadata", () => $cdfa7a8bb907606d$export$f7ef6e455933602c);
const $cdfa7a8bb907606d$export$3f072f06b90c3985 = 'media';
const $cdfa7a8bb907606d$export$f7ef6e455933602c = {
    tableView: {
        component: 'datasourceTable'
    },
    configModal: {
        component: 'datasourceConfigModal'
    },
    generic: {
        component: 'datasource'
    }
};

});

parcelRegister("kutOG", function(module, exports) {

$parcel$export(module.exports, "useDatasourceAnalyticsEvents", () => $718ba8176fe9fde8$export$22b7a355f5fe42b2);

var $kuzEc = parcelRequire("kuzEc");

var $6prJf = parcelRequire("6prJf");
const $718ba8176fe9fde8$export$22b7a355f5fe42b2 = ()=>(0, $6prJf.useAnalyticsEvents)();

});
parcelRegister("6prJf", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $29c4586c942f6ab1$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::21ae373abad7c370a8682ddcd3a7ed21>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-datasource
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $kuzEc = parcelRequire("kuzEc");

var $4IO5j = parcelRequire("4IO5j");
const $29c4586c942f6ab1$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $gwFzn.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4IO5j.default)(...params));
        event.fire((0, $kuzEc.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("4IO5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $069ea3eaed0cae04$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::819168596ba17484cadda969f8ecf82d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-datasource
 */ const $069ea3eaed0cae04$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $069ea3eaed0cae04$export$2e2bcd8739ae039 = $069ea3eaed0cae04$var$createEventPayload;

});



parcelRegister("N78o8", function(module, exports) {

$parcel$export(module.exports, "logToSentry", () => $a75d0558e506d695$export$48aa66ca4d914984);
$parcel$export(module.exports, "default", () => $a75d0558e506d695$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $gmi3X = parcelRequire("gmi3X");

var $hdKel = parcelRequire("hdKel");

var $6mn0G = parcelRequire("6mn0G");

var $kutOG = parcelRequire("kutOG");
const $a75d0558e506d695$var$getNetworkFields = (error)=>{
    switch(true){
        case error instanceof Response:
            return {
                traceId: (0, $6mn0G.getTraceId)(error),
                status: error.status,
                reason: 'response'
            };
        case error instanceof (0, $gmi3X.NetworkError):
            return {
                traceId: null,
                status: null,
                reason: 'network'
            };
        case error instanceof Error:
            return {
                traceId: null,
                status: null,
                reason: 'internal'
            };
        default:
            return {
                traceId: null,
                status: null,
                reason: 'unknown'
            };
    }
};
const $a75d0558e506d695$export$48aa66ca4d914984 = (error, ...captureExceptionParams)=>{
    if (error instanceof Error) (0, $hdKel.captureException)(error, ...captureExceptionParams);
};
const $a75d0558e506d695$var$useErrorLogger = (loggerProps)=>{
    const { fireEvent: fireEvent } = (0, $kutOG.useDatasourceAnalyticsEvents)();
    /**
	 * Sentry is good because it can retrieve name, message, stacktrace of an Error. That's why we will send to Sentry only
	 * if an error is instance of `Error`. Sentry is also capable of some PII scrubbing of these risky fields.
	 *
	 * We will send to Splunk every single time, though, but we won't send PII risky fields.
	 */ const captureError = (0, $gwFzn.useCallback)((errorLocation, error)=>{
        const { traceId: traceId, status: status, reason: reason } = $a75d0558e506d695$var$getNetworkFields(error);
        fireEvent('operational.datasource.operationFailed', {
            errorLocation: errorLocation,
            traceId: traceId,
            status: status,
            reason: reason
        });
        $a75d0558e506d695$export$48aa66ca4d914984(error, 'link-datasource', {
            ...loggerProps
        });
    }, [
        fireEvent,
        loggerProps
    ]);
    return {
        captureError: captureError
    };
};
var $a75d0558e506d695$export$2e2bcd8739ae039 = $a75d0558e506d695$var$useErrorLogger;

});
parcelRegister("hdKel", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $98cbbeecc3c59dff$export$f5282963edea4a68);
const $98cbbeecc3c59dff$export$f5282963edea4a68 = async (error, packageName, tags)=>{
    // Re-introduce in EDM-9682
    return;
};

});

parcelRegister("6mn0G", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $ef5055edddfff711$export$e88cb5bfb57ce9c4);
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}

});


parcelRegister("5n5ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $76bdb6f3964f3077$export$2e2bcd8739ae039);

var $9tehW = parcelRequire("9tehW");

var $81yTx = parcelRequire("81yTx");
const $76bdb6f3964f3077$var$AsyncSelect = (0, $81yTx.default)((0, $9tehW.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$76bdb6f3964f3077$export$2e2bcd8739ae039 = $76bdb6f3964f3077$var$AsyncSelect;

});

parcelRegister("2WHHL", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $4de09c96514ff692$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $4de09c96514ff692$export$945a571f3b658bf);
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}

});

parcelRegister("c9mMn", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $621c6a15c091c99d$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $621c6a15c091c99d$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $huub2 = parcelRequire("huub2");

var $eJPDm = parcelRequire("eJPDm");

var $d6Fdl = parcelRequire("d6Fdl");

var $dh538 = parcelRequire("dh538");
const $621c6a15c091c99d$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz1lh4"
}; // state of the parent option
const $621c6a15c091c99d$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
}; // the secondary color represents the radio dot or checkmark
const $621c6a15c091c99d$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $621c6a15c091c99d$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $621c6a15c091c99d$var$baseIconStyles = null;
const $621c6a15c091c99d$var$baseOptionStyles = null;
const $621c6a15c091c99d$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $gwFzn.useState)(false);
    const onMouseDown = (0, $gwFzn.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $gwFzn.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $gwFzn.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            $621c6a15c091c99d$var$optionStyles.default,
            isFocused && $621c6a15c091c99d$var$optionStyles.focused,
            isDisabled && $621c6a15c091c99d$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $621c6a15c091c99d$var$iconStyles.inherit : $621c6a15c091c99d$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                    label: "",
                    primaryColor: $621c6a15c091c99d$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $621c6a15c091c99d$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $621c6a15c091c99d$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6Fdl.default), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $621c6a15c091c99d$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6Fdl.default), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    }); /**
                       * __Checkbox option__
                       */ 
const $621c6a15c091c99d$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $dh538.fg)('platform-visual-refresh-icons') ? $621c6a15c091c99d$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($huub2))),
        ...props
    }); /**
                * __Radio option__
                */ 
const $621c6a15c091c99d$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $7UHDa.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $dh538.fg)('platform-visual-refresh-icons') ? $621c6a15c091c99d$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($eJPDm))),
        ...props
    });

});

parcelRegister("dDJDQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::636414aaf061bfcc39e7053bfa952962>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ee25257c3a1c2ac$var$_react = $9ee25257c3a1c2ac$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $9ee25257c3a1c2ac$var$_chevronUp = $9ee25257c3a1c2ac$var$_interopRequireDefault((parcelRequire("2AytZ")));

var $9ee25257c3a1c2ac$var$_chevronUp2 = $9ee25257c3a1c2ac$var$_interopRequireDefault((parcelRequire("8fhBi")));
function $9ee25257c3a1c2ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ee25257c3a1c2ac$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $9ee25257c3a1c2ac$var$_react.default.createElement($9ee25257c3a1c2ac$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $9ee25257c3a1c2ac$var$_chevronUp2.default
    }, props));
$9ee25257c3a1c2ac$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $9ee25257c3a1c2ac$var$_default = module.exports.default = $9ee25257c3a1c2ac$var$ChevronUpIcon;

});

parcelRegister("2n8po", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $f0c37d2844a91b76$export$62ed72bc21f6b8a6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $31bj1 = parcelRequire("31bj1");

var $9JSVA = parcelRequire("9JSVA");
function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;

});
parcelRegister("31bj1", function(module, exports) {

$parcel$export(module.exports, "Line", () => $1707735fc36ab082$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $9JSVA = parcelRequire("9JSVA");
const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $35pXk.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;

});
parcelRegister("9JSVA", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $795a0d6001dc944e$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $795a0d6001dc944e$export$45db03aa04b685e3);
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("5X6QO", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");

});
parcelRegister("eOL5r", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $20c6df176d77bef6$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("gZctg", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");

});
parcelRegister("ihBqS", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $713d889559578e2f$export$453c0582481cc59d);

var $d8F95 = parcelRequire("d8F95");

var $cmcCB = parcelRequire("cmcCB");
function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $d8F95.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};

});


parcelRegister("882hS", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");

});
parcelRegister("85Mv7", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $30069a8958953d8b$export$427e20518819fabc);

var $iFRCn = parcelRequire("iFRCn");
function $30069a8958953d8b$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on iOS**
		 *
		 * On iOS, the browser will set the transparent border color to be black. We can provide a
		 * more polished experience not using the transparent border on iOS.
		 *
		 * While dragging, iOS will shift the drag preview under the center of the users pointer,
		 * so the "pushing away" of the preview is short lived on iOS anyway.
		 *
		 * Notes:
		 *
		 * - Tested on `iOS@18.4.1` on May 7th 2025
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a black border
		 * - The `<body>` text or background color does not change the black border color
		 */ if (!(0, $iFRCn.isSafariOnIOS)()) Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("iFRCn", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $3720fb1a551ae595$export$52fc40c68fea4952);

var $aYpzB = parcelRequire("aYpzB");

var $e880Z = parcelRequire("e880Z");
const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});

});



parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("hcMBV", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $87ac0097385af1df$export$f40b7e0b762b928b);
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("fVdiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9767efcf504d089$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $b9767efcf504d089$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $gwFzn.useRef)(null);
    var maxWaitArgs = (0, $gwFzn.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $gwFzn.useRef)(false);
    var functionTimeoutHandler = (0, $gwFzn.useRef)(null);
    var isComponentUnmounted = (0, $gwFzn.useRef)(false);
    var debouncedFunction = (0, $gwFzn.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $gwFzn.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $gwFzn.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $gwFzn.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $gwFzn.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("e3TOY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59c2b1e7e5111fdcc302c5c09e351380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3cca56e09704fd9$var$_react = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $a3cca56e09704fd9$var$_baseNew = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3cca56e09704fd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3cca56e09704fd9$var$AudioIcon = (props)=>/*#__PURE__*/ $a3cca56e09704fd9$var$_react.default.createElement($a3cca56e09704fd9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$a3cca56e09704fd9$var$AudioIcon.displayName = 'AudioIcon';
var $a3cca56e09704fd9$var$_default = module.exports.default = $a3cca56e09704fd9$var$AudioIcon;

});

parcelRegister("8cjip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f7e698125b9a7f8$var$_react = $5f7e698125b9a7f8$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5f7e698125b9a7f8$var$_baseNew = $5f7e698125b9a7f8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5f7e698125b9a7f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f7e698125b9a7f8$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $5f7e698125b9a7f8$var$_react.default.createElement($5f7e698125b9a7f8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$5f7e698125b9a7f8$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $5f7e698125b9a7f8$var$_default = module.exports.default = $5f7e698125b9a7f8$var$EyeOpenIcon;

});

parcelRegister("gJsgh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2e6c576bef3e780$var$_react = $c2e6c576bef3e780$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c2e6c576bef3e780$var$_baseNew = $c2e6c576bef3e780$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c2e6c576bef3e780$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2e6c576bef3e780$var$GoalIcon = (props)=>/*#__PURE__*/ $c2e6c576bef3e780$var$_react.default.createElement($c2e6c576bef3e780$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$c2e6c576bef3e780$var$GoalIcon.displayName = 'GoalIcon';
var $c2e6c576bef3e780$var$_default = module.exports.default = $c2e6c576bef3e780$var$GoalIcon;

});

parcelRegister("bVHZY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8af725c21ff09654$var$_react = $8af725c21ff09654$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8af725c21ff09654$var$_baseNew = $8af725c21ff09654$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8af725c21ff09654$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8af725c21ff09654$var$ProjectIcon = (props)=>/*#__PURE__*/ $8af725c21ff09654$var$_react.default.createElement($8af725c21ff09654$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$8af725c21ff09654$var$ProjectIcon.displayName = 'ProjectIcon';
var $8af725c21ff09654$var$_default = module.exports.default = $8af725c21ff09654$var$ProjectIcon;

});

parcelRegister("6rSJC", function(module, exports) {

$parcel$export(module.exports, "default", () => $aabc54d8ecf8c9ec$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fb3kw = parcelRequire("fb3kw");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $aabc54d8ecf8c9ec$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $gwFzn.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
$aabc54d8ecf8c9ec$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $aabc54d8ecf8c9ec$export$2e2bcd8739ae039 = $aabc54d8ecf8c9ec$var$CheckboxField;

});

parcelRegister("avrhI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0300804bdadb8133f36dfd3426232a41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a61f6ca9f1fa7cb$var$_react = $7a61f6ca9f1fa7cb$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $7a61f6ca9f1fa7cb$var$_baseNew = $7a61f6ca9f1fa7cb$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7a61f6ca9f1fa7cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a61f6ca9f1fa7cb$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $7a61f6ca9f1fa7cb$var$_react.default.createElement($7a61f6ca9f1fa7cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$7a61f6ca9f1fa7cb$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $7a61f6ca9f1fa7cb$var$_default = module.exports.default = $7a61f6ca9f1fa7cb$var$FullscreenEnterIcon;

});

parcelRegister("heJQp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8c74e344a02b229$var$_react = $c8c74e344a02b229$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c8c74e344a02b229$var$_baseNew = $c8c74e344a02b229$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c8c74e344a02b229$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8c74e344a02b229$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $c8c74e344a02b229$var$_react.default.createElement($c8c74e344a02b229$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$c8c74e344a02b229$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $c8c74e344a02b229$var$_default = module.exports.default = $c8c74e344a02b229$var$ShrinkDiagonalIcon;

});

parcelRegister("kfsdt", function(module, exports) {

var $8ADNK = parcelRequire("8ADNK");

var $6QEZH = parcelRequire("6QEZH");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $ebdb188d7b633771$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $6QEZH(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $6QEZH(lower);
        lower = lower === lower ? lower : 0;
    }
    return $8ADNK($6QEZH(number), lower, upper);
}
module.exports = $ebdb188d7b633771$var$clamp;

});

parcelRegister("7pmxW", function(module, exports) {

var $ku8En = parcelRequire("ku8En");

var $alYxH = parcelRequire("alYxH");

var $7WDn2 = parcelRequire("7WDn2");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $564c5b6f7b92ee26$var$stringSize(string) {
    return $alYxH(string) ? $7WDn2(string) : $ku8En(string);
}
module.exports = $564c5b6f7b92ee26$var$stringSize;

});
parcelRegister("ku8En", function(module, exports) {

var $fStnf = parcelRequire("fStnf");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $ee9d51bce6f8f19a$var$asciiSize = $fStnf('length');
module.exports = $ee9d51bce6f8f19a$var$asciiSize;

});

parcelRegister("7WDn2", function(module, exports) {
/** Used to compose unicode character classes. */ var $5c8c7d5cae386c14$var$rsAstralRange = '\\ud800-\\udfff', $5c8c7d5cae386c14$var$rsComboMarksRange = '\\u0300-\\u036f', $5c8c7d5cae386c14$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $5c8c7d5cae386c14$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $5c8c7d5cae386c14$var$rsComboRange = $5c8c7d5cae386c14$var$rsComboMarksRange + $5c8c7d5cae386c14$var$reComboHalfMarksRange + $5c8c7d5cae386c14$var$rsComboSymbolsRange, $5c8c7d5cae386c14$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $5c8c7d5cae386c14$var$rsAstral = '[' + $5c8c7d5cae386c14$var$rsAstralRange + ']', $5c8c7d5cae386c14$var$rsCombo = '[' + $5c8c7d5cae386c14$var$rsComboRange + ']', $5c8c7d5cae386c14$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $5c8c7d5cae386c14$var$rsModifier = '(?:' + $5c8c7d5cae386c14$var$rsCombo + '|' + $5c8c7d5cae386c14$var$rsFitz + ')', $5c8c7d5cae386c14$var$rsNonAstral = '[^' + $5c8c7d5cae386c14$var$rsAstralRange + ']', $5c8c7d5cae386c14$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $5c8c7d5cae386c14$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $5c8c7d5cae386c14$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $5c8c7d5cae386c14$var$reOptMod = $5c8c7d5cae386c14$var$rsModifier + '?', $5c8c7d5cae386c14$var$rsOptVar = '[' + $5c8c7d5cae386c14$var$rsVarRange + ']?', $5c8c7d5cae386c14$var$rsOptJoin = '(?:' + $5c8c7d5cae386c14$var$rsZWJ + '(?:' + [
    $5c8c7d5cae386c14$var$rsNonAstral,
    $5c8c7d5cae386c14$var$rsRegional,
    $5c8c7d5cae386c14$var$rsSurrPair
].join('|') + ')' + $5c8c7d5cae386c14$var$rsOptVar + $5c8c7d5cae386c14$var$reOptMod + ')*', $5c8c7d5cae386c14$var$rsSeq = $5c8c7d5cae386c14$var$rsOptVar + $5c8c7d5cae386c14$var$reOptMod + $5c8c7d5cae386c14$var$rsOptJoin, $5c8c7d5cae386c14$var$rsSymbol = '(?:' + [
    $5c8c7d5cae386c14$var$rsNonAstral + $5c8c7d5cae386c14$var$rsCombo + '?',
    $5c8c7d5cae386c14$var$rsCombo,
    $5c8c7d5cae386c14$var$rsRegional,
    $5c8c7d5cae386c14$var$rsSurrPair,
    $5c8c7d5cae386c14$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $5c8c7d5cae386c14$var$reUnicode = RegExp($5c8c7d5cae386c14$var$rsFitz + '(?=' + $5c8c7d5cae386c14$var$rsFitz + ')|' + $5c8c7d5cae386c14$var$rsSymbol + $5c8c7d5cae386c14$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $5c8c7d5cae386c14$var$unicodeSize(string) {
    var result = $5c8c7d5cae386c14$var$reUnicode.lastIndex = 0;
    while($5c8c7d5cae386c14$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $5c8c7d5cae386c14$var$unicodeSize;

});


parcelRegister("izoLT", function(module, exports) {

var $fdmJU = parcelRequire("fdmJU");

var $jz4nc = parcelRequire("jz4nc");
/** Used to match HTML entities and HTML characters. */ var $d84eb5f90dbd2075$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $d84eb5f90dbd2075$var$reHasEscapedHtml = RegExp($d84eb5f90dbd2075$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $d84eb5f90dbd2075$var$unescape(string) {
    string = $fdmJU(string);
    return string && $d84eb5f90dbd2075$var$reHasEscapedHtml.test(string) ? string.replace($d84eb5f90dbd2075$var$reEscapedHtml, $jz4nc) : string;
}
module.exports = $d84eb5f90dbd2075$var$unescape;

});
parcelRegister("jz4nc", function(module, exports) {

var $d3hXu = parcelRequire("d3hXu");
/** Used to map HTML entities to characters. */ var $e3e4ad9c5724fa9a$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $e3e4ad9c5724fa9a$var$unescapeHtmlChar = $d3hXu($e3e4ad9c5724fa9a$var$htmlUnescapes);
module.exports = $e3e4ad9c5724fa9a$var$unescapeHtmlChar;

});


parcelRegister("8wnNT", function(module, exports) {

$parcel$export(module.exports, "withMediaClientAndSettings", () => $644dfef8d55a6120$export$ea8f1b8e2d843039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3rvSa = parcelRequire("3rvSa");

var $9k33u = parcelRequire("9k33u");

var $8IHds = parcelRequire("8IHds");
const $644dfef8d55a6120$var$MediaContextConsumer = ({ Component: Component, otherProps: otherProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9k33u.MediaContext).Consumer, {
        children: (mediaProviderValue)=>/*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaProviderValue?.mediaClient,
                mediaSettings: mediaProviderValue?.settings
            })
    });
const $644dfef8d55a6120$export$ea8f1b8e2d843039 = (Component)=>({ mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings, ...otherProps })=>{
        const parsedSettings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9k33u.MediaContext).Consumer, {
            children: (outterMediaProviderValue)=>{
                // If there is a MediaProvider up in the tree, use the top mediaClient and merge settings
                if (outterMediaProviderValue) {
                    const mergedParsedSettings = {
                        ...outterMediaProviderValue.settings,
                        ...parsedSettings
                    };
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9k33u.MediaContext).Provider, {
                        value: {
                            mediaClient: outterMediaProviderValue.mediaClient,
                            settings: mergedParsedSettings
                        },
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)($644dfef8d55a6120$var$MediaContextConsumer, {
                            Component: Component,
                            otherProps: otherProps
                        })
                    });
                }
                // Otherwise, check if there is a MediaClientProvider up in the tree
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
                    children: (mediaClientProviderValue)=>// If there is a MediaClientProvider, we reinject the mediaClient and mediaSettings into a new MediaProvider
                        mediaClientProviderValue ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9k33u.MediaContext).Provider, {
                            value: {
                                mediaClient: mediaClientProviderValue,
                                settings: parsedSettings
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($644dfef8d55a6120$var$MediaContextConsumer, {
                                Component: Component,
                                otherProps: otherProps
                            })
                        }) : // If no poviders found, we mount a MediaProvider and inject the given props mediaClientConfig and mediaSettings
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9k33u.MediaProvider), {
                            mediaClientConfig: mediaClientConfig,
                            mediaSettings: mediaSettings,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($644dfef8d55a6120$var$MediaContextConsumer, {
                                Component: Component,
                                otherProps: otherProps
                            })
                        })
                });
            }
        });
    };

});

parcelRegister("lw3De", function(module, exports) {

$parcel$export(module.exports, "withMediaAnalyticsContext", () => $7cb3645b740b6517$export$ba0fb5f6ba6ce56c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");

var $gSKON = parcelRequire("gSKON");
const $7cb3645b740b6517$export$ba0fb5f6ba6ce56c = (contextPublicAttributes)=>(WrappedComponent)=>{
        // forwardRef() allows passing React refs to the wrapped component WithMediaAnalyticsContext
        const WithMediaAnalyticsContext = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
            const { featureFlags: featureFlags } = props;
            const contextData = (0, $gwFzn.useMemo)(()=>{
                const contextPrivateAttributes = {
                    featureFlags: featureFlags
                };
                return {
                    ...contextPublicAttributes,
                    [(0, $gSKON.MEDIA_CONTEXT)]: {
                        ...contextPrivateAttributes
                    }
                };
            }, [
                featureFlags
            ]);
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
                data: contextData,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
                    ...props,
                    ref: ref
                })
            });
        });
        WithMediaAnalyticsContext.displayName = `WithMediaAnalyticsContext(${// @ts-ignore displayName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name})`;
        return WithMediaAnalyticsContext;
    };

});

parcelRegister("4QMC0", function(module, exports) {

$parcel$export(module.exports, "AbuseModal", () => $2fbda1ba245d093e$export$9b832d04bd876d78);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $ccHMk = parcelRequire("ccHMk");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");
var $6xdDU = parcelRequire("6xdDU");

var $31QJ7 = parcelRequire("31QJ7");
const $2fbda1ba245d093e$export$9b832d04bd876d78 = (0, $js7oX.default)(({ isOpen: isOpen, onConfirm: onConfirm, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
            onClose: onClose,
            testId: "mediaAbuseModal",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                        appearance: "warning",
                        children: formatMessage((0, $31QJ7.messages).abuse_modal_title)
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                    children: formatMessage((0, $31QJ7.messages).abuse_modal_body)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: formatMessage((0, $31QJ7.messages).cancel)
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            appearance: "warning",
                            onClick: onConfirm,
                            children: formatMessage((0, $31QJ7.messages).abuse_modal_submit)
                        })
                    ]
                })
            ]
        })
    });
});

});

parcelRegister("lOHzS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe2012194714c5ae$var$_react = $fe2012194714c5ae$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $fe2012194714c5ae$var$_baseNew = $fe2012194714c5ae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fe2012194714c5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe2012194714c5ae$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $fe2012194714c5ae$var$_react.default.createElement($fe2012194714c5ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$fe2012194714c5ae$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $fe2012194714c5ae$var$_default = module.exports.default = $fe2012194714c5ae$var$VideoPlayIcon;

});

parcelRegister("dv4ij", function(module, exports) {

$parcel$export(module.exports, "MediaTypeIcon", () => $054676e2aa38d1ed$export$3787195047fd197b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dtHK5 = parcelRequire("dtHK5");

var $40ldU = parcelRequire("40ldU");

var $dh538 = parcelRequire("dh538");
class $054676e2aa38d1ed$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        return (0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $40ldU.MediaTypeIcon), {
            ...this.props
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dtHK5.MediaTypeIcon), {
            ...this.props
        });
    }
}

});
parcelRegister("dtHK5", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $c73c553bed21235d$export$be58b4326e23250f);
$parcel$export(module.exports, "MediaTypeIcon", () => $c73c553bed21235d$export$3787195047fd197b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $20uDq = parcelRequire("20uDq");

var $gguok = parcelRequire("gguok");

var $hXc8o = parcelRequire("hXc8o");

var $i9cac = parcelRequire("i9cac");

var $fX9Sa = parcelRequire("fX9Sa");

var $djgQ6 = parcelRequire("djgQ6");

var $41GKb = parcelRequire("41GKb");

var $d4cCP = parcelRequire("d4cCP");

var $ayTrS = parcelRequire("ayTrS");

var $5mB97 = parcelRequire("5mB97");

var $dlbUV = parcelRequire("dlbUV");

var $8DZd1 = parcelRequire("8DZd1");

var $gwrgp = parcelRequire("gwrgp");
const $c73c553bed21235d$export$be58b4326e23250f = (0, $gwrgp.default)("span", {
    target: "exhtxam0"
})("display:inline-flex;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ size: size })=>size === 'large' ? `padding: 4px;` : '');
$c73c553bed21235d$export$be58b4326e23250f.displayName = 'IconWrapper';
const $c73c553bed21235d$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($20uDq))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($gguok))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($i9cac))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
};
const $c73c553bed21235d$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($5mB97))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)))
};
const $c73c553bed21235d$var$defaultType = 'unknown';
class $c73c553bed21235d$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $c73c553bed21235d$var$defaultType;
        const icons = size === 'large' ? $c73c553bed21235d$var$largeIcons : $c73c553bed21235d$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$c73c553bed21235d$var$defaultType];
        return /*#__PURE__*/ (0, $7UHDa.jsx)($c73c553bed21235d$export$be58b4326e23250f, {
            "data-testid": testId,
            "data-type": type,
            size: size,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}
$c73c553bed21235d$export$3787195047fd197b.defaultProps = {
    type: $c73c553bed21235d$var$defaultType,
    testId: 'file-type-icon',
    size: 'large'
};

});

parcelRegister("40ldU", function(module, exports) {

$parcel$export(module.exports, "MediaTypeIcon", () => $4f9fee939253b421$export$3787195047fd197b);
/* media-type-icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $20uDq = parcelRequire("20uDq");

var $gguok = parcelRequire("gguok");

var $hXc8o = parcelRequire("hXc8o");

var $i9cac = parcelRequire("i9cac");

var $fX9Sa = parcelRequire("fX9Sa");

var $djgQ6 = parcelRequire("djgQ6");

var $41GKb = parcelRequire("41GKb");

var $d4cCP = parcelRequire("d4cCP");

var $ayTrS = parcelRequire("ayTrS");

var $5mB97 = parcelRequire("5mB97");

var $dlbUV = parcelRequire("dlbUV");

var $8DZd1 = parcelRequire("8DZd1");
function $4f9fee939253b421$var$_defineProperty(e, r, t) {
    return (r = $4f9fee939253b421$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4f9fee939253b421$var$_toPropertyKey(t) {
    var i = $4f9fee939253b421$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4f9fee939253b421$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4f9fee939253b421$var$iconStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $4f9fee939253b421$var$iconStyles = null;
const $4f9fee939253b421$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($20uDq))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($gguok))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($i9cac))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
};
const $4f9fee939253b421$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($5mB97))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)))
};
const $4f9fee939253b421$var$defaultType = 'unknown';
class $4f9fee939253b421$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $4f9fee939253b421$var$defaultType;
        const icons = size === 'large' ? $4f9fee939253b421$var$largeIcons : $4f9fee939253b421$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$4f9fee939253b421$var$defaultType];
        return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            "data-testid": testId,
            "data-type": type,
            className: (0, $35pXk.default)([
                "_1e0c116y",
                $4f9fee939253b421$var$iconStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}
$4f9fee939253b421$var$_defineProperty($4f9fee939253b421$export$3787195047fd197b, "defaultProps", {
    type: $4f9fee939253b421$var$defaultType,
    testId: 'file-type-icon',
    size: 'large'
});

});


parcelRegister("cneVc", function(module, exports) {

$parcel$export(module.exports, "MimeTypeIcon", () => $486f7da454853fe7$export$875d423332b93b5f);
/* mime-type-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $a6JW6 = parcelRequire("a6JW6");

var $dtHK5 = parcelRequire("dtHK5");
var $dv4ij = parcelRequire("dv4ij");

var $dh538 = parcelRequire("dh538");
const $486f7da454853fe7$var$iconWrapperStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $486f7da454853fe7$var$iconWrapperStyles = null; /*
                                 * Renders an icon. First, check if the mimeType corresponds to any of the special mimeType icons (.gif, .sketch, .exe, ect). If so, render that icon.
                                 * Else, render an icon corresponding to its mediaType (doc/audio/image/video/unknown)
                                 */ 
const $486f7da454853fe7$export$875d423332b93b5f = ({ mediaType: mediaType = 'unknown', mimeType: mimeType = 'unknown', name: name = 'unknown', testId: testId, size: size = 'large' })=>{
    // retrieve mimetype icon and label
    const iconInfo = (0, $a6JW6.getMimeIcon)(mimeType, name); // a corresponding mimetype icon and label was found.
    if (iconInfo) {
        const Icon = iconInfo.icon;
        return (0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            "data-testid": testId,
            "data-type": iconInfo.label,
            className: (0, $35pXk.default)([
                "_1e0c116y",
                $486f7da454853fe7$var$iconWrapperStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                label: iconInfo.label
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dtHK5.IconWrapper), {
            "data-testid": testId,
            "data-type": iconInfo.label,
            size: size,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                label: iconInfo.label
            })
        });
    } // no corresponding mimetype icon/label was found.
    // Hence, return a mediatype (image/doc/audio/video/unknown) icon
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dv4ij.MediaTypeIcon), {
        testId: testId,
        type: mediaType,
        size: size
    });
};

});

parcelRegister("gLC1Y", function(module, exports) {

$parcel$export(module.exports, "MediaSVGError", () => $98d902313bc806c3$export$c4ae8d1d12c193a7);
$parcel$export(module.exports, "createUnexpectedErrorCallback", () => $98d902313bc806c3$export$ba08301c71bd9cf6);
class $98d902313bc806c3$export$c4ae8d1d12c193a7 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
const $98d902313bc806c3$export$ba08301c71bd9cf6 = (onError)=>(e)=>{
        onError?.(new $98d902313bc806c3$export$c4ae8d1d12c193a7('unexpected', e));
    };

});

parcelRegister("lpgfG", function(module, exports) {

$parcel$export(module.exports, "useResolveSvg", () => $fbe97e3aba6e7da3$export$d127d14f68c2bbcf);

var $gwFzn = parcelRequire("gwFzn");

var $2nsxJ = parcelRequire("2nsxJ");
var $jRNsq = parcelRequire("jRNsq");

var $6AHKK = parcelRequire("6AHKK");

var $dbETJ = parcelRequire("dbETJ");

var $gLC1Y = parcelRequire("gLC1Y");
// We need to convert the blob into Base64 for security reasons: https://asecurityteam.atlassian.net/browse/VULN-1495952
// Make sure to update the test helper mockFileReader if this is changed
function $fbe97e3aba6e7da3$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(// reader.readAsDataURL makes reader.result a string
            // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.result);
        reader.onerror = (e)=>reject(new (0, $gLC1Y.MediaSVGError)('blob-to-datauri', e instanceof Error ? e : undefined));
        reader.readAsDataURL(blob);
    });
}
const $fbe97e3aba6e7da3$var$getLocalSvg = async (preview)=>{
    const { value: value } = await preview;
    if (typeof value === 'string') return value;
    return $fbe97e3aba6e7da3$var$blobToBase64(value);
};
const $fbe97e3aba6e7da3$var$getRemoteSvg = async ({ id: id, collectionName: collectionName }, mediaClient)=>{
    const blob = await mediaClient.mediaStore.getFileBinary(id, collectionName).catch((e)=>{
        throw new (0, $gLC1Y.MediaSVGError)('binary-fetch', e instanceof Error ? e : undefined);
    });
    return await $fbe97e3aba6e7da3$var$blobToBase64(blob);
};
const $fbe97e3aba6e7da3$export$d127d14f68c2bbcf = (identifier, onError)=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const { id: id, collectionName: collectionName } = identifier;
    const { id: prevId } = (0, $dbETJ.usePrevious)(identifier) || identifier;
    const { fileState: fileState } = (0, $2nsxJ.useFileState)(id, {
        collectionName: collectionName
    });
    const [svgUrl, setSvgUrl] = (0, $gwFzn.useState)(undefined);
    const [source, setSource] = (0, $gwFzn.useState)(undefined);
    const onErrorRef = (0, $6AHKK.useCurrentValueRef)(onError);
    (0, $gwFzn.useEffect)(()=>{
        if (id !== prevId) setSvgUrl(undefined);
    }, [
        id,
        prevId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (svgUrl || !fileState || fileState.status === 'error' || fileState?.mimeType !== 'image/svg+xml') return;
        const { preview: preview } = fileState;
        if (preview) $fbe97e3aba6e7da3$var$getLocalSvg(preview).then((content)=>{
            setSvgUrl(content);
            setSource('local');
        }).catch(onErrorRef.current);
        else $fbe97e3aba6e7da3$var$getRemoteSvg(identifier, mediaClient).then((content)=>{
            setSvgUrl(content);
            setSource('remote');
        }).catch(onErrorRef.current);
    }, [
        identifier,
        fileState,
        mediaClient,
        onErrorRef,
        svgUrl
    ]);
    return {
        svgUrl: svgUrl,
        source: source
    };
};

});
parcelRegister("6AHKK", function(module, exports) {

$parcel$export(module.exports, "useCurrentValueRef", () => $dbbe900a6256c67c$export$b3e10e1f0fbb71db);

var $gwFzn = parcelRequire("gwFzn");
function $dbbe900a6256c67c$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $gwFzn.useRef)(value);
    ref.current = value;
    return ref;
}

});

parcelRegister("dbETJ", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $7ba3e974cac0549f$export$5cae361ad82dce8b);

var $gwFzn = parcelRequire("gwFzn");
function $7ba3e974cac0549f$export$5cae361ad82dce8b(value) {
    const ref = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("cXJTn", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $785905b405edb8f5$export$3ae94a2503e890a1);

var $9KYtE = parcelRequire("9KYtE");
const $785905b405edb8f5$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const $785905b405edb8f5$export$20911720278c41 = ({ day: day, month: month, year: year, hour: hour, minute: minute, dayPeriod: dayPeriod = '' })=>{
    const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month} ${year}, ${hour}:${minute} ${formattedDayPeriod}`;
};
const $785905b405edb8f5$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $9KYtE.createLocalizationProvider)(locale, $785905b405edb8f5$export$f34a3540a1aa68e4);
    return $785905b405edb8f5$export$20911720278c41(l10n.formatToParts(timestamp));
};

});

parcelRegister("550bQ", function(module, exports) {

$parcel$export(module.exports, "keyCodes", () => $9e2fc00106de4ec2$export$6d3e562ac77a9517);
$parcel$export(module.exports, "Shortcut", () => $9e2fc00106de4ec2$export$59451aa6b6270879);

var $gwFzn = parcelRequire("gwFzn");
const $9e2fc00106de4ec2$export$6d3e562ac77a9517 = {
    space: 'Space',
    m: 'KeyM',
    rightArrow: 'ArrowRight',
    leftArrow: 'ArrowLeft'
};
class $9e2fc00106de4ec2$export$59451aa6b6270879 extends (0, $gwFzn.Component) {
    componentDidMount() {
        this.init();
    }
    componentWillUnmount() {
        this.release();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.eventType = 'keydown';
        this.keyHandler = (e)=>{
            const { handler: handler, code: code } = this.props;
            if (code !== undefined && e.code === code) handler();
        };
        this.init = ()=>{
            const { eventType: eventType = 'keydown' } = this.props;
            this.eventType = eventType;
            document.addEventListener(this.eventType, this.keyHandler);
        };
        this.release = ()=>{
            document.removeEventListener(this.eventType, this.keyHandler);
        };
    }
}

});

parcelRegister("esd78", function(module, exports) {

$parcel$export(module.exports, "hideControlsClassName", () => $c93bff4886592e88$export$b0348b9bacdeb468);
const $c93bff4886592e88$export$b0348b9bacdeb468 = 'mvng-hide-controls';

});

parcelRegister("bSpVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0369c91b5556857$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Keep Media buttons to use static colors from the new color palette to support the hybrid
// theming in media viewer https://product-fabric.atlassian.net/browse/DSP-6067

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4KS7f = parcelRequire("4KS7f");
const $e0369c91b5556857$var$buttonTheme = {
    default: {
        background: {
            default: {
                light: 'transparent'
            },
            hover: {
                light: '#a1bdd914'
            },
            active: {
                light: '#a6c5e229'
            }
        },
        boxShadowColor: {
            focus: {
                light: '#85b8ff'
            }
        },
        color: {
            default: {
                light: '#c7d1db'
            },
            hover: {
                light: '#c7d1db'
            },
            active: {
                light: '#c7d1db'
            },
            disabled: {
                light: '#bfdbf847'
            },
            focus: {
                light: '#c7d1db'
            }
        }
    },
    primary: {
        background: {
            default: {
                light: '#579dff'
            },
            hover: {
                light: '#85b8ff'
            },
            active: {
                light: '#cce0ff'
            },
            disabled: {
                light: '#bcd6f00a'
            }
        },
        boxShadowColor: {
            focus: {
                light: '#85b8ff'
            }
        },
        color: {
            default: {
                light: '#161a1d'
            }
        }
    },
    selected: {
        color: {
            default: {
                light: 'red'
            }
        }
    }
};
function $e0369c91b5556857$var$extract(newTheme, { appearance: appearance, state: state, mode: mode }) {
    // @ts-ignore
    if (!newTheme[appearance]) return;
    // @ts-ignore
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            node = node[item];
            return;
        });
        return acc;
    }, {});
}
function $e0369c91b5556857$export$2e2bcd8739ae039({ appearance: appearance = 'default', buttonRef: buttonRef, ...rest }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4KS7f.default), {
        ...rest,
        ref: buttonRef,
        // Giving button the 'default' appearance so it can calculate the base styles
        appearance: appearance,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    // giving our extract function the real appearance value
                    ...$e0369c91b5556857$var$extract($e0369c91b5556857$var$buttonTheme, {
                        ...themeProps,
                        appearance: appearance
                    })
                },
                ...rest
            };
        }
    });
}

});

parcelRegister("cuqtp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fffd6491302c6769fb4d3b3ef483bcb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $917cd26bd0f586c3$var$_react = $917cd26bd0f586c3$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $917cd26bd0f586c3$var$_baseNew = $917cd26bd0f586c3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $917cd26bd0f586c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoHd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Single purpose - Reserved for enabling high definition videos
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $917cd26bd0f586c3$var$VideoHdIcon = (props)=>/*#__PURE__*/ $917cd26bd0f586c3$var$_react.default.createElement($917cd26bd0f586c3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M8.75 5h2.5c.97 0 1.75.78 1.75 1.75v2.5A1.75 1.75 0 0 1 11.25 11h-2.5zm1.5 1.5v3h1a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25zm-5.5.75V5h-1.5v6h1.5V8.75H6V11h1.5V5H6v2.25z" clip-rule="evenodd"/>`
    }, props));
$917cd26bd0f586c3$var$VideoHdIcon.displayName = 'VideoHdIcon';
var $917cd26bd0f586c3$var$_default = module.exports.default = $917cd26bd0f586c3$var$VideoHdIcon;

});

parcelRegister("ffVlp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f88e42987d85e82dbc4591352136384b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1b4bd1a56d13802$var$_react = $b1b4bd1a56d13802$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $b1b4bd1a56d13802$var$_baseNew = $b1b4bd1a56d13802$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b1b4bd1a56d13802$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoHdFilled".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Single purpose - Reserved to show that high definition is enabled for videos
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1b4bd1a56d13802$var$VideoHdFilledIcon = (props)=>/*#__PURE__*/ $b1b4bd1a56d13802$var$_react.default.createElement($b1b4bd1a56d13802$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.25 9.5v-3h1a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25z"/><path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.75 3v2.25H6V5h1.5v6H6V8.75H4.75V11h-1.5V5zm6.5 0h-2.5v6h2.5A1.75 1.75 0 0 0 13 9.25v-2.5A1.75 1.75 0 0 0 11.25 5" clip-rule="evenodd"/>`
    }, props));
$b1b4bd1a56d13802$var$VideoHdFilledIcon.displayName = 'VideoHdFilledIcon';
var $b1b4bd1a56d13802$var$_default = module.exports.default = $b1b4bd1a56d13802$var$VideoHdFilledIcon;

});

parcelRegister("9xAva", function(module, exports) {

$parcel$export(module.exports, "InactivityDetector", () => $c68922e1816745dc$export$d0e784e61b0f0774);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $esd78 = parcelRequire("esd78");

var $a6JW6 = parcelRequire("a6JW6");

var $boW5r = parcelRequire("boW5r");
const $c68922e1816745dc$var$mouseMovementDelay = 2000;
class $c68922e1816745dc$export$d0e784e61b0f0774 extends (0, $gwFzn.Component) {
    componentDidMount() {
        this.checkMouseMovement();
    }
    componentWillUnmount() {
        this.clearTimeout();
    }
    render() {
        const { controlsAreVisible: controlsAreVisible } = this.state;
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boW5r.InactivityDetectorWrapper), {
            ref: this.contentWrapperElement,
            controlsAreVisible: controlsAreVisible,
            onMouseMove: this.checkMouseMovement,
            onMouseOut: ()=>// Do not pass element, hence forcing elements to be hidden.
                this.checkMouseMovement(),
            onClick: this.checkMouseMovement,
            "data-testid": "inactivity-detector-wrapper",
            children: children(this.checkMouseMovement, controlsAreVisible)
        });
    }
    constructor(...args){
        super(...args);
        this.checkActivityTimeout = void 0;
        this.contentWrapperElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createRef();
        this.state = {
            controlsAreVisible: true
        };
        this.clearTimeout = ()=>{
            if (this.checkActivityTimeout) window.clearTimeout(this.checkActivityTimeout);
        };
        this.hideControls = (element)=>()=>{
                if (element) {
                    const isOverHideableElement = (0, $a6JW6.findParentByClassname)(element, (0, $esd78.hideControlsClassName), this.contentWrapperElement.current || undefined);
                    if (!isOverHideableElement) this.setState({
                        controlsAreVisible: false
                    });
                } else this.setState({
                    controlsAreVisible: false
                });
            };
        this.checkMouseMovement = (e)=>{
            const { controlsAreVisible: controlsAreVisible } = this.state;
            this.clearTimeout();
            // This check is needed to not trigger a render call on every movement.
            // Even if nothing will be re-renderer since the value is the same, it
            // will go into any children render method for nothing.
            if (!controlsAreVisible) this.setState({
                controlsAreVisible: true
            });
            this.checkActivityTimeout = window.setTimeout(this.hideControls(e && e.target), $c68922e1816745dc$var$mouseMovementDelay);
        };
    }
}

});
parcelRegister("boW5r", function(module, exports) {

$parcel$export(module.exports, "InactivityDetectorWrapper", () => $c825dd5bcc7de615$export$a2c17095eecb1344);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bkmqn = parcelRequire("bkmqn");

var $1pt35 = parcelRequire("1pt35");

var $dh538 = parcelRequire("dh538");
const $c825dd5bcc7de615$export$a2c17095eecb1344 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1pt35.InactivityDetectorWrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bkmqn.InactivityDetectorWrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("bkmqn", function(module, exports) {

$parcel$export(module.exports, "InactivityDetectorWrapper", () => $f07ee48ae6bf59f7$export$a2c17095eecb1344);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $esd78 = parcelRequire("esd78");

var $gwrgp = parcelRequire("gwrgp");
const $f07ee48ae6bf59f7$var$handleControlsVisibility = ({ controlsAreVisible: controlsAreVisible })=>`
  transition: opacity .3s;
  opacity: ${controlsAreVisible ? '1' : '0'};
`;
const $f07ee48ae6bf59f7$export$a2c17095eecb1344 = (0, $gwrgp.default)("div", {
    target: "eb6906k0"
})("width:100%;height:100%;display:flex;flex:1;overflow:visible;align-items:center;justify-content:center;position:relative;.", (0, $esd78.hideControlsClassName), "{", $f07ee48ae6bf59f7$var$handleControlsVisibility, ";}");
$f07ee48ae6bf59f7$export$a2c17095eecb1344.displayName = 'InactivityDetectorWrapper';

});

parcelRegister("1pt35", function(module, exports) {

$parcel$export(module.exports, "InactivityDetectorWrapper", () => $3501ade96904726b$export$a2c17095eecb1344);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $3501ade96904726b$var$inactivityDetectorWrapperStyles = null;
const $3501ade96904726b$var$inactivityDetectorControlsVisibleStyles = null;
const $3501ade96904726b$var$inactivityDetectorControlsNotVisibleStyles = null;
const $3501ade96904726b$export$a2c17095eecb1344 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ controlsAreVisible: controlsAreVisible, children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        ...props,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reoewfl _18m9ewfl _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1vqgg17y",
            controlsAreVisible && "_bq91kb7n",
            !controlsAreVisible && "_bq91idpf"
        ]),
        children: children
    });
});

});



parcelRegister("7YEWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9dac8ccc4d1b894102a944d61ac4f665>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cede6a65f901a4e$var$_react = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5cede6a65f901a4e$var$_baseNew = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5cede6a65f901a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cede6a65f901a4e$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $5cede6a65f901a4e$var$_react.default.createElement($5cede6a65f901a4e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5cede6a65f901a4e$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $5cede6a65f901a4e$var$_default = module.exports.default = $5cede6a65f901a4e$var$VideoPauseIcon;

});

parcelRegister("lm1k2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b0438824a8e962af0b238dcbe99fc6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8bcad9bd9936a5a$var$_react = $f8bcad9bd9936a5a$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f8bcad9bd9936a5a$var$_baseNew = $f8bcad9bd9936a5a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f8bcad9bd9936a5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VolumeHigh".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/volume-high
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8bcad9bd9936a5a$var$VolumeHighIcon = (props)=>/*#__PURE__*/ $f8bcad9bd9936a5a$var$_react.default.createElement($f8bcad9bd9936a5a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.233 1.434C8.125.672 9.5 1.307 9.5 2.48v11.04c0 1.174-1.375 1.808-2.267 1.047l-2.87-2.447A.5.5 0 0 0 4.04 12H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2.04a.5.5 0 0 0 .324-.12zM8 2.75 5.337 5.02a2 2 0 0 1-1.298.48H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.04a2 2 0 0 1 1.297.478L8 13.249zm4.97 8.719a4.907 4.907 0 0 0 0-6.94l1.06-1.06a6.407 6.407 0 0 1 0 9.06zm-2-2a2.08 2.08 0 0 0 0-2.94l1.06-1.06a3.58 3.58 0 0 1 0 5.06z" clip-rule="evenodd"/>`
    }, props));
$f8bcad9bd9936a5a$var$VolumeHighIcon.displayName = 'VolumeHighIcon';
var $f8bcad9bd9936a5a$var$_default = module.exports.default = $f8bcad9bd9936a5a$var$VolumeHighIcon;

});

parcelRegister("d25NA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97cff5ca1e27ee1f$var$_react = $97cff5ca1e27ee1f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $97cff5ca1e27ee1f$var$_lockLocked = $97cff5ca1e27ee1f$var$_interopRequireDefault((parcelRequire("9Q2dU")));

var $97cff5ca1e27ee1f$var$_lock = $97cff5ca1e27ee1f$var$_interopRequireDefault((parcelRequire("kfDgS")));
function $97cff5ca1e27ee1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97cff5ca1e27ee1f$var$LockLockedIcon = (props)=>/*#__PURE__*/ $97cff5ca1e27ee1f$var$_react.default.createElement($97cff5ca1e27ee1f$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $97cff5ca1e27ee1f$var$_lock.default
    }, props));
$97cff5ca1e27ee1f$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $97cff5ca1e27ee1f$var$_default = module.exports.default = $97cff5ca1e27ee1f$var$LockLockedIcon;

});

parcelRegister("h49AA", function(module, exports) {

$parcel$export(module.exports, "useShouldNestedElementRender", () => $cb0ef5a8a7f37bd1$export$37e8646a1abfc3e6);

var $gwFzn = parcelRequire("gwFzn");
const $cb0ef5a8a7f37bd1$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $cb0ef5a8a7f37bd1$export$f24166abe9ed712b = ()=>{
    const context = (0, $gwFzn.useContext)($cb0ef5a8a7f37bd1$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $cb0ef5a8a7f37bd1$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $gwFzn.useContext)($cb0ef5a8a7f37bd1$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});

parcelRegister("fJM5Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::381b22bd685279283aab9e50361768ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7505d4a6629268d$var$_react = $b7505d4a6629268d$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $b7505d4a6629268d$var$_baseNew = $b7505d4a6629268d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b7505d4a6629268d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7505d4a6629268d$var$HomeIcon = (props)=>/*#__PURE__*/ $b7505d4a6629268d$var$_react.default.createElement($b7505d4a6629268d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.798V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.798a2 2 0 0 1 .646-1.471zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.367V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.798a.5.5 0 0 0-.162-.367z" clip-rule="evenodd"/>`
    }, props));
$b7505d4a6629268d$var$HomeIcon.displayName = 'HomeIcon';
var $b7505d4a6629268d$var$_default = module.exports.default = $b7505d4a6629268d$var$HomeIcon;

});

parcelRegister("26gV0", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $187943fa6466b18f$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$187943fa6466b18f$var$debounce.debounce = $187943fa6466b18f$var$debounce;
module.exports = $187943fa6466b18f$var$debounce;

});

parcelRegister("2qY37", function(module, exports) {

$parcel$export(module.exports, "default", () => $118484dfd30546b5$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $118484dfd30546b5$var$messages = (0, $2nPZH.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    }
});
var $118484dfd30546b5$export$2e2bcd8739ae039 = $118484dfd30546b5$var$messages;

});

parcelRegister("aCzn4", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $26c671ba196278bc$export$eddcd8a5b7e09991);
const $26c671ba196278bc$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

parcelRegister("gwLGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0849edb79868e00$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $7IxPz = parcelRequire("7IxPz");

var $6Z3KL = parcelRequire("6Z3KL");

var $gfYwW = parcelRequire("gfYwW");
function $c0849edb79868e00$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6Z3KL.default)(1, arguments);
    var defaultOptions = (0, $gfYwW.getDefaultOptions)();
    var weekStartsOn = (0, $7IxPz.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $4YLNd.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7vcce", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15069c31a0410504ca6fc11c34278f93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5764e39836e64cff$var$_react = $5764e39836e64cff$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5764e39836e64cff$var$_location = $5764e39836e64cff$var$_interopRequireDefault((parcelRequire("kPml2")));

var $5764e39836e64cff$var$_location2 = $5764e39836e64cff$var$_interopRequireDefault((parcelRequire("3Ry19")));
function $5764e39836e64cff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LocationIcon.
 * This component is LocationIcon, with `UNSAFE_fallbackIcon` set to "LocationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5764e39836e64cff$var$LocationIcon = (props)=>/*#__PURE__*/ $5764e39836e64cff$var$_react.default.createElement($5764e39836e64cff$var$_location.default, Object.assign({
        LEGACY_fallbackIcon: $5764e39836e64cff$var$_location2.default
    }, props));
$5764e39836e64cff$var$LocationIcon.Name = 'LocationIconMigration';
var $5764e39836e64cff$var$_default = module.exports.default = $5764e39836e64cff$var$LocationIcon;

});
parcelRegister("kPml2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a077d34b75af68b5a629fa3ed5b43193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f299e6000fe75318$var$_react = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f299e6000fe75318$var$_baseNew = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f299e6000fe75318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f299e6000fe75318$var$LocationIcon = (props)=>/*#__PURE__*/ $f299e6000fe75318$var$_react.default.createElement($f299e6000fe75318$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$f299e6000fe75318$var$LocationIcon.displayName = 'LocationIcon';
var $f299e6000fe75318$var$_default = module.exports.default = $f299e6000fe75318$var$LocationIcon;

});


parcelRegister("aRCWA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c90f995a462686dc43276b76786a54f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e8d10150b03f07c$var$_react = $7e8d10150b03f07c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $7e8d10150b03f07c$var$_baseNew = $7e8d10150b03f07c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7e8d10150b03f07c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e8d10150b03f07c$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $7e8d10150b03f07c$var$_react.default.createElement($7e8d10150b03f07c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$7e8d10150b03f07c$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $7e8d10150b03f07c$var$_default = module.exports.default = $7e8d10150b03f07c$var$EyeOpenStrikethroughIcon;

});

parcelRegister("gI8uy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2a757b422db13e6$var$_react = $c2a757b422db13e6$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c2a757b422db13e6$var$_baseNew = $c2a757b422db13e6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c2a757b422db13e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2a757b422db13e6$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c2a757b422db13e6$var$_react.default.createElement($c2a757b422db13e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c2a757b422db13e6$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c2a757b422db13e6$var$_default = module.exports.default = $c2a757b422db13e6$var$StarStarredIcon;

});

parcelRegister("kfYj7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79fdc87e6bc8c8ac301f370494c87ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebf3fd288c7f16e5$var$_react = $ebf3fd288c7f16e5$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $ebf3fd288c7f16e5$var$_baseNew = $ebf3fd288c7f16e5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ebf3fd288c7f16e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebf3fd288c7f16e5$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $ebf3fd288c7f16e5$var$_react.default.createElement($ebf3fd288c7f16e5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$ebf3fd288c7f16e5$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $ebf3fd288c7f16e5$var$_default = module.exports.default = $ebf3fd288c7f16e5$var$StarUnstarredIcon;

});

parcelRegister("8nlrk", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $6b7f2dce15d051f7$export$62aa48085237e36f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");

var $lAwme = parcelRequire("lAwme");

var $bUp2E = parcelRequire("bUp2E");
const $6b7f2dce15d051f7$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $gwFzn.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics((0, $bUp2E.profileCardRendered)(profileType, 'spinner'));
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAwme.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {})
    });
};

});

parcelRegister("549Do", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d0d333f98e7051cb18259ec390fd7c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b04cca9d5dc0b85$var$_react = $3b04cca9d5dc0b85$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $3b04cca9d5dc0b85$var$_baseNew = $3b04cca9d5dc0b85$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3b04cca9d5dc0b85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Basketball".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Sport emoji category.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b04cca9d5dc0b85$var$BasketballIcon = (props)=>/*#__PURE__*/ $3b04cca9d5dc0b85$var$_react.default.createElement($3b04cca9d5dc0b85$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.951 1.499a8 8 0 0 1-.05 4.192 15.5 15.5 0 0 1 2.148 1.24 8 8 0 0 1 3.605-2.14 6.47 6.47 0 0 0-2.404-2.42 6.47 6.47 0 0 0-3.299-.872m6.291 4.689A6.5 6.5 0 0 0 11.25 7.85c1.017.862 1.9 1.84 2.639 2.903.69-1.47.781-3.091.353-4.565m-1.232 5.955a13.7 13.7 0 0 0-2.704-3.126 6.48 6.48 0 0 0-.754 5.295 6.5 6.5 0 0 0 3.458-2.17M8.05 14.5a7.98 7.98 0 0 1 1.06-6.396 14 14 0 0 0-1.755-1.013q-.103.205-.22.408a7.98 7.98 0 0 1-4.788 3.709 6.47 6.47 0 0 0 2.404 2.42 6.47 6.47 0 0 0 3.299.872M1.758 9.812a6.48 6.48 0 0 0 4.208-3.3 13.7 13.7 0 0 0-4.059-.78 6.5 6.5 0 0 0-.15 4.08m.914-5.535a15 15 0 0 1 3.833.834 6.5 6.5 0 0 0-.057-3.423 6.48 6.48 0 0 0-3.776 2.589M6.836.085A7.97 7.97 0 0 1 12 1.072a7.97 7.97 0 0 1 3.437 3.979 7.99 7.99 0 0 1-.909 7.574 8 8 0 0 1-5.364 3.29A7.97 7.97 0 0 1 4 14.928 7.97 7.97 0 0 1 .563 10.95 7.99 7.99 0 0 1 1.072 4 7.99 7.99 0 0 1 6.836.085" clip-rule="evenodd"/>`
    }, props));
$3b04cca9d5dc0b85$var$BasketballIcon.displayName = 'BasketballIcon';
var $3b04cca9d5dc0b85$var$_default = module.exports.default = $3b04cca9d5dc0b85$var$BasketballIcon;

});

parcelRegister("c8wfa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a72127bfc0e3d91a970ca1d9129c37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d5f3e4f4e200334$var$_react = $8d5f3e4f4e200334$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8d5f3e4f4e200334$var$_baseNew = $8d5f3e4f4e200334$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8d5f3e4f4e200334$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d5f3e4f4e200334$var$FlagIcon = (props)=>/*#__PURE__*/ $8d5f3e4f4e200334$var$_react.default.createElement($8d5f3e4f4e200334$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$8d5f3e4f4e200334$var$FlagIcon.displayName = 'FlagIcon';
var $8d5f3e4f4e200334$var$_default = module.exports.default = $8d5f3e4f4e200334$var$FlagIcon;

});

parcelRegister("i5wNP", function(module, exports) {

$parcel$export(module.exports, "EndOfPageRecFeedbackForm", () => $c9b58423be6b0f98$export$17f0bdedcc6ce875);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $fb3kw = parcelRequire("fb3kw");

var $9EtP6 = parcelRequire("9EtP6");

var $inPa6 = parcelRequire("inPa6");

var $dThp5 = parcelRequire("dThp5");

var $bQm3c = parcelRequire("bQm3c");

var $ihn35 = parcelRequire("ihn35");

var $6oZiN = parcelRequire("6oZiN");
const $c9b58423be6b0f98$export$a50d500033c15d61 = ({ closeSurvey: closeSurvey, entityId: entityId, recIds: recIds, sources: sources, spaceKey: spaceKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [completed, setCompleted] = (0, $gwFzn.useState)(false);
    const [dismiss, setDismiss] = (0, $gwFzn.useState)(false);
    const secondQuestion = (0, $gwFzn.useRef)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        if (dismiss) closeSurvey();
    }, [
        dismiss,
        closeSurvey
    ]);
    const secondFeedback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: "feedBackTextTwo",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ihn35.FeedbackFormQuestion), null, intl.formatMessage((0, $6oZiN.i18n).feedbackSecondFollowup))
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EtP6.default), {
            ...fieldProps,
            onChange: (event)=>{
                secondQuestion.current = event.target.value;
            },
            value: secondQuestion.current,
            maxHeight: "256px",
            rows: 3
        }));
    const handleFormData = (0, $gwFzn.useCallback)(({ reaction: reaction, feedback: feedback, submitted: submitted, dismissed: dismissed })=>{
        if (dismissed) setDismiss(true);
        else if (submitted) {
            if (spaceKey) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'submitted',
                    actionSubject: 'survey',
                    actionSubjectId: 'endOfPageRecsFeedbackForm',
                    source: 'endOfPageSpaceSettings',
                    attributes: {
                        rating: reaction.value,
                        questionOne: feedback,
                        userId: userId
                    },
                    objectId: spaceKey
                }
            }).fire();
            else createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'submitted',
                    actionSubject: 'survey',
                    actionSubjectId: 'endOfPageRecsFeedbackForm',
                    source: 'endOfPageRecsScreen',
                    attributes: {
                        rating: reaction.value,
                        questionOne: feedback,
                        questionTwo: secondQuestion.current,
                        recommendedIds: recIds,
                        sources: sources,
                        userId: userId
                    },
                    objectId: entityId
                }
            }).fire();
            setCompleted(true);
        }
    }, [
        setDismiss,
        createAnalyticsEvent,
        setCompleted,
        entityId,
        recIds,
        sources,
        userId,
        spaceKey
    ]);
    const reactions = [
        intl.formatMessage((0, $6oZiN.i18n).terrible),
        intl.formatMessage((0, $6oZiN.i18n).bad),
        intl.formatMessage((0, $6oZiN.i18n).okay),
        intl.formatMessage((0, $6oZiN.i18n).good),
        intl.formatMessage((0, $6oZiN.i18n).great)
    ];
    const questions = reactions.map(()=>intl.formatMessage((0, $6oZiN.i18n).feedbackFollowup));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dThp5.SatisfactionSurveyComponent), {
        title: intl.formatMessage((0, $6oZiN.i18n).feedbackTitle),
        description: intl.formatMessage((0, $6oZiN.i18n).feedbackDescription),
        finalTitle: intl.formatMessage((0, $6oZiN.i18n).feedbackConfirmation),
        finalDescription: intl.formatMessage((0, $6oZiN.i18n).feedbackConfirmationDescription),
        submitButtonText: intl.formatMessage((0, $6oZiN.i18n).feedbackSubmit),
        closeButtonText: intl.formatMessage((0, $6oZiN.i18n).feedbackCancel),
        reactionTitles: reactions,
        formQuestions: questions,
        isOnFinalStage: completed,
        onInteraction: handleFormData,
        customFields: !spaceKey ? secondFeedback : undefined
    });
};
const $c9b58423be6b0f98$export$17f0bdedcc6ce875 = ({ closeSurvey: closeSurvey, entityId: entityId, recIds: recIds, sources: sources, spaceKey: spaceKey, shouldReturnFocus: shouldReturnFocus })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "-feedback-survey"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dThp5.SatisfactionSurveyModal), {
        size: "medium",
        shouldReturnFocus: shouldReturnFocus,
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c9b58423be6b0f98$export$a50d500033c15d61, {
        closeSurvey: closeSurvey,
        entityId: entityId,
        sources: sources,
        recIds: recIds,
        spaceKey: spaceKey
    })));
};

});
parcelRegister("dThp5", function(module, exports) {

$parcel$export(module.exports, "SatisfactionSurveyFlag", () => $6044f8874c394072$export$c92860d290431d87);
$parcel$export(module.exports, "SatisfactionSurveyComponent", () => $6044f8874c394072$export$9102ca613e8d6cb);
$parcel$export(module.exports, "SatisfactionSurveyModal", () => $6044f8874c394072$export$f3dbdc3fe3ac5f78);
$parcel$export(module.exports, "SatisfactionSurveyOnlyTextBoxComponent", () => $6044f8874c394072$export$a0ec6bdaa5ccfdb);

var $jmjWc = parcelRequire("jmjWc");


const $6044f8874c394072$export$c92860d290431d87 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EkC3M",
    name: "SatisfactionSurveyFlag",
    loader: async ()=>(await (parcelRequire("eN1bG"))).SatisfactionSurveyFlag
});

const $6044f8874c394072$export$9102ca613e8d6cb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "PiCZk",
    name: "SatisfactionSurveyComponent",
    loader: async ()=>(await (parcelRequire("5VttZ"))).SatisfactionSurveyComponent
});

const $6044f8874c394072$export$f3dbdc3fe3ac5f78 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TlKiY",
    name: "SatisfactionSurveyModal",
    loader: async ()=>(await (parcelRequire("8ITf9"))).SatisfactionSurveyModal
});

const $6044f8874c394072$export$a0ec6bdaa5ccfdb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "na9Ro",
    name: "SatisfactionSurveyOnlyTextBoxComponent",
    loader: async ()=>(await (parcelRequire("3HaNi"))).SatisfactionSurveyOnlyTextBoxComponent
});

});
parcelRegister("eN1bG", function(module, exports) {

let $ac4690158f88ac37$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ac4690158f88ac37$var$load("iAaum"),
    $ac4690158f88ac37$var$load("l179X"),
    $ac4690158f88ac37$var$load("f8xBv"),
    $ac4690158f88ac37$var$load("c6MKV"),
    $ac4690158f88ac37$var$load("aZinD"),
    $ac4690158f88ac37$var$load("joJy8"),
    $ac4690158f88ac37$var$load("aHE9G"),
    $ac4690158f88ac37$var$load("jE5XU")
]).then(()=>parcelRequire('alFtm'));

});

parcelRegister("5VttZ", function(module, exports) {

let $45092547311d9a25$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $45092547311d9a25$var$load("iAaum"),
    $45092547311d9a25$var$load("l179X"),
    $45092547311d9a25$var$load("c6MKV"),
    $45092547311d9a25$var$load("aZinD"),
    $45092547311d9a25$var$load("joJy8"),
    $45092547311d9a25$var$load("aHE9G"),
    $45092547311d9a25$var$load("f8xBv")
]).then(()=>parcelRequire('21rGX'));

});

parcelRegister("8ITf9", function(module, exports) {

let $659d48f98314981e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $659d48f98314981e$var$load("iAaum"),
    $659d48f98314981e$var$load("l179X"),
    $659d48f98314981e$var$load("f8xBv"),
    $659d48f98314981e$var$load("c6MKV"),
    $659d48f98314981e$var$load("aZinD"),
    $659d48f98314981e$var$load("joJy8"),
    $659d48f98314981e$var$load("aHE9G"),
    $659d48f98314981e$var$load("9lDKI")
]).then(()=>parcelRequire('68LQc'));

});

parcelRegister("3HaNi", function(module, exports) {

let $2b0dc2bd28dfc59c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2b0dc2bd28dfc59c$var$load("iAaum"),
    $2b0dc2bd28dfc59c$var$load("l179X"),
    $2b0dc2bd28dfc59c$var$load("c6MKV"),
    $2b0dc2bd28dfc59c$var$load("aZinD"),
    $2b0dc2bd28dfc59c$var$load("joJy8"),
    $2b0dc2bd28dfc59c$var$load("aHE9G"),
    $2b0dc2bd28dfc59c$var$load("9FFAj")
]).then(()=>parcelRequire('jW3wg'));

});


parcelRegister("ihn35", function(module, exports) {

$parcel$export(module.exports, "EndOfPageRecContainer", () => $e8a7d12ee4dfec6a$export$762e81e2e5e5fd21);
$parcel$export(module.exports, "EndOfPageRecPlaceholderContainer", () => $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d);
$parcel$export(module.exports, "EndOfPageRecHeader", () => $e8a7d12ee4dfec6a$export$efb20161e583b9b8);
$parcel$export(module.exports, "HeaderFrontContainer", () => $e8a7d12ee4dfec6a$export$80837d77c7223a53);
$parcel$export(module.exports, "HeaderLineContainer", () => $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a);
$parcel$export(module.exports, "InfoContainer", () => $e8a7d12ee4dfec6a$export$48423cf6a25b5248);
$parcel$export(module.exports, "FeedbackContainer", () => $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1);
$parcel$export(module.exports, "EndOfPageRecAdminConfigContainer", () => $e8a7d12ee4dfec6a$export$227f3f793075b973);
$parcel$export(module.exports, "EndOfPageRecHideControlContainer", () => $e8a7d12ee4dfec6a$export$545440ab15c19255);
$parcel$export(module.exports, "EndOfPageRecHideToggleContainer", () => $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab);
$parcel$export(module.exports, "EndOfPageRecDefaultContainer", () => $e8a7d12ee4dfec6a$export$a436177ded449686);
$parcel$export(module.exports, "EndOfPageRecDefaultTitleContainer", () => $e8a7d12ee4dfec6a$export$faaa5da096482ae9);
$parcel$export(module.exports, "SpaceFeedbackButtonWrapper", () => $e8a7d12ee4dfec6a$export$a1abff0c22b50819);
$parcel$export(module.exports, "FeedbackFormQuestion", () => $e8a7d12ee4dfec6a$export$23b4998b204f6604);
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");
const $e8a7d12ee4dfec6a$export$762e81e2e5e5fd21 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1m0m4uv": (0, $iAWao.default)(__cmplp.maxWidth)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _2lx21bp4 _1bah1h6o _n3tdv47k _p12foqa0 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qoahv _n3tdv47k _p12fukw8 _1bsb1osq _4t3i68cl",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$efb20161e583b9b8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8140y _1e0c1txw _1bah1yb4 _4cvr1h6o _n3tdu2gc",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$80837d77c7223a53 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _bfhkm7j4 _4t3it94y _1bsbidpf",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$48423cf6a25b5248 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulputpp _11c82smr _1yt44ar7 _1e0c1txw _2lx21bp4 _p12fsb0t",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$49166591ec160d97 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$ee3e739bedcb3f4c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2lx2vrvc _1n261g80 _zulppxbi _1e0c1txw _4t3i1obz _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$227f3f793075b973 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulp1ejb _11c82smr _1e0c1txw _2lx21bp4 _u5f3xncg _p12f10k3",
            !__cmplp.isNav4Enabled && "_19bvv47k",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$545440ab15c19255 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulputpp _11c81vhk _syaz1gjq _1e0c1txw _4cvr1h6o _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$a436177ded449686 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o _19bvutpp",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$faaa5da096482ae9 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81vhk _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$a1abff0c22b50819 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $e8a7d12ee4dfec6a$export$23b4998b204f6604 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81vhk _syaz1gjq _n3tdu2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lnHWt", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $f90dd4f31f478051$export$c9058316764c140e);

var $8P7n3 = parcelRequire("8P7n3");

var $iCfa4 = parcelRequire("iCfa4");
function $f90dd4f31f478051$export$c9058316764c140e(refs) {
    return (0, $iCfa4.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $8P7n3.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("iCfa4", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $d8d78957d5b42a03$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $d8d78957d5b42a03$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("24xEE", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $f4e2c76b2dc4439a$export$30ab340faaed55d4);

var $gwFzn = parcelRequire("gwFzn");
const $f4e2c76b2dc4439a$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $gwFzn.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f4e2c76b2dc4439a$export$30ab340faaed55d4 = (experience)=>{
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f4e2c76b2dc4439a$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("2sbaw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c96dc2d86b32a61$var$_react = $1c96dc2d86b32a61$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $1c96dc2d86b32a61$var$_arrowUpRight = $1c96dc2d86b32a61$var$_interopRequireDefault((parcelRequire("69PnT")));

var $1c96dc2d86b32a61$var$_open = $1c96dc2d86b32a61$var$_interopRequireDefault((parcelRequire("5JtnX")));
function $1c96dc2d86b32a61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c96dc2d86b32a61$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $1c96dc2d86b32a61$var$_react.default.createElement($1c96dc2d86b32a61$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $1c96dc2d86b32a61$var$_open.default
    }, props));
$1c96dc2d86b32a61$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $1c96dc2d86b32a61$var$_default = module.exports.default = $1c96dc2d86b32a61$var$ArrowUpRightIcon;

});
parcelRegister("69PnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bb7135644f74cd$var$_react = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $47bb7135644f74cd$var$_baseNew = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $47bb7135644f74cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47bb7135644f74cd$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $47bb7135644f74cd$var$_react.default.createElement($47bb7135644f74cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$47bb7135644f74cd$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $47bb7135644f74cd$var$_default = module.exports.default = $47bb7135644f74cd$var$ArrowUpRightIcon;

});


parcelRegister("14Meb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95792f9115c7157853016297128836bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c8b9335913bb3f0$var$_react = $0c8b9335913bb3f0$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0c8b9335913bb3f0$var$_settings = $0c8b9335913bb3f0$var$_interopRequireDefault((parcelRequire("fIcbd")));

var $0c8b9335913bb3f0$var$_settings2 = $0c8b9335913bb3f0$var$_interopRequireDefault((parcelRequire("b0kd3")));
function $0c8b9335913bb3f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "SettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c8b9335913bb3f0$var$SettingsIcon = (props)=>/*#__PURE__*/ $0c8b9335913bb3f0$var$_react.default.createElement($0c8b9335913bb3f0$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $0c8b9335913bb3f0$var$_settings2.default
    }, props));
$0c8b9335913bb3f0$var$SettingsIcon.Name = 'SettingsIconMigration';
var $0c8b9335913bb3f0$var$_default = module.exports.default = $0c8b9335913bb3f0$var$SettingsIcon;

});

parcelRegister("cQDYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b2ee147542345d$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkn82g _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusn82g _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31osq",
    icon: "_rfx31l7b",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1xs8 _10881xs8 _18lgp3kn _zo24p3kn _1hfkn82g _1rusn82g",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;

});

parcelRegister("9Yv8Z", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudge", () => $98d1a77db1df3900$export$c09847f3a2ea8c56);
$parcel$export(module.exports, "OnboardingCTANudge", () => $98d1a77db1df3900$export$17d9cbc681ed8f19);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $98d1a77db1df3900$export$c09847f3a2ea8c56 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cS0IY",
    name: "OnboardingNudge",
    loader: async ()=>(await (parcelRequire("1qd3V"))).OnboardingNudge,
    loading: ({ children: children, renderChildrenWhileLoading: renderChildrenWhileLoading })=>renderChildrenWhileLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children) : null
});

const $98d1a77db1df3900$export$17d9cbc681ed8f19 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-pb3D",
    name: "OnboardingCTANudge",
    loader: async ()=>(await (parcelRequire("30k6T"))).OnboardingCTANudge,
    loading: ({ children: children, renderChildrenWhileLoading: renderChildrenWhileLoading })=>renderChildrenWhileLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children) : null
});

});
parcelRegister("1qd3V", function(module, exports) {

let $10925a144b29cb7f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $10925a144b29cb7f$var$load("iAaum"),
    $10925a144b29cb7f$var$load("6vzdH"),
    $10925a144b29cb7f$var$load("aZwOd"),
    $10925a144b29cb7f$var$load("k9ktU")
]).then(()=>parcelRequire('iFaMg'));

});

parcelRegister("30k6T", function(module, exports) {

let $2300f8a35413e09c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2300f8a35413e09c$var$load("iAaum"),
    $2300f8a35413e09c$var$load("6vzdH"),
    $2300f8a35413e09c$var$load("aZwOd"),
    $2300f8a35413e09c$var$load("k9ktU"),
    $2300f8a35413e09c$var$load("8Kyi2")
]).then(()=>parcelRequire('4I77f'));

});


parcelRegister("dH6p2", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $ad7aee5d47af256f$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dTk3A = parcelRequire("dTk3A");
var $6fnsQ = parcelRequire("6fnsQ");

var $dh538 = parcelRequire("dh538");
const $ad7aee5d47af256f$var$baseShadow = '0 0 0 3px';
const $ad7aee5d47af256f$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $6fnsQ).P75})`;
const $ad7aee5d47af256f$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $ad7aee5d47af256f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $ad7aee5d47af256f$var$pulseAnimation = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $ad7aee5d47af256f$var$easing,
    animationIterationCount: 'infinite'
});
const $ad7aee5d47af256f$var$pseudoStyle = (0, $3jLHL.css)({
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
});
const $ad7aee5d47af256f$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>(0, $3jLHL.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $ad7aee5d47af256f$var$pulseAnimation
            ]
        }
    });
const $ad7aee5d47af256f$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $dTk3A.borderRadius)(), pulseColor: pulseColor = $ad7aee5d47af256f$var$basePulseColor, pulseShadowColor: pulseShadowColor = $ad7aee5d47af256f$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $3jLHL.jsx)(CastTargetContainer, {
        css: [
            $ad7aee5d47af256f$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $dh538.fg)('jira_onboarding_experiences_a11y_fixes') && $ad7aee5d47af256f$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $ad7aee5d47af256f$var$inHeritWidthStyles = (0, $3jLHL.css)({
    width: 'inherit'
});

});

parcelRegister("gfIPU", function(module, exports) {

$parcel$export(module.exports, "ExperienceFailure", () => $5675860ef242c9e4$export$eed1d73ebdd8c7ab);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $5675860ef242c9e4$export$eed1d73ebdd8c7ab({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.fail({
            name: name,
            error: error,
            attributes: attributes
        }), [
        experienceTracker,
        name,
        error,
        attributes
    ]);
    return null;
}

});

parcelRegister("3hLsK", function(module, exports) {

$parcel$export(module.exports, "ORIGIN_ATTRIBUTES", () => $5b23a7bd3e23e56e$export$517f3026b656d37a);
$parcel$export(module.exports, "QUICKSTART_STATE_KEYS", () => $5b23a7bd3e23e56e$export$67d2bdeab932157d);
$parcel$export(module.exports, "INTEGRATION_TASK", () => $5b23a7bd3e23e56e$export$d05456a8ea0de639);
$parcel$export(module.exports, "JSW_XFLOW_SWITCHER_TOUR_TASK", () => $5b23a7bd3e23e56e$export$46c46696b5a7ae4f);
$parcel$export(module.exports, "JSW_CONFLUENCE_INTRO_TASK", () => $5b23a7bd3e23e56e$export$93034abc7a9a36e);
$parcel$export(module.exports, "JSW_CONFLUENCE_MODAL", () => $5b23a7bd3e23e56e$export$f72f5e831f728bdb);
$parcel$export(module.exports, "SHOW_SWITCHER_SPOTLIGHT_ONLY", () => $5b23a7bd3e23e56e$export$d9362ed0ac94a9f8);
$parcel$export(module.exports, "QSV2_INVITE_TEAMMATE_TASK", () => $5b23a7bd3e23e56e$export$6e0ac6a22e470ae2);
$parcel$export(module.exports, "QSV2_CONFLUENCE_GUIDE_TASK", () => $5b23a7bd3e23e56e$export$bf35811a56a7cd87);
$parcel$export(module.exports, "QSV2_INTEGRATION_TASK", () => $5b23a7bd3e23e56e$export$417c74a93b7a4bc9);
$parcel$export(module.exports, "QSV2_SITE_TOUR_TASK", () => $5b23a7bd3e23e56e$export$2f37c8b16273f56e);
$parcel$export(module.exports, "QSV2_SPOTLIGHT", () => $5b23a7bd3e23e56e$export$e3400d8b82a2f6c1);
$parcel$export(module.exports, "MIGRATIONS_WELCOME_TASK", () => $5b23a7bd3e23e56e$export$cec5ff8d02753e42);
$parcel$export(module.exports, "MIGRATIONS_NEW_PAGE_TASK", () => $5b23a7bd3e23e56e$export$291c48af440cb477);
$parcel$export(module.exports, "MIGRATIONS_COLLABORATE_TASK", () => $5b23a7bd3e23e56e$export$af64633856549760);
$parcel$export(module.exports, "MIGRATIONS_FIND_AND_ORGANIZE_PAGES_TASK", () => $5b23a7bd3e23e56e$export$c85b665118ff388b);
$parcel$export(module.exports, "MIGRATIONS_EDIT_AND_CUSTOMIZE_CONTENT_TASK", () => $5b23a7bd3e23e56e$export$91579532952a6b5);
$parcel$export(module.exports, "NQSV2_HELP_TASK", () => $5b23a7bd3e23e56e$export$d9afba8e0525ce5f);
$parcel$export(module.exports, "NQSV2_CONFLUENCE_101_TASK", () => $5b23a7bd3e23e56e$export$2da9139b7da400a3);
$parcel$export(module.exports, "NQSV2_CREATE_TASK", () => $5b23a7bd3e23e56e$export$7a6989d0bcfe7ca9);
$parcel$export(module.exports, "NQSV2_COLLABORATE_TASK", () => $5b23a7bd3e23e56e$export$96076d1ee44d366);
$parcel$export(module.exports, "TASK_ID_TO_STATE_KEY", () => $5b23a7bd3e23e56e$export$1f520c852194e989);
$parcel$export(module.exports, "IGNORE_COMPLETE_TASK_ON_TOGGLE", () => $5b23a7bd3e23e56e$export$2883f67b1bf0f40c);
const $5b23a7bd3e23e56e$export$517f3026b656d37a = 'onboarding-origin-state:attributes';
const $5b23a7bd3e23e56e$export$67d2bdeab932157d = {
    IS_PANEL_OPEN: 'quickstart-state:isPanelOpen',
    IS_DISMISSED: 'quickstart-state:isDismissed',
    OPEN_TASK_ID: 'quickstart-state:openTaskId',
    OPEN_COMPONENT_ID: 'quickstart-state:openComponentId',
    JSW_CONFLUENCE_INTRO_TASK: 'quickstart-state:jswConfIntroCompleted',
    HELP_COMPLETED: 'quickstart-state:helpCompleted',
    SPACE_MODAL_COMPLETED: 'quickstart-state:spaceModalCompleted',
    SPACE_TOUR_COMPLETED: 'quickstart-state:spaceTourCompleted',
    COLLABORATE_COMPLETED: 'quickstart-state:collaborateCompleted',
    HOME_MODAL_COMPLETED: 'quickstart-state:homeModalCompleted',
    HOME_TOUR_COMPLETED: 'quickstart-state:homeTourCompleted',
    MOBILE_COMPLETED: 'quickstart-state:mobileCompleted',
    HAS_SEEN_DISMISSED_FLAG: 'quickstart-state:hasSeenDismissedFlag',
    IS_MIGRATED_USER_V2: 'quickstart-state:isMigratedUserV2',
    JSW_XFLOW_SWITCHER_TOUR_TASK: 'quickstart-state:jswXflowSwitcherTourCompleted',
    ORIGIN_ATTRIBUTES: $5b23a7bd3e23e56e$export$517f3026b656d37a,
    JSW_CONFLUENCE_MODAL: 'quickstart-state:jswXFlowModalCompleted',
    EDITOR_TUTORIAL_TASK_COMPLETED: 'quickstart-state:editorTutorialTaskCompleted',
    QSV2_READ_GUIDE_COMPLETED: 'quickstart-state:qsv2ReadConfluenceGuideCompleted',
    QSV2_INVITE_TEAMMATE_TASK: 'quickstart-state:qsv2InviteTeammateCompleted',
    QSV2_INTEGRATION_TASK: 'quickstart-state:qsv2IntegrationCompleted',
    QSV2_VIDEO_TOUR_COMPLETED: 'quickstart-state:qsv2SiteVideoTourCompleted',
    QSV2_SPOTLIGHT_COMPLETED: 'quickstart-state:qsv2SpotlightCompleted',
    MIGRATIONS_WELCOME_TASK: 'quickstart-state:migrationsWelcomeCompleted',
    MIGRATIONS_NEW_PAGE_TASK: 'quickstart-state:migrationsNewPageCompleted',
    MIGRATIONS_COLLABORATE_TASK: 'quickstart-state:migrationsCollaborateCompleted',
    MIGRATIONS_FIND_AND_ORGANIZE_PAGES_COMPLETED: 'quickstart-state:migrationsFindAndOrganizePagesCompleted',
    MIGRATIONS_EDIT_AND_CUSTOMIZE_CONTENT_TASK: 'quickstart-state:migrationsEditAndCustomizeContentCompleted',
    SIMPLIFY_ADMIN_RENAME_TASK: 'quickstart-state:simplifyAdminRenameSiteCompleted',
    NQSV2_HELP_TASK_COMPLETED: 'quickstart-state:nqsv2HelpCompleted',
    NQSV2_CREATE_TASK_COMPLETED: 'quickstart-state:nqsv2CreateCompleted',
    NQSV2_COLLABORATE_TASK_COMPLETED: 'quickstart-state:nqsv2CollaborateCompleted',
    NQSV2_CONFLUENCE_101_TASK: 'quickstart-state:nqsv2Confluence101Completed'
};
const $5b23a7bd3e23e56e$export$69afb55780da55ef = 'quickstart-checklist.invite-teammate';
const $5b23a7bd3e23e56e$export$d05456a8ea0de639 = 'quickstart-checklist.integration';
const $5b23a7bd3e23e56e$export$46c46696b5a7ae4f = 'quickstart-checklist.jsw-xflow-switcher-tour';
const $5b23a7bd3e23e56e$export$93034abc7a9a36e = 'quickstart-checklist.jsw-conf-intro';
const $5b23a7bd3e23e56e$export$f72f5e831f728bdb = 'quickstart-checklist.jswXFlowModalCompleted';
const $5b23a7bd3e23e56e$export$d9362ed0ac94a9f8 = 'SHOW_SWITCHER_SPOTLIGHT_ONLY';
const $5b23a7bd3e23e56e$export$6e0ac6a22e470ae2 = 'quickstart-checklist.invite-teammate-v2';
const $5b23a7bd3e23e56e$export$bf35811a56a7cd87 = 'quickstart-checklist.confluence-guide-v2';
const $5b23a7bd3e23e56e$export$417c74a93b7a4bc9 = 'quickstart-checklist.integration-v2';
const $5b23a7bd3e23e56e$export$2f37c8b16273f56e = 'quickstart-checklist.site-tour-v2';
const $5b23a7bd3e23e56e$export$e3400d8b82a2f6c1 = 'quickstart-checklist.close-spotlight';
const $5b23a7bd3e23e56e$export$cec5ff8d02753e42 = 'quickstart-checklist.migrations.welcome';
const $5b23a7bd3e23e56e$export$291c48af440cb477 = 'quickstart-checklist.migrations.new-page';
const $5b23a7bd3e23e56e$export$af64633856549760 = 'quickstart-checklist.migrations.collaborate';
const $5b23a7bd3e23e56e$export$c85b665118ff388b = 'quickstart-checklist.migrations.find-and-organize-pages';
const $5b23a7bd3e23e56e$export$91579532952a6b5 = 'quickstart-checklist.migrations.edit-and-customize-content';
const $5b23a7bd3e23e56e$export$d521d3f5ee5a7baa = 'quickstart-checklist.simplify.admin.rename-site';
const $5b23a7bd3e23e56e$export$d9afba8e0525ce5f = 'quickstart-checklist.nth-user-v2.help';
const $5b23a7bd3e23e56e$export$2da9139b7da400a3 = 'quickstart-checklist.nth-user-v2.confluence-101';
const $5b23a7bd3e23e56e$export$7a6989d0bcfe7ca9 = 'quickstart-checklist.nth-user-v2.create';
const $5b23a7bd3e23e56e$export$96076d1ee44d366 = 'quickstart-checklist.nth-user-v2.collaborate';
const $5b23a7bd3e23e56e$export$1f520c852194e989 = {
    [$5b23a7bd3e23e56e$export$69afb55780da55ef]: 'inviteTeammateCompleted',
    [$5b23a7bd3e23e56e$export$d05456a8ea0de639]: 'integrationCompleted',
    [$5b23a7bd3e23e56e$export$46c46696b5a7ae4f]: 'jswXflowSwitcherTourCompleted',
    [$5b23a7bd3e23e56e$export$93034abc7a9a36e]: 'jswConfIntroCompleted',
    [$5b23a7bd3e23e56e$export$f72f5e831f728bdb]: 'jswXFlowModalCompleted',
    [$5b23a7bd3e23e56e$export$bf35811a56a7cd87]: 'qsv2ReadConfluenceGuideCompleted',
    [$5b23a7bd3e23e56e$export$6e0ac6a22e470ae2]: 'qsv2InviteTeammateCompleted',
    [$5b23a7bd3e23e56e$export$417c74a93b7a4bc9]: 'qsv2IntegrationCompleted',
    [$5b23a7bd3e23e56e$export$2f37c8b16273f56e]: 'qsv2SiteVideoTourCompleted',
    [$5b23a7bd3e23e56e$export$e3400d8b82a2f6c1]: 'qsv2SpotlightCompleted',
    [$5b23a7bd3e23e56e$export$cec5ff8d02753e42]: 'migrationsWelcomeCompleted',
    [$5b23a7bd3e23e56e$export$291c48af440cb477]: 'migrationsNewPageCompleted',
    [$5b23a7bd3e23e56e$export$af64633856549760]: 'migrationsCollaborateCompleted',
    [$5b23a7bd3e23e56e$export$c85b665118ff388b]: 'migrationsFindAndOrganizePagesCompleted',
    [$5b23a7bd3e23e56e$export$91579532952a6b5]: 'migrationsEditAndCustomizeContentCompleted',
    [$5b23a7bd3e23e56e$export$d521d3f5ee5a7baa]: 'simplifyAdminRenameSiteCompleted',
    [$5b23a7bd3e23e56e$export$7a6989d0bcfe7ca9]: 'nqsv2CreateCompleted',
    [$5b23a7bd3e23e56e$export$96076d1ee44d366]: 'nqsv2CollaborateCompleted',
    [$5b23a7bd3e23e56e$export$d9afba8e0525ce5f]: 'nqsv2HelpCompleted',
    [$5b23a7bd3e23e56e$export$2da9139b7da400a3]: 'nqsv2Confluence101Completed'
};
const $5b23a7bd3e23e56e$export$2883f67b1bf0f40c = new Set([
    $5b23a7bd3e23e56e$export$69afb55780da55ef,
    $5b23a7bd3e23e56e$export$93034abc7a9a36e,
    $5b23a7bd3e23e56e$export$bf35811a56a7cd87,
    $5b23a7bd3e23e56e$export$6e0ac6a22e470ae2,
    $5b23a7bd3e23e56e$export$417c74a93b7a4bc9,
    $5b23a7bd3e23e56e$export$2f37c8b16273f56e,
    $5b23a7bd3e23e56e$export$cec5ff8d02753e42,
    $5b23a7bd3e23e56e$export$291c48af440cb477,
    $5b23a7bd3e23e56e$export$af64633856549760,
    $5b23a7bd3e23e56e$export$91579532952a6b5,
    $5b23a7bd3e23e56e$export$c85b665118ff388b,
    $5b23a7bd3e23e56e$export$d521d3f5ee5a7baa,
    $5b23a7bd3e23e56e$export$96076d1ee44d366,
    $5b23a7bd3e23e56e$export$2da9139b7da400a3
]);

});

parcelRegister("2QpHc", function(module, exports) {

$parcel$export(module.exports, "PresenceSatisfactionSurvey", () => $370fd0003d7f2c6b$export$5cc9b0dbea8a94d6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $7gpC4 = parcelRequire("7gpC4");

var $dThp5 = parcelRequire("dThp5");
const $370fd0003d7f2c6b$var$i18n = (0, $2nPZH.defineMessages)({
    title: {
        id: "team-presence.satisfaction-survey.title",
        defaultMessage: "Tell us what you think"
    },
    description: {
        id: "team-presence.satisfaction-survey.description",
        defaultMessage: "How do you feel about the ability to see other viewers/editors on Confluence content?"
    },
    finalTitle: {
        id: "team-presence.satisfaction-survey.final.title",
        defaultMessage: "Feedback submitted"
    },
    finalDescription: {
        id: "team-presence.satisfaction-survey.final.description",
        defaultMessage: "Thanks for helping us make Confluence better!"
    },
    canContact: {
        id: "team-presence.satisfaction-survey.checkbox.can-contact",
        defaultMessage: "Atlassian can contact me about this feedback"
    },
    questionGood: {
        id: "team-presence.satisfaction-survey.question.good",
        defaultMessage: "Great! What do you like about it? Is there anything that could be improved? (optional)"
    },
    questionNeutral: {
        id: "team-presence.satisfaction-survey.question.okay",
        defaultMessage: "Could you tell us a little more? What do you like about it? What could be improved? (optional)"
    },
    questionBad: {
        id: "team-presence.satisfaction-survey.question.bad",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "We\u2018re sorry to hear that. What hasn\u2019t been working for you? Is there anything you like about it? (optional)"
    },
    reactionTerrible: {
        id: "team-presence.satisfaction-survey.reaction.terrible",
        defaultMessage: "Terrible"
    },
    reactionBad: {
        id: "team-presence.satisfaction-survey.reaction.bad",
        defaultMessage: "Bad"
    },
    reactionOkay: {
        id: "team-presence.satisfaction-survey.reaction.okay",
        defaultMessage: "Okay"
    },
    reactionGreat: {
        id: "team-presence.satisfaction-survey.reaction.great",
        defaultMessage: "Great"
    },
    reactionAmazing: {
        id: "team-presence.satisfaction-survey.reaction.amazing",
        defaultMessage: "Amazing"
    },
    buttonSubmit: {
        id: "team-presence.satisfaction-survey.button.submit",
        defaultMessage: "Submit"
    },
    buttonCancel: {
        id: "team-presence.satisfaction-survey.button.cancel",
        defaultMessage: "Cancel"
    }
});
const $370fd0003d7f2c6b$export$5cc9b0dbea8a94d6 = ({ onDone: onDone, onSubmitted: onSubmitted, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCompleted, setCompleted] = (0, $gwFzn.useState)(false);
    const [canContactUser, setCanContactUser] = (0, $gwFzn.useState)(false);
    // Note that the SatisfactionSurveyComponent can call "onInteraction()" several times when being
    // dismissed: once when the survey is closed (either when it is dismissed without submission or
    // when the "Thanks" is closed after submission), and once when it is unmounted (intended as a
    // fallback). But we only want to call onDone() once, so we use a Ref to keep track of that since
    // a state variable would cause an extra unwanted render when it changes (which refs do not cause)
    const onDoneFired = (0, $gwFzn.useRef)(false);
    const intl = (0, $dBxQj.default)();
    const handleSurveyInteraction = ({ dismissed: dismissed, feedback: feedback, reaction: reaction, submitted: submitted })=>{
        if (dismissed && onDoneFired.current === false) {
            onDoneFired.current = true;
            onDone();
        } else if (submitted) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'submitted',
                    actionSubject: 'survey',
                    actionSubjectId: 'presenceFeedbackSurvey',
                    source: source,
                    attributes: {
                        canContact: canContactUser,
                        reaction: reaction.value,
                        feedback: feedback
                    }
                }
            }).fire();
            onSubmitted && onSubmitted();
            setCompleted(true);
        }
    };
    const canContactUserCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
        isChecked: canContactUser,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.canContact),
        name: "can-contact-checkbox",
        onChange: (event)=>{
            setCanContactUser(event.currentTarget.checked);
        }
    });
    const questionGood = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.questionGood);
    const questionNeutral = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.questionNeutral);
    const questionBad = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.questionBad);
    const reactionQuestions = [
        questionBad,
        questionBad,
        questionNeutral,
        questionGood,
        questionGood
    ];
    const reactionTitles = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$370fd0003d7f2c6b$var$i18n.reactionTerrible,
            key: $370fd0003d7f2c6b$var$i18n.reactionTerrible.id
        }),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$370fd0003d7f2c6b$var$i18n.reactionBad,
            key: $370fd0003d7f2c6b$var$i18n.reactionBad.id
        }),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$370fd0003d7f2c6b$var$i18n.reactionOkay,
            key: $370fd0003d7f2c6b$var$i18n.reactionOkay.id
        }),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$370fd0003d7f2c6b$var$i18n.reactionGreat,
            key: $370fd0003d7f2c6b$var$i18n.reactionGreat.id
        }),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$370fd0003d7f2c6b$var$i18n.reactionAmazing,
            key: $370fd0003d7f2c6b$var$i18n.reactionAmazing.id
        })
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dThp5.SatisfactionSurveyComponent), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.description),
        finalTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.finalTitle),
        finalDescription: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.finalDescription),
        reactionTitles: reactionTitles,
        formQuestions: reactionQuestions,
        submitButtonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $370fd0003d7f2c6b$var$i18n.buttonSubmit),
        // closeButtonText needs to be a string because it is used as an aria-label too
        closeButtonText: intl.formatMessage($370fd0003d7f2c6b$var$i18n.buttonCancel),
        onInteraction: handleSurveyInteraction,
        isOnFinalStage: isCompleted,
        customFields: canContactUserCheckbox
    });
};

});

parcelRegister("5Rcfp", function(module, exports) {

$parcel$export(module.exports, "useAdminFeedbackSurvey", () => $b3fe40ccc5f822cf$export$be21f4e50acaf804);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $ivb8S = parcelRequire("ivb8S");

var $h86CY = parcelRequire("h86CY");
const $b3fe40ccc5f822cf$export$be21f4e50acaf804 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)((0, $h86CY.ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS).PRESENCE_ADMIN_FEEDBACK_SEEN);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if (loading || !error) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminFeedbackSurvey',
                actionSubject: 'AdminFeedbackSurvey',
                action: 'failed to get hasAdminSeenFeedbackSurvey',
                attributes: {
                    error: error
                }
            }
        }).fire();
    }, [
        loading,
        error,
        createAnalyticsEvent
    ]);
    const { hasAdminSeenFeedbackSurvey: hasAdminSeenFeedbackSurvey } = (0, $ivb8S.deserializeState)(data);
    const setAdminFeedbackSurveyViewed = ()=>setOnboardingState({
            key: (0, $h86CY.ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS).PRESENCE_ADMIN_FEEDBACK_SEEN,
            value: 'true'
        });
    return {
        hasAdminSeenFeedbackSurvey: Boolean(hasAdminSeenFeedbackSurvey),
        setAdminFeedbackSurveyViewed: setAdminFeedbackSurveyViewed
    };
};

});
parcelRegister("h86CY", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS", () => $1dd4a0157170f997$export$f8474b3e5d170456);
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};

});


parcelRegister("9kLXx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18373519e9b8bb8d789f8e6cb8a6aee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cbb2f0173cd9474$var$_react = $6cbb2f0173cd9474$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $6cbb2f0173cd9474$var$_baseNew = $6cbb2f0173cd9474$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6cbb2f0173cd9474$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityTrivial".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for trivial work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cbb2f0173cd9474$var$PriorityTrivialIcon = (props)=>/*#__PURE__*/ $6cbb2f0173cd9474$var$_react.default.createElement($6cbb2f0173cd9474$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<circle cx="8" cy="8" r="7.25" stroke="currentcolor" stroke-width="1.5"/>`
    }, props));
$6cbb2f0173cd9474$var$PriorityTrivialIcon.displayName = 'PriorityTrivialIcon';
var $6cbb2f0173cd9474$var$_default = module.exports.default = $6cbb2f0173cd9474$var$PriorityTrivialIcon;

});

parcelRegister("hwWwS", function(module, exports) {

$parcel$export(module.exports, "useCoordination", () => $9b64448510e1eff4$export$3c29cca421979b0e);

var $gwFzn = parcelRequire("gwFzn");
const $9b64448510e1eff4$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $gwFzn.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};

});

parcelRegister("1JEqL", function(module, exports) {

$parcel$export(module.exports, "getIsProductOrSiteAdminFromQuery", () => $e18808c613ab8370$export$138f02318593ab4);

var $eJhXX = parcelRequire("eJhXX");

var $icMDs = parcelRequire("icMDs");
function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}

});

parcelRegister("4kvYv", function(module, exports) {

$parcel$export(module.exports, "UserPersonalizationQuery", () => $add7c7c099668999$export$87c8216babb705a0);

var $d2LG0 = parcelRequire("d2LG0");
const $add7c7c099668999$export$87c8216babb705a0 = (0, $d2LG0.default)`query PersonalizationQuery($userId:String!)@experimental{experimentalUserPersonalization(userId:$userId){attributes{name value}}}`;

});

parcelRegister("ftNCU", function(module, exports) {

$parcel$export(module.exports, "useIsXflowUser", () => $8792b156dc21dc99$export$55c29737e03e48b6);

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $kAcNG = parcelRequire("kAcNG");
const $8792b156dc21dc99$export$79555f8f9058b0b6 = 'confluence.ondemand.activationDate';
const $8792b156dc21dc99$export$5eb928599eba2631 = 'jira-software.ondemand.activationDate';
const $8792b156dc21dc99$export$4e784ec4123c5637 = 'jira-workmanagement.ondemand.activationDate';
const $8792b156dc21dc99$export$c0ca169c4d79cb05 = 'jira-core.ondemand.activationDate';
const $8792b156dc21dc99$var$isSiteTraitActivationOrderEligible = (attributes)=>{
    const siteTraits = attributes?.reduce((obj, item)=>({
            ...obj,
            [item.name]: item.value
        }), {});
    const jiraOnDemandDate = Date.parse(siteTraits?.[$8792b156dc21dc99$export$5eb928599eba2631]) || Date.parse(siteTraits?.[$8792b156dc21dc99$export$4e784ec4123c5637]) || Date.parse(siteTraits?.[$8792b156dc21dc99$export$c0ca169c4d79cb05]);
    const confluenceOnDemandDate = Date.parse(siteTraits?.[$8792b156dc21dc99$export$79555f8f9058b0b6]);
    return !!jiraOnDemandDate && !!confluenceOnDemandDate && confluenceOnDemandDate > jiraOnDemandDate;
};
const $8792b156dc21dc99$export$55c29737e03e48b6 = ({ skip: skip = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipConditions = skip || !isLicensed;
    const { attributes: attributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skipConditions
    });
    if (sitePersonalizationLoading || sitePersonalizationError || skipConditions) return {
        isXflowUser: false,
        isLoading: sitePersonalizationLoading,
        error: sitePersonalizationError
    };
    return {
        isXflowUser: skipConditions ? false : Boolean(attributes) && $8792b156dc21dc99$var$isSiteTraitActivationOrderEligible(attributes),
        isLoading: sitePersonalizationLoading,
        error: sitePersonalizationError
    };
};

});
parcelRegister("kAcNG", function(module, exports) {

$parcel$export(module.exports, "useSitePersonalizationQuery", () => $a3e54b7319a42934$export$3cfde1d6c626a865);

var $j1Ss3 = parcelRequire("j1Ss3");

var $8Lx5S = parcelRequire("8Lx5S");

var $dIouf = parcelRequire("dIouf");

var $g2lhM = parcelRequire("g2lhM");
let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $g2lhM.SitePersonalizationQuery), {
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $dIouf.isStatusCodeError)(graphQLError, '401') || (0, $dIouf.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};

});
parcelRegister("g2lhM", function(module, exports) {

$parcel$export(module.exports, "SitePersonalizationQuery", () => $ce3ee7feeac4bdd4$export$f103a917673d8e03);

var $d2LG0 = parcelRequire("d2LG0");
const $ce3ee7feeac4bdd4$export$f103a917673d8e03 = (0, $d2LG0.default)`query SitePersonalizationQuery($cloudId:String!)@experimental{experimentalSitePersonalization(cloudId:$cloudId){attributes{name value}}}`;

});



parcelRegister("3Xs1I", function(module, exports) {

$parcel$export(module.exports, "QuickReloadSubscriber", () => $cf20926a3ed5ce71$export$b107cc869756fe73);

var $1SNEF = parcelRequire("1SNEF");
const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};

});
parcelRegister("1SNEF", function(module, exports) {

$parcel$export(module.exports, "useQuickReloadSubscriber", () => $511608ca1b2c45b1$export$2f94e407b6c7d69d);

var $gwFzn = parcelRequire("gwFzn");

var $c0urc = parcelRequire("c0urc");
const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $gwFzn.useContext)((0, $c0urc.QuickReloadContext));
    (0, $gwFzn.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};

});


parcelRegister("kjXns", function(module, exports) {

$parcel$export(module.exports, "GenericBreadcrumbItemTitles", () => $7658ec6bf458448d$export$4c099e5603d2ab62);
var $7658ec6bf458448d$export$4c099e5603d2ab62 = /*#__PURE__*/ function(GenericBreadcrumbItemTitles) {
    GenericBreadcrumbItemTitles["Blog"] = "BLOG";
    GenericBreadcrumbItemTitles["Overview"] = "OVERVIEW";
    GenericBreadcrumbItemTitles["Pages"] = "PAGES";
    GenericBreadcrumbItemTitles["People"] = "PEOPLE";
    GenericBreadcrumbItemTitles["Space"] = "SPACE";
    GenericBreadcrumbItemTitles["PersonalSpace"] = "PERSONAL_SPACE";
    GenericBreadcrumbItemTitles["ContentTitle"] = "CONTENT_TITLE";
    GenericBreadcrumbItemTitles["Ancestor"] = "ANCESTOR";
    GenericBreadcrumbItemTitles["BlogYear"] = "BLOG_YEAR";
    GenericBreadcrumbItemTitles["BlogMonth"] = "BLOG_MONTH";
    GenericBreadcrumbItemTitles["BlogDay"] = "BLOG_DAY";
    return GenericBreadcrumbItemTitles;
}({});

});

parcelRegister("aCez2", function(module, exports) {

$parcel$export(module.exports, "EditorBreadcrumbs", () => $c71f2c7b89c23548$export$18f927573c4993d5);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("6UBr9")).Breadcrumbs);
$parcel$export(module.exports, "EditorBreadcrumbsLinks", () => (parcelRequire("7Rhz8")).EditorBreadcrumbsLinks);

var $jmjWc = parcelRequire("jmjWc");

var $6UBr9 = parcelRequire("6UBr9");

var $7Rhz8 = parcelRequire("7Rhz8");

const $c71f2c7b89c23548$export$18f927573c4993d5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rMEfw",
    name: "EditorBreadcrumbs",
    loader: async ()=>{
        const { EditorBreadcrumbsComponent: EditorBreadcrumbsComponent } = await (parcelRequire("brSPC"));
        return EditorBreadcrumbsComponent;
    }
});

});
parcelRegister("6UBr9", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $5085033cb7e8ab02$export$2dc68d50d56fbbd);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $kGnTD = parcelRequire("kGnTD");

var $8l4KR = parcelRequire("8l4KR");

var $7zgzO = parcelRequire("7zgzO");

var $kjXns = parcelRequire("kjXns");
class $5085033cb7e8ab02$export$2dc68d50d56fbbd extends (0, $gwFzn.PureComponent) {
    render() {
        const { breadcrumbs: breadcrumbs, origin: origin, contentId: contentId, contentType: contentType, maxItems: maxItems, itemsBeforeCollapse: itemsBeforeCollapse, itemsAfterCollapse: itemsAfterCollapse, clickHandler: clickHandler, disabled: disabled } = this.props;
        const editorBreadcrumbClickAnalytics = this.analyticsAttributesCreator({
            origin: origin,
            breadcrumbItemsCount: breadcrumbs.length,
            contentType: contentType,
            contentId: contentId
        });
        const limits = maxItems ? {
            maxItems: maxItems,
            itemsBeforeCollapse: itemsBeforeCollapse,
            itemsAfterCollapse: itemsAfterCollapse
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kGnTD.default), {
                ...limits,
                testId: "editor-breadcrumbs"
            }, Array.isArray(breadcrumbs) && breadcrumbs.map(({ url: url, title: title }, index)=>{
                const nestedDepth = index + 1;
                return url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8l4KR.BreadcrumbsItem), {
                    href: !disabled ? url : undefined,
                    key: index,
                    text: title,
                    truncationWidth: index === 0 ? 160 : 240,
                    onClick: clickHandler && !disabled ? (destinationUrl)=>clickHandler(destinationUrl) : undefined,
                    clickEventAnalyticsAttributes: editorBreadcrumbClickAnalytics({
                        url: url,
                        nestedDepth: nestedDepth,
                        routeName: matchRoute(url)?.name,
                        titleLength: title.length
                    })
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8l4KR.BreadcrumbsItem), {
                    component: this._noLinkItem,
                    key: index,
                    text: title,
                    truncationWidth: index === 0 ? 160 : 240,
                    clickEventAnalyticsAttributes: editorBreadcrumbClickAnalytics({
                        nestedDepth: nestedDepth
                    })
                });
            })));
    }
    constructor(...args){
        super(...args);
        this._noLinkItem = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, children);
        this.analyticsAttributesCreator = ({ origin: origin, breadcrumbItemsCount: breadcrumbItemsCount, contentType: contentType, contentId: contentId })=>({ url: url, nestedDepth: nestedDepth, routeName: routeName, titleLength: titleLength })=>({
                    breadcrumbItemsCount: breadcrumbItemsCount,
                    nestedDepth: nestedDepth,
                    origin: origin,
                    contentType: contentType,
                    contentId: contentId,
                    titleLength: titleLength,
                    get destination () {
                        if (routeName) return routeName;
                        else if (url === '/wiki/peopledirectory.action') return (0, $kjXns.GenericBreadcrumbItemTitles).People;
                        else if (/display\/~[0-9a-zA-Z]+$/.test(url)) // eg. /wiki/display/~820701666
                        return (0, $kjXns.GenericBreadcrumbItemTitles).PersonalSpace;
                        else if (contentType === 'blogpost' && /\/\d{4}\/\d{2}$/.test(url)) // eg. /wiki/display/820701666/2021/04
                        return (0, $kjXns.GenericBreadcrumbItemTitles).BlogMonth;
                    }
                });
    }
}
$5085033cb7e8ab02$export$2dc68d50d56fbbd.propTypes = {
    breadcrumbs: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).array,
    origin: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    maxItems: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    itemsBeforeCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    itemsAfterCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    clickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};

});
parcelRegister("8l4KR", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsItem", () => $ade9c6d5cea37084$export$ac6d20b90d655160);

var $gwFzn = parcelRequire("gwFzn");

var $bknsA = parcelRequire("bknsA");

var $inPa6 = parcelRequire("inPa6");

var $3ro6F = parcelRequire("3ro6F");
const $ade9c6d5cea37084$var$isRegularClick = (e)=>!e.metaKey && !e.ctrlKey && e.button === 0;
const $ade9c6d5cea37084$export$ac6d20b90d655160 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const { href: href, onClick: onClick, clickEventAnalyticsAttributes: clickEventAnalyticsAttributes } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (e)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'breadcrumb',
                source: 'containerNavigation',
                attributes: {
                    navVersion: 3,
                    ...clickEventAnalyticsAttributes
                }
            }
        }).fire();
        if (onClick && $ade9c6d5cea37084$var$isRegularClick(e)) {
            e.preventDefault();
            onClick(href);
        }
    };
    const akProps = (0, (/*@__PURE__*/$parcel$interopDefault($bknsA)))(props, [
        'onClick',
        'clickEventAnalyticsAttributes'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3ro6F.default), {
        ...akProps,
        onClick: handleClick
    });
});

});


parcelRegister("7Rhz8", function(module, exports) {

$parcel$export(module.exports, "EditorBreadcrumbsLinks", () => $712a19f58ac71573$export$e31433f7523c9037);

var $gwFzn = parcelRequire("gwFzn");

var $jlIaF = parcelRequire("jlIaF");

var $6UBr9 = parcelRequire("6UBr9");
const $712a19f58ac71573$var$PEOPLE_DIR = `${(0, $jlIaF.CONTEXT_PATH)}/peopledirectory.action`;
const $712a19f58ac71573$export$e31433f7523c9037 = ({ breadcrumbs: breadcrumbs, contentType: contentType, contentId: contentId, breadcrumbsClickHandler: breadcrumbsClickHandler, origin: origin, disabled: disabled })=>{
    if (!breadcrumbs || breadcrumbs.length === 0) return null;
    // Remove the People link
    if (breadcrumbs[0].url === $712a19f58ac71573$var$PEOPLE_DIR) breadcrumbs = breadcrumbs.slice(1);
    if (contentType === 'blogpost') {
        // remove year, month, date, and do not truncate
        const yearIndex = breadcrumbs.findIndex((x)=>!x.url && x.title?.match(/^\d{4}$/));
        if (yearIndex !== -1) {
            breadcrumbs = [
                ...breadcrumbs
            ];
            breadcrumbs.splice(yearIndex, 3);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6UBr9.Breadcrumbs), {
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            clickHandler: breadcrumbsClickHandler,
            origin: origin,
            disabled: disabled
        });
    } else {
        // Show both Parent and Page, or just Parent if current page is not in breadcrumbs
        let after = 1;
        if (breadcrumbs.length > 0) {
            const last = breadcrumbs[breadcrumbs.length - 1];
            if (last.url && new RegExp(`(/pages/|/resumedraft.action\\?draftId=)${contentId}\\b`).test(last.url)) after = 2;
        }
        // Add one for the truncation "..." element
        const maxItems = after + 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6UBr9.Breadcrumbs), {
            breadcrumbs: breadcrumbs,
            maxItems: maxItems,
            itemsBeforeCollapse: 1,
            itemsAfterCollapse: after,
            clickHandler: breadcrumbsClickHandler,
            origin: origin,
            disabled: disabled
        });
    }
};

});

parcelRegister("brSPC", function(module, exports) {

let $855cbfbecd13a051$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $855cbfbecd13a051$var$load("6vzdH"),
    $855cbfbecd13a051$var$load("i2GTg"),
    $855cbfbecd13a051$var$load("aIO5d"),
    $855cbfbecd13a051$var$load("2F69B"),
    $855cbfbecd13a051$var$load("leIbB"),
    $855cbfbecd13a051$var$load("6nLV7"),
    $855cbfbecd13a051$var$load("ffEVr"),
    $855cbfbecd13a051$var$load("aIkc8")
]).then(()=>parcelRequire('aNZDi'));

});


parcelRegister("hjygH", function(module, exports) {

$parcel$export(module.exports, "ExperienceStop", () => $1aeb691895c5954d$export$85823f26dca064c3);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $1aeb691895c5954d$export$85823f26dca064c3({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>{
        if (error) experienceTracker.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
        else experienceTracker.succeed({
            name: name,
            attributes: attributes
        });
    }, [
        experienceTracker,
        name,
        attributes,
        error
    ]);
    return null;
}

});

parcelRegister("9NwnH", function(module, exports) {

$parcel$export(module.exports, "Rebaseable", () => $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd);
$parcel$export(module.exports, "rebaseSteps", () => $c4b7da7a59ba31a1$export$bced9e015fcf3afa);
$parcel$export(module.exports, "collab", () => $c4b7da7a59ba31a1$export$995d9de96d1b2e26);
$parcel$export(module.exports, "getDocBeforeUnconfirmedSteps", () => $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e);
$parcel$export(module.exports, "syncFromAnotherSource", () => $c4b7da7a59ba31a1$export$852bd88de4de2d35);
$parcel$export(module.exports, "receiveTransaction", () => $c4b7da7a59ba31a1$export$7581d8ca0d559ec6);
$parcel$export(module.exports, "sendableSteps", () => $c4b7da7a59ba31a1$export$4da2109e7644e6c2);
$parcel$export(module.exports, "getCollabState", () => $c4b7da7a59ba31a1$export$971539697c176258);

var $9HkI0 = parcelRequire("9HkI0");

var $7T7aA = parcelRequire("7T7aA");

var $1oCLl = parcelRequire("1oCLl");

var $iu6m9 = parcelRequire("iu6m9");

var $5jGZY = parcelRequire("5jGZY");
class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $7T7aA.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $9HkI0.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $7T7aA.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $7T7aA.TextSelection)) {
        tr.setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}

});
parcelRegister("5jGZY", function(module, exports) {

$parcel$export(module.exports, "mapStep", () => $33dcd085767efb3e$export$798cdecdcbbf9755);

var $lTYwY = parcelRequire("lTYwY");

var $kviC1 = parcelRequire("kviC1");

var $4FvAQ = parcelRequire("4FvAQ");
// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $lTYwY.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $4FvAQ.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $4FvAQ.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $kviC1.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $4FvAQ.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}

});


parcelRegister("jacyh", function(module, exports) {

$parcel$export(module.exports, "useBlogTreeStore", () => $d9bb792bb433dc50$export$9638016a54f09a07);
$parcel$export(module.exports, "useBlogTreeActions", () => $d9bb792bb433dc50$export$861bc4451e1cbefa);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $4ZoIm.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $iFWZA.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $iFWZA.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);

});

parcelRegister("8gU8P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $605b5dd6e5dbfa97$var$_react = $605b5dd6e5dbfa97$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $605b5dd6e5dbfa97$var$_share = $605b5dd6e5dbfa97$var$_interopRequireDefault((parcelRequire("9M4aB")));

var $605b5dd6e5dbfa97$var$_share2 = $605b5dd6e5dbfa97$var$_interopRequireDefault((parcelRequire("hycEC")));
function $605b5dd6e5dbfa97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $605b5dd6e5dbfa97$var$ShareIcon = (props)=>/*#__PURE__*/ $605b5dd6e5dbfa97$var$_react.default.createElement($605b5dd6e5dbfa97$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $605b5dd6e5dbfa97$var$_share2.default
    }, props));
$605b5dd6e5dbfa97$var$ShareIcon.Name = 'ShareIconMigration';
var $605b5dd6e5dbfa97$var$_default = module.exports.default = $605b5dd6e5dbfa97$var$ShareIcon;

});
parcelRegister("9M4aB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71dbd4ce92c1377b$var$_react = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $71dbd4ce92c1377b$var$_baseNew = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $71dbd4ce92c1377b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71dbd4ce92c1377b$var$ShareIcon = (props)=>/*#__PURE__*/ $71dbd4ce92c1377b$var$_react.default.createElement($71dbd4ce92c1377b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$71dbd4ce92c1377b$var$ShareIcon.displayName = 'ShareIcon';
var $71dbd4ce92c1377b$var$_default = module.exports.default = $71dbd4ce92c1377b$var$ShareIcon;

});


parcelRegister("2ZmKx", function(module, exports) {

$parcel$export(module.exports, "analyticsShareModalPageToggle", () => $ca86635dad6203eb$export$447813a4aa4bd88d);
$parcel$export(module.exports, "analyticsShareModalConfirmDisablePageButton", () => $ca86635dad6203eb$export$9e591b993765d3c5);
$parcel$export(module.exports, "analyticsShareModalCancelDisablePageButton", () => $ca86635dad6203eb$export$6be225cec6bb0b39);
$parcel$export(module.exports, "analyticsShareModalPageSettings", () => $ca86635dad6203eb$export$1cf323333eda57f3);
$parcel$export(module.exports, "analyticsEditPageScreenShown", () => $ca86635dad6203eb$export$ccde2b9ae5979813);
$parcel$export(module.exports, "analyticsViewPageScreenShown", () => $ca86635dad6203eb$export$c49161e4a5525da4);
$parcel$export(module.exports, "analyticsViewPageScreen", () => $ca86635dad6203eb$export$7f2de906fff40e8a);
$parcel$export(module.exports, "analyticsViewPageScreenGetAccessToViewMacroButton", () => $ca86635dad6203eb$export$18a256af514c1b00);
const $ca86635dad6203eb$var$eventFactory = (type, data, constantAttributes)=>(createAnalyticsEvent, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                ...data,
                attributes: {
                    ...constantAttributes,
                    ...attributes
                }
            }
        }).fire();
const $ca86635dad6203eb$var$eventFactoryPageSubjectId = (type, data)=>(createAnalyticsEvent, spaceId, contentId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                containerType: 'space',
                containerId: spaceId,
                objectType: 'page',
                objectId: contentId,
                ...data,
                actionSubjectId: contentId,
                attributes: attributes
            }
        }).fire();
const $ca86635dad6203eb$export$447813a4aa4bd88d = $ca86635dad6203eb$var$eventFactory('sendUIEvent', {
    source: 'shareButtonDialog',
    action: 'clicked',
    actionSubject: 'toggle',
    actionSubjectId: 'pagePublicLinksToggle'
});
const $ca86635dad6203eb$export$9e591b993765d3c5 = $ca86635dad6203eb$var$eventFactory('sendUIEvent', {
    source: 'shareButtonDialog',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'confirmDisablePagePublicLinksButton'
});
const $ca86635dad6203eb$export$6be225cec6bb0b39 = $ca86635dad6203eb$var$eventFactory('sendUIEvent', {
    source: 'shareButtonDialog',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'cancelTogglePagePublicLinksButton'
});
const $ca86635dad6203eb$export$1cf323333eda57f3 = $ca86635dad6203eb$var$eventFactoryPageSubjectId('sendTrackEvent', {
    // DO NOT CHANGE THIS ANALYTICS EVENT.
    // This shape is necessary to populate the audience for PL changeboarding.
    source: 'shareModal',
    action: 'updated',
    actionSubject: 'pagePublicLinksSettings'
});
const $ca86635dad6203eb$export$ccde2b9ae5979813 = $ca86635dad6203eb$var$eventFactoryPageSubjectId('sendTrackEvent', {
    source: 'editPageScreen',
    action: 'shown',
    actionSubject: 'page'
});
const $ca86635dad6203eb$export$c49161e4a5525da4 = $ca86635dad6203eb$var$eventFactoryPageSubjectId('sendTrackEvent', {
    source: 'viewPageScreen',
    action: 'shown',
    actionSubject: 'page'
});
const $ca86635dad6203eb$export$7f2de906fff40e8a = $ca86635dad6203eb$var$eventFactoryPageSubjectId('sendTrackEvent', {
    source: 'viewPageScreen',
    action: 'viewed',
    actionSubject: 'page'
});
const $ca86635dad6203eb$export$18a256af514c1b00 = $ca86635dad6203eb$var$eventFactory('sendUIEvent', {
    source: 'viewPageScreen',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'getAccessToViewMacroButton'
}, {
    isPublicView: true
});

});

parcelRegister("gabmL", function(module, exports) {

$parcel$export(module.exports, "usePublicLinkData", () => $b34fb09a67265b07$export$4725159de576f61f);
$parcel$export(module.exports, "usePublicLinkPageDataProvider", () => $b34fb09a67265b07$export$b7ccc28cc819be23);
$parcel$export(module.exports, "PublicLinkPageDataProvider", () => $b34fb09a67265b07$export$b86a4cadf4c50ae1);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $euL71 = parcelRequire("euL71");

var $hC6vw = parcelRequire("hC6vw");

var $1X7PR = parcelRequire("1X7PR");

var $bgRei = parcelRequire("bgRei");
const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $2nPZH.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && edition === (0, $euL71.ConfluenceEdition).PREMIUM && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const canEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') pageData.refetch();
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $dBxQj.default)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $diswb.useQuery)((0, $d2LG0.default)`query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId pageStatus publicLinkUrlPath}}`, {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $gwFzn.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $dIouf.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $gwFzn.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));

});
parcelRegister("hC6vw", function(module, exports) {

$parcel$export(module.exports, "PublicLinkPageStatus", () => $d0a960900d3ff81b$export$cb24eb3958583602);
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});

});

parcelRegister("1X7PR", function(module, exports) {

$parcel$export(module.exports, "usePublicLinkContentQuery", () => $3e0fb5c21944a86f$export$13a7a098bd5c2599);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $cLo2u = parcelRequire("cLo2u");

var $foQ4a = parcelRequire("foQ4a");
const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const isSpaceAdmin = Boolean(data?.space?.currentUser.isAdmin);
    const canEditPage = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
    return {
        contentType: contentType,
        canEditPublicLink: (isSpaceAdmin || canEditPage) && !isExternalCollaborator
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error } = (0, $diswb.useQuery)((0, $d2LG0.default)`query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!$spaceKey:String!$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id type operations{operation targetType}}}space(key:$spaceKey)@include(if:$hasSpaceKey){id currentUser{isAdmin}}}`, {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator)
    };
};

});

parcelRegister("bgRei", function(module, exports) {

$parcel$export(module.exports, "usePublicLinkPermissionsForObject", () => $6b8bec8977e1e896$export$c2d35981ca787f77);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $j0YKV = parcelRequire("j0YKV");
const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $diswb.useQuery)((0, $d2LG0.default)`query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId objectType:$objectType){permissions}}`, {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip
    });
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};

});
parcelRegister("j0YKV", function(module, exports) {

$parcel$export(module.exports, "PublicLinkPermissionsObjectType", () => $d2563be1c2ded005$export$fcb2676e4c5b8efd);
$parcel$export(module.exports, "PublicLinkPermissionsType", () => $d2563be1c2ded005$export$1d899d09218cc934);
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});

});



parcelRegister("bVAxT", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogStateContainer", () => $20c3e8ab10e63e24$export$f91385b453474810);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");
class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $ipPpS.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}

});

parcelRegister("zaaX9", function(module, exports) {

$parcel$export(module.exports, "LearnMoreLink", () => $02ab515830874018$export$d608ae2ec728a3cf);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $2Nwuj = parcelRequire("2Nwuj");

var $bQm3c = parcelRequire("bQm3c");

var $8y1s8 = parcelRequire("8y1s8");
const $02ab515830874018$export$d608ae2ec728a3cf = ({ children: children, screenSource: screenSource, analyticsAttributes: analyticsAttributes, isSpaceBlockedByOrg: isSpaceBlockedByOrg })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: screenSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'publicLinksLearnMoreLink',
                attributes: {
                    ...analyticsAttributes,
                    edition: edition
                }
            }
        }).fire();
    };
    const url = isSpaceBlockedByOrg ? (0, $8y1s8.DATA_SECURITY_POLICY_DOCUMENTATION) : (0, $8y1s8.SET_UP_AND_MANAGE_DOCUMENTATION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        rel: "noopener noreferrer",
        href: url,
        onClick: onClick
    }, children);
};

});
parcelRegister("8y1s8", function(module, exports) {

$parcel$export(module.exports, "PAGES_TABLE_CONFIRMATION_SOURCE", () => $ccf9837a697995d7$export$d9966e2dc944fbfa);
$parcel$export(module.exports, "ChangeboardingTypes", () => $ccf9837a697995d7$export$75b1e1d060e17f91);
$parcel$export(module.exports, "SET_UP_AND_MANAGE_DOCUMENTATION", () => $ccf9837a697995d7$export$49832baccfe11a28);
$parcel$export(module.exports, "DATA_SECURITY_POLICY_DOCUMENTATION", () => $ccf9837a697995d7$export$3cad030b6f1e0556);
$parcel$export(module.exports, "PUBLIC_LINKS_SECURITY_DOCUMENTATION", () => $ccf9837a697995d7$export$c077bb99fd334e2d);
$parcel$export(module.exports, "LEARN_MORE_PUBLIC_LINKS_HREF", () => $ccf9837a697995d7$export$abc0dd76bd8e2feb);
/* eslint-disable check-file/filename-blocklist */ const $ccf9837a697995d7$export$d9966e2dc944fbfa = 'publicLinksPagesActionConfirmationModal';
var $ccf9837a697995d7$export$75b1e1d060e17f91 = /*#__PURE__*/ function(ChangeboardingTypes) {
    ChangeboardingTypes["INTRODUCTION"] = "introduction";
    ChangeboardingTypes["TOGGLE_SPOTLIGHT"] = "toggle-spotlight";
    ChangeboardingTypes["MENU_SPOTLIGHT"] = "menu-spotlight";
    ChangeboardingTypes["NONE"] = "none";
    return ChangeboardingTypes;
}({});
const $ccf9837a697995d7$export$49832baccfe11a28 = 'https://support.atlassian.com/confluence-cloud/docs/set-up-and-manage-public-links/';
const $ccf9837a697995d7$export$3cad030b6f1e0556 = 'https://support.atlassian.com/security-and-access-policies/docs/prevent-public-links/';
const $ccf9837a697995d7$export$c077bb99fd334e2d = 'https://support.atlassian.com/confluence-cloud/docs/how-secure-are-public-links/';
const $ccf9837a697995d7$export$abc0dd76bd8e2feb = 'https://support.atlassian.com/confluence-cloud/docs/share-content-externally-with-public-links/';

});


parcelRegister("d5K4U", function(module, exports) {

$parcel$export(module.exports, "PublicLinkDialogBase", () => $af5936e2e7663f41$export$9b8c4d502d602bb2);
/* PublicLinkDialogBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $eEA8O = parcelRequire("eEA8O");

var $hArLp = parcelRequire("hArLp");

var $7gpC4 = parcelRequire("7gpC4");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");
const $af5936e2e7663f41$var$FooterContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCheckbox: hasCheckbox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.hasCheckbox && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $af5936e2e7663f41$export$9b8c4d502d602bb2 = ({ title: title, children: children, onYesButtonClick: onYesButtonClick, onCancelButtonClick: onCancelButtonClick, yesButtonText: yesButtonText, noButtonText: noButtonText, triggerScreen: triggerScreen, screenName: screenName, edition: edition, onClose: onClose, isWarning: isWarning = false, showOptOutCheckbox: showOptOutCheckbox = false, setKey: setKey, onCloseComplete: onCloseComplete = ()=>{}, onSecondaryActionButtonClick: onSecondaryActionButtonClick, secondaryActionButtonText: secondaryActionButtonText })=>{
    const [isChecked, setIsChecked] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screenName,
                attributes: {
                    ...triggerScreen && {
                        source: triggerScreen
                    },
                    ...edition && {
                        edition: edition
                    }
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        screenName,
        triggerScreen,
        edition
    ]);
    const onOptOutCheckboxChange = ()=>{
        setIsChecked(!isChecked);
    };
    const handleYesButtonClick = ()=>{
        onYesButtonClick();
        onClose();
        if (setKey) setKey(isChecked);
    };
    const handleSecondaryActionButtonClick = ()=>{
        onSecondaryActionButtonClick?.();
        onClose();
    };
    const handleCancelButtonClick = ()=>{
        onCancelButtonClick?.();
        onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        width: "medium",
        onClose: handleCancelButtonClick,
        onCloseComplete: onCloseComplete,
        testId: "public-links-friction"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), {
        appearance: isWarning ? 'warning' : undefined
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($af5936e2e7663f41$var$FooterContainer, {
        hasCheckbox: showOptOutCheckbox
    }, showOptOutCheckbox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
        isChecked: isChecked,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "public-links.checkbox.dont-show-again",
            defaultMessage: "Don\u2019t show me this again"
        }),
        name: "dont-show-again-checkbox",
        onChange: onOptOutCheckboxChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, noButtonText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleCancelButtonClick
    }, noButtonText), secondaryActionButtonText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        onClick: handleSecondaryActionButtonClick
    }, secondaryActionButtonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: isWarning ? 'warning' : 'primary',
        onClick: handleYesButtonClick
    }, yesButtonText)))));
};

});

parcelRegister("jZABW", function(module, exports) {

$parcel$export(module.exports, "usePublicLinkDisable", () => $0a46a414a356c71f$export$9911252fec048faa);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $5PE1K = parcelRequire("5PE1K");

var $inPa6 = parcelRequire("inPa6");

var $9wGTI = parcelRequire("9wGTI");

var $euL71 = parcelRequire("euL71");

var $bQm3c = parcelRequire("bQm3c");
const $0a46a414a356c71f$var$getTrialDaysLeftFromQuery = (queryData)=>{
    const trialEndDate = queryData?.license?.trialEndDate;
    return $0a46a414a356c71f$var$getTrialDaysLeft(trialEndDate);
};
const $0a46a414a356c71f$var$getTrialDaysLeft = (trialEndDate)=>{
    if (!trialEndDate) return 0;
    // +1 day to round up for fractional days
    return (0, $5PE1K.default)(new Date(trialEndDate), new Date()) + 1;
};
const $0a46a414a356c71f$export$872324061aad626b = 'confluence_disable_public_links_on_trial';
const $0a46a414a356c71f$export$9911252fec048faa = ({ source: source })=>{
    const { isLoggedIn: isLoggedIn, userId: userId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const skipTrialDetailsQuery = isFreeEdition || !isLoggedIn || !userId;
    const { data: trialDetailsData, error: trialDetailsError, loading: trialDetailsLoading } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query usePublicLinkDisableTrialDetailsQuery{license{trialEndDate}}`, {
        skip: skipTrialDetailsQuery
    });
    const daysLeft = !trialDetailsError && !trialDetailsLoading ? $0a46a414a356c71f$var$getTrialDaysLeftFromQuery(trialDetailsData) : 0;
    const isTrialEdition = daysLeft > 0;
    const shouldRenderDisablePublicLinkFeature = (isTrialEdition || isFreeEdition) && (0, $9wGTI.fg)('confluence_disable_public_links_on_trial');
    (0, $gwFzn.useEffect)(()=>{
        if (source && (isFreeEdition || isTrialEdition)) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'feature',
                action: 'exposed',
                source: source,
                attributes: {
                    flagKey: $0a46a414a356c71f$export$872324061aad626b,
                    flagValue: (0, $9wGTI.fg)('confluence_disable_public_links_on_trial'),
                    touchpointId: source,
                    edition: edition
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        edition,
        isFreeEdition,
        isTrialEdition,
        shouldRenderDisablePublicLinkFeature,
        source
    ]);
    return {
        shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature
    };
};

});

parcelRegister("1yUaH", function(module, exports) {

$parcel$export(module.exports, "getAdminDataSecurityPolicyUrl", () => $6330c4f1726ccfe6$export$13b14bbaaf4eab95);
$parcel$export(module.exports, "getAdminGlobalPermsPublicLinksUrl", () => $6330c4f1726ccfe6$export$7ff4c55b73be0f0d);
$parcel$export(module.exports, "getPublicLinksSpaceSettingsBlockedStateUrl", () => $6330c4f1726ccfe6$export$5cf3dc8353fd3d8b);

var $1NBp8 = parcelRequire("1NBp8");
const $6330c4f1726ccfe6$export$13b14bbaaf4eab95 = (environment, orgId)=>environment === 'PRODUCTION' ? `https://admin.atlassian.com/o/${orgId}/data-security-policies` : `https://admin.stg.atlassian.com/o/${orgId}/data-security-policies`;
const $6330c4f1726ccfe6$export$7ff4c55b73be0f0d = (spaceId)=>spaceId ? `${(0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()}?tab=public-links&space=${spaceId}` : `${(0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()}?tab=public-links`;
const $6330c4f1726ccfe6$export$5cf3dc8353fd3d8b = ({ isSpaceBlockedByOrg: isSpaceBlockedByOrg, environment: environment, orgId: orgId })=>isSpaceBlockedByOrg ? $6330c4f1726ccfe6$export$13b14bbaaf4eab95(environment, orgId) : $6330c4f1726ccfe6$export$7ff4c55b73be0f0d();

});

parcelRegister("7EdWc", function(module, exports) {

$parcel$export(module.exports, "useIsPLEmpoweredUser", () => $8766384911629fab$export$69022991fc7a5580);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $1JEqL = parcelRequire("1JEqL");
var $w033M = parcelRequire("w033M");

var $hC6vw = parcelRequire("hC6vw");
var $8766384911629fab$var$AccessLevelRequired = /*#__PURE__*/ function(AccessLevelRequired) {
    AccessLevelRequired["space"] = "space";
    AccessLevelRequired["org"] = "org";
    AccessLevelRequired["product"] = "product";
    return AccessLevelRequired;
}($8766384911629fab$var$AccessLevelRequired || {});
const $8766384911629fab$var$publicLinkStatusToAccessLevelRequiredMappings = {
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_SPACE]: "space",
    [(0, $hC6vw.PublicLinkPageStatus).SPACE_DISABLED]: "space",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_PRODUCT]: "product",
    [(0, $hC6vw.PublicLinkPageStatus).SITE_DISABLED]: "product",
    [(0, $hC6vw.PublicLinkPageStatus).SPACE_BLOCKED]: "product",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_ORG]: "org",
    [(0, $hC6vw.PublicLinkPageStatus).SITE_BLOCKED]: "org",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_CONTAINER_POLICY]: "org",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_CLASSIFICATION_LEVEL]: "org"
};
const $8766384911629fab$var$getAccessLevelRequired = (publicLinkStatus)=>{
    if (!publicLinkStatus) return null;
    return $8766384911629fab$var$publicLinkStatusToAccessLevelRequiredMappings[publicLinkStatus] || null;
};
const $8766384911629fab$export$69022991fc7a5580 = ({ publicLinkStatus: publicLinkStatus, skip: skip })=>{
    // get admin level of current user, and derive their access level
    // get access level needed to unblock public link
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useIsPLEmpoweredUserPublicLinkUserAdminStatusQuery($key:String){user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole space(key:$key){currentUser{isAdmin}}}`, {
        variables: {
            key: spaceKey
        },
        skip: skip || !publicLinkStatus
    });
    if (skip || !publicLinkStatus) return {
        isEmpoweredUser: false
    };
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(data);
    const accessLevelRequired = $8766384911629fab$var$getAccessLevelRequired(publicLinkStatus);
    const isEmpoweredUserForAccessLevel = (accessLevelRequired)=>{
        // User is not blocked, is empowered automatically
        if (!accessLevelRequired) return true;
        // If user is site admin, they can make any needed changes
        if (accessLevelRequired === "org") return isSiteAdmin;
        return isProductOrSiteAdmin || // Otherwise, they can only fix it if it's a space access issue and they
        // are space admin
        accessLevelRequired === "space" && isSpaceAdmin;
    };
    return {
        isEmpoweredUser: isEmpoweredUserForAccessLevel(accessLevelRequired),
        isSpaceAdmin: isSpaceAdmin,
        isSiteAdmin: isSiteAdmin,
        error: error
    };
};

});

parcelRegister("9vcPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ecfbba62430f741$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $8OOLo = parcelRequire("8OOLo");

var $563la = parcelRequire("563la");

var $5kH4g = parcelRequire("5kH4g");
class $4ecfbba62430f741$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        const isModernContext = (0, $8OOLo.default) || (0, $dh538.fg)('analytics-next-use-modern-context_jira');
        if (hasError) {
            if (ErrorComponent) {
                if (isModernContext) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5kH4g.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(ErrorComponent, {})
                });
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $563la.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(ErrorComponent, {})
                });
            }
            return null;
        }
        if (isModernContext) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5kH4g.default), {
            data: data,
            children: children
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $563la.default), {
            data: data,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}

});

parcelRegister("kJJry", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $dfb78161248313f8$export$606f11b2eb45ecc6);

var $gwFzn = parcelRequire("gwFzn");

var $fzqvY = parcelRequire("fzqvY");
// Constantized to avoid a new object reference built every call
const $dfb78161248313f8$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $dfb78161248313f8$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $dfb78161248313f8$export$606f11b2eb45ecc6 = (subscriptionConfig = $dfb78161248313f8$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $gwFzn.useContext)((0, $fzqvY.FormContext));
    const [state, setState] = (0, $gwFzn.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $gwFzn.useMemo)(()=>$dfb78161248313f8$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $gwFzn.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("2hEyf", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $24ffa0794f8d0bc4$export$2a99220fb32ec798);
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $24ffa0794f8d0bc4$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};

});

parcelRegister("5csm1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74bfec641d4189e7274e991164fabf9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c94114da66aab69$var$_react = $3c94114da66aab69$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $3c94114da66aab69$var$_baseNew = $3c94114da66aab69$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3c94114da66aab69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flask".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: labs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c94114da66aab69$var$FlaskIcon = (props)=>/*#__PURE__*/ $3c94114da66aab69$var$_react.default.createElement($3c94114da66aab69$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.75 0h6.5v1.5h-.75v3.359l3.284 8.414A2 2 0 0 1 11.92 16H4.08a2 2 0 0 1-1.864-2.727L5.5 4.859V1.5h-.75zM7 1.5V5a.8.8 0 0 1-.051.273L5.689 8.5h4.622L9.05 5.273A.8.8 0 0 1 9 5V1.5zm3.896 8.5H5.104l-1.49 3.818a.5.5 0 0 0 .466.682h7.84a.5.5 0 0 0 .466-.682z" clip-rule="evenodd"/>`
    }, props));
$3c94114da66aab69$var$FlaskIcon.displayName = 'FlaskIcon';
var $3c94114da66aab69$var$_default = module.exports.default = $3c94114da66aab69$var$FlaskIcon;

});

parcelRegister("6fjxX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48c34e576a5d6e3c$var$_react = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $48c34e576a5d6e3c$var$_baseNew = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $48c34e576a5d6e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48c34e576a5d6e3c$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $48c34e576a5d6e3c$var$_react.default.createElement($48c34e576a5d6e3c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$48c34e576a5d6e3c$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $48c34e576a5d6e3c$var$_default = module.exports.default = $48c34e576a5d6e3c$var$MegaphoneIcon;

});

parcelRegister("bgttk", function(module, exports) {

$parcel$export(module.exports, "default", () => $83380cdcc7db46a6$export$2e2bcd8739ae039);

var $eaVC4 = parcelRequire("eaVC4");

var $6Z3KL = parcelRequire("6Z3KL");
function $83380cdcc7db46a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6Z3KL.default)(2, arguments);
    var dateLeftStartOfDay = (0, $eaVC4.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $eaVC4.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("2SyN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $218b9cbbd7630f91$export$2e2bcd8739ae039);

var $jn4Wd = parcelRequire("jn4Wd");

var $6Z3KL = parcelRequire("6Z3KL");

var $7IxPz = parcelRequire("7IxPz");
function $218b9cbbd7630f91$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    return (0, $jn4Wd.default)(dirtyDate, -amount);
}

});
parcelRegister("jn4Wd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a3fee6c3213cb4$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $e1a3fee6c3213cb4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});


parcelRegister("bTdbD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a7f0f5cf9a8ca34$var$_react = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8a7f0f5cf9a8ca34$var$_baseNew = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8a7f0f5cf9a8ca34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a7f0f5cf9a8ca34$var$PagesIcon = (props)=>/*#__PURE__*/ $8a7f0f5cf9a8ca34$var$_react.default.createElement($8a7f0f5cf9a8ca34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$8a7f0f5cf9a8ca34$var$PagesIcon.displayName = 'PagesIcon';
var $8a7f0f5cf9a8ca34$var$_default = module.exports.default = $8a7f0f5cf9a8ca34$var$PagesIcon;

});

parcelRegister("9vvQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ebfb6f6e33ed6b8$var$_react = $6ebfb6f6e33ed6b8$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $6ebfb6f6e33ed6b8$var$_baseNew = $6ebfb6f6e33ed6b8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6ebfb6f6e33ed6b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ebfb6f6e33ed6b8$var$ScreenIcon = (props)=>/*#__PURE__*/ $6ebfb6f6e33ed6b8$var$_react.default.createElement($6ebfb6f6e33ed6b8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$6ebfb6f6e33ed6b8$var$ScreenIcon.displayName = 'ScreenIcon';
var $6ebfb6f6e33ed6b8$var$_default = module.exports.default = $6ebfb6f6e33ed6b8$var$ScreenIcon;

});

parcelRegister("fvDx3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b629ce667363596df95f1c13e631244>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4a86a86f4811620$var$_react = $b4a86a86f4811620$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $b4a86a86f4811620$var$_baseNew = $b4a86a86f4811620$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4a86a86f4811620$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DeviceMobile".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call, contact us.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4a86a86f4811620$var$DeviceMobileIcon = (props)=>/*#__PURE__*/ $b4a86a86f4811620$var$_react.default.createElement($b4a86a86f4811620$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2zm2-.5A.5.5 0 0 0 4 2v12a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5zM10 13H6v-1.5h4z" clip-rule="evenodd"/>`
    }, props));
$b4a86a86f4811620$var$DeviceMobileIcon.displayName = 'DeviceMobileIcon';
var $b4a86a86f4811620$var$_default = module.exports.default = $b4a86a86f4811620$var$DeviceMobileIcon;

});

parcelRegister("bQIml", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcutsDialog", () => $3dacbbeae0d408d7$export$dc5d1c021e0a8741);

var $jmjWc = parcelRequire("jmjWc");

var $9wGTI = parcelRequire("9wGTI");



const $3dacbbeae0d408d7$export$dc5d1c021e0a8741 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "oTpkC",
    name: "KeyboardShortcutsDialog",
    loader: async ()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_new_keyboard_shortcut_dialog')) return (await (parcelRequire("d2bHX"))).KeyboardShortcutsDialog;
        else return (await (parcelRequire("9UfPG"))).KeyboardShortcutsDialog;
    }
});

});
parcelRegister("d2bHX", function(module, exports) {

let $0272e978bf229183$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0272e978bf229183$var$load("iAaum"),
    $0272e978bf229183$var$load("6vzdH"),
    $0272e978bf229183$var$load("dVcPf"),
    $0272e978bf229183$var$load("c6MKV"),
    $0272e978bf229183$var$load("fwbht"),
    $0272e978bf229183$var$load("ffEVr"),
    $0272e978bf229183$var$load("joJy8"),
    $0272e978bf229183$var$load("aHE9G"),
    $0272e978bf229183$var$load("3WCRn")
]).then(()=>parcelRequire('cIjy3'));

});

parcelRegister("9UfPG", function(module, exports) {

let $7365a00bc8da0aa9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7365a00bc8da0aa9$var$load("iAaum"),
    $7365a00bc8da0aa9$var$load("6vzdH"),
    $7365a00bc8da0aa9$var$load("ef0fn"),
    $7365a00bc8da0aa9$var$load("dVcPf"),
    $7365a00bc8da0aa9$var$load("c6MKV"),
    $7365a00bc8da0aa9$var$load("fwbht"),
    $7365a00bc8da0aa9$var$load("ffEVr"),
    $7365a00bc8da0aa9$var$load("joJy8"),
    $7365a00bc8da0aa9$var$load("aHE9G"),
    $7365a00bc8da0aa9$var$load("h5Eq0")
]).then(()=>parcelRequire('8IuF3'));

});


parcelRegister("9mLIQ", function(module, exports) {

$parcel$export(module.exports, "DevToolsDialog", () => $6d1b2fcade0e4c0b$export$23eed8de2215911d);
$parcel$export(module.exports, "LazyDevToolsDialog", () => $6d1b2fcade0e4c0b$export$edf3a07292eacd91);
$parcel$export(module.exports, "DevToolsBanner", () => $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82);

var $jmjWc = parcelRequire("jmjWc");

const $6d1b2fcade0e4c0b$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J4uP_",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("42m7i"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-mSEo",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("42m7i"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rSlGt",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("f4Bmr"))).DevToolsBanner
});

});
parcelRegister("42m7i", function(module, exports) {

let $2f0881422eba036f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2f0881422eba036f$var$load("iAaum"),
    $2f0881422eba036f$var$load("6vzdH"),
    $2f0881422eba036f$var$load("ikem6"),
    $2f0881422eba036f$var$load("c6MKV"),
    $2f0881422eba036f$var$load("aZinD"),
    $2f0881422eba036f$var$load("ffEVr"),
    $2f0881422eba036f$var$load("joJy8"),
    $2f0881422eba036f$var$load("aHE9G"),
    $2f0881422eba036f$var$load("i4Poh")
]).then(()=>parcelRequire('FAgdQ'));

});

parcelRegister("f4Bmr", function(module, exports) {

let $af9435dbab743814$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $af9435dbab743814$var$load("iAaum"),
    $af9435dbab743814$var$load("1PKKF"),
    $af9435dbab743814$var$load("C72jX")
]).then(()=>parcelRequire('5uV65'));

});


parcelRegister("hthDv", function(module, exports) {

$parcel$export(module.exports, "useUpdateNav4OptIn", () => $a132f3d6463ec602$export$b796ceec19d5414c);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");

var $iuIEr = parcelRequire("iuIEr");
const $a132f3d6463ec602$export$b796ceec19d5414c = ({ newIsNav4OptedIn: newIsNav4OptedIn, onCompleted: onCompleted, onError: onError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [nav4OptInSitewideMutation, { data: optInMutationData, loading: optInMutationLoading, error: optInMutationError }] = (0, $diswb.useMutation)((0, $d2LG0.default)`mutation useUpdateNav4OptInSitewideMutation($cloudId:ID!$enableNav4:Boolean!){confluence_updateNav4OptIn(cloudId:$cloudId input:{enableNav4:$enableNav4}){success errors{message}}}`);
    const updateNav4OptInSitewide = ()=>nav4OptInSitewideMutation({
            variables: {
                cloudId: cloudId,
                enableNav4: newIsNav4OptedIn
            }
        }).then((updateSiteConfigData)=>{
            const updateSiteConfiguration = updateSiteConfigData?.data?.confluence_updateNav4OptIn;
            if (updateSiteConfiguration?.success) {
                (0, $iuIEr.updateNav4AdminOptInCache)(newIsNav4OptedIn);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'changed',
                        actionSubject: 'navigationVersion',
                        source: 'nav4OptIn',
                        attributes: {
                            originalNavVersion: newIsNav4OptedIn ? '3' : '4',
                            newNavVersion: newIsNav4OptedIn ? '4' : '3'
                        }
                    }
                }).fire();
                onCompleted?.();
            } else // updateSiteConfiguration mutation can return successfully without server errors
            // but have { success: false } in the response. This should be treated as an error
            // as changes were not successfully applied
            handleError(updateSiteConfiguration?.errors);
        }).catch((error)=>{
            handleError(error);
        });
    const handleError = (error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'changeFailed',
                actionSubject: 'navigationVersion',
                source: 'nav4OptIn',
                attributes: {
                    error: error
                }
            }
        }).fire();
        onError?.();
    };
    return {
        updateNav4OptIn: updateNav4OptInSitewide,
        loading: optInMutationLoading,
        error: optInMutationError,
        isSiteWideUpdateSuccessful: optInMutationData?.confluence_updateNav4OptIn?.success
    };
};

});

parcelRegister("lohHj", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY", () => $3f26c87821b680a5$export$215d0f9cb557eff8);
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];

});

parcelRegister("1gy7x", function(module, exports) {

$parcel$export(module.exports, "PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS", () => $071869849092e495$export$d8593f7ef284bfd8);
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = [
    ...Object.values($071869849092e495$export$d8593f7ef284bfd8)
];

});

parcelRegister("eoU1C", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_SHARE_AND_RESTRICT_DIALOG", () => $b3332cb66ea1a913$export$7f1c6b461c54348b);
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};

});

parcelRegister("isKLx", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_SPACE_MISSION_CONTROL", () => $d14f8037089c8dc2$export$92d46364e5595a5a);
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};

});

parcelRegister("Asv1P", function(module, exports) {

$parcel$export(module.exports, "useCallbackWithAnalytics", () => $040545af9856ecf6$export$53c2b9c37c40e0d8);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fTXBo = parcelRequire("fTXBo");
const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $gwFzn.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("8DMug", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a0922b43eeb26f0$export$2e2bcd8739ae039);

var $4c48T = parcelRequire("4c48T");

var $jtTDB = parcelRequire("jtTDB");

var $83H3T = parcelRequire("83H3T");

var $dclyF = parcelRequire("dclyF");

var $g9Srd = parcelRequire("g9Srd");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $7a0922b43eeb26f0$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const exiting = (0, $g9Srd.useExitingPersistence)();
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dclyF.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4c48T.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4c48T.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $7a0922b43eeb26f0$export$2e2bcd8739ae039 = $7a0922b43eeb26f0$var$ShrinkOut;

});
parcelRegister("83H3T", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $68de0fcb6733268f$export$ff879f35a69d56b7);

var $gwFzn = parcelRequire("gwFzn");
const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $gwFzn.useRef)(null);
    const setRef = (0, $gwFzn.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("gXsSh", function(module, exports) {

$parcel$export(module.exports, "withRoutesContext", () => $fce7c419b91370d9$export$62d325d4ac84165c);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");
function $fce7c419b91370d9$export$62d325d4ac84165c(WrappedComponent) {
    function WithRoutesContext(props) {
        const routesContext = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
            ...routesContext,
            ...props
        });
    }
    WithRoutesContext.displayName = `withRoutesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithRoutesContext;
}

});

parcelRegister("5hAil", function(module, exports) {

$parcel$export(module.exports, "QueryGroup", () => $3d8ab1ac7a88b72c$export$9fae4d77e240e114);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $fppBw = parcelRequire("fppBw");
class $3d8ab1ac7a88b72c$export$9fae4d77e240e114 extends (0, $gwFzn.Component) {
    render() {
        const { queryProps: queryProps, children: children } = this.props;
        return this._renderQueryComponent(queryProps, children, 0);
    }
    constructor(..._args){
        super(..._args);
        this._queryResults = [];
        this._queryProperties = [];
        this._anyLoading = ()=>this._queryResults.some((data)=>data.loading === true);
        this._renderQueryComponent = (configArray, children, index)=>{
            if (!configArray.length) return children({
                results: [],
                loading: false
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
                errorPolicy: "all",
                ...configArray[index]
            }, ({ data: data, loading: loading, error: error, ...args })=>{
                this._queryResults[index] = {
                    data: data,
                    loading: loading,
                    error: error
                };
                this._queryProperties[index] = args;
                const nextIndex = index + 1;
                if (configArray.length > nextIndex) return this._renderQueryComponent(configArray, children, nextIndex);
                return children({
                    results: this._queryResults,
                    loading: this._anyLoading(),
                    properties: this._queryProperties
                });
            });
        };
    }
}
$3d8ab1ac7a88b72c$export$9fae4d77e240e114.propTypes = {
    queryProps: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).array.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};

});

parcelRegister("5CyTZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $417b932da088effb$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $hK4Zq = parcelRequire("hK4Zq");

var $6Z3KL = parcelRequire("6Z3KL");
function $417b932da088effb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    return (0, $hK4Zq.default)(dirtyDate, amount * 12);
}

});
parcelRegister("hK4Zq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceaa9a687fcb2ce1$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $ceaa9a687fcb2ce1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});


parcelRegister("5AtW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8777d177426e798b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jZrBc = parcelRequire("jZrBc");
class $8777d177426e798b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $7UHDa.jsx)($8777d177426e798b$var$WithEditorActionsNew, {
            ...this.props
        });
    }
    constructor(props){
        super(props);
    }
}
function $8777d177426e798b$var$WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $jZrBc.EditorContext));
    return /*#__PURE__*/ (0, $7UHDa.jsx)($8777d177426e798b$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8777d177426e798b$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}

});

parcelRegister("kFwgS", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $b38de1a13d5a6bb8$export$816ef638e478449a);
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("4icDV", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_METRICS_PREFIX", () => $2c9093170036a8a1$export$ad3f29048eb3061);
$parcel$export(module.exports, "EMBEDDED_VIEW_TTI", () => $2c9093170036a8a1$export$e5b04c2a3cc97ddc);
$parcel$export(module.exports, "EMBEDDED_EDITOR_TTI", () => $2c9093170036a8a1$export$9f8bbf62fac57d48);
$parcel$export(module.exports, "EMBEDDED_EDIT_CLICK", () => $2c9093170036a8a1$export$e08d2ab8ef653595);
$parcel$export(module.exports, "EMBEDDED_IFRAME_CONTENT_INITIALIZED", () => $2c9093170036a8a1$export$73b982309451f084);
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';

});

parcelRegister("hpNab", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_FEATURES", () => $cfa17a27dec34885$export$a3fda3dcee62e1cc);
$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $cfa17a27dec34885$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $cfa17a27dec34885$export$3207c60940c4a9b0);

var $9tQM5 = parcelRequire("9tQM5");
var $kFwgS = parcelRequire("kFwgS");
var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("9tQM5", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $5b5865fbd831eb6d$export$942a5fac9b8c9dc2);
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});


parcelRegister("7dyLS", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $ff4c1fab1412a389$export$775b6bb06e53a214);

var $lEY55 = parcelRequire("lEY55");

var $iUYhn = parcelRequire("iUYhn");

var $eFiFf = parcelRequire("eFiFf");

var $3YFt4 = parcelRequire("3YFt4");
var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};

});
parcelRegister("lEY55", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $31e4730094d25be0$export$775b6bb06e53a214);
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';

});

parcelRegister("iUYhn", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $4cce666965dd4176$export$775b6bb06e53a214);
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});

});

parcelRegister("eFiFf", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $e9e0239fba21ef53$export$775b6bb06e53a214);
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});

});

parcelRegister("3YFt4", function(module, exports) {

$parcel$export(module.exports, "TownsquareScope", () => $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa);
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.

});


parcelRegister("3paC4", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $6b372c322d10f06f$export$5d730b7aed1a3eb0);

var $dwp40 = parcelRequire("dwp40");

var $jppmC = parcelRequire("jppmC");
const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};

});
parcelRegister("jppmC", function(module, exports) {

$parcel$export(module.exports, "timed", () => $e3bb250125deb745$export$d35186a762cd39c8);
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};

});


parcelRegister("kw19Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be842260db55ec0$export$2e2bcd8739ae039);

var $ODlve = parcelRequire("ODlve");

var $hZW9z = parcelRequire("hZW9z");
class $0be842260db55ec0$export$2e2bcd8739ae039 {
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $hZW9z.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $ODlve.defaultSchema)) {
        return new $0be842260db55ec0$export$2e2bcd8739ae039(schema);
    }
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
}

});
parcelRegister("hZW9z", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $06474df1136b3dc1$export$533b26079ad0b4b);

var $dpr67 = parcelRequire("dpr67");

var $4lxYo = parcelRequire("4lxYo");

var $lnC5W = parcelRequire("lnC5W");

var $luMIx = parcelRequire("luMIx");

var $j4yOf = parcelRequire("j4yOf");

var $80lKV = parcelRequire("80lKV");

var $4pSzj = parcelRequire("4pSzj");

var $7oJlc = parcelRequire("7oJlc");

var $6BJLi = parcelRequire("6BJLi");

var $9553M = parcelRequire("9553M");

var $1XLKe = parcelRequire("1XLKe");

var $8SD1i = parcelRequire("8SD1i");

var $ntsJf = parcelRequire("ntsJf");

var $hhMD5 = parcelRequire("hhMD5");

var $7O1my = parcelRequire("7O1my");

var $14o7M = parcelRequire("14o7M");

var $fNci1 = parcelRequire("fNci1");

var $bvn5Z = parcelRequire("bvn5Z");
const $06474df1136b3dc1$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $06474df1136b3dc1$var$nodeToReducerMapping[node.type.name] || $06474df1136b3dc1$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $06474df1136b3dc1$var$nodeToReducerMapping = {
    blockquote: $dpr67.default,
    bulletList: $4lxYo.default,
    date: $lnC5W.default,
    decisionItem: $luMIx.default,
    hardBreak: $j4yOf.default,
    heading: $80lKV.default,
    inlineCard: $4pSzj.default,
    listItem: $7oJlc.default,
    mediaGroup: $6BJLi.default,
    mention: $9553M.default,
    orderedList: $1XLKe.default,
    panel: $8SD1i.default,
    paragraph: $ntsJf.default,
    rule: $hhMD5.default,
    status: $7O1my.default,
    table: $14o7M.default,
    taskItem: $fNci1.default,
    unknown: $bvn5Z.default
};

});
parcelRegister("dpr67", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa8f1012bb552b9a$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $aa8f1012bb552b9a$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $aa8f1012bb552b9a$export$2e2bcd8739ae039 = $aa8f1012bb552b9a$var$blockquote;

});

parcelRegister("4lxYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f70b3fb9c9a420a$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $6f70b3fb9c9a420a$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $hZW9z.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $6f70b3fb9c9a420a$export$2e2bcd8739ae039 = $6f70b3fb9c9a420a$var$bulletList;

});

parcelRegister("lnC5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $45097794511600bc$export$2e2bcd8739ae039);

var $dIxHZ = parcelRequire("dIxHZ");

var $b7FrM = parcelRequire("b7FrM");
const $45097794511600bc$var$date = (node, schema)=>{
    return node.attrs.timestamp ? (0, $dIxHZ.timestampToIsoFormat)(node.attrs.timestamp) : (0, $b7FrM.getText)(node);
};
var $45097794511600bc$export$2e2bcd8739ae039 = $45097794511600bc$var$date;

});

parcelRegister("luMIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f744f6dce90c93$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $a2f744f6dce90c93$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $a2f744f6dce90c93$export$2e2bcd8739ae039 = $a2f744f6dce90c93$var$decisionItem;

});

parcelRegister("j4yOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $28af56f2b8986b57$export$2e2bcd8739ae039);
const $28af56f2b8986b57$var$hardBreak = ()=>{
    return '\n';
};
var $28af56f2b8986b57$export$2e2bcd8739ae039 = $28af56f2b8986b57$var$hardBreak;

});

parcelRegister("80lKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $951f7824bed45cdb$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $951f7824bed45cdb$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('');
};
var $951f7824bed45cdb$export$2e2bcd8739ae039 = $951f7824bed45cdb$var$heading;

});

parcelRegister("4pSzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $defd2b7923d300de$export$2e2bcd8739ae039);

var $b7FrM = parcelRequire("b7FrM");
const $defd2b7923d300de$var$inlineCard = (node, schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $b7FrM.getText)(node);
};
var $defd2b7923d300de$export$2e2bcd8739ae039 = $defd2b7923d300de$var$inlineCard;

});

parcelRegister("7oJlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $134205d8b087ad65$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $134205d8b087ad65$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $134205d8b087ad65$export$2e2bcd8739ae039 = $134205d8b087ad65$var$listItem;

});

parcelRegister("6BJLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d832b43c98f4140b$export$2e2bcd8739ae039);
const $d832b43c98f4140b$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $d832b43c98f4140b$export$2e2bcd8739ae039 = $d832b43c98f4140b$var$mediaGroup;

});

parcelRegister("9553M", function(module, exports) {

$parcel$export(module.exports, "default", () => $788567eaebbf2e2c$export$2e2bcd8739ae039);
const $788567eaebbf2e2c$var$mention = (node, schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $788567eaebbf2e2c$export$2e2bcd8739ae039 = $788567eaebbf2e2c$var$mention;

});

parcelRegister("1XLKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d47451ce06aad1$export$2e2bcd8739ae039);

var $irKZA = parcelRequire("irKZA");

var $hZW9z = parcelRequire("hZW9z");
const $d8d47451ce06aad1$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $irKZA.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $hZW9z.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d8d47451ce06aad1$export$2e2bcd8739ae039 = $d8d47451ce06aad1$var$orderedList;

});

parcelRegister("8SD1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e4a61201921798$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $49e4a61201921798$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $49e4a61201921798$export$2e2bcd8739ae039 = $49e4a61201921798$var$panel;

});

parcelRegister("ntsJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17bffe0d8dcd208$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $c17bffe0d8dcd208$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $c17bffe0d8dcd208$export$2e2bcd8739ae039 = $c17bffe0d8dcd208$var$paragraph;

});

parcelRegister("hhMD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d065cc1601112956$export$2e2bcd8739ae039);
const $d065cc1601112956$var$rule = ()=>{
    return '';
};
var $d065cc1601112956$export$2e2bcd8739ae039 = $d065cc1601112956$var$rule;

});

parcelRegister("7O1my", function(module, exports) {

$parcel$export(module.exports, "default", () => $5da49fbb8ebaf963$export$2e2bcd8739ae039);

var $b7FrM = parcelRequire("b7FrM");
const $5da49fbb8ebaf963$var$status = (node, schema)=>{
    return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, $b7FrM.getText)(node);
};
var $5da49fbb8ebaf963$export$2e2bcd8739ae039 = $5da49fbb8ebaf963$var$status;

});

parcelRegister("14o7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $429219c4864a9efd$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $429219c4864a9efd$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($429219c4864a9efd$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $429219c4864a9efd$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($429219c4864a9efd$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $429219c4864a9efd$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $429219c4864a9efd$export$2e2bcd8739ae039 = $429219c4864a9efd$var$table;

});

parcelRegister("fNci1", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fce170cf034ba3$export$2e2bcd8739ae039);

var $hZW9z = parcelRequire("hZW9z");
const $96fce170cf034ba3$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $96fce170cf034ba3$export$2e2bcd8739ae039 = $96fce170cf034ba3$var$taskItem;

});

parcelRegister("bvn5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e7757f2318836a$export$2e2bcd8739ae039);

var $b7FrM = parcelRequire("b7FrM");

var $hZW9z = parcelRequire("hZW9z");
const $14e7757f2318836a$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $b7FrM.getText)(node);
};
var $14e7757f2318836a$export$2e2bcd8739ae039 = $14e7757f2318836a$var$unknown;

});



parcelRegister("kt8c2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f62061dbe92ec1bb$export$2e2bcd8739ae039);

var $9Bict = parcelRequire("9Bict");
const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
}

});
parcelRegister("9Bict", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $21987ac45ee5412e$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("jIOyV", function(module, exports) {

$parcel$export(module.exports, "MORE_ACTIONS_DROPDOWN_INTERACTION", () => $4fa41f80373a2ebe$export$f49429c67898bd15);
$parcel$export(module.exports, "MOVE_PAGE_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$daaf73616fe91ce9);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$d4222bce9029f393);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION", () => $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$eb06363d6ef3b8dd);
$parcel$export(module.exports, "QUICK_SUMMARY_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$ef2fb65c026ab7d3);
$parcel$export(module.exports, "OPEN_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$8122cf0ca2968a7b);
$parcel$export(module.exports, "INITIALIZE_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$ea9696a28a6fbc61);
$parcel$export(module.exports, "COMMENTS_SUMMARY_COMPONENT_INTERACTION", () => $4fa41f80373a2ebe$export$e561726b92a6162d);
$parcel$export(module.exports, "CREATE_SPACE_DRAWER_INTERACTION", () => $4fa41f80373a2ebe$export$e348981755bdab67);
$parcel$export(module.exports, "VIEW_AI_PRESENTATION_INTERACTION", () => $4fa41f80373a2ebe$export$af1eb8557193d022);
$parcel$export(module.exports, "AI_CONTENT_CATCHUP_INTERACTION", () => $4fa41f80373a2ebe$export$7f72b8ffbbbfef58);
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';

});

parcelRegister("8fj5s", function(module, exports) {

$parcel$export(module.exports, "useSkippableCoordination", () => $595fe854badba39a$export$a691d616fae8bb9d);

var $gwFzn = parcelRequire("gwFzn");

var $lwNi3 = parcelRequire("lwNi3");

var $dIouf = parcelRequire("dIouf");

var $5ZqQS = parcelRequire("5ZqQS");
const $595fe854badba39a$export$a691d616fae8bb9d = (messageId, skip = false, withChoreographer = true)=>{
    const [isMessageActive, setisMessageActive] = (0, $gwFzn.useState)(false);
    const [isLoading, setLoading] = (0, $gwFzn.useState)(true);
    const coordinationClient = (0, $lwNi3.useCoordinationClient)(withChoreographer);
    (0, $gwFzn.useEffect)(()=>{
        async function startMessage() {
            try {
                const _isMessageActive = await coordinationClient.start(messageId);
                setisMessageActive(_isMessageActive);
            } catch (err) {
                (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                    attribution: (0, $dIouf.Attribution).CONTENPLATES
                });
            }
            setLoading(false);
        }
        if (skip) return;
        startMessage();
    }, [
        coordinationClient,
        messageId,
        skip
    ]);
    const stop = (0, $gwFzn.useCallback)(async (force = false)=>{
        if (!force && !isMessageActive) return;
        try {
            await coordinationClient.stop(messageId);
            setisMessageActive(false);
        } catch (err) {
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $dIouf.Attribution).CONTENPLATES
            });
        }
    }, [
        isMessageActive,
        coordinationClient,
        messageId
    ]);
    return [
        isMessageActive,
        stop,
        skip ? false : isLoading
    ];
};

});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f9cbf95ff826dbea235ae2539545b0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("10CSJ", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $330e3eb3197f64f9$export$3ce634ac4a869e2c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");


class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("h0pw3")),
                (parcelRequire("d7uRE"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(this.state.Browser, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;

});
parcelRegister("h0pw3", function(module, exports) {

let $c6163ab3ed0d54f2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c6163ab3ed0d54f2$var$load("iAaum"),
    $c6163ab3ed0d54f2$var$load("6vzdH"),
    $c6163ab3ed0d54f2$var$load("jkTol"),
    $c6163ab3ed0d54f2$var$load("kIjBt"),
    $c6163ab3ed0d54f2$var$load("hIYCb"),
    $c6163ab3ed0d54f2$var$load("fNL1b"),
    $c6163ab3ed0d54f2$var$load("eqSsW"),
    $c6163ab3ed0d54f2$var$load("aZinD"),
    $c6163ab3ed0d54f2$var$load("7VwsU"),
    $c6163ab3ed0d54f2$var$load("fsZ6i"),
    $c6163ab3ed0d54f2$var$load("eAnbE"),
    $c6163ab3ed0d54f2$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("d7uRE", function(module, exports) {

let $98d3ded41815485f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $98d3ded41815485f$var$load("iAaum"),
    $98d3ded41815485f$var$load("jkTol"),
    $98d3ded41815485f$var$load("6gqpV"),
    $98d3ded41815485f$var$load("1qUWs"),
    $98d3ded41815485f$var$load("hzK1f"),
    $98d3ded41815485f$var$load("fqrMn"),
    $98d3ded41815485f$var$load("fYi1a"),
    $98d3ded41815485f$var$load("bjzRn"),
    $98d3ded41815485f$var$load("8mzoy"),
    $98d3ded41815485f$var$load("7a9CL"),
    $98d3ded41815485f$var$load("ivQYH"),
    $98d3ded41815485f$var$load("8pE8S"),
    $98d3ded41815485f$var$load("9Bu2S"),
    $98d3ded41815485f$var$load("42vdC"),
    $98d3ded41815485f$var$load("P5iE2"),
    $98d3ded41815485f$var$load("6ACCg"),
    $98d3ded41815485f$var$load("kIjBt"),
    $98d3ded41815485f$var$load("ffEVr"),
    $98d3ded41815485f$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});


parcelRegister("lhT9r", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $d6fdc1f3aa5fd3b7$export$66201d263cd6342);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");



class $d6fdc1f3aa5fd3b7$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("h0pw3")),
                (parcelRequire("45ZLF")),
                (parcelRequire("8YFUc"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(MediaPickerErrorBoundary, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Dropzone, {
                ...this.props
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.displayName = 'AsyncDropzone';
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = void 0;
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = void 0;

});
parcelRegister("45ZLF", function(module, exports) {

let $2fb78adae11e273d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2fb78adae11e273d$var$load("iAaum"),
    $2fb78adae11e273d$var$load("jkTol"),
    $2fb78adae11e273d$var$load("6gqpV"),
    $2fb78adae11e273d$var$load("1qUWs"),
    $2fb78adae11e273d$var$load("hzK1f"),
    $2fb78adae11e273d$var$load("fqrMn"),
    $2fb78adae11e273d$var$load("fYi1a"),
    $2fb78adae11e273d$var$load("bjzRn"),
    $2fb78adae11e273d$var$load("8mzoy"),
    $2fb78adae11e273d$var$load("7a9CL"),
    $2fb78adae11e273d$var$load("ivQYH"),
    $2fb78adae11e273d$var$load("8pE8S"),
    $2fb78adae11e273d$var$load("9Bu2S"),
    $2fb78adae11e273d$var$load("42vdC"),
    $2fb78adae11e273d$var$load("P5iE2"),
    $2fb78adae11e273d$var$load("6ACCg"),
    $2fb78adae11e273d$var$load("kIjBt"),
    $2fb78adae11e273d$var$load("ffEVr"),
    $2fb78adae11e273d$var$load("cCWZm")
]).then(()=>parcelRequire('xvLlm'));

});

parcelRegister("8YFUc", function(module, exports) {

let $68946ee1df52d3e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $68946ee1df52d3e9$var$load("iAaum"),
    $68946ee1df52d3e9$var$load("jkTol"),
    $68946ee1df52d3e9$var$load("lE3cg")
]).then(()=>parcelRequire('dp2qz'));

});


parcelRegister("aMqwg", function(module, exports) {

$parcel$export(module.exports, "useRovoEntitlement", () => $9d4cc27d6faf7a6e$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $9d4cc27d6faf7a6e$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $9d4cc27d6faf7a6e$export$d03a05ad8547472c);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $4ZoIm.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $iFWZA.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $iFWZA.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $gwFzn.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};

});

parcelRegister("c5gk7", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $3611e64236f83f1d$export$de65de8213222d10);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $lnqHu = parcelRequire("lnqHu");

var $3gadb = parcelRequire("3gadb");
const $3611e64236f83f1d$var$i18n = (0, $2nPZH.defineMessages)({
    close: {
        id: "editor-context-panel.panel-close-button.close-label",
        defaultMessage: "Close configuration panel"
    }
});
const $3611e64236f83f1d$export$de65de8213222d10 = /*#__PURE__*/ (0, $gwFzn.memo)(({ appearance: appearance = 'subtle', onClose: onClose, label: label, isTooltipDisabled: isTooltipDisabled = true, testId: testId = 'panel-close-button', analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        hideTooltipOnClick: true,
        content: label || formatMessage($3611e64236f83f1d$var$i18n.close)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        onClick: onClose,
        appearance: appearance,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        label: label || formatMessage($3611e64236f83f1d$var$i18n.close),
        testId: testId,
        isTooltipDisabled: isTooltipDisabled,
        analyticsContext: analyticsContext
    }));
});

});

parcelRegister("6p02T", function(module, exports) {

$parcel$export(module.exports, "processExcerpt", () => $3cbad44d75de57c9$export$16c2ab98757b54d6);
$parcel$export(module.exports, "enrichExcerpt", () => $3cbad44d75de57c9$export$b847312d69858d61);
$parcel$export(module.exports, "cleanExcerpt", () => $3cbad44d75de57c9$export$7512fe8206a7f75b);

var $gwFzn = parcelRequire("gwFzn");

var $iXCQx = parcelRequire("iXCQx");
const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');

});

parcelRegister("3yh4a", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $d415184962066c9b$export$cf56d0f54cfcce4);

var $8YePs = parcelRequire("8YePs");

var $9wGTI = parcelRequire("9wGTI");
const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);

});
parcelRegister("8YePs", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $b3ddd992633db411$export$6e8ea24b15199873);

var $gwFzn = parcelRequire("gwFzn");
function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("ajdQJ", function(module, exports) {

$parcel$export(module.exports, "dangerouslyCreateSafeString", () => $78166bfa877f38c2$export$b91bb42a4e3ff500);
$parcel$export(module.exports, "markAsSafe", () => $78166bfa877f38c2$export$2a4aba80518f1883);
class $78166bfa877f38c2$var$SafeString {
    constructor(value){
        this.value = value;
        this.valueOf = this.toString = this.toJSON = ()=>this.value;
    }
}
const $78166bfa877f38c2$export$b91bb42a4e3ff500 = (value)=>new $78166bfa877f38c2$var$SafeString(value);
const $78166bfa877f38c2$export$7d336779073e9481 = (value)=>value instanceof $78166bfa877f38c2$var$SafeString;
const $78166bfa877f38c2$export$2a4aba80518f1883 = (...allowedStrings)=>(value)=>allowedStrings.includes(value) ? Object.freeze(new $78166bfa877f38c2$var$SafeString(value)) : value;

});

parcelRegister("a7SsH", function(module, exports) {

$parcel$export(module.exports, "NotificationAction", () => $92a679059989a896$export$fb999f8a83c64817);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $92a679059989a896$export$fb999f8a83c64817 = /*#__PURE__*/ function(NotificationAction) {
    NotificationAction["NOTIFY"] = "NOTIFY";
    NotificationAction["DONT_NOTIFY"] = "DONT_NOTIFY";
    return NotificationAction;
}({});

});

parcelRegister("14SPd", function(module, exports) {

$parcel$export(module.exports, "RESTRICTIONS_BUTTON_METRIC", () => $8ab24ab9418ac89d$export$34cc51d2a4e5cf67);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_METRIC", () => $8ab24ab9418ac89d$export$2ba38536ff91e2a7);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
var $jIOyV = parcelRequire("jIOyV");
const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});

});

parcelRegister("5nr5P", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDataContainer", () => $22dbf97de39b4a94$export$8428b29fbe35d5c);

var $ipPpS = parcelRequire("ipPpS");
class $22dbf97de39b4a94$export$8428b29fbe35d5c extends (0, $ipPpS.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                contentPermissions: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                contentStatus: undefined,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: //   currentUserInfo: PropTypes.shape({
            //     id: PropTypes.string.isRequired,
            //     displayName: PropTypes.string.isRequired,
            //     isSuperAdmin: PropTypes.bool,
            //     profilePicture: PropTypes.shape({
            //       path: PropTypes.string
            //     })
            //   }).isRequired,
            currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: // const restrictionsShape = {
            //   restrictions: PropTypes.shape({
            //     user: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           accountId: PropTypes.string,
            //           displayName: PropTypes.string,
            //           type: PropTypes.string
            //         })
            //       )
            //     }),
            //     group: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           name: PropTypes.string
            //         })
            //       )
            //     })
            //   })
            // };
            restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}

});

parcelRegister("c4ECQ", function(module, exports) {

$parcel$export(module.exports, "ContentRestrictionType", () => $e40ae21eed558c2b$export$91111a1ebace330);
$parcel$export(module.exports, "RestrictionFrom", () => $e40ae21eed558c2b$export$7602248773d1f745);
$parcel$export(module.exports, "EntityType", () => $e40ae21eed558c2b$export$8eda7e02f8f033b2);
$parcel$export(module.exports, "PermissionType", () => $e40ae21eed558c2b$export$af2022a36dc13b47);
$parcel$export(module.exports, "ErrorMessageType", () => $e40ae21eed558c2b$export$efe8384a5aa2f235);
$parcel$export(module.exports, "OpenDialogType", () => $e40ae21eed558c2b$export$4ecc254c2ddad822);
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});

});

parcelRegister("91m2d", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $863b1d05b97a0c11$export$954628993bf3188e);

var $5PE1K = parcelRequire("5PE1K");
const $863b1d05b97a0c11$export$954628993bf3188e = (trialEndDate)=>{
    if (!trialEndDate) return 0;
    // +1 day to round up for fractional days
    return (0, $5PE1K.default)(new Date(trialEndDate), new Date()) + 1;
};

});

parcelRegister("5x0y1", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $548cbc934d83dd4c$export$cbf8224b64e0d942);
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });

});

parcelRegister("jyw2s", function(module, exports) {

$parcel$export(module.exports, "getParticipantColor", () => $514d44140915e951$export$60ba61eca4eb64f2);

var $aFUXX = parcelRequire("aFUXX");
function $514d44140915e951$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $514d44140915e951$export$60ba61eca4eb64f2(str) {
    const index = $514d44140915e951$export$c14f61804029af13(str) % (0, $aFUXX.participantColors).length;
    return {
        index: index,
        color: (0, $aFUXX.participantColors)[index]
    };
}

});

parcelRegister("kKgGX", function(module, exports) {

$parcel$export(module.exports, "experimentalRequestAccessMutation", () => $f1a50d3298f02558$export$fcef4298a59b8dda);

var $d2LG0 = parcelRequire("d2LG0");
const $f1a50d3298f02558$export$fcef4298a59b8dda = (0, $d2LG0.default)`mutation experimentalRequestAccessMutation($contentId:String!$accessType:String!)@experimental{experimentalRequestAccess(contentId:$contentId accessType:$accessType){complete fullName}}`;

});

parcelRegister("sLZsl", function(module, exports) {

$parcel$export(module.exports, "useAutoConvertState", () => $9e73f43295b80088$export$dc84155a8aa7f285);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $9e73f43295b80088$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        isAutoConverted: false
    },
    actions: {
        setIsAutoConverted: (isAutoConverted)=>({ setState: setState })=>{
                setState({
                    isAutoConverted: isAutoConverted
                });
            }
    },
    name: 'isAutoConverted'
});
const $9e73f43295b80088$var$getAutoConvertState = (state)=>{
    return state.isAutoConverted;
};
const $9e73f43295b80088$export$dc84155a8aa7f285 = (0, $iFWZA.createHook)($9e73f43295b80088$var$Store, {
    selector: $9e73f43295b80088$var$getAutoConvertState
});

});

parcelRegister("cQhbe", function(module, exports) {

$parcel$export(module.exports, "AutoConvertEvent", () => $3ddd96eb421fb45c$export$c184dc244f9dacf4);
$parcel$export(module.exports, "AutoConvertActionSubject", () => $3ddd96eb421fb45c$export$a248ed70ead7ff08);
$parcel$export(module.exports, "RevertAutoConvertEvent", () => $3ddd96eb421fb45c$export$d8b435b7aa875953);
$parcel$export(module.exports, "AutoConvertPanelEvent", () => $3ddd96eb421fb45c$export$b22548c36d783030);
$parcel$export(module.exports, "AutoConversionByLineEvent", () => $3ddd96eb421fb45c$export$e8dbd545dc7c3af0);
$parcel$export(module.exports, "sendEditorConversionAnalyticsPageEvent", () => $3ddd96eb421fb45c$export$b4535793cfa6d80a);
$parcel$export(module.exports, "sendEditorConversionAnalyticsPanelEvent", () => $3ddd96eb421fb45c$export$e045315387fc4262);
var $3ddd96eb421fb45c$export$c184dc244f9dacf4 = /*#__PURE__*/ function(AutoConvertEvent) {
    AutoConvertEvent["VIEWED"] = "pageViewed";
    AutoConvertEvent["EDITED"] = "pageEdited";
    AutoConvertEvent["PUBLISHED"] = "pagePublished";
    AutoConvertEvent["NOTIFICATION_SHOWN"] = "notificationShown";
    AutoConvertEvent["NOTIFICATION_ERROR"] = "notificationError";
    return AutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$a248ed70ead7ff08 = /*#__PURE__*/ function(AutoConvertActionSubject) {
    AutoConvertActionSubject["AUTO_CONVERSION"] = "autoConversion";
    AutoConvertActionSubject["AUTO_CONVERSION_BYLINE"] = "autoConversionByLine";
    return AutoConvertActionSubject;
}({});
var $3ddd96eb421fb45c$export$d8b435b7aa875953 = /*#__PURE__*/ function(RevertAutoConvertEvent) {
    RevertAutoConvertEvent["DIALOG_OPEN"] = "revertDialogOpen";
    RevertAutoConvertEvent["CLICKED"] = "revertClicked";
    RevertAutoConvertEvent["CANCELLED"] = "revertCancelled";
    RevertAutoConvertEvent["CONFIRMED"] = "revertConfirmed";
    RevertAutoConvertEvent["ERROR"] = "revertError";
    return RevertAutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$b22548c36d783030 = /*#__PURE__*/ function(AutoConvertPanelEvent) {
    AutoConvertPanelEvent["VIEWED"] = "panelViewed";
    AutoConvertPanelEvent["SUPPORTED"] = "panelSupported";
    AutoConvertPanelEvent["NONE"] = "panelNone";
    AutoConvertPanelEvent["GET_ERROR"] = "panelGetError";
    AutoConvertPanelEvent["SET_ERROR"] = "panelSetError";
    return AutoConvertPanelEvent;
}({});
var $3ddd96eb421fb45c$export$e8dbd545dc7c3af0 = /*#__PURE__*/ function(AutoConversionByLineEvent) {
    AutoConversionByLineEvent["CLICKED"] = "bylineClicked";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_OPENED"] = "newEditorModalOpened";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_CLOSED"] = "newEditorModalClosed";
    return AutoConversionByLineEvent;
}({});
const $3ddd96eb421fb45c$export$b4535793cfa6d80a = (createAnalyticsEvent, analytics, actionSubject)=>{
    const { pageAction: pageAction, source: source, setting: setting } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'triggered',
            actionSubject: actionSubject,
            source: source,
            actionSubjectId: 'page',
            attributes: {
                pageAction: pageAction,
                setting: setting
            }
        }
    }).fire();
};
const $3ddd96eb421fb45c$export$e045315387fc4262 = (createAnalyticsEvent, analytics)=>{
    const { level: level, panelAction: panelAction, source: source } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'autoConversion',
            source: source,
            actionSubjectId: 'panel',
            attributes: {
                level: level,
                panelAction: panelAction
            }
        }
    }).fire();
};

});

parcelRegister("3zetf", function(module, exports) {

$parcel$export(module.exports, "getSpaceNameFromResults", () => $578f455bd7f79c76$export$64984dda48ed9108);
$parcel$export(module.exports, "getSpaceNameQueryProps", () => $578f455bd7f79c76$export$5e300c68d69bb755);
/* eslint-disable check-file/filename-blocklist */ 
var $7ftOo = parcelRequire("7ftOo");
const $578f455bd7f79c76$export$64984dda48ed9108 = (results)=>{
    const errors = results.filter((result)=>result.error).map((result)=>result.error);
    if (errors.length) throw new Error(errors.join('\n\n'));
    return results[0]?.data?.space?.name || '';
};
const $578f455bd7f79c76$export$5e300c68d69bb755 = (spaceKey)=>{
    return [
        {
            query: (0, $7ftOo.SpaceNameQuery),
            variables: {
                spaceKey: spaceKey
            },
            skip: !spaceKey
        }
    ];
};

});
parcelRegister("7ftOo", function(module, exports) {

$parcel$export(module.exports, "SpaceNameQuery", () => $6a955c062718cf11$export$572a16972f8daeee);

var $d2LG0 = parcelRequire("d2LG0");
const $6a955c062718cf11$export$572a16972f8daeee = (0, $d2LG0.default)`query SpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id name key}}`;

});


parcelRegister("kj1gY", function(module, exports) {

$parcel$export(module.exports, "ChangesDiffLoader", () => $65a70e5bc153e910$export$3ecbd7f299e957b2);

var $jmjWc = parcelRequire("jmjWc");

const $65a70e5bc153e910$export$3ecbd7f299e957b2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "20b9O",
    name: "ChangesDiffLoader",
    loader: async ()=>(await (parcelRequire("5jBeR"))).ChangesDiff
});

});
parcelRegister("5jBeR", function(module, exports) {

let $3deb9cefd7e13c8a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3deb9cefd7e13c8a$var$load("8OiWl").then(()=>parcelRequire('fQeQL'));

});


parcelRegister("18HQ4", function(module, exports) {

$parcel$export(module.exports, "StatusIndicator", () => $4dfb2d8a6603cd21$export$b4f88f0ca5784eef);
$parcel$export(module.exports, "StyledText", () => $4dfb2d8a6603cd21$export$31ea92f3997410dd);
$parcel$export(module.exports, "FadingSpan", () => $4dfb2d8a6603cd21$export$bb5d4b172e6970cd);
$parcel$export(module.exports, "EllipsisContainer", () => $4dfb2d8a6603cd21$export$91672a4b819b5126);
$parcel$export(module.exports, "AnimatedDot", () => $4dfb2d8a6603cd21$export$c30cc6d619162254);
$parcel$export(module.exports, "StyledRefreshLink", () => $4dfb2d8a6603cd21$export$b9ead157d7292e86);
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $aFUXX = parcelRequire("aFUXX");
const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1lnnvun": (0, $iAWao.default)((0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)())
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhk11bn _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154irowa",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_1911rowa",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhkmv6i" : "_bfhk11bn",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $iAWao.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pmoej _1wyb1crf _syaz131l _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _11q7131l _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81o8v _k48pmoej _syaz1e6v",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lxuKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae488f825ea0b6f$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $etA3X = parcelRequire("etA3X");

var $6Z3KL = parcelRequire("6Z3KL");
var $fae488f825ea0b6f$var$MILLISECONDS_IN_MINUTE = 60000;
function $fae488f825ea0b6f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    return (0, $etA3X.default)(dirtyDate, amount * $fae488f825ea0b6f$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("axAnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9dab50b8978c7c$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $gwFzn.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};

});

parcelRegister("cF2C3", function(module, exports) {

$parcel$export(module.exports, "timeFormatter", () => $9428fa9f64a90dcf$export$5a00511f040384d7);

var $62ptY = parcelRequire("62ptY");

var $2nPZH = parcelRequire("2nPZH");
const $9428fa9f64a90dcf$var$i18n = (0, $2nPZH.defineMessages)({
    aMomentAgo: {
        id: "save-indicator.tooltip.time.aMomentAgo",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "save-indicator.tooltip.time.lessThanAMinuteAgo",
        defaultMessage: "less than a minute ago"
    },
    oneMinuteAgo: {
        id: "save-indicator.tooltip.time.oneMinuteAgo",
        defaultMessage: "a minute ago"
    },
    xMinutesAgo: {
        id: "save-indicator.tooltip.time.xMinutesAgo",
        defaultMessage: "{time} minutes ago"
    },
    oneHourAgo: {
        id: "save-indicator.tooltip.time.oneHourAgo",
        defaultMessage: "about an hour ago"
    },
    xHoursAgo: {
        id: "save-indicator.tooltip.time.xHoursAgo",
        defaultMessage: "about {time} hours ago"
    },
    yesterday: {
        id: "save-indicator.tooltip.time.yesterday",
        defaultMessage: "yesterday at {time}"
    }
});
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_SECONDS = 1000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES = 60000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR = 3600000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_DAY = 86400000;
const $9428fa9f64a90dcf$export$5a00511f040384d7 = (savedTime, formatMessage)=>{
    let formattedTime;
    const timeNow = new Date();
    const timeDifference = timeNow.getTime() - savedTime.getTime();
    if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_SECONDS < 4) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.aMomentAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 1) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.lessThanAMinuteAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 2) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.oneMinuteAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 50) {
        const roundedMinutes = Math.round(timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES);
        formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.xMinutesAgo, {
            time: roundedMinutes
        });
    } else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 90) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.oneHourAgo);
    else {
        const yesterday = timeNow;
        yesterday.setDate(timeNow.getDate() - 1);
        const savedTimeWasYesterday = yesterday.toLocaleDateString() === savedTime.toLocaleDateString();
        if (savedTimeWasYesterday && timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR > 5) // yesterday and more than 5 hours ago
        formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.yesterday, {
            time: (0, $62ptY.default)(savedTime, 'p')
        });
        else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_DAY < 1) {
            const roundedHours = Math.round(timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR);
            formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.xHoursAgo, {
                time: roundedHours
            });
        } else formattedTime = (0, $62ptY.default)(savedTime, 'PP');
    }
    return formattedTime;
};

});

parcelRegister("kkQZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed290d22e560c9dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $eEA8O = parcelRequire("eEA8O");

var $hPd3F = parcelRequire("hPd3F");

var $7cTWR = parcelRequire("7cTWR");

var $3Npfo = parcelRequire("3Npfo");

var $k5HOq = parcelRequire("k5HOq");

var $9A5yV = parcelRequire("9A5yV");
function $ed290d22e560c9dd$var$_defineProperty(e, r, t) {
    return (r = $ed290d22e560c9dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed290d22e560c9dd$var$_toPropertyKey(t) {
    var i = $ed290d22e560c9dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ed290d22e560c9dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ed290d22e560c9dd$var$baselineUnit = "var(--ds-space-050, 4px)";
const $ed290d22e560c9dd$var$COLOR_N900 = '#091E42';
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $ed290d22e560c9dd$var$ContentContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$Image = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$ButtonContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$BodyContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_ca0q1b66 _n3td1b66 _syaz1fxt",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ed290d22e560c9dd$export$c7313f750e9cbc9d extends (0, $gwFzn.Component) {
    getPrimaryButton() {
        const { primaryAction: primaryAction, primaryText: primaryText } = this.props;
        return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
    getSecondaryButton() {
        const { secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
    getActionButton(appearance, onClick, action, text) {
        const type = action ? action.type : (0, $7cTWR.buttonActionTypes).DISMISS;
        switch(type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                {
                    const actionData = action.data;
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                        href: actionData.url,
                        target: actionData.target,
                        appearance: appearance,
                        onClick: onClick,
                        children: text
                    });
                }
            default:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                    appearance: appearance,
                    onClick: onClick,
                    children: text
                });
        }
    }
    render() {
        const { children: children, title: title, imageSrc: imageSrc, imageAlt: imageAlt, body: body, position: position, order: order, secondaryText: secondaryText } = this.props;
        const messageContent = {
            image: null,
            title: null,
            body: null
        };
        if (title) // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/ (0, $7UHDa.jsx)("h4", {
            children: title
        }, "title");
        if (imageSrc) messageContent.image = /*#__PURE__*/ (0, $7UHDa.jsx)($ed290d22e560c9dd$var$Image, {
            src: imageSrc,
            alt: imageAlt
        }, "img");
        messageContent.body = /*#__PURE__*/ (0, $7UHDa.jsx)($ed290d22e560c9dd$var$BodyContainer, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9A5yV.default), {
                html: body
            })
        }, "body");
        const orderedContent = order.map((c)=>messageContent[c]);
        const content = /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)($ed290d22e560c9dd$var$ContentContainer, {
                    children: orderedContent
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)($ed290d22e560c9dd$var$ButtonContainer, {
                    children: [
                        this.getPrimaryButton(),
                        secondaryText ? this.getSecondaryButton() : null
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPd3F.default), {
            content: content,
            placement: position,
            isOpen: true,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        $ed290d22e560c9dd$var$_defineProperty(this, "onPrimaryClick", ()=>{
            this.props.fireClickEvent('primary');
        });
        $ed290d22e560c9dd$var$_defineProperty(this, "onSecondaryClick", ()=>{
            this.props.fireClickEvent('secondary');
        });
    }
}
$ed290d22e560c9dd$var$_defineProperty($ed290d22e560c9dd$export$c7313f750e9cbc9d, "defaultProps", {
    children: null,
    order: [
        'title',
        'image',
        'body'
    ],
    position: 'bottom left'
});
const $ed290d22e560c9dd$export$3660ec843fc5ef1b = (0, $3Npfo.default)($ed290d22e560c9dd$export$c7313f750e9cbc9d);
var $ed290d22e560c9dd$export$2e2bcd8739ae039 = (0, $k5HOq.default)($ed290d22e560c9dd$export$3660ec843fc5ef1b, 'inlineDialog');

});

parcelRegister("f1ONH", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $af0e5af08b78b49a$var$nativeFloor = Math.floor, $af0e5af08b78b49a$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $af0e5af08b78b49a$var$baseRandom(lower, upper) {
    return lower + $af0e5af08b78b49a$var$nativeFloor($af0e5af08b78b49a$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $af0e5af08b78b49a$var$baseRandom;

});

parcelRegister("gHANe", function(module, exports) {

$parcel$export(module.exports, "UserContextQuery", () => $d5213b14145490b2$export$4dfd297558414f12);

var $d2LG0 = parcelRequire("d2LG0");
const $d5213b14145490b2$export$4dfd297558414f12 = (0, $d2LG0.default)`query UserContextQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;

});

parcelRegister("kpLJY", function(module, exports) {

$parcel$export(module.exports, "canArchiveContent", () => $0a26534720307814$export$482055539d5cd058);
$parcel$export(module.exports, "canDeleteContent", () => $0a26534720307814$export$c1a3ac49d9650e25);
$parcel$export(module.exports, "canRestoreContent", () => $0a26534720307814$export$b70e008aef4dbd20);
$parcel$export(module.exports, "canEditContentArchiveNote", () => $0a26534720307814$export$45c8d206d1e3c1a5);

var $1ggpj = parcelRequire("1ggpj");
const $0a26534720307814$var$isValidContentType = (contentType)=>{
    if (!contentType) return false;
    return (0, $1ggpj.VALID_OPERATION_TARGETS).includes(contentType);
};
const $0a26534720307814$export$482055539d5cd058 = (operations)=>{
    if (operations) return operations.some((singleOperation)=>{
        return $0a26534720307814$var$isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'archive';
    });
    return false;
};
const $0a26534720307814$export$c1a3ac49d9650e25 = (operations)=>{
    if (operations) return operations.some((singleOperation)=>{
        return $0a26534720307814$var$isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'delete';
    });
    return false;
};
const $0a26534720307814$export$b70e008aef4dbd20 = (operations)=>$0a26534720307814$export$482055539d5cd058(operations);
const $0a26534720307814$export$45c8d206d1e3c1a5 = (operations)=>$0a26534720307814$export$482055539d5cd058(operations);

});

parcelRegister("2yLZj", function(module, exports) {

$parcel$export(module.exports, "debouncePromise", () => $66b7bbb283b4e707$export$45ee3b73b8783988);
const $66b7bbb283b4e707$export$45ee3b73b8783988 = (inner, ms = 0)=>{
    let timer = null;
    let resolves = [];
    return (...args)=>{
        // Run the function after a certain amount of time
        timer != null && clearTimeout(timer);
        timer = setTimeout(()=>{
            // Get the result of the inner function, then apply it to the resolve function of
            // each promise that has been created since the last time the inner function was run
            const result = inner(...args);
            resolves.forEach((r)=>r(result));
            resolves = [];
        }, ms);
        return new Promise((r)=>resolves.push(r));
    };
};

});

parcelRegister("h6CV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d67025ac73559bd$export$2e2bcd8739ae039);

var $g9LeK = parcelRequire("g9LeK");

var $lRn1m = parcelRequire("lRn1m");
function $6d67025ac73559bd$var$updateRootItems(rootItems, allItems = [], { key: key, keysCache: keysCache, operation: operation }) {
    const newKeysCache = {
        ...keysCache
    };
    // If it is not an append operation we can ignore allItems as they will be swaped with new items
    const allBaseItems = operation === 'UPDATE' ? [] : [
        ...allItems
    ];
    const startIndexWith = allBaseItems.length;
    rootItems.forEach((rootItem, index)=>{
        const rootItemKey = rootItem[key];
        if (rootItemKey === undefined) throw new Error(`[ERROR] Property '${String(key)}' not found in rootItem[${index}]`);
        else newKeysCache[rootItem[key]] = index + startIndexWith;
    });
    return {
        keysCache: newKeysCache,
        items: allBaseItems.concat(rootItems)
    };
}
function $6d67025ac73559bd$var$updateChildItems(newitems, allTableItems, itemParent, { key: key, keysCache: keysCache, operation: operation }) {
    const newKeysCache = {
        ...keysCache
    };
    const parentCacheKey = itemParent[key];
    if (parentCacheKey === undefined) throw new Error(`[Table Tree] Property '${String(key)}' not found in parent item`);
    const parentLocation = newKeysCache[parentCacheKey];
    const allItemsCopy = [
        ...allTableItems
    ];
    const objectToChange = (0, (/*@__PURE__*/$parcel$interopDefault($g9LeK)))(allItemsCopy, parentLocation);
    const baseChildrenOfObjectToChange = operation === 'UPDATE' ? [] : (0, (/*@__PURE__*/$parcel$interopDefault($g9LeK)))(objectToChange, 'children', []);
    objectToChange.children = baseChildrenOfObjectToChange.concat(newitems);
    // Update cache
    newitems.forEach((item, index)=>{
        newKeysCache[item[key]] = `${parentLocation}.children[${index + baseChildrenOfObjectToChange.length}]`;
    });
    return {
        keysCache: newKeysCache,
        items: (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(allItemsCopy, parentLocation, objectToChange)
    };
}
class $6d67025ac73559bd$export$2e2bcd8739ae039 {
    updateItems(items, allItems = [], parentItem) {
        const options = {
            key: this.key,
            keysCache: this.keysCache,
            operation: 'UPDATE'
        };
        if (!parentItem) {
            const { keysCache: keysCache, items: updatedRootItems } = $6d67025ac73559bd$var$updateRootItems(items, allItems, options);
            this.keysCache = keysCache;
            return updatedRootItems;
        }
        const { keysCache: keysCache, items: updatedItems } = $6d67025ac73559bd$var$updateChildItems(items, allItems, parentItem, options);
        this.keysCache = keysCache;
        return updatedItems;
    }
    appendItems(items, allItems = [], parentItem) {
        const options = {
            key: this.key,
            keysCache: this.keysCache,
            operation: 'APPEND'
        };
        if (!parentItem) {
            const { keysCache: keysCache, items: updatedRootItems } = $6d67025ac73559bd$var$updateRootItems(items, allItems, options);
            this.keysCache = keysCache;
            return updatedRootItems;
        }
        const { keysCache: keysCache, items: updatedItems } = $6d67025ac73559bd$var$updateChildItems(items, allItems, parentItem, options);
        this.keysCache = keysCache;
        return updatedItems;
    }
    constructor({ key: key = 'key' } = {}){
        this.key = void 0;
        this.keysCache = void 0;
        this.key = key;
        this.keysCache = {};
    }
}

});

parcelRegister("a1uvs", function(module, exports) {

$parcel$export(module.exports, "ExperienceAbort", () => $5da8a4a03d184e93$export$c9b6bcd70239a39c);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $5da8a4a03d184e93$export$c9b6bcd70239a39c({ name: name, reason: reason }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.abort({
            name: name,
            reason: reason
        }), [
        name,
        reason,
        experienceTracker
    ]);
    return null;
}

});

parcelRegister("4oZIh", function(module, exports) {

$parcel$export(module.exports, "useTrialDetails", () => $539a9f290c7f1955$export$be2f13183561cb);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $5PE1K = parcelRequire("5PE1K");

var $8H5XZ = parcelRequire("8H5XZ");

var $7Sm4c = parcelRequire("7Sm4c");

var $bQm3c = parcelRequire("bQm3c");
/**
 * Productionization note:
 * this is copied from next/packages/trial-components/src/graphql/getTrialDaysLeftFromQuery.ts
 * revisit this when productionize
 */ const $539a9f290c7f1955$var$getTrialDaysLeft = (trialEndDate)=>{
    if (!trialEndDate) return 0;
    // +1 day to round up for fractional days
    return (0, $5PE1K.default)(new Date(trialEndDate), new Date()) + 1;
};
const $539a9f290c7f1955$export$be2f13183561cb = ({ skip: skip = true })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const shouldSkipQuery = skip || !isLoggedIn;
    const { data: trialData, loading: trialDetailsLoading, error: trialDetailsError } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useTrialDetailsTrialDetailsQuery{license{trialEndDate billingSourceSystem}}`, {
        skip: shouldSkipQuery
    });
    if ((0, $8H5XZ.isGraphQLError)(trialDetailsError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(trialDetailsError)) (0, $7Sm4c.markErrorAsHandled)(trialDetailsError);
    const trialDaysLeft = $539a9f290c7f1955$var$getTrialDaysLeft(trialData?.license?.trialEndDate);
    return {
        trialData: trialData,
        trialDetailsLoading: trialDetailsLoading,
        trialDetailsError: trialDetailsError,
        isInstanceInTrial: trialDaysLeft > 0,
        trialDaysLeft: trialDaysLeft,
        trialEndDate: trialData?.license?.trialEndDate,
        billingSourceSystem: trialData?.license?.billingSourceSystem
    };
};

});

parcelRegister("62D01", function(module, exports) {

$parcel$export(module.exports, "default", () => $46612e6d4abcdf5a$export$2e2bcd8739ae039);

var $eaVC4 = parcelRequire("eaVC4");
function $46612e6d4abcdf5a$export$2e2bcd8739ae039() {
    return (0, $eaVC4.default)(Date.now());
}

});

parcelRegister("9WPRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e1c2df684a4716$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $5CyTZ = parcelRequire("5CyTZ");

var $6Z3KL = parcelRequire("6Z3KL");
function $73e1c2df684a4716$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    return (0, $5CyTZ.default)(dirtyDate, -amount);
}

});

parcelRegister("Qlykt", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SIZE_MEDIUM", () => $f866e8db934ec558$export$d7240ab6bd9deaf0);
$parcel$export(module.exports, "EMOJI_SIZE_LARGE", () => $f866e8db934ec558$export$7d383c70a74caba8);
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;

});

parcelRegister("f0NfR", function(module, exports) {

$parcel$export(module.exports, "withSessionData", () => $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");
function $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a(WrappedComponent) {
    function WithSessionData(props) {
        const sessionData = (0, $bQm3c.useSessionData)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(WrappedComponent, {
            sessionData: sessionData,
            ...props
        });
    }
    WithSessionData.displayName = `withSessionData(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithSessionData;
}

});

parcelRegister("lfzYK", function(module, exports) {

var $iedpG = parcelRequire("iedpG");

var $aknvL = parcelRequire("aknvL");

var $lslb5 = parcelRequire("lslb5");

var $bb3KV = parcelRequire("bb3KV");

var $eWxUs = parcelRequire("eWxUs");

var $3evUw = parcelRequire("3evUw");
/** Used as the size to enable large array optimizations. */ var $f786e857b8310d83$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $f786e857b8310d83$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $aknvL, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $bb3KV(values, $eWxUs(iteratee));
    if (comparator) {
        includes = $lslb5;
        isCommon = false;
    } else if (values.length >= $f786e857b8310d83$var$LARGE_ARRAY_SIZE) {
        includes = $3evUw;
        isCommon = false;
        values = new $iedpG(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $f786e857b8310d83$var$baseDifference;

});

parcelRegister("47lh8", function(module, exports) {

$parcel$export(module.exports, "Page", () => $3ad3d086c2ad2457$export$6955bcca4cd3539f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $63PsS = parcelRequire("63PsS");

var $I1nNR = parcelRequire("I1nNR");
var $kudeD = parcelRequire("kudeD");

var $9ImuD = parcelRequire("9ImuD");
const $3ad3d086c2ad2457$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
};

const $3ad3d086c2ad2457$var$LazyPage = (0, $63PsS.lazyForPaint)(()=>(parcelRequire("eqlXv")));
const $3ad3d086c2ad2457$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kudeD.PerformanceMetricsProvider), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $63PsS.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $3ad3d086c2ad2457$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($3ad3d086c2ad2457$var$LazyPage, {
                    ...props
                })
            })
        })
    });

});
parcelRegister("I1nNR", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => $7834fba73424be0b$export$a54013f0d02a8f82);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");

var $chRg6 = parcelRequire("chRg6");
const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $gwFzn.useState)();
    const locale = (0, $gwFzn.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};

});
parcelRegister("chRg6", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $22ba11b592de8836$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $22ba11b592de8836$export$dca0327c9b9c6498);
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};

});


parcelRegister("kudeD", function(module, exports) {

$parcel$export(module.exports, "usePerformanceMetrics", () => $0a26766864270169$export$865423e6f8e2e839);
$parcel$export(module.exports, "PerformanceMetricsProvider", () => $0a26766864270169$export$c6f19d9afc6c86c8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $khmAd = parcelRequire("khmAd");

var $4icDV = parcelRequire("4icDV");

var $dh538 = parcelRequire("dh538");
// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType })=>{
    const [currentContentType, setCurrentContentType] = (0, $gwFzn.useState)(contentType);
    const isInitialized = (0, $gwFzn.useRef)(true);
    const iframeLoadMetrics = (0, $gwFzn.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $gwFzn.useRef)((0, $khmAd.embeddedViewToEditTransitionMetric)());
    (0, $gwFzn.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        // Setup iframe post message handling
        const handler = (e)=>{
            switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    embeddedViewToEditTransitionTimer.current.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, []);
    // Set load metric based on content type
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current.start();
            iframeLoadMetrics.current.mark('lazy-load-start');
        // iframeLoadMetrics.current.mark('tt-onload-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType
    ]);
    const cancelIframeLoadMetrics = (0, $gwFzn.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $gwFzn.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $gwFzn.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$2ba0c6357609a3dd = ({ children: children, contentType: contentType })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $gwFzn.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $7UHDa.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType })=>(0, $dh538.fg)('embedded-confluence-performance-markers') ? /*#__PURE__*/ (0, $7UHDa.jsx)($0a26766864270169$export$2ba0c6357609a3dd, {
        contentType: contentType,
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });

});
parcelRegister("khmAd", function(module, exports) {

$parcel$export(module.exports, "embeddedViewToEditTransitionMetric", () => $078bd495543d458c$export$4de078c3b9971f9b);
$parcel$export(module.exports, "embeddedConfluenceIframeLoadMetrics", () => $078bd495543d458c$export$a23245993532c751);

var $kyiqo = parcelRequire("kyiqo");

var $j4jXg = parcelRequire("j4jXg");
const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);

});


parcelRegister("9ImuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd7e121efbbc6f0$export$2e2bcd8739ae039);

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("cvqfo"));
        case 'da-DK':
            return (parcelRequire("froU0"));
        case 'de-DE':
            return (parcelRequire("45m46"));
        case 'en-US':
            return (parcelRequire("eCpCQ"));
        case 'en-GB':
            return (parcelRequire("4gyAJ"));
        case 'en-ZZ':
            return (parcelRequire("5VElO"));
        case 'es-ES':
            return (parcelRequire("fzwjY"));
        case 'fi-FI':
            return (parcelRequire("i1mVz"));
        case 'fr-FR':
            return (parcelRequire("1ZDiw"));
        case 'hu-HU':
            return (parcelRequire("01Kuq"));
        case 'it-IT':
            return (parcelRequire("9stPh"));
        case 'ja-JP':
            return (parcelRequire("5ZO0z"));
        case 'ko-KR':
            return (parcelRequire("9ef4p"));
        case 'no-NO':
            return (parcelRequire("7s3uD"));
        case 'nl-NL':
            return (parcelRequire("ggQJw"));
        case 'pl-PL':
            return (parcelRequire("bxNop"));
        case 'pt-BR':
            return (parcelRequire("7KZXF"));
        case 'ru-RU':
            return (parcelRequire("axkDU"));
        case 'sv-SE':
            return (parcelRequire("5hnEV"));
        case 'tr-TR':
            return (parcelRequire("g48tH"));
        case 'th-TH':
            return (parcelRequire("k7V0C"));
        case 'uk-UA':
            return (parcelRequire("bMXpm"));
        case 'vi-VN':
            return (parcelRequire("jdr6D"));
        case 'zh-TW':
            return (parcelRequire("485Vr"));
        case 'zh-CN':
            return (parcelRequire("5XQyQ"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;

});
parcelRegister("cvqfo", function(module, exports) {

let $91acbd74216dd8cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $91acbd74216dd8cf$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("froU0", function(module, exports) {

let $b3dcb1ba607de1ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b3dcb1ba607de1ea$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("45m46", function(module, exports) {

let $2f98beb8812209d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2f98beb8812209d3$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("eCpCQ", function(module, exports) {

let $aa487e03cefb6ded$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aa487e03cefb6ded$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("4gyAJ", function(module, exports) {

let $31b37d2b7a6e4574$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $31b37d2b7a6e4574$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("5VElO", function(module, exports) {

let $4511936ebd59c505$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4511936ebd59c505$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("fzwjY", function(module, exports) {

let $b563323a9ad2364f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b563323a9ad2364f$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("i1mVz", function(module, exports) {

let $d1ea1aed9a3a6089$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d1ea1aed9a3a6089$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("1ZDiw", function(module, exports) {

let $1739f8acef1db385$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1739f8acef1db385$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("01Kuq", function(module, exports) {

let $00542804db8f84b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00542804db8f84b8$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("9stPh", function(module, exports) {

let $6e2ddd7009332651$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e2ddd7009332651$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("5ZO0z", function(module, exports) {

let $45d970dbf52ac790$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $45d970dbf52ac790$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9ef4p", function(module, exports) {

let $01bbe38e415c2b08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $01bbe38e415c2b08$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("7s3uD", function(module, exports) {

let $56cddb9c264ca6e2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $56cddb9c264ca6e2$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("ggQJw", function(module, exports) {

let $bd870bb0fc800810$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bd870bb0fc800810$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("bxNop", function(module, exports) {

let $86791726fcc64048$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $86791726fcc64048$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("7KZXF", function(module, exports) {

let $5a5ce4854010f566$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5a5ce4854010f566$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("axkDU", function(module, exports) {

let $7abcffa7854948e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7abcffa7854948e8$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("5hnEV", function(module, exports) {

let $3d80e47535dd9fd8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d80e47535dd9fd8$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("g48tH", function(module, exports) {

let $bb2398a375240c83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bb2398a375240c83$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("k7V0C", function(module, exports) {

let $ea70aee20f3e468d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ea70aee20f3e468d$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("bMXpm", function(module, exports) {

let $89524295a388eddc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $89524295a388eddc$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("jdr6D", function(module, exports) {

let $dfd441e79260d900$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dfd441e79260d900$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("485Vr", function(module, exports) {

let $301c81768fd98bf1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $301c81768fd98bf1$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("5XQyQ", function(module, exports) {

let $457b3bf5b17c2024$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $457b3bf5b17c2024$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});


parcelRegister("eqlXv", function(module, exports) {

let $a80486ee2170b0f0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a80486ee2170b0f0$var$load("iAaum"),
    $a80486ee2170b0f0$var$load("6vzdH"),
    $a80486ee2170b0f0$var$load("gGI57"),
    $a80486ee2170b0f0$var$load("lPCqB"),
    $a80486ee2170b0f0$var$load("joJy8"),
    $a80486ee2170b0f0$var$load("aHE9G"),
    $a80486ee2170b0f0$var$load("iaptT")
]).then(()=>parcelRequire('hB4M9'));

});


parcelRegister("kiOFr", function(module, exports) {

$parcel$export(module.exports, "useAvailableSites", () => $78f887db99bd3113$export$3738ff0cbe469211);
$parcel$export(module.exports, "useAvailableSitesV2", () => $78f887db99bd3113$export$3f59b707a86875c4);

var $gwFzn = parcelRequire("gwFzn");

var $kSC7A = parcelRequire("kSC7A");

var $f8S0G = parcelRequire("f8S0G");

var $hBNGD = parcelRequire("hBNGD");

var $inPa6 = parcelRequire("inPa6");

var $bZKB2 = parcelRequire("bZKB2");

var $6fCTI = parcelRequire("6fCTI");
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $gwFzn.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $gwFzn.useState)({
        data: [],
        loading: true
    });
    (0, $gwFzn.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/available-sites` : '/gateway/api/available-sites', requestConfig);
    if (response.ok) return response.json();
    throw response;
}

});
parcelRegister("kSC7A", function(module, exports) {

$parcel$export(module.exports, "AvailableSitesProductType", () => $2f440bf1e6112d68$export$16bdf84263b17cf0);
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});

});

parcelRegister("f8S0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a22b51dcbeecd57$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::6aeaf735bb1855a8d29ca67bd7a680b4>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const event = eventKey.split('.');
    return {
        eventType: event[0],
        actionSubject: event[1],
        action: event[2],
        actionSubjectId: event[3],
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;

});

parcelRegister("bZKB2", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $d79b64f48ff0234f$export$80c2a3957bcb42ea);

var $gwFzn = parcelRequire("gwFzn");
function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $gwFzn.useCallback)(()=>isMounted.current, []);
}

});

parcelRegister("6fCTI", function(module, exports) {

$parcel$export(module.exports, "getOperationFailedAttributes", () => $9cbe6bde573cd7a4$export$b2d107ab31565d0b);

var $6mn0G = parcelRequire("6mn0G");
const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};

});


parcelRegister("4HdGj", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $e8b7e85943c161a1$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $e8b7e85943c161a1$export$57069f5b2ecc9128);
const $e8b7e85943c161a1$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $e8b7e85943c161a1$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});

parcelRegister("2gFWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a6d9ce0af0b710c$export$2e2bcd8739ae039);

var $kUHL8 = parcelRequire("kUHL8");

var $6Z3KL = parcelRequire("6Z3KL");
function $1a6d9ce0af0b710c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6Z3KL.default)(1, arguments);
    return (0, $kUHL8.default)(dirtyDate, Date.now(), options);
}

});

parcelRegister("5qrxS", function(module, exports) {

$parcel$export(module.exports, "useLinkPickerPlugins", () => $a7827c25df0a1c01$export$45a18a62e79260ff);

var $gwFzn = parcelRequire("gwFzn");

var $c6GJD = parcelRequire("c6GJD");

var $dh538 = parcelRequire("dh538");

var $7dyLS = parcelRequire("7dyLS");
var $1C4cT = parcelRequire("1C4cT");

var $3FTlm = parcelRequire("3FTlm");

var $d4Mwr = parcelRequire("d4Mwr");
const $a7827c25df0a1c01$export$c0007b48d375a9ff = {
    tabConfig: {
        tabKey: 'jira',
        tabTitle: 'Jira'
    },
    products: [
        'jira'
    ],
    scope: (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter
};
const $a7827c25df0a1c01$export$bae28638fec080e9 = {
    ...$a7827c25df0a1c01$export$c0007b48d375a9ff,
    action: {
        label: 'Create',
        callback: ()=>{
            console.log('Placeholder for Jira Create');
        }
    }
};
const $a7827c25df0a1c01$export$3fc43c5f39c4a529 = {
    tabConfig: {
        tabKey: 'confluence',
        tabTitle: 'Confluence'
    },
    products: [
        'confluence'
    ],
    scope: (0, $7dyLS.Scope).ConfluenceContentType
};
const $a7827c25df0a1c01$export$547f1973f56da40b = {
    tabConfig: {
        tabKey: 'atlas',
        tabTitle: 'Atlas'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$32f102fef46346 = {
    tabConfig: {
        tabKey: 'home',
        tabTitle: 'Home'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$b1b5e4959b6adcf2 = {
    tabConfig: {
        tabKey: 'loom',
        tabTitle: 'Loom'
    },
    products: [
        'loom'
    ],
    scope: (0, $7dyLS.Scope).Loom,
    disableActivityClient: true
};
const $a7827c25df0a1c01$var$currentProductToPluginMap = {
    jira: $a7827c25df0a1c01$export$c0007b48d375a9ff,
    confluence: $a7827c25df0a1c01$export$3fc43c5f39c4a529,
    atlas: $a7827c25df0a1c01$export$547f1973f56da40b,
    loom: $a7827c25df0a1c01$export$b1b5e4959b6adcf2,
    townsquare: $a7827c25df0a1c01$export$32f102fef46346
};
const $a7827c25df0a1c01$export$ede9abe489c9321b = (config)=>{
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = config ?? {};
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $d4Mwr.useAvailableProducts)(config?.cloudId);
    /**
	 * Lower case possible name of product. Should be `confluence` or `jira`.
	 * This typing is not ideal. An unknown current product will:
	 * - in the case of no 1P tabs enabled, default to Scope.ConfluencePageBlog scope
	 * - in the case of 1P tabs enabled, not ensure the first tab is the current product
	 */ const currentProduct = config?.product?.toLowerCase();
    const createPluginConfig = (0, $gwFzn.useMemo)(()=>{
        return (config)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config
            });
    }, [
        cloudId,
        activityClientEndpoint,
        aggregatorUrl
    ]);
    const configMap = (0, $gwFzn.useMemo)(()=>{
        return {
            jira: createPluginConfig((0, $dh538.fg)('platform.linking-platform.link-picker.enable-jira-create') ? $a7827c25df0a1c01$export$bae28638fec080e9 : $a7827c25df0a1c01$var$currentProductToPluginMap.jira),
            confluence: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence),
            atlas: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas),
            townsquare: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare),
            loom: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom)
        };
    }, [
        createPluginConfig
    ]);
    return (0, $gwFzn.useMemo)(()=>{
        const plugins = [];
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate('confluence_loom_beta_enabled');
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate('confluence_frontend_loom_cross_sell');
        // Add plugin for current product as the first tab, if we have a supported tab for it
        // We are assuming that if a product is the current product and we have a supported tab, it's in available products
        // (eg. we assume if you're in Jira, Jira will be in available products)
        if (currentProduct && (0, $3FTlm.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        return {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $3FTlm.supportedCurrentProducts)// Exclude the current product, we've already included it above if theres a matching config available
                .filter((product)=>currentProduct !== product)// Exclude 'Atlas' tab is there is already a 'Home' tab
                .filter((product)=>{
                    if (currentProduct === 'townsquare') return product !== 'atlas';
                    return !!product;
                })// Remove any products that did not appear in the list of availableProducts
                // Does not factor in the currentProduct, that will still be in the resulting array as it
                // has been included seperately above
                .filter((product)=>product === 'loom' && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product === (0, $3FTlm.lookupCurrentProductByProduct)(availableProduct) && (product !== 'loom' || isLoomM25Enabled)))// Map product strings to their defined config in the config map
                .map((product)=>configMap[product])
            ]
        };
    }, [
        configMap,
        availableProducts,
        currentProduct,
        isLoading
    ]);
};
const $a7827c25df0a1c01$export$45a18a62e79260ff = (config)=>{
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1C4cT.useAtlassianPlugins)(atlassianPluginsConfig);
    return {
        plugins: plugins,
        isLoading: isLoading
    };
};

});
parcelRegister("1C4cT", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPlugins", () => $1ff157185fb6e44c$export$679584c8d36ab911);

var $gwFzn = parcelRequire("gwFzn");

var $8fW0f = parcelRequire("8fW0f");
const $1ff157185fb6e44c$export$679584c8d36ab911 = (configs)=>{
    const [atlassianPlugins] = (0, $gwFzn.useState)(()=>new WeakMap());
    return (0, $gwFzn.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $8fW0f.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};

});

parcelRegister("3FTlm", function(module, exports) {

$parcel$export(module.exports, "supportedCurrentProducts", () => $c011f3c2795ed007$export$15d6fc53154f51b3);
$parcel$export(module.exports, "isSupportedCurrentProduct", () => $c011f3c2795ed007$export$40cf7a2a01d13d9d);
$parcel$export(module.exports, "lookupCurrentProductByProduct", () => $c011f3c2795ed007$export$7e250790d0036a52);
/**
 * Product key returned by /available_sites data. We are only interested in
 * 'townsquare' (Atlas), 'confluence.ondemand' or 'jira-software.ondemand' currently.
 */ const $c011f3c2795ed007$export$2db74afa1ef496f1 = [
    'jira-core.ondemand',
    'jira-incident-manager.ondemand',
    'jira-product-discovery',
    'jira-servicedesk.ondemand',
    'jira-software.ondemand',
    'confluence.ondemand',
    'townsquare',
    'loom'
];
const $c011f3c2795ed007$export$15d6fc53154f51b3 = [
    'loom',
    'jira',
    'confluence',
    'atlas',
    'townsquare'
];
const $c011f3c2795ed007$var$suportedCurrentProductMap = {
    'jira-core.ondemand': 'jira',
    'jira-incident-manager.ondemand': 'jira',
    'jira-product-discovery': 'jira',
    'jira-servicedesk.ondemand': 'jira',
    'jira-software.ondemand': 'jira',
    'confluence.ondemand': 'confluence',
    townsquare: 'atlas',
    loom: 'loom'
};
function $c011f3c2795ed007$export$40cf7a2a01d13d9d(str) {
    const strings = $c011f3c2795ed007$export$15d6fc53154f51b3;
    return strings.includes(str);
}
function $c011f3c2795ed007$export$7e250790d0036a52(product) {
    // Product may not be in supportedProducts array, that's what this is checking
    if (!(product in $c011f3c2795ed007$var$suportedCurrentProductMap)) return undefined;
    return $c011f3c2795ed007$var$suportedCurrentProductMap[product];
}

});

parcelRegister("d4Mwr", function(module, exports) {

$parcel$export(module.exports, "useAvailableProducts", () => $30f10d0a027e62a0$export$5afbfe6edea8e998);

var $gwFzn = parcelRequire("gwFzn");

var $kiOFr = parcelRequire("kiOFr");
const $30f10d0a027e62a0$export$5afbfe6edea8e998 = (cloudId)=>{
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    return {
        availableProducts: (0, $gwFzn.useMemo)(()=>{
            if (!data.length) return [];
            if (cloudId) return data.find((site)=>site.cloudId === cloudId)?.products ?? [];
            // Get all the products from all sites and deduplicate
            return Array.from(data.reduce((prev, curr)=>{
                return new Set([
                    ...curr.products,
                    ...Array.from(prev)
                ]);
            }, new Set()));
        }, [
            data,
            cloudId
        ]),
        isLoading: isLoading
    };
};

});


parcelRegister("4oRNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3343220ab6916488$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $gs6TW = parcelRequire("gs6TW");

var $6Z3KL = parcelRequire("6Z3KL");
function $3343220ab6916488$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    return (0, $gs6TW.default)(dirtyDate, -amount);
}

});
parcelRegister("gs6TW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfa49d508cdf9956$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $jn4Wd = parcelRequire("jn4Wd");

var $6Z3KL = parcelRequire("6Z3KL");
function $bfa49d508cdf9956$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $jn4Wd.default)(dirtyDate, days);
}

});


parcelRegister("hGK0I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e11ccb97e0d586e61a9d73f9190646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce0a0ca606e3a0bc$var$_react = $ce0a0ca606e3a0bc$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $ce0a0ca606e3a0bc$var$_chevronLeft = $ce0a0ca606e3a0bc$var$_interopRequireDefault((parcelRequire("laHi9")));

var $ce0a0ca606e3a0bc$var$_chevronLeft2 = $ce0a0ca606e3a0bc$var$_interopRequireDefault((parcelRequire("6jcw2")));
function $ce0a0ca606e3a0bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce0a0ca606e3a0bc$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ce0a0ca606e3a0bc$var$_react.default.createElement($ce0a0ca606e3a0bc$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $ce0a0ca606e3a0bc$var$_chevronLeft2.default
    }, props));
$ce0a0ca606e3a0bc$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $ce0a0ca606e3a0bc$var$_default = module.exports.default = $ce0a0ca606e3a0bc$var$ChevronLeftIcon;

});

parcelRegister("bU2oC", function(module, exports) {

var $j5g7z = parcelRequire("j5g7z");
var $8aa6c875dbf8d863$var$root = typeof window === 'undefined' ? $parcel$global : window, $8aa6c875dbf8d863$var$vendors = [
    'moz',
    'webkit'
], $8aa6c875dbf8d863$var$suffix = 'AnimationFrame', $8aa6c875dbf8d863$var$raf = $8aa6c875dbf8d863$var$root['request' + $8aa6c875dbf8d863$var$suffix], $8aa6c875dbf8d863$var$caf = $8aa6c875dbf8d863$var$root['cancel' + $8aa6c875dbf8d863$var$suffix] || $8aa6c875dbf8d863$var$root['cancelRequest' + $8aa6c875dbf8d863$var$suffix];
for(var $8aa6c875dbf8d863$var$i = 0; !$8aa6c875dbf8d863$var$raf && $8aa6c875dbf8d863$var$i < $8aa6c875dbf8d863$var$vendors.length; $8aa6c875dbf8d863$var$i++){
    $8aa6c875dbf8d863$var$raf = $8aa6c875dbf8d863$var$root[$8aa6c875dbf8d863$var$vendors[$8aa6c875dbf8d863$var$i] + 'Request' + $8aa6c875dbf8d863$var$suffix];
    $8aa6c875dbf8d863$var$caf = $8aa6c875dbf8d863$var$root[$8aa6c875dbf8d863$var$vendors[$8aa6c875dbf8d863$var$i] + 'Cancel' + $8aa6c875dbf8d863$var$suffix] || $8aa6c875dbf8d863$var$root[$8aa6c875dbf8d863$var$vendors[$8aa6c875dbf8d863$var$i] + 'CancelRequest' + $8aa6c875dbf8d863$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$8aa6c875dbf8d863$var$raf || !$8aa6c875dbf8d863$var$caf) {
    var $8aa6c875dbf8d863$var$last = 0, $8aa6c875dbf8d863$var$id = 0, $8aa6c875dbf8d863$var$queue = [], $8aa6c875dbf8d863$var$frameDuration = 1000 / 60;
    $8aa6c875dbf8d863$var$raf = function(callback) {
        if ($8aa6c875dbf8d863$var$queue.length === 0) {
            var _now = $j5g7z(), next = Math.max(0, $8aa6c875dbf8d863$var$frameDuration - (_now - $8aa6c875dbf8d863$var$last));
            $8aa6c875dbf8d863$var$last = next + _now;
            setTimeout(function() {
                var cp = $8aa6c875dbf8d863$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $8aa6c875dbf8d863$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($8aa6c875dbf8d863$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $8aa6c875dbf8d863$var$queue.push({
            handle: ++$8aa6c875dbf8d863$var$id,
            callback: callback,
            cancelled: false
        });
        return $8aa6c875dbf8d863$var$id;
    };
    $8aa6c875dbf8d863$var$caf = function(handle) {
        for(var i = 0; i < $8aa6c875dbf8d863$var$queue.length; i++)if ($8aa6c875dbf8d863$var$queue[i].handle === handle) $8aa6c875dbf8d863$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $8aa6c875dbf8d863$var$raf.call($8aa6c875dbf8d863$var$root, fn);
};
module.exports.cancel = function() {
    $8aa6c875dbf8d863$var$caf.apply($8aa6c875dbf8d863$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $8aa6c875dbf8d863$var$root;
    object.requestAnimationFrame = $8aa6c875dbf8d863$var$raf;
    object.cancelAnimationFrame = $8aa6c875dbf8d863$var$caf;
};

});
parcelRegister("j5g7z", function(module, exports) {

var $3mTvL = parcelRequire("3mTvL");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $3mTvL !== "undefined" && $3mTvL !== null && $3mTvL.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $3mTvL.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $3mTvL.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("4Pzqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $384767a5483b8d2b$export$2e2bcd8739ae039);

var $4eQbn = parcelRequire("4eQbn");

var $jn4Wd = parcelRequire("jn4Wd");

var $hK4Zq = parcelRequire("hK4Zq");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");

var $7IxPz = parcelRequire("7IxPz");
function $384767a5483b8d2b$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $6Z3KL.default)(2, arguments);
    if (!duration || (0, $4eQbn.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, $7IxPz.default)(duration.years) : 0;
    var months = duration.months ? (0, $7IxPz.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $7IxPz.default)(duration.weeks) : 0;
    var days = duration.days ? (0, $7IxPz.default)(duration.days) : 0;
    var hours = duration.hours ? (0, $7IxPz.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $7IxPz.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $7IxPz.default)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $4YLNd.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, $hK4Zq.default)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $jn4Wd.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});

parcelRegister("6FQwA", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $fba4647064c9da0b$export$6405071f390601f7);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $fba4647064c9da0b$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $fba4647064c9da0b$export$eddc20a009406015);

var $kGZ7I = parcelRequire("kGZ7I");
const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("kGZ7I", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $0075612de7c1f282$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $0075612de7c1f282$export$3cd6b610e7ede579);
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt'
];

});


parcelRegister("3MAnl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::162fb3a08de04e361e110fa070371a1f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c121239fa79f88d$var$_react = $2c121239fa79f88d$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2c121239fa79f88d$var$_briefcase = $2c121239fa79f88d$var$_interopRequireDefault((parcelRequire("oeZjt")));

var $2c121239fa79f88d$var$_suitcase = $2c121239fa79f88d$var$_interopRequireDefault((parcelRequire("fe39K")));
function $2c121239fa79f88d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BriefcaseIcon.
 * This component is BriefcaseIcon, with `UNSAFE_fallbackIcon` set to "SuitcaseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c121239fa79f88d$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $2c121239fa79f88d$var$_react.default.createElement($2c121239fa79f88d$var$_briefcase.default, Object.assign({
        LEGACY_fallbackIcon: $2c121239fa79f88d$var$_suitcase.default
    }, props));
$2c121239fa79f88d$var$BriefcaseIcon.Name = 'BriefcaseIconMigration';
var $2c121239fa79f88d$var$_default = module.exports.default = $2c121239fa79f88d$var$BriefcaseIcon;

});

parcelRegister("1qW0V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10b53889046519ee$var$_react = $10b53889046519ee$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $10b53889046519ee$var$_baseNew = $10b53889046519ee$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $10b53889046519ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10b53889046519ee$var$SprintIcon = (props)=>/*#__PURE__*/ $10b53889046519ee$var$_react.default.createElement($10b53889046519ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$10b53889046519ee$var$SprintIcon.displayName = 'SprintIcon';
var $10b53889046519ee$var$_default = module.exports.default = $10b53889046519ee$var$SprintIcon;

});

parcelRegister("e31DP", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", () => $5e20bb9e4d5269b7$export$6620595b7f837f8f);

var $gwFzn = parcelRequire("gwFzn");

var $4kTI0 = parcelRequire("4kTI0");

var $h4NLj = parcelRequire("h4NLj");

var $6hu6G = parcelRequire("6hu6G");
const $5e20bb9e4d5269b7$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $4kTI0.useFlightDeckContext)();
    return (0, $gwFzn.useMemo)(()=>(0, $6hu6G.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $h4NLj.FD_CLIENT_FETCH_PROPS).name, (0, $h4NLj.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("4kTI0", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $32843e49ed48dc13$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $32843e49ed48dc13$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $32843e49ed48dc13$export$3b241cde208d2c5e);

var $gwFzn = parcelRequire("gwFzn");

var $c5kBK = parcelRequire("c5kBK");
const $32843e49ed48dc13$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    getArtifact: null
});
function $32843e49ed48dc13$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        return new (0, $c5kBK.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($32843e49ed48dc13$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $32843e49ed48dc13$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($32843e49ed48dc13$export$ca1b33377afa620);
function $32843e49ed48dc13$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState();
    const { getArtifact: getArtifact } = $32843e49ed48dc13$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});


parcelRegister("2YIh2", function(module, exports) {

$parcel$export(module.exports, "PersonCard", () => $2fb19ef32ab04e83$export$4c094c8f61edecb4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $4JDbp = parcelRequire("4JDbp");

var $g91Ox = parcelRequire("g91Ox");
const $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT = 180;
const $2fb19ef32ab04e83$var$styles = {
    emptyLine: "_4t3igktf"
};
function $2fb19ef32ab04e83$export$4c094c8f61edecb4({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(0);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $g91Ox.PersonCardWrapper), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                        src: avatarUrl,
                        name: name,
                        size: width < $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                size: "medium",
                                weight: "medium",
                                align: "center",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                xcss: $2fb19ef32ab04e83$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("g91Ox", function(module, exports) {

$parcel$export(module.exports, "PersonCardWrapper", () => $ead1b65abe4e11c5$export$a3474cd1dd8e70a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $gdv5Z = parcelRequire("gdv5Z");
const $ead1b65abe4e11c5$var$wrapperStyles = {
    root: "_2rkopd34 _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _4t3i1osq _1ul91lit _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqswh2mm _9oik18uv _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $ead1b65abe4e11c5$export$a3474cd1dd8e70a = ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ead1b65abe4e11c5$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};

});


parcelRegister("7lL49", function(module, exports) {

$parcel$export(module.exports, "messages", () => $827bbb02634e926d$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $827bbb02634e926d$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Messages for the AI Answer Component
   */ ai_answer_component_initial_title_text: {
        id: "search_ai.ai_answer_component.initial_title_text",
        defaultMessage: "Ask questions in search and get answers based on the content you have access to"
    },
    ai_answer_component_beta_status_label: {
        id: "search_ai.ai_answer_component.beta_status_label",
        defaultMessage: "Beta"
    },
    ai_answer_component_title_text: {
        id: "search_ai.ai_answer_component.title_text",
        defaultMessage: "Atlassian Intelligence"
    },
    ai_answer_component_title_text_loading: {
        id: "search_ai.ai_answer_component.title_text_loading",
        defaultMessage: "is working..."
    },
    ai_answer_component_title_text_loading_reading_aids: {
        id: "search_ai.ai_answer_component.title_text_loading_reading_aids",
        defaultMessage: "Generating"
    },
    ai_answer_component_title_text_loaded: {
        id: "search_ai.ai_answer_component.title_text_loaded",
        defaultMessage: "Answered by"
    },
    ai_answer_component_button_text: {
        id: "ai_answer_component_button_text",
        defaultMessage: "Ask AI"
    },
    ai_answer_component_result_error_text: {
        id: "search_ai.ai_answer_component.result_error_text",
        defaultMessage: "{brandName} couldn't generate an answer for you. Try rephrasing or explore using filters in {advancedSearchLink}."
    },
    ai_answer_component_result_error_advanced_search_link: {
        id: "search_ai.ai_answer_component.result_error_advanced_search_link",
        defaultMessage: "advanced search"
    },
    ai_answer_component_source_label: {
        id: "search_ai.ai_answer_component.source_label",
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_reference_label: {
        id: "search_ai.ai_answer_component.reference_label",
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_source_page_icon_label: {
        id: "search_ai.ai_answer_component.source_page_icon_label",
        defaultMessage: "Source Page Icon"
    },
    ai_answer_expand_button_label: {
        id: "search_ai.ai_answer_component.expand_button_label",
        defaultMessage: "Show more"
    },
    ai_answer_collapse_button_label: {
        id: "search_ai.ai_answer_component.collapse_button_label",
        defaultMessage: "Show less"
    },
    ai_answer_component_information_icon_tooltip_text: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_text",
        defaultMessage: "Information quality may vary. {informationLink}"
    },
    ai_answer_component_information_icon_tooltip_link: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_link",
        defaultMessage: "Learn why"
    },
    ai_answer_component_feedback_label: {
        id: "search_ai.ai_answer_component_feedback_label",
        defaultMessage: "Was this helpful?"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_answer_component_report_button: {
        id: "search_ai.ai_answer_component_report_button",
        defaultMessage: "Report this"
    },
    ai_answer_component_copy_button: {
        id: "search_ai.ai_answer_component_copy_button",
        defaultMessage: "Copy"
    },
    ai_answer_component_report_success_text: {
        id: "search_ai.ai_answer_component_report_success_text",
        defaultMessage: "Report submitted"
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {brandName}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the AI response? Let us know what happened."
    },
    ai_answer_component_report_empty_option_label: {
        id: "search_ai.ai_answer_component_report_empty_option_label",
        defaultMessage: "I want to report..."
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_followups_label: {
        id: "search_ai.ai_answer_component_followups_label",
        defaultMessage: "Ask a follow up question"
    },
    ai_answer_component_error_state_subjective_query: {
        id: "search_ai.ai_answer_component_error_state_subjective_query",
        defaultMessage: "That seems like a subjective question, so {brandName} can\u2019t answer it for you right now."
    },
    ai_answer_component_error_state_keyword: {
        id: "search_ai.ai_answer_component_error_state_keyword",
        defaultMessage: "{brandName} couldn\u2019t understand your question, possibly because it didn\u2019t include enough details. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_error_state_acceptable_use: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use",
        defaultMessage: "{brandName} can\u2019t provide you with a response, as it might go against {acceptableUseLink}. Please try asking another question."
    },
    ai_answer_component_error_state_acceptable_use_link: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    ai_answer_component_error_state_network: {
        id: "search_ai.ai_answer_component_error_state_network",
        defaultMessage: "{brandName} can't provide a response right now. Read more in our {supportLink}."
    },
    ai_answer_component_error_state_hipaa: {
        id: "search_ai.ai_answer_component_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    ai_answer_component_error_state_no_answer: {
        id: "search_ai.ai_answer_component_error_state_no_answer",
        defaultMessage: "{brandName} doesn\u2019t have enough data to provide a response right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_open_ai_rate_limit_error: {
        id: "search_ai.ai_answer_component_open_ai_rate_limit_error",
        defaultMessage: "Excessive use has been detected with {brandName}. Try again later. Read more in our {supportLink}."
    },
    ai_answer_component_support_link: {
        id: "search_ai.ai_answer_component_support_link",
        defaultMessage: "support documentation"
    },
    ai_answer_component_hipaa_compliance_link: {
        id: "search_ai.ai_answer_component_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    },
    ai_answer_component_error_state_no_who_is_answer: {
        id: "search_ai.ai_answer_component_error_state_no_who_is_answer",
        defaultMessage: "{brandName} couldn\u2019t find a match for this person in your organisation. It\u2019s possible that there was a misspelling in your search, this person goes by another name, or that this person doesn\u2019t work here."
    },
    ai_answer_component_disclaimer_who_question: {
        id: "search_ai.ai_answer_component_disclaimer_who_question",
        defaultMessage: "This information is solely based on what\u2019s in your knowledge base and may not always be accurate."
    },
    ai_answer_permission_label: {
        id: "search_ai.ai_answer_permission_label",
        defaultMessage: "Answers may include information from pages that are restricted to others but visible to you."
    },
    ai_answer_dialog_cancel_label: {
        id: "search_ai.ai_answer_dialog_cancel_label",
        defaultMessage: "Dive deeper into the {searchResultsLink}"
    },
    ai_answer_dialog_search_results_label: {
        id: "search_ai.ai_answer_dialog_search_results_label",
        defaultMessage: "search results"
    },
    ai_answer_onboarding_banner_title: {
        id: "search_ai.ai_answer_onboarding_banner_title",
        defaultMessage: "Try Atlassian Intelligence in search"
    },
    ai_answer_onboarding_banner_v1_info: {
        id: "search_ai.ai_answer_onboarding_banner_v1_info",
        defaultMessage: "<b>Example:</b>How do I submit expenses for reimbursement?"
    },
    ai_answer_onboarding_banner_info: {
        id: "search_ai.ai_answer_onboarding_banner_info",
        defaultMessage: "Ask about a project or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_onboarding_banner_tooltip_link: {
        id: "search_ai.ai_answer_onboarding_banner_tooltip_link",
        defaultMessage: "Learn more"
    },
    ai_answer_onboarding_close_button_text: {
        id: "search_ai.ai_answer_onboarding_close_button_text",
        defaultMessage: "Close"
    },
    ai_answer_onboarding_banner_example_query_vacation_policy: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_vacation_policy",
        defaultMessage: "What is the vacation policy?"
    },
    ai_answer_onboarding_banner_example_query_expenses: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_expenses",
        defaultMessage: "How to submit expenses for reimbursement?"
    },
    ai_answer_dialog_loaded_footer_sac: {
        id: "search_ai.ai_answer_dialog_loaded_footer_sac",
        defaultMessage: "Powered by AI"
    },
    ai_answer_dialog_loaded_footer: {
        id: "search_ai.ai_answer_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    ai_answer_dialog_footer_more_options_tooltip: {
        id: "search_ai.ai_answer_dialog_footer_more_options_tooltip",
        defaultMessage: "More options"
    },
    ai_answer_dialog_updated: {
        id: "search_ai.ai_answer_dialog_updated",
        defaultMessage: "Updated"
    },
    ai_answer_who_questions_frequent_locations_header: {
        id: "search_ai.ai_answer_who_questions_frequent_locations_header",
        defaultMessage: "Frequent locations"
    },
    ai_answer_who_questions_frequent_collaborators_header: {
        id: "search_ai.ai_answer_who_questions_frequent_collaborators_header",
        defaultMessage: "Frequent collaborators"
    },
    ai_answer_who_question_team_section_member_count: {
        id: "search_ai.ai_answer_who_question_team_section_member_count",
        defaultMessage: "{count, plural, =0 {No members} one {# member} other {# members}}"
    },
    ai_answer_who_questions_teams_header: {
        id: "search_ai.ai_answer_who_questions_teams_header",
        defaultMessage: "Teams"
    },
    ai_answer_who_questions_view_profile: {
        id: "search_ai.ai_answer_who_questions_view_profile",
        defaultMessage: "View profile"
    },
    ai_answer_who_questions_hover_role_icon: {
        id: "search_ai.ai_answer_who_questions_hover_role_icon",
        defaultMessage: "Role"
    },
    ai_answer_who_questions_hover_department_icon: {
        id: "search_ai.ai_answer_who_questions_hover_department_icon",
        defaultMessage: "Department"
    },
    ai_answer_who_questions_hover_location_icon: {
        id: "search_ai.ai_answer_who_questions_hover_location_icon",
        defaultMessage: "Location"
    },
    ai_answer_who_questions_hover_local_time_icon: {
        id: "search_ai.ai_answer_who_questions_hover_local_time_icon",
        defaultMessage: "Local time"
    },
    ai_answer_who_questions_hover_email_icon: {
        id: "search_ai.ai_answer_who_questions_hover_email_icon",
        defaultMessage: "Email"
    },
    ai_answer_who_questions_footer_header: {
        id: "search_ai.ai_answer_who_questions_footer_header",
        defaultMessage: "{numMatches} additional {numMatches, plural, =1 {match} other {matches}}"
    },
    ai_answer_dialog_footer_content_quality_short: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_short",
        defaultMessage: "Content quality may vary"
    },
    ai_answer_dialog_footer_beta_tag: {
        id: "search_ai.ai_answer_dialog_footer_beta_tag",
        defaultMessage: "BETA"
    },
    ai_answer_dialog_footer_content_quality_long: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_long",
        defaultMessage: "Content is based on your permissions, and its quality may vary"
    },
    reading_aids_dialog_information_icon_tooltip_link: {
        id: "search_ai.reading_aids_dialog_information_icon_tooltip_link",
        defaultMessage: "Learn more"
    },
    reading_aids_dialog_loaded_footer: {
        id: "search_ai.reading_aids_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    reading_aids_dialog_disclaimer: {
        id: "search_ai.reading_aids_dialog_disclaimer",
        defaultMessage: "Information may vary."
    },
    reading_aids_dialog_disclaimer_link: {
        id: "search_ai.reading_aids_dialog_disclaimer_link",
        defaultMessage: "Learn why"
    },
    reading_aids_defined_by: {
        id: "search_ai.reading_aids_dialog_defined_by",
        defaultMessage: "Defined by"
    },
    reading_aids_see_edit_history: {
        id: "search_ai.reading_aids_dialog_see_edit_history",
        defaultMessage: "See all edit history"
    },
    ai_answer_admin_message: {
        id: "search_ai.ai_answer_admin_message",
        defaultMessage: "Unleash the knowledge in your Confluence by asking questions in search and getting answers from Atlassian Intelligence."
    },
    ai_answer_admin_turn_on_atlassian_intelligence: {
        id: "search_ai.ai_admin_turn_on_atlassian_intelligence",
        defaultMessage: "Turn on Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_header: {
        id: "search_ai.ai_answer_admin_info_popup_header",
        defaultMessage: "Get answers from Atlassian Intelligence in search"
    },
    ai_answer_admin_info_popup_banner_alt_text: {
        id: "search_ai.ai_answer_admin_info_popup_banner_alt_text",
        defaultMessage: "Search input with example query \"What is the vacation policy?\""
    },
    ai_answer_admin_info_popup_link: {
        id: "search_ai.ai_answer_admin_info_popup_link",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_dismiss: {
        id: "search_ai.ai_answer_admin_info_popup_dismiss",
        defaultMessage: "Dismiss"
    },
    ai_answer_generating_text: {
        id: "search_ai.ai_answer_generating_text",
        defaultMessage: "Generating"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_generating_icon_alt_text: {
        id: "search_ai.ai_answer_generating_icon_alt_text",
        defaultMessage: "Generating icon"
    },
    ai_answer_button_tooltip_message: {
        id: "search_ai_answer_prompt.ask_ai_button.tooltip",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    ai_answer_reading_aids_banner_header: {
        id: "search_ai.reading_aids.banner_header",
        defaultMessage: "Define any term with AI, not just acronyms"
    },
    ai_answer_reading_aids_banner_description: {
        id: "search_ai.reading_aids.banner_description",
        defaultMessage: "Get definitions for project terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    reading_aids_edited_definition_report_modal_title: {
        id: "search_ai.reading_aids_edited_definition_report_modal_title",
        defaultMessage: "Help us improve Definitions"
    },
    reading_aids_edited_definition_report_label: {
        id: "search_ai.reading_aids_edited_definition_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    knowledge_cards_view_team: {
        id: "search_ai.knowledge_cards.view_team",
        defaultMessage: "View team page"
    },
    knowledge_cards_team_subheader: {
        id: "search_ai.knowledge_cards.team_subheader",
        defaultMessage: "Team"
    },
    knowledge_cards_copy_email_address: {
        id: "search_ai.knowledge_cards.copy_email_address",
        defaultMessage: "Copy email address"
    },
    knowledge_cards_recent_work_subheader: {
        id: "search_ai.knowledge_cards.recent_work_subheader",
        defaultMessage: "Recent work"
    },
    knowledge_cards_collaborators_subheader: {
        id: "search_ai.knowledge_cards.collaborators_subheader",
        defaultMessage: "Collaborators"
    },
    knowledge_cards_recent_work_empty: {
        id: "search_ai.knowledge_cards.recent_work_empty",
        defaultMessage: "No recent work"
    },
    knowledge_cards_collaborators_empty: {
        id: "search_ai.knowledge_cards.collaborators_empty",
        defaultMessage: "No recent collaborators"
    },
    knowledge_cards_teammembers_empty: {
        id: "search_ai.knowledge_cards.teammembers_empty",
        defaultMessage: "No team members"
    },
    knowledge_cards_view_all_link: {
        id: "search_ai.knowledge_cards.view_all_link",
        defaultMessage: "View all"
    },
    knowledge_cards_team_members_subheader: {
        id: "search_ai.knowledge_cards.team_members_subheader",
        defaultMessage: "Team members"
    }
});

});

parcelRegister("9D6Kx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $702cfde9ca1d470b$var$_react = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $702cfde9ca1d470b$var$_baseNew = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $702cfde9ca1d470b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $702cfde9ca1d470b$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $702cfde9ca1d470b$var$_react.default.createElement($702cfde9ca1d470b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$702cfde9ca1d470b$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $702cfde9ca1d470b$var$_default = module.exports.default = $702cfde9ca1d470b$var$BookWithBookmarkIcon;

});

parcelRegister("ab1fW", function(module, exports) {

$parcel$export(module.exports, "FollowUpButton", () => $de70ae3c39f94954$export$668058776bea98f5);
$parcel$export(module.exports, "ChatPill", () => (parcelRequire("lBFuf")).ChatPill);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lBFuf = parcelRequire("lBFuf");

var $jA9SA = parcelRequire("jA9SA");
var $kIvLT = parcelRequire("kIvLT");
const $de70ae3c39f94954$export$668058776bea98f5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const analyticsPropertiesRef = (0, $gwFzn.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $gwFzn.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $gwFzn.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lBFuf.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref,
        children: followUpText
    });
});

});

parcelRegister("crcDg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61b69757778da2d771dbef5df6aae1a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90e1ce2e3ef66e77$var$_react = $90e1ce2e3ef66e77$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $90e1ce2e3ef66e77$var$_department = $90e1ce2e3ef66e77$var$_interopRequireDefault((parcelRequire("7O0l1")));

var $90e1ce2e3ef66e77$var$_department2 = $90e1ce2e3ef66e77$var$_interopRequireDefault((parcelRequire("ak2ew")));
function $90e1ce2e3ef66e77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DepartmentIcon.
 * This component is DepartmentIcon, with `UNSAFE_fallbackIcon` set to "DepartmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90e1ce2e3ef66e77$var$DepartmentIcon = (props)=>/*#__PURE__*/ $90e1ce2e3ef66e77$var$_react.default.createElement($90e1ce2e3ef66e77$var$_department.default, Object.assign({
        LEGACY_fallbackIcon: $90e1ce2e3ef66e77$var$_department2.default
    }, props));
$90e1ce2e3ef66e77$var$DepartmentIcon.Name = 'DepartmentIconMigration';
var $90e1ce2e3ef66e77$var$_default = module.exports.default = $90e1ce2e3ef66e77$var$DepartmentIcon;

});

parcelRegister("4GKfl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::052aa506253b4fa39b1a73c5776ea203>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $369ef546b7acc0ed$var$_react = $369ef546b7acc0ed$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $369ef546b7acc0ed$var$_baseNew = $369ef546b7acc0ed$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $369ef546b7acc0ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $369ef546b7acc0ed$var$ShieldIcon = (props)=>/*#__PURE__*/ $369ef546b7acc0ed$var$_react.default.createElement($369ef546b7acc0ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$369ef546b7acc0ed$var$ShieldIcon.displayName = 'ShieldIcon';
var $369ef546b7acc0ed$var$_default = module.exports.default = $369ef546b7acc0ed$var$ShieldIcon;

});

parcelRegister("dm2vv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4258944dab2ce3$export$2e2bcd8739ae039);

var $llMqh = parcelRequire("llMqh");

var $81yTx = parcelRequire("81yTx");
const $fd4258944dab2ce3$var$AsyncCreatableSelect = (0, $81yTx.default)((0, $llMqh.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd4258944dab2ce3$export$2e2bcd8739ae039 = $fd4258944dab2ce3$var$AsyncCreatableSelect;

});
parcelRegister("llMqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $78dde7f22d8b91b6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jb7rL = parcelRequire("jb7rL");

var $gJgOY = parcelRequire("gJgOY");

var $8lfDt = parcelRequire("8lfDt");

var $kjDWr = parcelRequire("kjDWr");
const $78dde7f22d8b91b6$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $gJgOY.default)(props);
    const creatableProps = (0, $kjDWr.default)(stateManagerProps);
    const selectProps = (0, $8lfDt.default)(creatableProps);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jb7rL.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$78dde7f22d8b91b6$export$2e2bcd8739ae039 = $78dde7f22d8b91b6$var$AsyncCreatableSelect;

});


parcelRegister("jZuqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e9909ce239e1d8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $gxtzC = parcelRequire("gxtzC");

var $ee7An = parcelRequire("ee7An");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $4kjfc = parcelRequire("4kjfc");
const $62e9909ce239e1d8$var$packageName = "platform-pkg";
const $62e9909ce239e1d8$var$packageVersion = "0.0.0-use.local";
const $62e9909ce239e1d8$var$progressIndicatorGapMap = {
    comfortable: {
        default: 'space.100',
        large: 'space.150'
    },
    cozy: {
        default: 'space.075',
        large: 'space.100'
    },
    compact: {
        default: 'space.050',
        large: 'space.075'
    }
};
const $62e9909ce239e1d8$var$sizes = {
    default: 8,
    large: 12
};
const $62e9909ce239e1d8$var$varDotsSize = '--ds-dots-size';
const $62e9909ce239e1d8$var$varDotsMargin = '--ds-dots-margin';
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $62e9909ce239e1d8$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $gwFzn.useRef)(null);
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $ee7An.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $62e9909ce239e1d8$var$packageName,
        packageVersion: $62e9909ce239e1d8$var$packageVersion
    });
    const gap = $62e9909ce239e1d8$var$progressIndicatorGapMap[gutter][size];
    const handleKeyDown = (0, $gwFzn.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!onSelect) return 0, $ee7An.default;
        return (0, $d8F95.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        style: {
            [$62e9909ce239e1d8$var$varDotsSize]: `${$62e9909ce239e1d8$var$sizes[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$62e9909ce239e1d8$var$varDotsMargin]: gap
        },
        role: onSelect && 'tablist',
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
            testId: testId,
            ref: (r)=>{
                tablistRef.current = r;
            },
            alignInline: "center",
            space: gap,
            children: values.map((_, index)=>{
                const isSelected = selectedIndex === index;
                const tabId = `${ariaLabel}${index}`;
                const panelId = `${ariaControls}${index}`;
                const indicatorTestId = testId && `${testId}-ind-${index}`;
                return onSelect ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4kjfc.ButtonIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected,
                    tabId: tabId,
                    panelId: panelId,
                    onClick: (event)=>onSelectWithAnalytics({
                            event: event,
                            index: index
                        })
                }, index) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4kjfc.PresentationalIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected
                }, index);
            })
        })
    });
};
var $62e9909ce239e1d8$export$2e2bcd8739ae039 = $62e9909ce239e1d8$var$ProgressDots;

});
parcelRegister("4kjfc", function(module, exports) {

$parcel$export(module.exports, "PresentationalIndicator", () => $ab0fca144a05f4f5$export$ec3c81af58a0c4e7);
$parcel$export(module.exports, "ButtonIndicator", () => $ab0fca144a05f4f5$export$3716cb524d6018c1);
/* indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $gdv5Z = parcelRequire("gdv5Z");
var $fVUfS = parcelRequire("fVUfS");

var $6F6hl = parcelRequire("6F6hl");
const $ab0fca144a05f4f5$var$commonStyles = {
    common: "_2rko14q2 _1bsbg7kr _4t3ig7kr _kqswh2mm _cfu11ule _1mp41th6 _kfgt1th6 _1cs8stnw _1kt9b3bt _iajm1yh4 _z5wt1yh4"
};
const $ab0fca144a05f4f5$var$colorBorderMap = {
    default: "_19itt9ly",
    help: "_19itt9ly",
    inverted: "_19it1ps9",
    primary: "_19itt9ly"
};
const $ab0fca144a05f4f5$var$buttonStyle = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke"
};
const $ab0fca144a05f4f5$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #44546F)",
        help: "var(--ds-icon-discovery, #8270DB)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #0C66E4)"
    };
};
const $ab0fca144a05f4f5$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: testId,
        // here we set it dynamic because that backgroundColor and xcss don't support the colors we need here eg. token('color.icon')
        style: {
            backgroundColor: $ab0fca144a05f4f5$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $ddbVR.cx)($ab0fca144a05f4f5$var$commonStyles.common, $ab0fca144a05f4f5$var$colorBorderMap[appearance])
    });
};
const $ab0fca144a05f4f5$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        role: "tab",
        style: {
            backgroundColor: $ab0fca144a05f4f5$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $ddbVR.cx)($ab0fca144a05f4f5$var$commonStyles.common, $ab0fca144a05f4f5$var$buttonStyle.root, $ab0fca144a05f4f5$var$colorBorderMap[appearance]),
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
            children: tabId
        })
    });
};

});


parcelRegister("jq4tF", function(module, exports) {

$parcel$export(module.exports, "FeedbackType", () => $edeacd0030bcf485$export$d4c0482bf980ef26);
var $edeacd0030bcf485$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    return FeedbackType;
}({});

});

parcelRegister("1NrSh", function(module, exports) {

$parcel$export(module.exports, "PRD_CONFIG", () => $49895188b0a86f3f$export$d4fff2dfff3e2bc1);
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};

});

parcelRegister("7v8CL", function(module, exports) {

$parcel$export(module.exports, "setUnifiedSearchOptIn", () => $4e97d13e58a818d5$export$b431d2590f7e693b);
$parcel$export(module.exports, "setUnifiedSearchOptOut", () => $4e97d13e58a818d5$export$bb88e8c3c6c48482);
$parcel$export(module.exports, "setUnifiedSearchOptBackIn", () => $4e97d13e58a818d5$export$6e463a6898d2f57e);
$parcel$export(module.exports, "setUnifiedSearchDismissed", () => $4e97d13e58a818d5$export$d9129e21fffd1d56);
$parcel$export(module.exports, "getUnifiedSearchUserState", () => $4e97d13e58a818d5$export$5ac1954516bf8eeb);
$parcel$export(module.exports, "isUnifiedSearchOptIn", () => $4e97d13e58a818d5$export$de9ee63afdffa3b0);
$parcel$export(module.exports, "isUnifiedSearchOptBackIn", () => $4e97d13e58a818d5$export$bccf6cdee86c9b99);
$parcel$export(module.exports, "isUnifiedSearchDismissed", () => $4e97d13e58a818d5$export$8cbecacac8ab8b);
const $4e97d13e58a818d5$export$d8474cff104280f3 = 'atlassian.unified-search.toggle-feature';
var $4e97d13e58a818d5$export$d2972e84a51aa654 = /*#__PURE__*/ function(UserPreferenceState) {
    UserPreferenceState["OPT_IN"] = "OPT_IN";
    UserPreferenceState["OPT_OUT"] = "OPT_OUT";
    UserPreferenceState["OPT_IN_DISMISSED"] = "OPT_IN_DISMISSED";
    UserPreferenceState["OPT_OUT_DISMISSED"] = "OPT_OUT_DISMISSED";
    UserPreferenceState["OPT_BACK_IN"] = "OPT_BACK_IN";
    UserPreferenceState["OPT_BACK_IN_DISMISSED"] = "OPT_BACK_IN_DISMISSED";
    return UserPreferenceState;
}({});
const $4e97d13e58a818d5$var$defaultPreference = {
    state: "OPT_IN"
};
const $4e97d13e58a818d5$export$b431d2590f7e693b = (userId)=>{
    if (userId === null) return;
    const parsedData = $4e97d13e58a818d5$var$getParsedData(userId);
    parsedData[userId] = {
        state: "OPT_IN"
    };
    $4e97d13e58a818d5$var$setLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3, JSON.stringify(parsedData));
};
const $4e97d13e58a818d5$export$bb88e8c3c6c48482 = (userId)=>{
    if (userId === null) return;
    const parsedData = $4e97d13e58a818d5$var$getParsedData(userId);
    parsedData[userId] = {
        state: "OPT_OUT"
    };
    $4e97d13e58a818d5$var$setLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3, JSON.stringify(parsedData));
};
const $4e97d13e58a818d5$export$6e463a6898d2f57e = (userId)=>{
    if (userId === null) return;
    const parsedData = $4e97d13e58a818d5$var$getParsedData(userId);
    parsedData[userId] = {
        state: "OPT_BACK_IN"
    };
    $4e97d13e58a818d5$var$setLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3, JSON.stringify(parsedData));
};
const $4e97d13e58a818d5$export$d9129e21fffd1d56 = (userId)=>{
    if (userId === null) return;
    const parsedData = $4e97d13e58a818d5$var$getParsedData(userId);
    if ($4e97d13e58a818d5$export$5ac1954516bf8eeb(userId) === "OPT_IN") parsedData[userId] = {
        state: "OPT_IN_DISMISSED"
    };
    else if ($4e97d13e58a818d5$export$5ac1954516bf8eeb(userId) === "OPT_OUT") parsedData[userId] = {
        state: "OPT_OUT_DISMISSED"
    };
    else if ($4e97d13e58a818d5$export$5ac1954516bf8eeb(userId) === "OPT_BACK_IN") parsedData[userId] = {
        state: "OPT_BACK_IN_DISMISSED"
    };
    $4e97d13e58a818d5$var$setLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3, JSON.stringify(parsedData));
};
const $4e97d13e58a818d5$export$de9ee63afdffa3b0 = (userId)=>{
    if (userId === null) return false;
    // if user clears local storage, then by default they should see Unified Search
    if ($4e97d13e58a818d5$var$getLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3) === null) return true;
    const state = $4e97d13e58a818d5$export$5ac1954516bf8eeb(userId);
    return state === "OPT_IN" || state === "OPT_IN_DISMISSED" || state === "OPT_BACK_IN" || state === "OPT_BACK_IN_DISMISSED";
};
const $4e97d13e58a818d5$export$bccf6cdee86c9b99 = (userId)=>{
    if (userId === null) return false;
    const state = $4e97d13e58a818d5$export$5ac1954516bf8eeb(userId);
    return state === "OPT_BACK_IN";
};
const $4e97d13e58a818d5$export$8cbecacac8ab8b = (userId)=>{
    if (userId === null) return false;
    const state = $4e97d13e58a818d5$export$5ac1954516bf8eeb(userId);
    return state === undefined || state === "OPT_IN_DISMISSED" || state === "OPT_OUT_DISMISSED" || state === "OPT_BACK_IN_DISMISSED";
};
const $4e97d13e58a818d5$export$5ac1954516bf8eeb = (userId)=>{
    if (userId === null || $4e97d13e58a818d5$var$getLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3) === null) return null;
    const parsedData = $4e97d13e58a818d5$var$getParsedData(userId);
    return parsedData[userId].state;
};
const $4e97d13e58a818d5$var$getParsedData = (userId)=>{
    const data = $4e97d13e58a818d5$var$getLocalStorageItem($4e97d13e58a818d5$export$d8474cff104280f3);
    let parsedData = {};
    // if data retrieved is not in json format, then we want to remove it
    if (data) try {
        parsedData = JSON.parse(data);
    } catch (error) {
        localStorage.removeItem($4e97d13e58a818d5$export$d8474cff104280f3);
    }
    if (!parsedData[userId]) parsedData[userId] = {
        ...$4e97d13e58a818d5$var$defaultPreference
    };
    return parsedData;
};
const $4e97d13e58a818d5$var$setLocalStorageItem = (key, value)=>{
    localStorage.setItem(key, value);
};
const $4e97d13e58a818d5$var$getLocalStorageItem = (key)=>{
    return localStorage.getItem(key);
};

});

parcelRegister("buzhH", function(module, exports) {

$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageBanner", () => $8503df358cb92af5$export$572064d9f672f85d);
/* ExternalCollaboratorsSpaceInformationMessageBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6lvbX = parcelRequire("6lvbX");
const $8503df358cb92af5$var$Wrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt4pxbi _2rko1l7b _1reo15vq _18m915vq _bfhk11bn",
            __cmplp.className
        ])
    });
});
const $8503df358cb92af5$export$572064d9f672f85d = (props)=>{
    const [shouldShowExternalCollaborators, setShouldShowExternalCollaborators] = (0, $gwFzn.useState)(false);
    const onExternalCollaborationLoadComplete = (props)=>{
        setShouldShowExternalCollaborators(props?.guestCount > 0);
    };
    const onExternalCollaborationLoadError = ()=>{
        setShouldShowExternalCollaborators(false);
    };
    const ParentWrapper = props?.wrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ParentWrapper, {
        hidden: !shouldShowExternalCollaborators
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8503df358cb92af5$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), {
        ...props,
        onLoadComplete: onExternalCollaborationLoadComplete,
        onLoadError: onExternalCollaborationLoadError
    })));
};

});

parcelRegister("bcVso", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $43b4631b11c19cf4$export$8995abb8169b2cb8);
$parcel$export(module.exports, "RenderForUserPermissionType", () => $43b4631b11c19cf4$export$cea0b419c6270a6b);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dIouf = parcelRequire("dIouf");
var $43b4631b11c19cf4$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
const $43b4631b11c19cf4$export$cea0b419c6270a6b = ({ children: children, excludedPermissionTypes: // "allowedPermissionTypes" prop can easily be added as needed
excludedPermissionTypes = [] })=>{
    const { data: data, error: error } = (0, $diswb.useQuery)((0, $d2LG0.default)`query RenderForUserPermissionTypeUserPermissionTypeQuery{user:confluence_atlassianUser(current:true){id confluence{permissionType}}tenant{editions{edition}}}`);
    const userPermissionType = data?.user?.confluence?.permissionType;
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }) : !userPermissionType || !excludedPermissionTypes.includes(userPermissionType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children) : null;
};

});

parcelRegister("gTHUu", function(module, exports) {

$parcel$export(module.exports, "ANIMATE_TIME_SEC", () => $dbbd5ec89c313eef$export$19ffb24f8071504);
$parcel$export(module.exports, "PageTreeLoader", () => $dbbd5ec89c313eef$export$10d5dbd9dd81149f);
$parcel$export(module.exports, "PageTreeLoaderOnHover", () => $dbbd5ec89c313eef$export$8ce7795bff922b41);
$parcel$export(module.exports, "PageTree", () => $dbbd5ec89c313eef$export$73500bf5f2e2b0c4);
$parcel$export(module.exports, "ConditionalTreeItemTooltip", () => (parcelRequire("5C17p")).ConditionalTreeItemTooltip);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $5Abqh = parcelRequire("5Abqh");

var $4VJDS = parcelRequire("4VJDS");

var $5C17p = parcelRequire("5C17p");

const $dbbd5ec89c313eef$export$19ffb24f8071504 = 2;
const $dbbd5ec89c313eef$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';

const $dbbd5ec89c313eef$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lv8Qa",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("4RxGJ"))).PageTree
});

const $dbbd5ec89c313eef$export$8ce7795bff922b41 = (0, $jmjWc.LoadableHydrateOnHover)({
    __loadable_id__: "3TpN_",
    name: "PageTreeLoaderOnHover",
    loader: async ()=>(await (parcelRequire("4RxGJ"))).PageTree,
    hydrateImmediately: ()=>{
        // If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
        return !(0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    }
});
const $dbbd5ec89c313eef$export$73500bf5f2e2b0c4 = (props)=>{
    const delayHydrationOnHoverTimeout = (0, $4VJDS.default).getNumber($dbbd5ec89c313eef$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, delayHydrationOnHoverTimeout > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($dbbd5ec89c313eef$export$8ce7795bff922b41, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($dbbd5ec89c313eef$export$10d5dbd9dd81149f, props));
};

});
parcelRegister("5C17p", function(module, exports) {

$parcel$export(module.exports, "ConditionalTreeItemTooltip", () => $2703b103d1a678c3$export$cba03ec732da70ea);

var $gwFzn = parcelRequire("gwFzn");

var $6p02T = parcelRequire("6p02T");

var $aU0Vx = parcelRequire("aU0Vx");
const $2703b103d1a678c3$export$cba03ec732da70ea = ({ isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen })=>{
    return isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aU0Vx.PageTreeTooltip), {
        title: (0, $6p02T.cleanExcerpt)(title),
        isQuickActionsOpen: isQuickActionsOpen
    }, children);
};

});
parcelRegister("aU0Vx", function(module, exports) {

$parcel$export(module.exports, "PageTreeTooltip", () => $17e4300d7b59a3d4$export$6c94635022fac1d1);

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");
const $17e4300d7b59a3d4$export$6c94635022fac1d1 = ({ children: children, title: title, isQuickActionsOpen: isQuickActionsOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: !isQuickActionsOpen && title ? title : null,
        position: "top",
        delay: 750,
        hideTooltipOnMouseDown: true
    }, children);

});


parcelRegister("4RxGJ", function(module, exports) {

let $38a63e6cdd704dca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $38a63e6cdd704dca$var$load("deXSb"),
    $38a63e6cdd704dca$var$load("iAaum"),
    $38a63e6cdd704dca$var$load("1ISAt"),
    $38a63e6cdd704dca$var$load("mKoWX"),
    $38a63e6cdd704dca$var$load("6vzdH"),
    $38a63e6cdd704dca$var$load("5ko8n"),
    $38a63e6cdd704dca$var$load("4T4bq"),
    $38a63e6cdd704dca$var$load("jPS1u"),
    $38a63e6cdd704dca$var$load("kmhnK"),
    $38a63e6cdd704dca$var$load("6RLxE"),
    $38a63e6cdd704dca$var$load("3pIYR"),
    $38a63e6cdd704dca$var$load("fwbht"),
    $38a63e6cdd704dca$var$load("4PppF"),
    $38a63e6cdd704dca$var$load("ffEVr"),
    $38a63e6cdd704dca$var$load("c6MKV"),
    $38a63e6cdd704dca$var$load("aZinD"),
    $38a63e6cdd704dca$var$load("zogKQ"),
    $38a63e6cdd704dca$var$load("fW5Fh"),
    $38a63e6cdd704dca$var$load("joJy8"),
    $38a63e6cdd704dca$var$load("aHE9G"),
    $38a63e6cdd704dca$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});


parcelRegister("eA1Kn", function(module, exports) {

var $lfzYK = parcelRequire("lfzYK");

var $boEVR = parcelRequire("boEVR");

var $a4SN8 = parcelRequire("a4SN8");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $a9d5c868841a39fe$var$without = $boEVR(function(array, values) {
    return $a4SN8(array) ? $lfzYK(array, values) : [];
});
module.exports = $a9d5c868841a39fe$var$without;

});

parcelRegister("1u6lx", function(module, exports) {

$parcel$export(module.exports, "TagButtonUIVariant", () => $a200b44450c31008$export$f72f271864b318ce);
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});

});

parcelRegister("cH0F8", function(module, exports) {

$parcel$export(module.exports, "useConsumptionEvents", () => $99b9dc495b87cac6$export$2fc805631456aefd);

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $04e9M = parcelRequire("04e9M");

var $6ggfK = parcelRequire("6ggfK");

var $iYrVi = parcelRequire("iYrVi");

var $a2hNG = parcelRequire("a2hNG");
const $99b9dc495b87cac6$export$2fc805631456aefd = ()=>{
    const client = (0, $diswb.useApolloClient)();
    const { sendEvent: sendEvent } = (0, $6ggfK.useSendAnalyticsEvents)();
    const dwellTimeHelperRef = (0, $gwFzn.useRef)(null);
    const sendErrorEvent = (0, $gwFzn.useCallback)((errorMessage, data)=>{
        const unifiedErrorEvent = (0, $a2hNG.createConsumptionErrorEvent)(errorMessage, data);
        sendEvent(unifiedErrorEvent);
    }, [
        sendEvent
    ]);
    const sendInitiatedEvent = (0, $gwFzn.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(client, data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionInitiatedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        client,
        sendErrorEvent,
        sendEvent
    ]);
    const sendViewedEvent = (0, $gwFzn.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(client, data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        client,
        sendErrorEvent,
        sendEvent
    ]);
    const sendCompletedEvent = (0, $gwFzn.useCallback)((event, dwellTimeHelperData)=>{
        if (dwellTimeHelperData.attributes.finalDwellEvent) {
            const consumptionCompletedEvent = (0, $a2hNG.createConsumptionCompletedEvent)(event, dwellTimeHelperData, document.visibilityState);
            sendEvent(consumptionCompletedEvent, true);
        }
    }, [
        sendEvent
    ]);
    const sendViewedEventAndCompletedEvent = (0, $gwFzn.useCallback)((data, contentAttributesOverride)=>{
        const sendEventPromise = (0, $iYrVi.loadSpaceAndContentData)(client, data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
            return event;
        });
        Promise.all([
            sendEventPromise,
            (0, $04e9M.getDwellTimeHelper)()
        ]).then(([event, DwellTimeHelper])=>{
            const dwellTimeHelper = new DwellTimeHelper((callbackData)=>sendCompletedEvent(event, callbackData), event.data);
            dwellTimeHelper.start();
            dwellTimeHelperRef.current = dwellTimeHelper;
        }).catch((error)=>{
            sendErrorEvent(error.message, data);
        });
    }, [
        client,
        sendEvent,
        sendCompletedEvent,
        sendErrorEvent
    ]);
    const stopDwellTimeTracker = (0, $gwFzn.useCallback)(()=>{
        if (dwellTimeHelperRef.current) dwellTimeHelperRef.current.stop();
    }, []);
    return {
        sendInitiatedEvent: sendInitiatedEvent,
        sendViewedEvent: sendViewedEvent,
        sendViewedEventAndCompletedEvent: sendViewedEventAndCompletedEvent,
        sendCompletedEvent: sendCompletedEvent,
        sendErrorEvent: sendErrorEvent,
        stopDwellTimeTracker: stopDwellTimeTracker
    };
};

});
parcelRegister("6ggfK", function(module, exports) {

$parcel$export(module.exports, "useSendAnalyticsEvents", () => $37a7b14bbef74679$export$ba826f94d4d18f90);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");
const $37a7b14bbef74679$export$ba826f94d4d18f90 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendEvent = (0, $gwFzn.useCallback)((event, skipVisibilityCheck = false)=>{
        if (document.visibilityState === 'hidden' && !skipVisibilityCheck) document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') createAnalyticsEvent(event).fire();
        }, {
            once: true
        });
        else createAnalyticsEvent(event).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendEvent: sendEvent
    };
};

});

parcelRegister("iYrVi", function(module, exports) {

$parcel$export(module.exports, "loadSpaceAndContentData", () => $515f7b87fcfa6100$export$22490ad3617f1d6c);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");
const $515f7b87fcfa6100$export$22490ad3617f1d6c = async (client, spaceKey, contentId)=>{
    if (!contentId) return Promise.reject(new Error('Content ID is required'));
    const response = await client.query({
        query: (0, $d2LG0.default)`query getConsumptionEventDataQuery($spaceKey:String!$contentId:ID!){space(key:$spaceKey){id type status}singleContent(id:$contentId){id status type subType}}`,
        variables: {
            spaceKey: spaceKey,
            contentId: contentId
        }
    });
    // this is a workaround to handle the case where the content is restricted
    if (!response.errors && response.data.singleContent === null) return Promise.reject('singleContent is null');
    return response;
};

});

parcelRegister("a2hNG", function(module, exports) {

$parcel$export(module.exports, "createConsumptionViewedEvent", () => $d12dabfe6ca737c1$export$6d76e0936bf44cc2);
$parcel$export(module.exports, "createConsumptionInitiatedEvent", () => $d12dabfe6ca737c1$export$b4ddea3e5241109a);
$parcel$export(module.exports, "createConsumptionCompletedEvent", () => $d12dabfe6ca737c1$export$ea5bf29fc7b309b8);
$parcel$export(module.exports, "createConsumptionErrorEvent", () => $d12dabfe6ca737c1$export$b2d32ef04e5142a1);
const $d12dabfe6ca737c1$export$1931aa92cd9ee803 = (status, contentState)=>{
    if (contentState) return contentState;
    switch(status){
        case 'current':
            return 'published';
        case 'archived':
            return 'archived';
        case 'draft':
            return 'draft';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$3f4d5492ecb52ee5 = (subType, contentMode)=>{
    if (contentMode) return contentMode;
    switch(subType){
        case 'live':
            return 'live';
        case 'embed':
            return 'embedded';
        default:
            return 'classic';
    }
};
const $d12dabfe6ca737c1$export$5e059cd6f8a921d7 = (type, contentType)=>{
    if (contentType) return contentType;
    switch(type){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blogpost';
        case 'whiteboard':
            return 'whiteboard';
        case 'database':
            return 'database';
        case 'embed':
            return 'smartlink';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$6d76e0936bf44cc2 = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data.space?.id ?? 'unset',
                contentId: response?.data.singleContent?.id ?? 'unset'
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b4ddea3e5241109a = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'initiated',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data.space?.id ?? 'unset',
                contentId: response?.data.singleContent?.id ?? 'unset',
                utmSource: data.utmSource
            }
        }
    };
};
const $d12dabfe6ca737c1$export$ea5bf29fc7b309b8 = (event, dwellTimeHelperData, visibilityState)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            ...event.data,
            action: 'completed',
            attributes: {
                ...event.data.attributes,
                dwellTime: dwellTimeHelperData.attributes.dwellTime,
                pageVisibility: visibilityState
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b2d32ef04e5142a1 = (errorMessage, props)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'error',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: props.source,
            attributes: {
                error: errorMessage,
                contentId: props.contentId ?? 'unset',
                spaceKey: props.spaceKey
            }
        }
    };
};

});


parcelRegister("7uUnJ", function(module, exports) {

$parcel$export(module.exports, "LiveDocsIconTile", () => $1f248bc2c3d9f18f$export$ef69bde44521bba7);

var $jmjWc = parcelRequire("jmjWc");

const $1f248bc2c3d9f18f$export$ef69bde44521bba7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q9h_Y",
    name: "LiveDocsIconTile",
    loader: async ()=>(await (parcelRequire("6LrBj"))).LiveDocsIconTile
});

});
parcelRegister("6LrBj", function(module, exports) {

let $4ecc8ad1731554a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4ecc8ad1731554a4$var$load("ffEVr"),
    $4ecc8ad1731554a4$var$load("kjZZD"),
    $4ecc8ad1731554a4$var$load("e19Zv")
]).then(()=>parcelRequire('nSMSQ'));

});


parcelRegister("bZSO8", function(module, exports) {

$parcel$export(module.exports, "buildCreationLink", () => $e7afa99020494478$export$b3086acbf0304043);
$parcel$export(module.exports, "useCreateRouteSupportedContentType", () => $e7afa99020494478$export$963d972ae7433a64);
$parcel$export(module.exports, "parseQueryParams", () => $e7afa99020494478$export$67c4cee80a3410cd);
$parcel$export(module.exports, "ExperienceResolution", () => $e7afa99020494478$export$f9ad0711e89cafb5);

var $dPJCf = parcelRequire("dPJCf");
var $c3Qwv = parcelRequire("c3Qwv");

var $1NBp8 = parcelRequire("1NBp8");

var $hQnHK = parcelRequire("hQnHK");

var $9wGTI = parcelRequire("9wGTI");

var $98wxI = parcelRequire("98wxI");
const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === 'folder' && !(0, $9wGTI.fg)('confluence_cloud_folder_view')) return undefined;
        return contentType;
    }
    return undefined;
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams, isJswWhiteboardExperimentEnabled = false)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = isJswWhiteboardExperimentEnabled && (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = isJswWhiteboardExperimentEnabled ? (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId) : undefined;
    const projectUuid = isJswWhiteboardExperimentEnabled ? (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid) : undefined;
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});

});
parcelRegister("98wxI", function(module, exports) {

$parcel$export(module.exports, "PaywallStatus", () => $5046ea0ba58442ff$export$d9669dcdbd1161d9);
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});

});


parcelRegister("gPB5e", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageSubType", () => $f70aed7e9f7e1079$export$c5ec0cc4d455d1c8);
$parcel$export(module.exports, "GraphQLContentStatus", () => $f70aed7e9f7e1079$export$b634e5de755b7d35);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $f70aed7e9f7e1079$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $f70aed7e9f7e1079$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});

});

parcelRegister("6adZX", function(module, exports) {

$parcel$export(module.exports, "useIsFlyoutOpen", () => $059c9f3c8066ba5d$export$377168f986312a4);
$parcel$export(module.exports, "useFlyout", () => $059c9f3c8066ba5d$export$3f64b5809402b3ff);
$parcel$export(module.exports, "useFlyoutActions", () => $059c9f3c8066ba5d$export$285f2f1642666795);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $4ZoIm.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $iFWZA.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $gwFzn.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $gwFzn.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $iFWZA.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);

});

parcelRegister("iI2ST", function(module, exports) {

$parcel$export(module.exports, "ButtonMenuItem", () => $d3e054ddee411308$export$6dc09b7c0ec1dfcd);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5ujhR = parcelRequire("5ujhR");

var $jjpBv = parcelRequire("jjpBv");
const $d3e054ddee411308$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $jjpBv.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
				 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
				 * so they aren't rendered in the disabled state.
				 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    }));

});

parcelRegister("jZM59", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $e6220385bdb59eee$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $e6220385bdb59eee$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $e6220385bdb59eee$export$94561f6055639ef7);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $gwFzn.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $gwFzn.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $gwFzn.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("5w6h6", function(module, exports) {

$parcel$export(module.exports, "GetPromotedSpacesQuery", () => $650ff8f94eceb315$export$45c1ff968876a8ac);

var $d2LG0 = parcelRequire("d2LG0");
const $650ff8f94eceb315$export$45c1ff968876a8ac = (0, $d2LG0.default)`query GetPromotedSpacesQuery($promotedSpaceKey:String)@experimental{experimentalPromotedSpaces(promotedSpacesLimit:1 otherSpacesLimit:1 promotedSpaceKey:$promotedSpaceKey){nodes{id}matchedPromotedSpaces{id}}}`;

});

parcelRegister("5ijTm", function(module, exports) {

$parcel$export(module.exports, "LivePagesBetaLozenge", () => $f0e665314235adeb$export$a5918700383e7a93);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $5nBzc = parcelRequire("5nBzc");
const $f0e665314235adeb$var$i18n = (0, $2nPZH.defineMessages)({
    new: {
        id: "live-pages-features.new.lozenge",
        defaultMessage: "New"
    }
});
const $f0e665314235adeb$export$a5918700383e7a93 = ({ bold: bold = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
        appearance: "new",
        isBold: bold
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f0e665314235adeb$var$i18n.new));

});

parcelRegister("f6IRL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $affa380c4e32b374$var$_react = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $affa380c4e32b374$var$_baseNew = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $affa380c4e32b374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $affa380c4e32b374$var$RoadmapIcon = (props)=>/*#__PURE__*/ $affa380c4e32b374$var$_react.default.createElement($affa380c4e32b374$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$affa380c4e32b374$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $affa380c4e32b374$var$_default = module.exports.default = $affa380c4e32b374$var$RoadmapIcon;

});

parcelRegister("1dKyn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e3b1de532be22c3$var$_react = $0e3b1de532be22c3$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0e3b1de532be22c3$var$_baseNew = $0e3b1de532be22c3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0e3b1de532be22c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e3b1de532be22c3$var$TeamsIcon = (props)=>/*#__PURE__*/ $0e3b1de532be22c3$var$_react.default.createElement($0e3b1de532be22c3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$0e3b1de532be22c3$var$TeamsIcon.displayName = 'TeamsIcon';
var $0e3b1de532be22c3$var$_default = module.exports.default = $0e3b1de532be22c3$var$TeamsIcon;

});

parcelRegister("291hi", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $725b0c40c654c097$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $ecnYn = parcelRequire("ecnYn");

var $lIKKD = parcelRequire("lIKKD");
const $725b0c40c654c097$var$hideAboveQueries = (0, $lIKKD.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$var$hideBelowQueries = (0, $lIKKD.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $3jLHL.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $725b0c40c654c097$var$hideAboveQueries[above],
            below && $725b0c40c654c097$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("fj1Kw", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $cfc409e85fa5c319$export$9923361bd43fa030);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kNHXO = parcelRequire("kNHXO");

var $aaBfd = parcelRequire("aaBfd");
const $cfc409e85fa5c319$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $cfc409e85fa5c319$export$9923361bd43fa030 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $aaBfd.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kNHXO))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $cfc409e85fa5c319$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));

});
parcelRegister("kNHXO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f24a7c82f1a8c849$var$_react = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f24a7c82f1a8c849$var$_baseNew = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f24a7c82f1a8c849$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f24a7c82f1a8c849$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $f24a7c82f1a8c849$var$_react.default.createElement($f24a7c82f1a8c849$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$f24a7c82f1a8c849$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $f24a7c82f1a8c849$var$_default = module.exports.default = $f24a7c82f1a8c849$var$AppSwitcherIcon;

});

parcelRegister("aaBfd", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $8856355ea91006d2$export$c25acd513dcc8062);
$parcel$export(module.exports, "LinkIconButton", () => $8856355ea91006d2$export$edad7fca51b767e1);
$parcel$export(module.exports, "Button", () => $8856355ea91006d2$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $8856355ea91006d2$export$29d11c0fe2fc51d8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");
var $7p4As = parcelRequire("7p4As");
var $dE1p6 = parcelRequire("dE1p6");

var $aGop9 = parcelRequire("aGop9");

var $efXed = parcelRequire("efXed");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedIconButton) : (0, $1qfLF.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedLinkIconButton) : (0, $dE1p6.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedButton) : (0, $ccHMk.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedLinkButton) : (0, $7p4As.default);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("aGop9", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", () => $90c58b5063b4a6d0$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $90c58b5063b4a6d0$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $90c58b5063b4a6d0$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $90c58b5063b4a6d0$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $90c58b5063b4a6d0$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $90c58b5063b4a6d0$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $90c58b5063b4a6d0$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $90c58b5063b4a6d0$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $90c58b5063b4a6d0$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $90c58b5063b4a6d0$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $90c58b5063b4a6d0$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $90c58b5063b4a6d0$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $90c58b5063b4a6d0$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $90c58b5063b4a6d0$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $90c58b5063b4a6d0$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $90c58b5063b4a6d0$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $90c58b5063b4a6d0$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $90c58b5063b4a6d0$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $90c58b5063b4a6d0$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $3654r = parcelRequire("3654r");

var $auNCB = parcelRequire("auNCB");
var $fVUfS = parcelRequire("fVUfS");

var $3gadb = parcelRequire("3gadb");

var $6F6hl = parcelRequire("6F6hl");

var $9vHyP = parcelRequire("9vHyP");
function $90c58b5063b4a6d0$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
} /**
   * Props present in underlying primitives but we want to override,
   * so we don't want to inherit their definitions
   */ 
const $90c58b5063b4a6d0$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $90c58b5063b4a6d0$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $90c58b5063b4a6d0$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $90c58b5063b4a6d0$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $90c58b5063b4a6d0$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $90c58b5063b4a6d0$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $90c58b5063b4a6d0$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $90c58b5063b4a6d0$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $90c58b5063b4a6d0$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $90c58b5063b4a6d0$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $90c58b5063b4a6d0$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $90c58b5063b4a6d0$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
const $90c58b5063b4a6d0$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
const $90c58b5063b4a6d0$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
const $90c58b5063b4a6d0$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
const $90c58b5063b4a6d0$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m3acm _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $90c58b5063b4a6d0$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $90c58b5063b4a6d0$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $90c58b5063b4a6d0$var$ThemedPressable = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        ...$90c58b5063b4a6d0$var$getPrimitiveSpreadProps(props),
        ref: ref,
        type: "button" /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ ,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $ddbVR.cx)($90c58b5063b4a6d0$var$styles.root, $90c58b5063b4a6d0$var$shapeStyles[shape], hasBorder && $90c58b5063b4a6d0$var$styles.border, $90c58b5063b4a6d0$var$appearanceStyles[appearance], isSelected && $90c58b5063b4a6d0$var$styles.selected, isDisabled && $90c58b5063b4a6d0$var$styles.disabled),
        isDisabled: isDisabled
    });
});
const $90c58b5063b4a6d0$var$ThemedAnchor = (0, $9vHyP.forwardRefWithGeneric)(function ThemedAnchor({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auNCB.default), {
        ...$90c58b5063b4a6d0$var$getPrimitiveSpreadProps(props),
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $ddbVR.cx)($90c58b5063b4a6d0$var$styles.root, $90c58b5063b4a6d0$var$shapeStyles[shape], hasBorder && $90c58b5063b4a6d0$var$styles.border, $90c58b5063b4a6d0$var$appearanceStyles[appearance], isSelected && $90c58b5063b4a6d0$var$styles.selected, isDisabled && $90c58b5063b4a6d0$var$styles.disabled)
    });
});
const $90c58b5063b4a6d0$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
}; /**
    * Props shared by `Button` and `LinkButton`
    */ 
const $90c58b5063b4a6d0$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($90c58b5063b4a6d0$var$ThemedPressable, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $90c58b5063b4a6d0$export$b0b5aeed52623827 = (0, $9vHyP.forwardRefWithGeneric)(function ThemedLinkButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($90c58b5063b4a6d0$var$ThemedAnchor, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
}); /**
     * Props shared by `ThemedIconButtonProps` and `ThemedLinkIconButton`
     */ 
const $90c58b5063b4a6d0$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $7UHDa.jsxs)($90c58b5063b4a6d0$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                        children: label
                    })
                ]
            })
    });
});
const $90c58b5063b4a6d0$export$a1ab08e79d264ec8 = (0, $9vHyP.forwardRefWithGeneric)(function ThemedLinkIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $7UHDa.jsxs)($90c58b5063b4a6d0$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                        children: label
                    })
                ]
            })
    });
});

});

parcelRegister("efXed", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", () => $02aebea47caa4c41$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $02aebea47caa4c41$export$abfcaeeca4ae7a55);

var $gwFzn = parcelRequire("gwFzn");
const $02aebea47caa4c41$export$d158fa15757a1890 = /*#__PURE__*/ (0, $gwFzn.createContext)(false);
function $02aebea47caa4c41$export$abfcaeeca4ae7a55() {
    return (0, $gwFzn.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
}

});



parcelRegister("aj8rL", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", () => $c2262423552b3e29$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $c2262423552b3e29$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $c2262423552b3e29$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $dh538 = parcelRequire("dh538");

var $fpGTa = parcelRequire("fpGTa");

var $efXed = parcelRequire("efXed");
const $c2262423552b3e29$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $c2262423552b3e29$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $c2262423552b3e29$var$anchorStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    newBorderRadius: "_2rkoftgi",
    newMargin: "_ahbq1b66",
    newInteractionStates: "_irr3166n _1di61wwy",
    newInteractionStatesCustomTheming: "_irr31rps _1di6yhlj"
};
const $c2262423552b3e29$var$sharedIconOrLogoContainerStyles = {
    root: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    appIconTilePaddingFlagged: "_18zr1b66"
};
const $c2262423552b3e29$var$iconContainerStyles = {
    root: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh18uv _10y4glyw"
};
const $c2262423552b3e29$var$logoContainerStyles = {
    root: "_18zru2gc _1e0cglyw _p12fnklw _vchh18uv _10y41txw"
}; /**
    * __Nav logo__
    *
    * The product logo for the top navigation.
    *
    * To provide a responsive experience, it requires both a logo and an icon component.
    * The logo component will be used for large viewports, and the icon component will be used for small viewports.
    */ 
const $c2262423552b3e29$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fpGTa.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $ddbVR.cx)($c2262423552b3e29$var$anchorStyles.root, (0, $dh538.fg)('platform_design_system_nav_logo_interaction_states') && $c2262423552b3e29$var$anchorStyles.newMargin, (0, $dh538.fg)('platform_design_system_nav_logo_interaction_states') && $c2262423552b3e29$var$anchorStyles.newBorderRadius, (0, $dh538.fg)('platform_design_system_nav_logo_interaction_states') && (hasCustomTheme ? $c2262423552b3e29$var$anchorStyles.newInteractionStatesCustomTheming : $c2262423552b3e29$var$anchorStyles.newInteractionStates)),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $c2262423552b3e29$var$sharedIconOrLogoContainerStyles.root,
                    $c2262423552b3e29$var$iconContainerStyles.root,
                    (0, $dh538.fg)('platform-team25-app-icon-tiles') && $c2262423552b3e29$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($c2262423552b3e29$var$NavLogoRenderer, {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $c2262423552b3e29$var$sharedIconOrLogoContainerStyles.root,
                    $c2262423552b3e29$var$logoContainerStyles.root,
                    (0, $dh538.fg)('platform-team25-app-icon-tiles') && $c2262423552b3e29$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($c2262423552b3e29$var$NavLogoRenderer, {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
function $c2262423552b3e29$var$NavLogoRenderer({ logoOrIcon: logoOrIcon }) {
    return (0, $dh538.fg)('jiv-20710-fix-nav-rerender') ? /*#__PURE__*/ (0, $7UHDa.jsx)($c2262423552b3e29$var$NavLogoRendererMemo, {
        logoOrIcon: logoOrIcon
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($c2262423552b3e29$var$NavLogoRendererNoMemo, {
        logoOrIcon: logoOrIcon
    });
}
const $c2262423552b3e29$var$NavLogoRendererMemo = /*#__PURE__*/ (0, $gwFzn.memo)($c2262423552b3e29$var$NavLogoRendererNoMemo);
function $c2262423552b3e29$var$NavLogoRendererNoMemo({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: `var(${$c2262423552b3e29$export$24328117f1132113})`,
        textColor: `var(${$c2262423552b3e29$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("8zu8b", function(module, exports) {

$parcel$export(module.exports, "EndItem", () => $44a5ab6ab1735952$export$b3477e90773be2d0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dukN8 = parcelRequire("dukN8");

var $aaBfd = parcelRequire("aaBfd");
const $44a5ab6ab1735952$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $dukN8.ListItem) : (0, $gwFzn.Fragment);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aaBfd.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        })
    });
});

});

parcelRegister("gaXc0", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $90d8da16fbe995a1$export$36ba2f559d49a8f6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ckcSY = parcelRequire("ckcSY");

var $2uMjy = parcelRequire("2uMjy");

var $8zu8b = parcelRequire("8zu8b");
const $90d8da16fbe995a1$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $90d8da16fbe995a1$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2uMjy.BadgeContainer), {
        id: $90d8da16fbe995a1$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8zu8b.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ckcSY))),
            // We explicitly set the EndItem to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false
        })
    });
});

});
parcelRegister("ckcSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e0c080c29498771abac7d6e0a3c394>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f91591f413eb2d9$var$_react = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8f91591f413eb2d9$var$_baseNew = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f91591f413eb2d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f91591f413eb2d9$var$NotificationIcon = (props)=>/*#__PURE__*/ $8f91591f413eb2d9$var$_react.default.createElement($8f91591f413eb2d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$8f91591f413eb2d9$var$NotificationIcon.displayName = 'NotificationIcon';
var $8f91591f413eb2d9$var$_default = module.exports.default = $8f91591f413eb2d9$var$NotificationIcon;

});

parcelRegister("2uMjy", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $aed22086c0956b03$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $aed22086c0956b03$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $aed22086c0956b03$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $35pXk.default)([
            $aed22086c0956b03$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $35pXk.default)([
                    $aed22086c0956b03$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(Badge, {})
            })
        ]
    });

});


parcelRegister("hOWPZ", function(module, exports) {

$parcel$export(module.exports, "Help", () => $2a846bdc2a978f08$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $ci7Ox = parcelRequire("ci7Ox");

var $2uMjy = parcelRequire("2uMjy");

var $8zu8b = parcelRequire("8zu8b");
const $2a846bdc2a978f08$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $2a846bdc2a978f08$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zu8b.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2uMjy.BadgeContainer), {
        id: $2a846bdc2a978f08$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zu8b.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});

parcelRegister("9xVAL", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $edb6938477f5d9c0$export$c72f6eaae7b9adff);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fIcbd = parcelRequire("fIcbd");

var $8zu8b = parcelRequire("8zu8b");
const $edb6938477f5d9c0$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8zu8b.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd)))
    }));

});

parcelRegister("e1eDr", function(module, exports) {

$parcel$export(module.exports, "CustomTitle", () => $af11962bf99de229$export$9ccddf7ee2a0e24e);
/* custom-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $efXed = parcelRequire("efXed");
const $af11962bf99de229$var$styles = {
    root: "_1reo15vq _18m915vq _11c82smr _o5721q9c _p12fuuw1 _1bto1l2s _bozg1b66 _1e0cglyw _10y41txw",
    subtleText: "_syaz1gjq",
    paddingInlineEnd: "_y4tiu2gc"
};
const $af11962bf99de229$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $af11962bf99de229$var$styles.root,
            !hasCustomTheme && $af11962bf99de229$var$styles.subtleText,
            (0, $dh538.fg)('platform_design_system_nav4_top_nav_min_widths') && $af11962bf99de229$var$styles.paddingInlineEnd
        ]),
        children: children
    });
});

});

parcelRegister("6MlZq", function(module, exports) {

$parcel$export(module.exports, "useIsCreationDropdownEnabled", () => $2b534f0161088f49$export$f5501c77c624c70);
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};

});

parcelRegister("6lLr9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d24329325b8e254a68f910248b6c4858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49f9803524b2651a$var$_react = $49f9803524b2651a$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $49f9803524b2651a$var$_baseNew = $49f9803524b2651a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $49f9803524b2651a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $49f9803524b2651a$var$ShortcutIcon = (props)=>/*#__PURE__*/ $49f9803524b2651a$var$_react.default.createElement($49f9803524b2651a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$49f9803524b2651a$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $49f9803524b2651a$var$_default = module.exports.default = $49f9803524b2651a$var$ShortcutIcon;

});

parcelRegister("blsJs", function(module, exports) {

$parcel$export(module.exports, "useSubmitSSRScriptErrors", () => $7bdb5572ed9c8600$export$290a00987d4ffd42);

var $gwFzn = parcelRequire("gwFzn");

var $5ZqQS = parcelRequire("5ZqQS");
const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};

});

parcelRegister("lgKMU", function(module, exports) {

$parcel$export(module.exports, "ShareAndRestrictDialogController", () => $d6607a34d68309a3$export$9542b2119eeb5eb4);

var $jmjWc = parcelRequire("jmjWc");

const $d6607a34d68309a3$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2Q0Hi",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("bE7AL"))).Controller
});

});
parcelRegister("bE7AL", function(module, exports) {

let $87a951c45c94746d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $87a951c45c94746d$var$load("2BIkk"),
    $87a951c45c94746d$var$load("lJxwk"),
    $87a951c45c94746d$var$load("hIYCb"),
    $87a951c45c94746d$var$load("fNL1b"),
    $87a951c45c94746d$var$load("fwbht"),
    $87a951c45c94746d$var$load("h4Nf7"),
    $87a951c45c94746d$var$load("lfEn7"),
    $87a951c45c94746d$var$load("6nLV7"),
    $87a951c45c94746d$var$load("cyGuT"),
    $87a951c45c94746d$var$load("dTsOE"),
    $87a951c45c94746d$var$load("8DoxJ"),
    $87a951c45c94746d$var$load("c6MKV"),
    $87a951c45c94746d$var$load("aZinD"),
    $87a951c45c94746d$var$load("6qiXX"),
    $87a951c45c94746d$var$load("iAaum"),
    $87a951c45c94746d$var$load("1ISAt"),
    $87a951c45c94746d$var$load("mKoWX"),
    $87a951c45c94746d$var$load("1m9tW"),
    $87a951c45c94746d$var$load("7J7Dl"),
    $87a951c45c94746d$var$load("6vzdH"),
    $87a951c45c94746d$var$load("9u4sz"),
    $87a951c45c94746d$var$load("dnZ4C"),
    $87a951c45c94746d$var$load("i3TSs"),
    $87a951c45c94746d$var$load("cKXbf"),
    $87a951c45c94746d$var$load("ifr0h"),
    $87a951c45c94746d$var$load("7sZmN"),
    $87a951c45c94746d$var$load("kjZZD"),
    $87a951c45c94746d$var$load("5JvKa"),
    $87a951c45c94746d$var$load("1TOYq"),
    $87a951c45c94746d$var$load("6qah4"),
    $87a951c45c94746d$var$load("hKqxh"),
    $87a951c45c94746d$var$load("7sseo"),
    $87a951c45c94746d$var$load("ffEVr"),
    $87a951c45c94746d$var$load("joJy8"),
    $87a951c45c94746d$var$load("aHE9G"),
    $87a951c45c94746d$var$load("7pZ0V"),
    $87a951c45c94746d$var$load("c4Kdp"),
    $87a951c45c94746d$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});


parcelRegister("hfPJk", function(module, exports) {

$parcel$export(module.exports, "useUnifiedShareDialogEligible", () => $4c837cd68f9ce4c0$export$ec1a39480eeb12ae);

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $6mKj3 = parcelRequire("6mKj3");
const $4c837cd68f9ce4c0$export$ec1a39480eeb12ae = (skipExposure = false)=>{
    const { edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = [
        (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
        (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS
    ].includes(accessStatus);
    const isStandard = [
        (0, $euL71.ConfluenceEdition).STANDARD
    ].includes(edition);
    const isEligible = isLoggedIn && isLicensed && isStandard;
    return {
        isUSDExperimentEnabled: isEligible ? skipExposure ? (0, $6mKj3.expValEqualsNoExposure)('unified_share_dialog_usd_experiment', 'cohort', 'test') : (0, $6mKj3.expValEquals)('unified_share_dialog_usd_experiment', 'cohort', 'test') : false
    };
};

});

parcelRegister("h1ewt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63dcb99536cc850$var$_react = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c63dcb99536cc850$var$_baseNew = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c63dcb99536cc850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63dcb99536cc850$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $c63dcb99536cc850$var$_react.default.createElement($c63dcb99536cc850$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c63dcb99536cc850$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $c63dcb99536cc850$var$_default = module.exports.default = $c63dcb99536cc850$var$LockUnlockedIcon;

});

parcelRegister("6DT7W", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPopupComponent", () => $8e77e8dd4ed98ba0$export$8e100eba08cca59e);

var $jmjWc = parcelRequire("jmjWc");

const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("a7wn2"))).RequestAccessPopupComponent
});

});
parcelRegister("a7wn2", function(module, exports) {

let $75e3aafa683ec2ee$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75e3aafa683ec2ee$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});


parcelRegister("boTVZ", function(module, exports) {

$parcel$export(module.exports, "areRestrictionsDisabledForContentType", () => $931d0cc8e8f4f258$export$a7e172d99bfa7de7);
function $931d0cc8e8f4f258$export$a7e172d99bfa7de7(contentType) {
    if (contentType === 'embed') return true;
    return false;
}

});

parcelRegister("dzImV", function(module, exports) {

$parcel$export(module.exports, "FEATURE_ID_PAGE_ANALYTICS_MODAL", () => $8cb719031efeaa2b$export$f6d85b85b6c620f5);
$parcel$export(module.exports, "FEATURE_ID_PAGE_ANALYTICS_PAGE", () => $8cb719031efeaa2b$export$2495b6fbc3fc1bff);
$parcel$export(module.exports, "FEATURE_ID_PAGE_RESTRICTIONS_MODAL", () => $8cb719031efeaa2b$export$4a7b6a415b5b4246);
$parcel$export(module.exports, "FEATURE_ID_AUTOMATION_PAGE", () => $8cb719031efeaa2b$export$cbd8370df04a657a);
$parcel$export(module.exports, "FEATURE_ID_SPACE_ANALYTICS_PAGE", () => $8cb719031efeaa2b$export$9743380173eac25c);
$parcel$export(module.exports, "FEATURE_ID_TEAM_CALENDAR_PAGE", () => $8cb719031efeaa2b$export$28b898ecceafa8c3);
$parcel$export(module.exports, "FEATURE_ID_USD_MODAL", () => $8cb719031efeaa2b$export$70c25ef275d61c94);
$parcel$export(module.exports, "EDITION_PREMIUM", () => $8cb719031efeaa2b$export$3275adca28abf19a);
// Features combined with placements as found in https://www.figma.com/design/c5JCpE4Fdh4B8SVt2xoOvB/Confluence%3A-Prompt-for-payment-on-paid-feautres
const $8cb719031efeaa2b$export$f6d85b85b6c620f5 = 'itfg-bnr-page-analytics-modal';
const $8cb719031efeaa2b$export$2495b6fbc3fc1bff = 'itfg-bnr-page-analytics-page';
const $8cb719031efeaa2b$export$4a7b6a415b5b4246 = 'itfg-bnr-page-restrictions-modal';
const $8cb719031efeaa2b$export$cbd8370df04a657a = 'itfg-bnr-automation-page';
const $8cb719031efeaa2b$export$9743380173eac25c = 'itfg-bnr-space-analytics-page';
const $8cb719031efeaa2b$export$28b898ecceafa8c3 = 'itfg-bnr-team-calendar-page';
const $8cb719031efeaa2b$export$70c25ef275d61c94 = 'itfg-bnr-usd-modal';
const $8cb719031efeaa2b$export$3275adca28abf19a = 'premium';
const $8cb719031efeaa2b$export$2fbb79dba909cd48 = 'standard';

});

parcelRegister("bcPlG", function(module, exports) {

$parcel$export(module.exports, "formatEventCallBackPayloadForAtlasKitAnalyticsEvent", () => $63f2ffd6f4a8b946$export$e9129b434f0562a);
const $63f2ffd6f4a8b946$export$e9129b434f0562a = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: source, type: type, name: name })=>({
        type: type,
        data: {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            source: source,
            ...name && {
                name: name
            }
        }
    });

});

parcelRegister("i1qvR", function(module, exports) {

$parcel$export(module.exports, "InTrialFeatureGatesBannerWithData", () => $50ac98d9a22aacea$export$bc24d29e6182c1b2);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $7jjWP = parcelRequire("7jjWP");

const $50ac98d9a22aacea$var$InTrialFeatureGatesBanner = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9FFQU")));
const $50ac98d9a22aacea$export$bc24d29e6182c1b2 = ({ featureId: featureId, aggClient: // AGG client to refetch pre-fetched data from the GQL cache
aggClient, tenantId: tenantId, edition: edition, sendOperationalEvent: sendOperationalEvent, sendScreenEvent: sendScreenEvent, sendTrackEvent: sendTrackEvent })=>{
    const { daysLeftInTrial: daysLeftInTrial, paymentFlowExperienceUrl: paymentFlowExperienceUrl, error: error, loading: loading } = (0, $7jjWP.useGetInTrialFeatureGateBannerData)({
        aggClient: aggClient,
        sendOperationalEvent: sendOperationalEvent,
        tenantId: tenantId,
        featureId: featureId
    });
    // In order for us to even be able to render this experience, we will already have verified that the user is in a valid audience. Adding the payment details and trial check here is just a typecheck for below.
    if (error || loading || !daysLeftInTrial || !paymentFlowExperienceUrl) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {}),
        onError: (error)=>{
            sendOperationalEvent({
                type: 'sendOperationalEvent',
                action: 'error',
                actionSubject: 'luna-growth-experiment-error-boundary',
                actionSubjectId: 'in-trial-feature-gates-banner-error-boundary',
                attributes: {
                    error: error.message,
                    tenantId: tenantId,
                    featureId: featureId
                },
                source: 'in_trial_feature_gates_banner'
            });
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {}),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($50ac98d9a22aacea$var$InTrialFeatureGatesBanner, {
                daysLeftInTrial: daysLeftInTrial,
                paymentFlowExperienceUrl: paymentFlowExperienceUrl,
                featureId: featureId,
                sendScreenEvent: sendScreenEvent,
                sendTrackEvent: sendTrackEvent,
                edition: edition
            })
        })
    });
};

});
parcelRegister("7jjWP", function(module, exports) {

$parcel$export(module.exports, "useGetInTrialFeatureGateBannerData", () => $e31cbcc0cfebf616$export$cf372f2cfe52e989);

var $diswb = parcelRequire("diswb");

var $6ZXYe = parcelRequire("6ZXYe");

var $ekm5c = parcelRequire("ekm5c");
const $e31cbcc0cfebf616$export$cf372f2cfe52e989 = ({ aggClient: // Apps have different ways of getting the AGG client. Its not always as simple as useClient() and depends on the app's architecture.
// Therefore, we need to pass it in as a prop.
aggClient, tenantId: tenantId, sendOperationalEvent: sendOperationalEvent, featureId: featureId, skip: skip = false })=>{
    const { data: data, error: error, loading: loading } = (0, $diswb.useQuery)((0, $6ZXYe.InTrialFeatureGatesBannerQuery), {
        client: aggClient,
        variables: {
            cloudId: tenantId
        },
        skip: skip
    });
    if (error) {
        sendOperationalEvent({
            type: 'sendOperationalEvent',
            action: 'error',
            actionSubject: 'luna-growth-experiment-graphql-error',
            actionSubjectId: `in-trial-feature-gates-banner-graphql-error`,
            attributes: {
                error: error?.message,
                extraInfo: error?.extraInfo,
                graphqlErrors: error?.graphQLErrors,
                networkErrors: error?.networkError,
                tenantId: tenantId,
                featureId: featureId
            },
            source: 'in_trial_feature_gates_banner'
        });
        return {
            error: error,
            loading: loading,
            paymentFlowExperienceUrl: undefined,
            hasPaymentDetailsOnFile: false,
            canUserPayAndUpgrade: false,
            daysLeftInTrial: undefined
        };
    }
    const invoiceGroup = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup;
    const subscription = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription;
    const experienceCapabilities = invoiceGroup?.experienceCapabilities;
    /**
	 * Calculate core data for the in-trial feature gate banner
	 */ const paymentFlowExperienceUrl = (0, $ekm5c.addOriginToPaymentFlowUrl)({
        paymentExperienceUrlV1: experienceCapabilities?.configurePayment?.experienceUrl,
        paymentExperienceUrlV2: experienceCapabilities?.configurePaymentV2?.experienceUrl
    });
    const hasPaymentDetailsOnFile = !!subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const canUserPayAndUpgrade = !!experienceCapabilities?.configurePaymentV2?.isAvailableToUser || !!experienceCapabilities?.configurePayment?.isAvailableToUser;
    const daysLeftInTrial = (0, $ekm5c.getTrialEndDate)(subscription?.trial?.endTimestamp);
    return {
        error: error,
        loading: loading,
        paymentFlowExperienceUrl: paymentFlowExperienceUrl,
        hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
        canUserPayAndUpgrade: canUserPayAndUpgrade,
        daysLeftInTrial: daysLeftInTrial
    };
};

});
parcelRegister("6ZXYe", function(module, exports) {

$parcel$export(module.exports, "InTrialFeatureGatesBannerQuery", () => $6886a1d5065d514b$export$cf368a853317d665);

var $d2LG0 = parcelRequire("d2LG0");
const $6886a1d5065d514b$export$cf368a853317d665 = (0, $d2LG0.default)`query InTrialFeatureGatesBannerQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement(where:{AND:[{inTrialOrPreDunning:true}]}){subscription{trial{endTimestamp}accountDetails{invoiceGroup{invoiceable experienceCapabilities{configurePaymentV2{experienceUrl isAvailableToUser}configurePayment{experienceUrl isAvailableToUser}}}}}}}}}`;

});

parcelRegister("ekm5c", function(module, exports) {

$parcel$export(module.exports, "addOriginToPaymentFlowUrl", () => $5457c328dde2b413$export$7abd679947855d17);
$parcel$export(module.exports, "getTrialEndDate", () => $5457c328dde2b413$export$af328981d3bdc5ad);

var $6Co6F = parcelRequire("6Co6F");

var $5PE1K = parcelRequire("5PE1K");
const $5457c328dde2b413$export$7abd679947855d17 = ({ paymentExperienceUrlV1: paymentExperienceUrlV1, paymentExperienceUrlV2: paymentExperienceUrlV2 })=>{
    const experienceUrl = paymentExperienceUrlV2 || paymentExperienceUrlV1;
    if (!experienceUrl) return undefined;
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(experienceUrl);
};
const $5457c328dde2b413$export$af328981d3bdc5ad = (endTimestamp)=>{
    if (!endTimestamp) return undefined;
    return (0, $5PE1K.default)(new Date(endTimestamp), new Date()) + 1;
};

});


parcelRegister("9FFQU", function(module, exports) {

let $70a86866282000fc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $70a86866282000fc$var$load("joJy8"),
    $70a86866282000fc$var$load("aHE9G"),
    $70a86866282000fc$var$load("ffEVr"),
    $70a86866282000fc$var$load("13QWg")
]).then(()=>parcelRequire('kUaha'));

});


parcelRegister("5Xk8L", function(module, exports) {

$parcel$export(module.exports, "isFeatureDismissedForPeriodInTrial", () => $f5c3a66c1ece75a4$export$36992f6c91b0e47e);
$parcel$export(module.exports, "markFeatureAsDismissedForTrialPeriod", () => $f5c3a66c1ece75a4$export$191d939d2860d296);
function $f5c3a66c1ece75a4$export$476cad7b60124106(featureId, daysLeftInTrial) {
    const suffix = daysLeftInTrial > 3 ? 'sot' : 'eot';
    return `${featureId}_${suffix}`;
}
function $f5c3a66c1ece75a4$export$36992f6c91b0e47e(featureId, daysLeftInTrial) {
    // Adhere to SSR potential issues
    if (typeof window === 'undefined') return false;
    const key = $f5c3a66c1ece75a4$export$476cad7b60124106(featureId, daysLeftInTrial);
    return window.localStorage.getItem(key) !== null;
}
function $f5c3a66c1ece75a4$export$191d939d2860d296(featureId, daysLeftInTrial) {
    // Adhere to SSR potential issues
    if (typeof window === 'undefined') return;
    const key = $f5c3a66c1ece75a4$export$476cad7b60124106(featureId, daysLeftInTrial);
    window.localStorage.setItem(key, 'true');
}

});

parcelRegister("1Tx06", function(module, exports) {

$parcel$export(module.exports, "useInTrialFeatureGatesExperimentEnrollmentAB", () => $7ed1ab4755b609ab$export$45552391e022e54);

var $gwFzn = parcelRequire("gwFzn");

var $c6GJD = parcelRequire("c6GJD");

var $dh538 = parcelRequire("dh538");

var $5Xk8L = parcelRequire("5Xk8L");

var $ddBLb = parcelRequire("ddBLb");

var $j57x0 = parcelRequire("j57x0");
const $7ed1ab4755b609ab$var$COHORT = 'cohort';
const $7ed1ab4755b609ab$export$5b7423264d48ab04 = 'not-enrolled';
const $7ed1ab4755b609ab$export$c6528ba9c08031f7 = ({ experimentName: experimentName, isFeatureGateEnabled: isFeatureGateEnabled, featureId: featureId, aggClient: aggClient, tenantId: tenantId, sendTrackEvent: sendTrackEvent, sendOperationalEvent: sendOperationalEvent, skip: skip = false, extraAnalyticsAttributes: extraAnalyticsAttributes = {} })=>{
    const { isValidAudience: isValidAudience, data: { hasPaymentDetailsOnFile: hasPaymentDetailsOnFile, canUserPayAndUpgrade: canUserPayAndUpgrade, daysLeftInTrial: daysLeftInTrial }, isLoading: isLoading } = (0, $ddBLb.useIsValidAudience)({
        aggClient: aggClient,
        tenantId: tenantId,
        sendOperationalEvent: sendOperationalEvent,
        featureId: featureId,
        skip: !isFeatureGateEnabled || skip
    });
    const { cohort: cohort, isTreatment: isTreatment, isEnrolled: isEnrolled, canRenderTreatment: canRenderTreatment } = (0, $gwFzn.useMemo)(()=>{
        if (skip || !isFeatureGateEnabled || !isValidAudience) return {
            cohort: (0, $j57x0.COHORTS).NOT_ENROLLED,
            isTreatment: false,
            isEnrolled: false,
            canRenderTreatment: false,
            isLoading: false
        };
        const cohort = (0, $c6GJD.default).getExperimentValue(experimentName, $7ed1ab4755b609ab$var$COHORT, $7ed1ab4755b609ab$export$5b7423264d48ab04, {
            fireExperimentExposure: false
        });
        if (cohort === (0, $j57x0.COHORTS).NOT_ENROLLED) return {
            cohort: (0, $j57x0.COHORTS).NOT_ENROLLED,
            isTreatment: false,
            isEnrolled: false,
            canRenderTreatment: false,
            isLoading: false
        };
        let canRenderTreatment = false;
        if (cohort === (0, $j57x0.COHORTS).TREATMENT && daysLeftInTrial) canRenderTreatment = !(0, $5Xk8L.isFeatureDismissedForPeriodInTrial)(featureId, daysLeftInTrial);
        // manually fire StatSig exposure event
        (0, $c6GJD.default).manuallyLogExperimentExposure(experimentName);
        sendTrackEvent({
            type: 'sendTrackEvent',
            action: 'exposed',
            actionSubject: 'experiment',
            actionSubjectId: `${experimentName}-exposed`,
            attributes: {
                cohort: cohort,
                hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
                canUserPayAndUpgrade: canUserPayAndUpgrade,
                canRenderTreatment: canRenderTreatment,
                daysLeftInTrial: daysLeftInTrial,
                featureId: featureId,
                ...extraAnalyticsAttributes
            },
            source: experimentName
        });
        return {
            cohort: cohort,
            isTreatment: cohort === (0, $j57x0.COHORTS).TREATMENT,
            isEnrolled: cohort === (0, $j57x0.COHORTS).TREATMENT || cohort === (0, $j57x0.COHORTS).CONTROL,
            canRenderTreatment: canRenderTreatment
        };
    // Ignoring createAnalyticsEvent as a dependency since it isn't a primitive value and can cause side effects. It also doesn't change between renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        skip,
        isFeatureGateEnabled,
        isValidAudience,
        experimentName,
        hasPaymentDetailsOnFile,
        canUserPayAndUpgrade,
        daysLeftInTrial,
        featureId,
        tenantId
    ]);
    return {
        cohort: cohort,
        isTreatment: isTreatment,
        isEnrolled: isEnrolled,
        canRenderTreatment: canRenderTreatment,
        isLoading: isLoading
    };
};
const $7ed1ab4755b609ab$export$45552391e022e54 = ({ featureId: featureId, tenantId: tenantId, aggClient: aggClient, sendTrackEvent: sendTrackEvent, sendOperationalEvent: sendOperationalEvent, skip: skip = false, extraAnalyticsAttributes: extraAnalyticsAttributes = {} })=>{
    return $7ed1ab4755b609ab$export$c6528ba9c08031f7({
        experimentName: 'in_trial_feature_gates_ab',
        isFeatureGateEnabled: (0, $dh538.fg)('in_trial_feature_gates_ab_fg'),
        featureId: featureId,
        aggClient: aggClient,
        tenantId: tenantId,
        sendTrackEvent: sendTrackEvent,
        sendOperationalEvent: sendOperationalEvent,
        skip: skip,
        extraAnalyticsAttributes: extraAnalyticsAttributes
    });
};

});
parcelRegister("ddBLb", function(module, exports) {

$parcel$export(module.exports, "useIsValidAudience", () => $a0d8fb5c8cb2a507$export$408b18df0eda87d1);

var $7jjWP = parcelRequire("7jjWP");
const $a0d8fb5c8cb2a507$export$408b18df0eda87d1 = ({ aggClient: // Apps have different ways of getting the AGG client. Its not always as simple as useClient() and depends on the app's architecture.
// Therefore, we need to pass it in as a prop.
aggClient, tenantId: tenantId, sendOperationalEvent: sendOperationalEvent, featureId: featureId, skip: skip = false })=>{
    const { error: error, hasPaymentDetailsOnFile: hasPaymentDetailsOnFile, canUserPayAndUpgrade: canUserPayAndUpgrade, daysLeftInTrial: daysLeftInTrial, loading: loading } = (0, $7jjWP.useGetInTrialFeatureGateBannerData)({
        aggClient: aggClient,
        sendOperationalEvent: sendOperationalEvent,
        skip: skip,
        tenantId: tenantId,
        featureId: featureId
    });
    if (error || skip) return {
        isValidAudience: false,
        data: {
            hasPaymentDetailsOnFile: false,
            canUserPayAndUpgrade: false,
            daysLeftInTrial: undefined
        },
        isLoading: false
    };
    const isValidAudience = daysLeftInTrial !== undefined && daysLeftInTrial > 0 && !Boolean(hasPaymentDetailsOnFile) && Boolean(canUserPayAndUpgrade);
    return {
        isValidAudience: isValidAudience,
        // Returning the same data as useGetInTrialFeatureGateBannerData to allow us to leverage the same data for exposure analytics
        data: {
            hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
            canUserPayAndUpgrade: canUserPayAndUpgrade,
            daysLeftInTrial: daysLeftInTrial
        },
        isLoading: loading
    };
};

});

parcelRegister("j57x0", function(module, exports) {

$parcel$export(module.exports, "COHORTS", () => $9dee5a21e345fde3$export$f1a98e82c0c821bd);
const $9dee5a21e345fde3$export$f1a98e82c0c821bd = {
    NOT_ENROLLED: 'not-enrolled',
    CONTROL: 'control',
    TREATMENT: 'treatment'
};

});


parcelRegister("6UqI3", function(module, exports) {

$parcel$export(module.exports, "getSpaceType", () => $a3c7cd489159fe33$export$28eddf802cd184f7);
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};

});

parcelRegister("3XjWl", function(module, exports) {

$parcel$export(module.exports, "useExperienceState", () => $a5d6810b007644fc$export$4a4fb33de7d01f75);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceState, setExperienceState] = (0, $gwFzn.useState)(experienceTracker.getExperienceState(experienceName));
    (0, $gwFzn.useEffect)(()=>experienceTracker.subscribe((e)=>{
            if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
        }), [
        experienceName,
        experienceTracker
    ]);
    return experienceState;
};

});

parcelRegister("3P1RK", function(module, exports) {

$parcel$export(module.exports, "SpacePermissionsTabKey", () => $4a56ff9e2636e665$export$ad59ff7dc414850a);
$parcel$export(module.exports, "SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP", () => $4a56ff9e2636e665$export$d4f1d7ffc41e2d29);

var $fHoxN = parcelRequire("fHoxN");
var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};

});
parcelRegister("fHoxN", function(module, exports) {

$parcel$export(module.exports, "PermissionDisplayType", () => $8a20bb30841ead37$export$f1a726cdbae0d72a);
$parcel$export(module.exports, "SpacePermissionType", () => $8a20bb30841ead37$export$a99f5dae9c149910);
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});


parcelRegister("avmqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3afa2f21af7175e$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $6cnUO = parcelRequire("6cnUO");
function $e3afa2f21af7175e$export$2e2bcd8739ae039() {
    const { targets: targets } = (0, $gwFzn.useContext)((0, $6cnUO.SpotlightContext));
    const targetRef = (0, $gwFzn.useRef)(targets);
    (0, $gwFzn.useEffect)(()=>{
        targetRef.current = targets;
    }, [
        targets
    ]);
    const isTargetRendered = (0, $gwFzn.useCallback)((target)=>!!targetRef.current[target], []);
    return (0, $gwFzn.useMemo)(()=>({
            isTargetRendered: isTargetRendered
        }), [
        isTargetRendered
    ]);
}

});

parcelRegister("4Gau4", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $c747837ed372cb4a$export$da99457d6430d83);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7hpmn = parcelRequire("7hpmn");

var $ig6yX = parcelRequire("ig6yX");

var $4c48T = parcelRequire("4c48T");

var $jtTDB = parcelRequire("jtTDB");

var $83H3T = parcelRequire("83H3T");

var $dclyF = parcelRequire("dclyF");

var $4QtAs = parcelRequire("4QtAs");
const $c747837ed372cb4a$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $gwFzn.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $c747837ed372cb4a$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $c747837ed372cb4a$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: children(resizing)
    });
};

});
parcelRegister("4QtAs", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $0136602141ebd577$export$9e95200239cd148b);

var $gwFzn = parcelRequire("gwFzn");

var $dclyF = parcelRequire("dclyF");
const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $gwFzn.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("iKskQ", function(module, exports) {

$parcel$export(module.exports, "SpaceIcon", () => $b378bfc9d198c46c$export$38ffce4a7986ba20);
/* SpaceIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $buthI = parcelRequire("buthI");

var $4wwVl = parcelRequire("4wwVl");
const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkn82g",
    loaded: "_bfhk18uv"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko1y44 _1bsbgktf _4t3igktf",
    small: "_2rkoyh40 _1bsb1tcg _4t3i1tcg",
    medium: "_2rko1l7b _1bsbzwfg _4t3izwfg",
    large: "_2rko1l7b _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rkoi2wt _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $gwFzn.memo)(({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $gwFzn.useState)(!src);
    const setLoaded = (0, $gwFzn.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
        label: label,
        testId: testId
    });
});

});

parcelRegister("8TBLR", function(module, exports) {

$parcel$export(module.exports, "useChangeHubNameDialog", () => $83ab77eb80b41b96$export$8aef071e360cc004);

var $gwFzn = parcelRequire("gwFzn");

var $8aF6s = parcelRequire("8aF6s");

var $jmjWc = parcelRequire("jmjWc");
function $83ab77eb80b41b96$export$8aef071e360cc004(props = {}) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $gwFzn.useRef)();
    propsRef.current = props;
    return (0, $gwFzn.useCallback)(()=>showModal($83ab77eb80b41b96$var$ChangeHubNameDialogLoadable, propsRef.current), [
        showModal
    ]);
}

const $83ab77eb80b41b96$var$ChangeHubNameDialogLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CkW__",
    name: "ChangeHubNameDialogLoadable",
    loader: async ()=>(await (parcelRequire("3ZFrX"))).ChangeHubNameDialog
});

});
parcelRegister("3ZFrX", function(module, exports) {

let $2e8738afa676f074$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2e8738afa676f074$var$load("c6MKV"),
    $2e8738afa676f074$var$load("aZinD"),
    $2e8738afa676f074$var$load("ffEVr"),
    $2e8738afa676f074$var$load("kjZZD"),
    $2e8738afa676f074$var$load("iAaum"),
    $2e8738afa676f074$var$load("joJy8"),
    $2e8738afa676f074$var$load("aHE9G"),
    $2e8738afa676f074$var$load("6vzdH"),
    $2e8738afa676f074$var$load("lpcEN")
]).then(()=>parcelRequire('7uvLj'));

});


parcelRegister("63PsI", function(module, exports) {

$parcel$export(module.exports, "useCompanyHubName", () => $acec4613ff860ea3$export$e7c489d818076f3d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1ytiN = parcelRequire("1ytiN");
function $acec4613ff860ea3$export$e7c489d818076f3d() {
    let { companyHubName: companyHubName } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const intl = (0, $dBxQj.default)();
    if (!companyHubName) companyHubName = intl.formatMessage($acec4613ff860ea3$var$messages.defaultCompanyHubName);
    return companyHubName;
}
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- Moved from confluence/next/packages/app-navigation/src/Nav3/PrimaryItems/CompanyHubItem.tsx
const $acec4613ff860ea3$var$messages = (0, $2nPZH.defineMessages)({
    defaultCompanyHubName: {
        id: "app-navigation.company-hub.link",
        defaultMessage: "Company hub"
    }
});

});

parcelRegister("bjlBD", function(module, exports) {

$parcel$export(module.exports, "HubStatusLozenge", () => $9b533d2ebf123a97$export$6a1262a949a329a4);
/* HubStatusLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $5nBzc = parcelRequire("5nBzc");

var $3gadb = parcelRequire("3gadb");
var $afneb = parcelRequire("afneb");

var $1s5hv = parcelRequire("1s5hv");

var $4vzBZ = parcelRequire("4vzBZ");

var $1ytiN = parcelRequire("1ytiN");

var $cEgMD = parcelRequire("cEgMD");
const $9b533d2ebf123a97$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    publishedPill: {
        id: "company-hub-utils.hub-status-lozenge.general.dashboard.pill.published",
        defaultMessage: "Published"
    },
    publishedTooltip: {
        id: "company-hub-utils.hub-status-lozenge.general.dashboard.tooltip.published",
        defaultMessage: "Your hub is visible to everyone in the company"
    },
    notPublishedPill: {
        id: "company-hub-utils.hub-status-lozenge.general.dashboard.pill.not-published",
        defaultMessage: "Not published"
    },
    notPublishedTooltip: {
        id: "company-hub-utils.hub-status-lozenge.general.dashboard.tooltip.not-published",
        defaultMessage: "Your hub is only visible to you and other admin and editors. The rest of the company will not see your hub until you publish."
    }
});
const $9b533d2ebf123a97$var$tooltipStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b533d2ebf123a97$export$a8ac4109f6959128 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function customTooltipContent({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $35pXk.default)([
            "_11q71bhr _2rkoglpi _1yt41bs6 _16qs1cd0 _syaz1fxt _p12f1mjv"
        ])
    }, children);
});
const $9b533d2ebf123a97$export$6a1262a949a329a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { frontCoverState: frontCoverState } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const isPublished = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
        appearance: isPublished ? 'success' : undefined,
        isBold: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), isPublished ? $9b533d2ebf123a97$export$a7357cdd1f0b0168.publishedPill : $9b533d2ebf123a97$export$a7357cdd1f0b0168.notPublishedPill)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        component: $9b533d2ebf123a97$export$a8ac4109f6959128,
        position: "bottom-start",
        content: formatMessage(isPublished ? $9b533d2ebf123a97$export$a7357cdd1f0b0168.publishedTooltip : $9b533d2ebf123a97$export$a7357cdd1f0b0168.notPublishedTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    })));
};

});

parcelRegister("5GHmV", function(module, exports) {

$parcel$export(module.exports, "CompanyHubIcon", () => $4d612a190d16def3$export$5ef3f25e16249826);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2892e85dc70722149c914e6f0c299fa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7JAtv = parcelRequire("7JAtv");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4d612a190d16def3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z" clip-rule="evenodd"/>
</svg>
`;
function $4d612a190d16def3$export$5ef3f25e16249826({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7JAtv.IconWrapper), {
        svg: $4d612a190d16def3$var$svg,
        label: label || 'Company Hub',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3oZ9l", function(module, exports) {

$parcel$export(module.exports, "LAST_UPDATED_SPOTLIGHT_TARGET", () => $09bfdb7630dff79d$export$737801fc243e8eaf);
$parcel$export(module.exports, "OBJECT_SIDEBAR_SPOTLIGHT_TARGET", () => $09bfdb7630dff79d$export$1dc258e42eba4d7f);
$parcel$export(module.exports, "Spotlights", () => $09bfdb7630dff79d$export$c7b90ff96148d0e3);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $fpGTa = parcelRequire("fpGTa");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $cOrQJ = parcelRequire("cOrQJ");

var $lsxnT = parcelRequire("lsxnT");

var $5Mdl1 = parcelRequire("5Mdl1");

var $jYnGA = parcelRequire("jYnGA");

var $kW4Cm = parcelRequire("kW4Cm");

var $5RBkO = parcelRequire("5RBkO");
const $09bfdb7630dff79d$export$737801fc243e8eaf = 'content-wrapper-last-updated-spotlight-target';
const $09bfdb7630dff79d$export$fafe2d9a65afe15 = 'content-wrapper-last-updated-spotlight';
const $09bfdb7630dff79d$export$1dc258e42eba4d7f = 'content-wrapper-object-sidebar-spotlight-target';
const $09bfdb7630dff79d$export$68204ed6e5130087 = 'content-wrapper-object-sidebar-spotlight';
const $09bfdb7630dff79d$var$FLOATING_ACTION_BAR_LINK = 'https://support.atlassian.com/confluence-cloud/docs/get-to-know-the-new-and-simplified-content-layout/#The-floating-action-bar';
const $09bfdb7630dff79d$var$LAST_UPDATED_LINK = 'https://support.atlassian.com/confluence-cloud/docs/get-to-know-the-new-and-simplified-content-layout/#Header:-Last-updated';
const $09bfdb7630dff79d$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.inverse',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse'
    },
    ':visited': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':focus': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':visited:active': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    }
});
const $09bfdb7630dff79d$var$floatingMenuSpotlight = (0, $2nPZH.defineMessages)({
    heading: {
        id: "modernize-changeboarding.floating-menu-spotlight.heading",
        defaultMessage: "Comments, details, and more"
    },
    body: {
        id: "modernize-changeboarding.floating-menu-spotlight.body",
        defaultMessage: "Work faster with a <a>floating menu</a> that gets you closer to your content."
    }
});
const $09bfdb7630dff79d$var$lastUpdatedSpotlight = (0, $2nPZH.defineMessages)({
    heading: {
        id: "modernize-changeboarding.last-updated-spotlight.heading",
        defaultMessage: "Last updated is here"
    },
    body: {
        id: "modernize-changeboarding.last-updated-spotlight.body",
        defaultMessage: "Instantly track when your content was <a>last updated</a>."
    }
});
const $09bfdb7630dff79d$var$LastUpdatedSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: $09bfdb7630dff79d$export$fafe2d9a65afe15
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "bottom right",
        dialogWidth: 300,
        heading: formatMessage($09bfdb7630dff79d$var$lastUpdatedSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: $09bfdb7630dff79d$export$fafe2d9a65afe15
        }),
        key: $09bfdb7630dff79d$export$fafe2d9a65afe15,
        messageId: $09bfdb7630dff79d$export$fafe2d9a65afe15,
        messageType: messageType,
        shouldWatchTarget: true,
        target: $09bfdb7630dff79d$export$737801fc243e8eaf,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }, formatMessage($09bfdb7630dff79d$var$lastUpdatedSpotlight.body, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fpGTa.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: $09bfdb7630dff79d$export$fafe2d9a65afe15,
                            action: 'clicked',
                            actionSubject: 'link',
                            actionSubjectId: 'exploreContentWrapper'
                        }
                    }).fire();
                },
                href: $09bfdb7630dff79d$var$LAST_UPDATED_LINK,
                target: "_blank",
                testId: "content-wrapper-last-updated-spotlight-link",
                xcss: $09bfdb7630dff79d$var$linkStyles
            }, chunks)
    }));
};
const $09bfdb7630dff79d$var$ObjectSidebarSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const theme = (0, $cOrQJ.default)();
    const ContentWrapperSpotlightGIF = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($kW4Cm))) : (0, (/*@__PURE__*/$parcel$interopDefault($5RBkO)));
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: $09bfdb7630dff79d$export$68204ed6e5130087
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "left bottom",
        dialogWidth: 338,
        heading: formatMessage($09bfdb7630dff79d$var$floatingMenuSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: $09bfdb7630dff79d$export$68204ed6e5130087
        }),
        key: $09bfdb7630dff79d$export$68204ed6e5130087,
        image: ContentWrapperSpotlightGIF,
        messageId: $09bfdb7630dff79d$export$68204ed6e5130087,
        messageType: messageType,
        shouldWatchTarget: true,
        target: $09bfdb7630dff79d$export$1dc258e42eba4d7f,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 12
    }, formatMessage($09bfdb7630dff79d$var$floatingMenuSpotlight.body, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fpGTa.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: $09bfdb7630dff79d$export$68204ed6e5130087,
                            action: 'clicked',
                            actionSubject: 'link',
                            actionSubjectId: 'exploreContentWrapper'
                        }
                    }).fire();
                },
                href: $09bfdb7630dff79d$var$FLOATING_ACTION_BAR_LINK,
                target: "_blank",
                testId: "content-wrapper-object-sidebar-spotlight-link",
                xcss: $09bfdb7630dff79d$var$linkStyles
            }, chunks)
    }));
};
const $09bfdb7630dff79d$export$c7b90ff96148d0e3 = {
    LastUpdatedSpotlight: $09bfdb7630dff79d$var$LastUpdatedSpotlight,
    ObjectSidebarSpotlight: $09bfdb7630dff79d$var$ObjectSidebarSpotlight
};

});
parcelRegister("jYnGA", function(module, exports) {

$parcel$export(module.exports, "useSpotlightActions", () => $27905e2c6c2692ba$export$d52beefead77af4c);

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");
const $27905e2c6c2692ba$export$d52beefead77af4c = ({ progress: progress, onNext: onNext, onBack: onBack, source: source })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLast: isLast, isFirst: isFirst, step: step, steps: steps } = progress;
    const actions = [
        {
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'next',
                        source: source
                    }
                }).fire();
                onNext();
            },
            text: formatMessage(isLast ? $27905e2c6c2692ba$var$messages.done : $27905e2c6c2692ba$var$messages.next)
        },
        ...isFirst ? [] : [
            {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'back',
                            source: source
                        }
                    }).fire();
                    onBack();
                },
                text: formatMessage($27905e2c6c2692ba$var$messages.back),
                appearance: 'subtle'
            }
        ]
    ];
    const actionsBeforeElement = steps === 1 ? null : formatMessage($27905e2c6c2692ba$var$messages.progress, {
        step: step,
        steps: steps
    });
    return {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement
    };
};
const $27905e2c6c2692ba$var$messages = (0, $2nPZH.defineMessages)({
    back: {
        id: "modernize-changeboarding.useSpotlightActions.back",
        defaultMessage: "Back"
    },
    next: {
        id: "modernize-changeboarding.useSpotlightActions.next",
        defaultMessage: "Next"
    },
    done: {
        id: "modernize-changeboarding.useSpotlightActions.done",
        defaultMessage: "Done"
    },
    progress: {
        id: "modernize-changeboarding.useSpotlightActions.progress",
        defaultMessage: "{step}/{steps}"
    }
});

});

parcelRegister("kW4Cm", function(module, exports) {
module.exports = new URL("ContentWrapperSpotlightGIF-dark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("5RBkO", function(module, exports) {
module.exports = new URL("ContentWrapperSpotlightGIF-light.9900190e.gif", import.meta.url).toString();

});


parcelRegister("33kXB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e9795e597b52fb83fbace5cb1978ff6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2391e932c66f7955$var$_react = $2391e932c66f7955$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2391e932c66f7955$var$_baseNew = $2391e932c66f7955$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2391e932c66f7955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFlow".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Database schema in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2391e932c66f7955$var$DataFlowIcon = (props)=>/*#__PURE__*/ $2391e932c66f7955$var$_react.default.createElement($2391e932c66f7955$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.75 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5H9.563C8.976 3 8.5 3.476 8.5 4.063V7.25h3.128a2.251 2.251 0 1 1 0 1.5H8.5v3.188c0 .586.476 1.062 1.063 1.062h2.065a2.251 2.251 0 1 1 0 1.5H9.563A2.563 2.563 0 0 1 7 11.938V8.75H4.372a2.25 2.25 0 1 1 0-1.5H7V4.063A2.56 2.56 0 0 1 9.563 1.5zM2.25 7.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m11.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 5.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$2391e932c66f7955$var$DataFlowIcon.displayName = 'DataFlowIcon';
var $2391e932c66f7955$var$_default = module.exports.default = $2391e932c66f7955$var$DataFlowIcon;

});

parcelRegister("bvjDB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4184f921700e882128556324b8090399>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8601d29e65a3bd86$var$_react = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $8601d29e65a3bd86$var$_baseNew = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8601d29e65a3bd86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8601d29e65a3bd86$var$MinimizeIcon = (props)=>/*#__PURE__*/ $8601d29e65a3bd86$var$_react.default.createElement($8601d29e65a3bd86$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$8601d29e65a3bd86$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $8601d29e65a3bd86$var$_default = module.exports.default = $8601d29e65a3bd86$var$MinimizeIcon;

});

parcelRegister("FjHnq", function(module, exports) {

$parcel$export(module.exports, "DragHandleButton", () => $99266c3e40a077c6$export$4c99a519d851f90c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1dmTi = parcelRequire("1dmTi");

var $BhFQp = parcelRequire("BhFQp");
const $99266c3e40a077c6$export$4c99a519d851f90c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $BhFQp.DragHandleButtonBase), {
        ref: ref,
        ...buttonProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dmTi))), {
            color: "currentColor",
            spacing: "spacious",
            label: label,
            size: "small"
        })
    });
});

});
parcelRegister("1dmTi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8e199447618ebf9961e7eca7a27c952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e28c2fadb88a110$var$_react = $0e28c2fadb88a110$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0e28c2fadb88a110$var$_dragHandleVertical = $0e28c2fadb88a110$var$_interopRequireDefault((parcelRequire("8aNCk")));

var $0e28c2fadb88a110$var$_dragHandler = $0e28c2fadb88a110$var$_interopRequireDefault((parcelRequire("6Dqb4")));
function $0e28c2fadb88a110$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DragHandleVerticalIcon.
 * This component is DragHandleVerticalIcon, with `UNSAFE_fallbackIcon` set to "DragHandlerIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e28c2fadb88a110$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $0e28c2fadb88a110$var$_react.default.createElement($0e28c2fadb88a110$var$_dragHandleVertical.default, Object.assign({
        LEGACY_fallbackIcon: $0e28c2fadb88a110$var$_dragHandler.default
    }, props));
$0e28c2fadb88a110$var$DragHandleVerticalIcon.Name = 'DragHandleVerticalIconMigration';
var $0e28c2fadb88a110$var$_default = module.exports.default = $0e28c2fadb88a110$var$DragHandleVerticalIcon;

});

parcelRegister("BhFQp", function(module, exports) {

$parcel$export(module.exports, "DragHandleButtonBase", () => $428e284101874428$export$c099c65cfbd84d0a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dOMrE = parcelRequire("dOMrE");
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $428e284101874428$var$buttonStyles = (0, $3jLHL.css)({
    color: "var(--ds-text, #172B4D)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    padding: "var(--ds-space-0, 0px)",
    width: 'max-content',
    border: 'none',
    cursor: 'grab',
    display: 'flex'
});
const $428e284101874428$var$buttonAppearanceStyles = {
    default: (0, $3jLHL.css)({
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        '&:hover': {
            backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    }),
    subtle: (0, $3jLHL.css)({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        '&:hover': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        '&:active': {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
        }
    }),
    selected: (0, $3jLHL.css)({
        backgroundColor: "var(--ds-background-selected, #E9F2FF)",
        color: "var(--ds-text-selected, #0C66E4)"
    })
};
const $428e284101874428$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $dOMrE.default), null, /*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        ref: ref,
        css: [
            $428e284101874428$var$buttonStyles,
            $428e284101874428$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});

});


parcelRegister("dM2NO", function(module, exports) {

$parcel$export(module.exports, "List", () => $4e2cb6c2515ba804$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $4e2cb6c2515ba804$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $4e2cb6c2515ba804$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)($4e2cb6c2515ba804$var$_List);

});

parcelRegister("fgRQY", function(module, exports) {

$parcel$export(module.exports, "useElementSeenCallback", () => $40c43516853cc93d$export$951d3821f04440e9);

var $gwFzn = parcelRequire("gwFzn");
const $40c43516853cc93d$export$951d3821f04440e9 = (elementRef, onSeen, threshold = 1.0)=>{
    const observerRef = (0, $gwFzn.useRef)();
    const hasIntersected = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        const disconnectObserver = ()=>{
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = undefined;
            }
        };
        const handleIntersect = (entries)=>{
            if (!hasIntersected.current && entries[0].isIntersecting) {
                onSeen();
                hasIntersected.current = true;
                disconnectObserver();
            }
        };
        // eslint-disable-next-line
        observerRef.current = new IntersectionObserver(handleIntersect, {
            threshold: threshold
        });
        if (elementRef.current) observerRef.current.observe(elementRef.current);
        return disconnectObserver;
    }, [
        onSeen,
        elementRef,
        threshold
    ]);
};

});

parcelRegister("hAauA", function(module, exports) {

$parcel$export(module.exports, "STEPS", () => $18c0ce8e6ce7aa7a$export$6836fb99d2ec00dc);
$parcel$export(module.exports, "useGetModernizeChangeboardingOnboardingState", () => $18c0ce8e6ce7aa7a$export$1fd867888be3cc89);
$parcel$export(module.exports, "useSetModernizeChangeboardingOnboardingState", () => $18c0ce8e6ce7aa7a$export$f3de357f3d6ca0df);

var $gwFzn = parcelRequire("gwFzn");

var $4mCpo = parcelRequire("4mCpo");
var $bCqMo = parcelRequire("bCqMo");
var $cpyCM = parcelRequire("cpyCM");

var $ivb8S = parcelRequire("ivb8S");

var $dBcar = parcelRequire("dBcar");
var $9DBk6 = parcelRequire("9DBk6");

var $8Lx5S = parcelRequire("8Lx5S");

var $7Sm4c = parcelRequire("7Sm4c");
const $18c0ce8e6ce7aa7a$export$bc130f10168df871 = (values, defaultDate)=>{
    // Only keep expected dismissed values: either valid ISO datetimes,
    // or the legacy value `true` which we replace with a default date
    const validDates = values.map((value)=>value === true ? defaultDate : value).filter((value)=>typeof value === 'string').map((value)=>(0, $cpyCM.default)(value)).filter((0, $4mCpo.default));
    return validDates.length === 0 ? undefined : (0, $bCqMo.default)(validDates);
};
const $18c0ce8e6ce7aa7a$var$DEFAULT_CHANGEBOARDING_DISMISSED_DATE = '2025-06-09T00:00:00.000Z';
var $18c0ce8e6ce7aa7a$export$6836fb99d2ec00dc = /*#__PURE__*/ function(STEPS) {
    STEPS["NAV_4_GLOBAL"] = "nav4Global";
    STEPS["NAV_4_SPACE"] = "nav4Space";
    STEPS["LIVE_DOC"] = "liveDoc";
    STEPS["CONVERT_TO_PAGE"] = "convertToPage";
    STEPS["CONTENT_WRAPPER"] = "contentWrapper";
    return STEPS;
}({});
const $18c0ce8e6ce7aa7a$export$ea73d43a15ad8a09 = {
    ["nav4Global"]: (0, $dBcar.IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED),
    ["nav4Space"]: (0, $dBcar.IS_NAV_4_SPACE_TOUR_DISMISSED),
    ["liveDoc"]: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
    ["convertToPage"]: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedConvertToPageSpotlight,
    ["contentWrapper"]: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedContentWrapperTour
};
const $18c0ce8e6ce7aa7a$export$1fd867888be3cc89 = ()=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const accessError = isLicensed || isGuest ? null : new Error('Only licensed or guest users can retrieve onboarding state');
    if (accessError) (0, $7Sm4c.markErrorAsHandled)(accessError);
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED),
        (0, $dBcar.IS_NAV_4_SPACE_TOUR_DISMISSED),
        ...Object.values((0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS)),
        ...Object.values((0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL))
    ]);
    const { isNav4GlobalSpotlightDismissed: isNav4GlobalSpotlightDismissed, isNav4SpaceTourDismissed: isNav4SpaceTourDismissed, hasDismissedIntroSpotlight: hasDismissedIntroSpotlight, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasDismissedLiveDocModal: hasDismissedLiveDocModal, hasDismissedContentWrapperTour: hasDismissedContentWrapperTour, hasDismissedAiButtonTour: hasDismissedAiButtonTour, hasDismissedConvertToPageSpotlight: hasDismissedConvertToPageSpotlight, hasDismissedModernizeConfluenceIpmModal: hasDismissedModernizeConfluenceIpmModal } = (0, $ivb8S.deserializeState)(data);
    const changeboardingStartedAt = (0, $gwFzn.useMemo)(()=>{
        return $18c0ce8e6ce7aa7a$export$bc130f10168df871([
            isNav4GlobalSpotlightDismissed,
            isNav4SpaceTourDismissed,
            hasDismissedIntroSpotlight,
            hasDismissedLiveDocTour,
            hasDismissedLiveDocModal,
            hasDismissedContentWrapperTour,
            hasDismissedConvertToPageSpotlight
        ], $18c0ce8e6ce7aa7a$var$DEFAULT_CHANGEBOARDING_DISMISSED_DATE);
    }, [
        isNav4GlobalSpotlightDismissed,
        isNav4SpaceTourDismissed,
        hasDismissedIntroSpotlight,
        hasDismissedLiveDocTour,
        hasDismissedLiveDocModal,
        hasDismissedContentWrapperTour,
        hasDismissedConvertToPageSpotlight
    ]);
    return {
        isNav4GlobalSpotlightDismissed: isNav4GlobalSpotlightDismissed,
        isNav4SpaceTourDismissed: isNav4SpaceTourDismissed,
        hasDismissedIntroSpotlight: hasDismissedIntroSpotlight,
        hasDismissedLiveDocTour: hasDismissedLiveDocTour,
        hasDismissedLiveDocModal: hasDismissedLiveDocModal,
        hasDismissedContentWrapperTour: hasDismissedContentWrapperTour,
        hasDismissedAiButtonTour: hasDismissedAiButtonTour,
        hasDismissedConvertToPageSpotlight: hasDismissedConvertToPageSpotlight,
        hasDismissedModernizeConfluenceIpmModal: hasDismissedModernizeConfluenceIpmModal,
        changeboardingStartedAt: changeboardingStartedAt,
        loading: loading,
        error: error || accessError
    };
};
const $18c0ce8e6ce7aa7a$export$f3de357f3d6ca0df = ()=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const completeNav4GlobalSpotlight = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED),
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeNav4SpaceTour = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_SPACE_TOUR_DISMISSED),
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeContentWrapperTour = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedContentWrapperTour,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocModal = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocModal,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeModernizeConfluenceIpmModal = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $dBcar.MODERNIZE_CONFLUENCE_IPM_MODAL).HAS_DISMISSED_MODAL,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocTour = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeConvertToPageSpotlight = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: $18c0ce8e6ce7aa7a$export$ea73d43a15ad8a09["convertToPage"],
            value: new Date().toISOString()
        });
    }, [
        setOnboardingState
    ]);
    const completeSegments = (0, $gwFzn.useCallback)((steps)=>{
        if (steps.length === 0) return;
        setOnboardingState(steps.map((step)=>({
                key: $18c0ce8e6ce7aa7a$export$ea73d43a15ad8a09[step],
                value: new Date().toISOString()
            })));
    }, [
        setOnboardingState
    ]);
    return {
        completeNav4GlobalSpotlight: completeNav4GlobalSpotlight,
        completeNav4SpaceTour: completeNav4SpaceTour,
        completeLiveDocModal: completeLiveDocModal,
        completeLiveDocTour: completeLiveDocTour,
        completeContentWrapperTour: completeContentWrapperTour,
        completeConvertToPageSpotlight: completeConvertToPageSpotlight,
        completeSegments: completeSegments,
        completeModernizeConfluenceIpmModal: completeModernizeConfluenceIpmModal
    };
};

});
parcelRegister("bCqMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8758043321c9a7d4$export$2e2bcd8739ae039);

var $4eQbn = parcelRequire("4eQbn");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $8758043321c9a7d4$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $6Z3KL.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $4eQbn.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $4YLNd.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});


parcelRegister("7S7nY", function(module, exports) {

$parcel$export(module.exports, "useModernizeChangeboardingTapTraits", () => $63574695e209bf34$export$a942c00307626545);

var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $bQm3c = parcelRequire("bQm3c");
const $63574695e209bf34$export$a942c00307626545 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { loading: loading, data: data, error: error } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useModernizeChangeboardingTapTraitsQuery($cloudId:String!$userId:String!)@experimental{experimentalSiteUserPersonalization(cloudId:$cloudId userId:$userId){attributes{name value}}}`, {
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId
    });
    if (!data) return {
        isInNav4Audience: false,
        hasDismissedNav4ChangeboardingViaEP: false,
        loading: loading,
        error: error
    };
    let isInNav4Audience = false;
    let hasDismissedNav4ChangeboardingViaEP = false;
    for (const { name: name, value: value } of data.experimentalSiteUserPersonalization.attributes){
        if (name === 'segment_confluence_nav_4_changeboarding_cloned_siteuser') isInNav4Audience = value === 'true';
        else if (name === 'completed_cc-nav-4-changeboarding-prod') hasDismissedNav4ChangeboardingViaEP = Boolean(value);
    }
    return {
        isInNav4Audience: isInNav4Audience,
        hasDismissedNav4ChangeboardingViaEP: hasDismissedNav4ChangeboardingViaEP,
        loading: loading,
        error: error
    };
};

});

parcelRegister("47zp4", function(module, exports) {

$parcel$export(module.exports, "CONVERT_TO_PAGE_SPOTLIGHT_TARGET", () => $0d18a6ceee3ea649$export$28e6adad41f72d0c);
$parcel$export(module.exports, "Spotlights", () => $0d18a6ceee3ea649$export$c7b90ff96148d0e3);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $lsxnT = parcelRequire("lsxnT");

var $5Mdl1 = parcelRequire("5Mdl1");

var $jYnGA = parcelRequire("jYnGA");

var $7FIdS = parcelRequire("7FIdS");
const $0d18a6ceee3ea649$export$789d6d0dffe2f1d7 = 'live-doc-share-button-spotlight-target';
const $0d18a6ceee3ea649$export$28e6adad41f72d0c = 'convert-to-page-spotlight-target';
const $0d18a6ceee3ea649$var$SHARE_MENU_SPOTLIGHT_NAME = 'live-doc-share-button-spotlight';
const $0d18a6ceee3ea649$var$CONVERT_TO_PAGE_SPOTLIGHT_NAME = 'convert-to-page-spotlight';
const $0d18a6ceee3ea649$var$COMMUNITY_POST_LINK = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $0d18a6ceee3ea649$var$ShareMenuSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: $0d18a6ceee3ea649$var$SHARE_MENU_SPOTLIGHT_NAME
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "bottom right",
        dialogWidth: 338,
        heading: formatMessage($0d18a6ceee3ea649$var$shareMenuSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: $0d18a6ceee3ea649$var$SHARE_MENU_SPOTLIGHT_NAME
        }),
        key: "live-doc-share-button-spotlight",
        messageId: "live-doc-share-button-spotlight",
        messageType: messageType,
        shouldWatchTarget: true,
        target: $0d18a6ceee3ea649$export$789d6d0dffe2f1d7,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }, formatMessage($0d18a6ceee3ea649$var$shareMenuSpotlight.body, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fpGTa.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: $0d18a6ceee3ea649$var$SHARE_MENU_SPOTLIGHT_NAME,
                            action: 'clicked',
                            actionSubject: 'link',
                            actionSubjectId: 'exploreLiveDocs'
                        }
                    }).fire();
                },
                href: $0d18a6ceee3ea649$var$COMMUNITY_POST_LINK,
                target: "_blank",
                testId: "live-doc-share-button-spotlight-link",
                xcss: $0d18a6ceee3ea649$var$linkStyles
            }, chunks)
    }));
};
const $0d18a6ceee3ea649$var$ConvertToPageSpotlight = ({ onNext: onNext, onBack: onBack, onDismiss: onDismiss, progress: progress, messageType: messageType = 'engagement' })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { actions: actions, actionsBeforeElement: actionsBeforeElement } = (0, $jYnGA.useSpotlightActions)({
        progress: progress,
        onNext: onNext,
        onBack: onBack,
        source: $0d18a6ceee3ea649$var$CONVERT_TO_PAGE_SPOTLIGHT_NAME
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7FIdS.WithMoreActionsMenuOpen), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
        actions: actions,
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "left top",
        dialogWidth: 328,
        header: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $0d18a6ceee3ea649$var$headerStyles
            }, children),
        heading: formatMessage($0d18a6ceee3ea649$var$convertToPageSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Mdl1.CrossIconCloseButton), {
            onClose: onDismiss,
            source: $0d18a6ceee3ea649$var$CONVERT_TO_PAGE_SPOTLIGHT_NAME
        }),
        key: $0d18a6ceee3ea649$var$CONVERT_TO_PAGE_SPOTLIGHT_NAME,
        messageId: $0d18a6ceee3ea649$var$CONVERT_TO_PAGE_SPOTLIGHT_NAME,
        messageType: messageType,
        shouldWatchTarget: true,
        target: $0d18a6ceee3ea649$export$28e6adad41f72d0c,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 4
    }, formatMessage($0d18a6ceee3ea649$var$convertToPageSpotlight.body, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fpGTa.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: $0d18a6ceee3ea649$var$CONVERT_TO_PAGE_SPOTLIGHT_NAME,
                            action: 'clicked',
                            actionSubject: 'link',
                            actionSubjectId: 'exploreLiveDocs'
                        }
                    }).fire();
                },
                href: $0d18a6ceee3ea649$var$COMMUNITY_POST_LINK,
                target: "_blank",
                xcss: $0d18a6ceee3ea649$var$linkStyles
            }, chunks)
    })));
};
const $0d18a6ceee3ea649$var$headerStyles = (0, $ecnYn.xcss)({
    textWrap: 'pretty',
    // Prevents an orphan in the spotlight headline.
    // These match the default spotlight header styles.
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingBlockEnd: 'space.100'
});
const $0d18a6ceee3ea649$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.inverse',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse'
    },
    ':visited': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':focus': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':visited:active': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    }
});
const $0d18a6ceee3ea649$var$shareMenuSpotlight = (0, $2nPZH.defineMessages)({
    heading: {
        id: "modernize-changeboarding.share-menu-spotlight.heading",
        defaultMessage: "Open to all when created"
    },
    body: {
        id: "modernize-changeboarding.share-menu-spotlight.body",
        defaultMessage: "When <a>live docs</a> are started, they\u2019re open to all in this space. Make them private anytime."
    }
});
const $0d18a6ceee3ea649$var$convertToPageSpotlight = (0, $2nPZH.defineMessages)({
    heading: {
        id: "modernize-changeboarding.convert-to-page-spotlight.heading",
        defaultMessage: "Convert any live doc to a page"
    },
    body: {
        id: "modernize-changeboarding.convert-to-page-spotlight.body",
        defaultMessage: "<a>Live docs</a> can be converted and published as pages (and converted back) anytime."
    }
});
const $0d18a6ceee3ea649$export$c7b90ff96148d0e3 = {
    ShareMenuSpotlight: $0d18a6ceee3ea649$var$ShareMenuSpotlight,
    ConvertToPageSpotlight: $0d18a6ceee3ea649$var$ConvertToPageSpotlight
};

});
parcelRegister("7FIdS", function(module, exports) {

$parcel$export(module.exports, "WithMoreActionsMenuOpen", () => $c5e1cc2ec6f0674f$export$dd0c646ab5223b8b);

var $gwFzn = parcelRequire("gwFzn");

var $c54hr = parcelRequire("c54hr");
const $c5e1cc2ec6f0674f$export$dd0c646ab5223b8b = ({ children: children })=>{
    const { setIsMenuOpen: setIsMenuOpen, setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $gwFzn.useEffect)(()=>{
        setIsCloseMenuDisabled(true);
        setIsMenuOpen(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
            setIsMenuOpen(false);
        };
    }, [
        setIsMenuOpen,
        setIsCloseMenuDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};

});
parcelRegister("c54hr", function(module, exports) {

$parcel$export(module.exports, "useMoreActionsMenuState", () => $367766f6f044c46b$export$14d00db016c2b3ef);
$parcel$export(module.exports, "useMoreActionsMenuActions", () => $367766f6f044c46b$export$1f1f8c486fa8a1cb);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $4ZoIm.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $iFWZA.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $iFWZA.createActionsHook)($367766f6f044c46b$var$Store);

});



parcelRegister("ktziD", function(module, exports) {

$parcel$export(module.exports, "useExcludeFromModernizeGAChangeboarding", () => $4d9f5979af6eaf98$export$47bcbeae4ba4de7);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $hAauA = parcelRequire("hAauA");
const $4d9f5979af6eaf98$export$47bcbeae4ba4de7 = (skip = false)=>{
    const { completeSegments: completeSegments } = (0, $hAauA.useSetModernizeChangeboardingOnboardingState)();
    const hasCompleted = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') || hasCompleted.current) return;
        completeSegments([
            (0, $hAauA.STEPS).NAV_4_GLOBAL,
            (0, $hAauA.STEPS).NAV_4_SPACE,
            (0, $hAauA.STEPS).LIVE_DOC,
            (0, $hAauA.STEPS).CONVERT_TO_PAGE,
            (0, $hAauA.STEPS).CONTENT_WRAPPER
        ]);
        hasCompleted.current = true;
    }, [
        completeSegments,
        skip
    ]);
};

});

parcelRegister("jEeDd", function(module, exports) {

$parcel$export(module.exports, "getLoginLink", () => $2dd269c5e0cf48e9$export$264b5fa7ee2d3260);

var $6X8o4 = parcelRequire("6X8o4");

var $ge2sX = parcelRequire("ge2sX");
function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}

});

parcelRegister("bfcUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b4e4ecd5b980279$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4KS7f = parcelRequire("4KS7f");
var $boHsq = parcelRequire("boHsq");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $804cB = parcelRequire("804cB");

var $dVmRp = parcelRequire("dVmRp");

var $9BPJm = parcelRequire("9BPJm");
class $6b4e4ecd5b980279$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $804cB.useModal)();
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dVmRp.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
            autoFocus: true,
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)(Header, {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dVmRp.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $7UHDa.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args);
        this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $dVmRp.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        };
        this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boHsq.default).Provider, {
                    value: (0, $9BPJm.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dVmRp.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dVmRp.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4KS7f.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("dVmRp", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $51071d0057ab1254$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $51071d0057ab1254$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $51071d0057ab1254$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $51071d0057ab1254$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $51071d0057ab1254$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gdv5Z = parcelRequire("gdv5Z");
const $51071d0057ab1254$var$modalBodyStyles = null;
const $51071d0057ab1254$var$modalHeadingStyles = null;
const $51071d0057ab1254$var$modalImageStyles = null;
const $51071d0057ab1254$var$modalActionContainerStyles = null;
const $51071d0057ab1254$var$modalActionContainerReversedStyles = null;
const $51071d0057ab1254$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
}; /**
    * __Modal body__
    *
    * @internal
    */ 
const $51071d0057ab1254$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    }); /**
                                                                                                    * __Modal heading__
                                                                                                    *
                                                                                                    * @internal
                                                                                                    */ 
const $51071d0057ab1254$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("h1", {
        id: id,
        className: (0, $35pXk.default)([
            "_11c8lodh _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
}; /**
    * __Modal image__
    *
    * @internal
    */ 
const $51071d0057ab1254$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $35pXk.default)([
            "_1bsb1osq _4t3i1wug _5fbc1sit _1s1g1sit _j722idpf"
        ])
    }); /**
                                                                                                                           * __Modal action container__
                                                                                                                           *
                                                                                                                           * @internal
                                                                                                                           */ 
const $51071d0057ab1254$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    }); /**
          * __Modal action item__
          *
          * @internal
          */ 
const $51071d0057ab1254$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $51071d0057ab1254$var$modalActionItemStyles.root,
        children: children
    });

});


parcelRegister("bvJMy", function(module, exports) {

$parcel$export(module.exports, "StarSelectedIcon", () => $82c992371ed08bb5$export$fd017b91d8968d63);

var $gwFzn = parcelRequire("gwFzn");

var $gI8uy = parcelRequire("gI8uy");

var $cOrQJ = parcelRequire("cOrQJ");
const $82c992371ed08bb5$export$fd017b91d8968d63 = ({ label: label, size: size, testId: testId, spacing: spacing })=>{
    const theme = (0, $cOrQJ.default)();
    const primaryColor = (0, $gwFzn.useMemo)(()=>{
        return theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E56910)";
    }, [
        theme.colorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        label: label,
        color: primaryColor,
        ...size && {
            size: size
        },
        ...testId && {
            testId: testId
        },
        spacing: spacing
    });
};

});

parcelRegister("lTRsf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff1832fefd16ba51$var$_react = $ff1832fefd16ba51$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $ff1832fefd16ba51$var$_baseNew = $ff1832fefd16ba51$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ff1832fefd16ba51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff1832fefd16ba51$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $ff1832fefd16ba51$var$_react.default.createElement($ff1832fefd16ba51$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ff1832fefd16ba51$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $ff1832fefd16ba51$var$_default = module.exports.default = $ff1832fefd16ba51$var$ChartTrendIcon;

});

parcelRegister("4WJnD", function(module, exports) {

$parcel$export(module.exports, "CardMacroIcon", () => $35c4513eb1360b1b$export$1a12565d3b149b13);

var $gwFzn = parcelRequire("gwFzn");
const $35c4513eb1360b1b$export$1a12565d3b149b13 = ()=>{
    // Moving from <Icon> to <svg> since this icon will be replaced soon
    // and because of the complexity of scaling each path in the SVG.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "32",
        height: "22",
        viewBox: "0 0 32 22",
        "aria-label": "Card",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("mask", {
        id: "path-1-inside-1_4424_408291",
        fill: "var(--ds-surface-raised, #FFFFFF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M8 11H24V21C24 21.5523 23.5523 22 23 22H9C8.44772 22 8 21.5523 8 21V11Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M8 11H24V21C24 21.5523 23.5523 22 23 22H9C8.44772 22 8 21.5523 8 21V11Z",
        fill: "var(--ds-surface-raised, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M8 11H24H8ZM25 21C25 22.1046 24.1046 23 23 23H9C7.89543 23 7 22.1046 7 21H9H23H25ZM9 23C7.89543 23 7 22.1046 7 21V11H9V21V23ZM25 11V21C25 22.1046 24.1046 23 23 23V21V11H25Z",
        fill: "var(--ds-background-neutral-hovered, #091E4224)",
        mask: "url(#path-1-inside-1_4424_408291)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "11",
        y: "13",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-neutral-hovered, #091E4224)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "11",
        y: "16",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-neutral-hovered, #091E4224)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("g", {
        clipPath: "url(#clip0_4424_408291)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "8",
        width: "16",
        height: "11",
        fill: "var(--ds-background-neutral-hovered, #091E4224)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M9.56641 9.66749L13.2958 5.53027L17.0252 9.66749H9.56641Z",
        fill: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M11.5586 9.66747L17.0239 3.60449L22.4891 9.66747H11.5586Z",
        fill: "var(--ds-icon-information, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("g", {
        opacity: "0.37"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M18.9894 7.11779C17.2437 6.25471 15.5864 6.72991 13.31 6.17401C11.7498 5.79302 9.81297 4.90515 8 2.75V10.9403H21.5292C21.3154 9.51503 20.6897 7.95836 18.9894 7.11779Z",
        fill: "url(#paint0_linear_4424_408291)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M11.3333 4.85151C12.0697 4.85151 12.6667 4.22717 12.6667 3.457C12.6667 2.68684 12.0697 2.0625 11.3333 2.0625C10.597 2.0625 10 2.68684 10 3.457C10 4.22717 10.597 4.85151 11.3333 4.85151Z",
        fill: "var(--ds-background-accent-orange-subtle, #FEA362)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "26",
        y: "19",
        width: "16",
        height: "11",
        transform: "rotate(-90 26 19)",
        fill: "var(--ds-background-neutral-hovered, #091E4224)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "6",
        y: "3",
        width: "16",
        height: "11",
        transform: "rotate(90 6 3)",
        fill: "var(--ds-background-neutral-hovered, #091E4224)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("linearGradient", {
        id: "paint0_linear_4424_408291",
        x1: "21.6237",
        y1: "2.12675",
        x2: "6.03556",
        y2: "2.12675",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("stop", {
        stopColor: "var(--ds-border, #091E4224)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("stop", {
        offset: "0.1252",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        stopOpacity: "0.8589"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("stop", {
        offset: "0.5465",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        stopOpacity: "0.4017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("stop", {
        offset: "0.8366",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        stopOpacity: "0.1128"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("stop", {
        offset: "0.9703",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        stopOpacity: "0.01"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("clipPath", {
        id: "clip0_4424_408291"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M8 1C8 0.447715 8.44772 0 9 0H23C23.5523 0 24 0.447715 24 1V11H8V1Z",
        fill: "var(--ds-background-neutral-hovered, #091E4224)"
    }))));
};

});

parcelRegister("3f6mR", function(module, exports) {

$parcel$export(module.exports, "CarouselMacroIcon", () => $db4282a2f8ec24e9$export$89b1c8e86f71db51);

var $gwFzn = parcelRequire("gwFzn");
const $db4282a2f8ec24e9$export$89b1c8e86f71db51 = ()=>{
    // Moving from <Icon> to <svg> since this icon will be replaced soon
    // and because of the complexity of scaling each path in the SVG.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "34",
        height: "32",
        viewBox: "0 0 34 32",
        fill: "none",
        "aria-label": "Carousel",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "0.599609",
        y: "24.7302",
        width: "10",
        height: "6.30769",
        rx: "3.15385",
        fill: "#0055CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "11.5996",
        y: "24.7302",
        width: "10",
        height: "6.30769",
        rx: "3.15385",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "22.5996",
        y: "24.7302",
        width: "10",
        height: "6.30769",
        rx: "3.15385",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("rect", {
        x: "1.23038",
        y: "1.18155",
        width: "31.5385",
        height: "20.6051",
        rx: "3.15385",
        stroke: "var(--ds-border, #091E4224)",
        strokeOpacity: "0.84",
        strokeWidth: "1.26154"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M3.8125 19.7685L11.4577 11.5442L19.1029 19.7685H3.8125Z",
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M7.89746 19.7688L19.1013 7.71631L30.305 19.7688H7.89746Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M7.43255 10.1951C8.94213 10.1951 10.1659 8.95398 10.1659 7.42298C10.1659 5.89199 8.94213 4.65088 7.43255 4.65088C5.92297 4.65088 4.69922 5.89199 4.69922 7.42298C4.69922 8.95398 5.92297 10.1951 7.43255 10.1951Z",
        fill: "#C25100"
    }));
};

});

parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("btVRN"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("3HNy3"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("s92VS"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("lG7kZ"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("keNEU"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("iEmAk"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("28Yts"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("lO3Qr"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("7rx6L"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("1ypVK"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("a4nuc"))).PageBannerForgeApp
});

});
parcelRegister("btVRN", function(module, exports) {

let $85bf4a3e7cc3a0a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $85bf4a3e7cc3a0a5$var$load("1ISAt"),
    $85bf4a3e7cc3a0a5$var$load("mKoWX"),
    $85bf4a3e7cc3a0a5$var$load("1m9tW"),
    $85bf4a3e7cc3a0a5$var$load("7J7Dl"),
    $85bf4a3e7cc3a0a5$var$load("jqXtk"),
    $85bf4a3e7cc3a0a5$var$load("6vzdH"),
    $85bf4a3e7cc3a0a5$var$load("hmhwB"),
    $85bf4a3e7cc3a0a5$var$load("f0WOR"),
    $85bf4a3e7cc3a0a5$var$load("9sgov"),
    $85bf4a3e7cc3a0a5$var$load("fS2SK"),
    $85bf4a3e7cc3a0a5$var$load("afNiU"),
    $85bf4a3e7cc3a0a5$var$load("FNKrB"),
    $85bf4a3e7cc3a0a5$var$load("1SiRe"),
    $85bf4a3e7cc3a0a5$var$load("lnKog"),
    $85bf4a3e7cc3a0a5$var$load("gCIfF"),
    $85bf4a3e7cc3a0a5$var$load("koo1l"),
    $85bf4a3e7cc3a0a5$var$load("8eNS3"),
    $85bf4a3e7cc3a0a5$var$load("50LrB"),
    $85bf4a3e7cc3a0a5$var$load("iQ0Jm"),
    $85bf4a3e7cc3a0a5$var$load("ikem6"),
    $85bf4a3e7cc3a0a5$var$load("5Smk7"),
    $85bf4a3e7cc3a0a5$var$load("h4Nf7"),
    $85bf4a3e7cc3a0a5$var$load("lfEn7"),
    $85bf4a3e7cc3a0a5$var$load("bGaMz"),
    $85bf4a3e7cc3a0a5$var$load("2BIkk"),
    $85bf4a3e7cc3a0a5$var$load("lJxwk"),
    $85bf4a3e7cc3a0a5$var$load("7VwsU"),
    $85bf4a3e7cc3a0a5$var$load("fsZ6i"),
    $85bf4a3e7cc3a0a5$var$load("hKqxh"),
    $85bf4a3e7cc3a0a5$var$load("7sseo"),
    $85bf4a3e7cc3a0a5$var$load("45SdR"),
    $85bf4a3e7cc3a0a5$var$load("6gqpV"),
    $85bf4a3e7cc3a0a5$var$load("g9CVe"),
    $85bf4a3e7cc3a0a5$var$load("aZinD"),
    $85bf4a3e7cc3a0a5$var$load("hIYCb"),
    $85bf4a3e7cc3a0a5$var$load("fNL1b"),
    $85bf4a3e7cc3a0a5$var$load("6qah4"),
    $85bf4a3e7cc3a0a5$var$load("iAaum"),
    $85bf4a3e7cc3a0a5$var$load("ffEVr"),
    $85bf4a3e7cc3a0a5$var$load("joJy8"),
    $85bf4a3e7cc3a0a5$var$load("aHE9G"),
    $85bf4a3e7cc3a0a5$var$load("c6MKV"),
    $85bf4a3e7cc3a0a5$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("3HNy3", function(module, exports) {

let $2b2bd28439b6112f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2b2bd28439b6112f$var$load("1ISAt"),
    $2b2bd28439b6112f$var$load("mKoWX"),
    $2b2bd28439b6112f$var$load("1m9tW"),
    $2b2bd28439b6112f$var$load("7J7Dl"),
    $2b2bd28439b6112f$var$load("jqXtk"),
    $2b2bd28439b6112f$var$load("6vzdH"),
    $2b2bd28439b6112f$var$load("hmhwB"),
    $2b2bd28439b6112f$var$load("f0WOR"),
    $2b2bd28439b6112f$var$load("9sgov"),
    $2b2bd28439b6112f$var$load("fS2SK"),
    $2b2bd28439b6112f$var$load("afNiU"),
    $2b2bd28439b6112f$var$load("FNKrB"),
    $2b2bd28439b6112f$var$load("1SiRe"),
    $2b2bd28439b6112f$var$load("lnKog"),
    $2b2bd28439b6112f$var$load("gCIfF"),
    $2b2bd28439b6112f$var$load("koo1l"),
    $2b2bd28439b6112f$var$load("8eNS3"),
    $2b2bd28439b6112f$var$load("50LrB"),
    $2b2bd28439b6112f$var$load("iQ0Jm"),
    $2b2bd28439b6112f$var$load("ikem6"),
    $2b2bd28439b6112f$var$load("5Smk7"),
    $2b2bd28439b6112f$var$load("h4Nf7"),
    $2b2bd28439b6112f$var$load("lfEn7"),
    $2b2bd28439b6112f$var$load("bGaMz"),
    $2b2bd28439b6112f$var$load("2BIkk"),
    $2b2bd28439b6112f$var$load("lJxwk"),
    $2b2bd28439b6112f$var$load("7VwsU"),
    $2b2bd28439b6112f$var$load("fsZ6i"),
    $2b2bd28439b6112f$var$load("hKqxh"),
    $2b2bd28439b6112f$var$load("7sseo"),
    $2b2bd28439b6112f$var$load("45SdR"),
    $2b2bd28439b6112f$var$load("6gqpV"),
    $2b2bd28439b6112f$var$load("g9CVe"),
    $2b2bd28439b6112f$var$load("aZinD"),
    $2b2bd28439b6112f$var$load("hIYCb"),
    $2b2bd28439b6112f$var$load("fNL1b"),
    $2b2bd28439b6112f$var$load("6qah4"),
    $2b2bd28439b6112f$var$load("iAaum"),
    $2b2bd28439b6112f$var$load("ffEVr"),
    $2b2bd28439b6112f$var$load("joJy8"),
    $2b2bd28439b6112f$var$load("aHE9G"),
    $2b2bd28439b6112f$var$load("c6MKV"),
    $2b2bd28439b6112f$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("s92VS", function(module, exports) {

let $0549a20bb6718d5f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0549a20bb6718d5f$var$load("1ISAt"),
    $0549a20bb6718d5f$var$load("mKoWX"),
    $0549a20bb6718d5f$var$load("1m9tW"),
    $0549a20bb6718d5f$var$load("7J7Dl"),
    $0549a20bb6718d5f$var$load("jqXtk"),
    $0549a20bb6718d5f$var$load("6vzdH"),
    $0549a20bb6718d5f$var$load("hmhwB"),
    $0549a20bb6718d5f$var$load("f0WOR"),
    $0549a20bb6718d5f$var$load("9sgov"),
    $0549a20bb6718d5f$var$load("fS2SK"),
    $0549a20bb6718d5f$var$load("afNiU"),
    $0549a20bb6718d5f$var$load("FNKrB"),
    $0549a20bb6718d5f$var$load("1SiRe"),
    $0549a20bb6718d5f$var$load("lnKog"),
    $0549a20bb6718d5f$var$load("gCIfF"),
    $0549a20bb6718d5f$var$load("koo1l"),
    $0549a20bb6718d5f$var$load("8eNS3"),
    $0549a20bb6718d5f$var$load("50LrB"),
    $0549a20bb6718d5f$var$load("iQ0Jm"),
    $0549a20bb6718d5f$var$load("ikem6"),
    $0549a20bb6718d5f$var$load("5Smk7"),
    $0549a20bb6718d5f$var$load("h4Nf7"),
    $0549a20bb6718d5f$var$load("lfEn7"),
    $0549a20bb6718d5f$var$load("bGaMz"),
    $0549a20bb6718d5f$var$load("2BIkk"),
    $0549a20bb6718d5f$var$load("lJxwk"),
    $0549a20bb6718d5f$var$load("7VwsU"),
    $0549a20bb6718d5f$var$load("fsZ6i"),
    $0549a20bb6718d5f$var$load("hKqxh"),
    $0549a20bb6718d5f$var$load("7sseo"),
    $0549a20bb6718d5f$var$load("45SdR"),
    $0549a20bb6718d5f$var$load("6gqpV"),
    $0549a20bb6718d5f$var$load("g9CVe"),
    $0549a20bb6718d5f$var$load("aZinD"),
    $0549a20bb6718d5f$var$load("hIYCb"),
    $0549a20bb6718d5f$var$load("fNL1b"),
    $0549a20bb6718d5f$var$load("6qah4"),
    $0549a20bb6718d5f$var$load("iAaum"),
    $0549a20bb6718d5f$var$load("ffEVr"),
    $0549a20bb6718d5f$var$load("joJy8"),
    $0549a20bb6718d5f$var$load("aHE9G"),
    $0549a20bb6718d5f$var$load("c6MKV"),
    $0549a20bb6718d5f$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("lG7kZ", function(module, exports) {

let $fc83364cea68ac55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fc83364cea68ac55$var$load("1ISAt"),
    $fc83364cea68ac55$var$load("mKoWX"),
    $fc83364cea68ac55$var$load("1m9tW"),
    $fc83364cea68ac55$var$load("7J7Dl"),
    $fc83364cea68ac55$var$load("jqXtk"),
    $fc83364cea68ac55$var$load("6vzdH"),
    $fc83364cea68ac55$var$load("fS2SK"),
    $fc83364cea68ac55$var$load("afNiU"),
    $fc83364cea68ac55$var$load("FNKrB"),
    $fc83364cea68ac55$var$load("gCIfF"),
    $fc83364cea68ac55$var$load("ikem6"),
    $fc83364cea68ac55$var$load("5Smk7"),
    $fc83364cea68ac55$var$load("h4Nf7"),
    $fc83364cea68ac55$var$load("lfEn7"),
    $fc83364cea68ac55$var$load("7VwsU"),
    $fc83364cea68ac55$var$load("fsZ6i"),
    $fc83364cea68ac55$var$load("hKqxh"),
    $fc83364cea68ac55$var$load("7sseo"),
    $fc83364cea68ac55$var$load("45SdR"),
    $fc83364cea68ac55$var$load("6gqpV"),
    $fc83364cea68ac55$var$load("g9CVe"),
    $fc83364cea68ac55$var$load("6qah4"),
    $fc83364cea68ac55$var$load("aZinD"),
    $fc83364cea68ac55$var$load("hIYCb"),
    $fc83364cea68ac55$var$load("fNL1b"),
    $fc83364cea68ac55$var$load("iAaum"),
    $fc83364cea68ac55$var$load("ffEVr"),
    $fc83364cea68ac55$var$load("joJy8"),
    $fc83364cea68ac55$var$load("aHE9G"),
    $fc83364cea68ac55$var$load("c6MKV"),
    $fc83364cea68ac55$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("keNEU", function(module, exports) {

let $ebbba2ad241181c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ebbba2ad241181c7$var$load("1ISAt"),
    $ebbba2ad241181c7$var$load("mKoWX"),
    $ebbba2ad241181c7$var$load("1m9tW"),
    $ebbba2ad241181c7$var$load("7J7Dl"),
    $ebbba2ad241181c7$var$load("jqXtk"),
    $ebbba2ad241181c7$var$load("6vzdH"),
    $ebbba2ad241181c7$var$load("fS2SK"),
    $ebbba2ad241181c7$var$load("afNiU"),
    $ebbba2ad241181c7$var$load("FNKrB"),
    $ebbba2ad241181c7$var$load("gCIfF"),
    $ebbba2ad241181c7$var$load("ikem6"),
    $ebbba2ad241181c7$var$load("5Smk7"),
    $ebbba2ad241181c7$var$load("h4Nf7"),
    $ebbba2ad241181c7$var$load("lfEn7"),
    $ebbba2ad241181c7$var$load("7VwsU"),
    $ebbba2ad241181c7$var$load("fsZ6i"),
    $ebbba2ad241181c7$var$load("hKqxh"),
    $ebbba2ad241181c7$var$load("7sseo"),
    $ebbba2ad241181c7$var$load("45SdR"),
    $ebbba2ad241181c7$var$load("6gqpV"),
    $ebbba2ad241181c7$var$load("g9CVe"),
    $ebbba2ad241181c7$var$load("6qah4"),
    $ebbba2ad241181c7$var$load("aZinD"),
    $ebbba2ad241181c7$var$load("hIYCb"),
    $ebbba2ad241181c7$var$load("fNL1b"),
    $ebbba2ad241181c7$var$load("iAaum"),
    $ebbba2ad241181c7$var$load("ffEVr"),
    $ebbba2ad241181c7$var$load("joJy8"),
    $ebbba2ad241181c7$var$load("aHE9G"),
    $ebbba2ad241181c7$var$load("c6MKV"),
    $ebbba2ad241181c7$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("iEmAk", function(module, exports) {

let $d93d7b4d49065b88$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d93d7b4d49065b88$var$load("1ISAt"),
    $d93d7b4d49065b88$var$load("mKoWX"),
    $d93d7b4d49065b88$var$load("1m9tW"),
    $d93d7b4d49065b88$var$load("7J7Dl"),
    $d93d7b4d49065b88$var$load("jqXtk"),
    $d93d7b4d49065b88$var$load("6vzdH"),
    $d93d7b4d49065b88$var$load("fS2SK"),
    $d93d7b4d49065b88$var$load("afNiU"),
    $d93d7b4d49065b88$var$load("FNKrB"),
    $d93d7b4d49065b88$var$load("1SiRe"),
    $d93d7b4d49065b88$var$load("lnKog"),
    $d93d7b4d49065b88$var$load("gCIfF"),
    $d93d7b4d49065b88$var$load("ikem6"),
    $d93d7b4d49065b88$var$load("5Smk7"),
    $d93d7b4d49065b88$var$load("h4Nf7"),
    $d93d7b4d49065b88$var$load("lfEn7"),
    $d93d7b4d49065b88$var$load("7VwsU"),
    $d93d7b4d49065b88$var$load("fsZ6i"),
    $d93d7b4d49065b88$var$load("hKqxh"),
    $d93d7b4d49065b88$var$load("7sseo"),
    $d93d7b4d49065b88$var$load("45SdR"),
    $d93d7b4d49065b88$var$load("6gqpV"),
    $d93d7b4d49065b88$var$load("g9CVe"),
    $d93d7b4d49065b88$var$load("6qah4"),
    $d93d7b4d49065b88$var$load("aZinD"),
    $d93d7b4d49065b88$var$load("hIYCb"),
    $d93d7b4d49065b88$var$load("fNL1b"),
    $d93d7b4d49065b88$var$load("iAaum"),
    $d93d7b4d49065b88$var$load("ffEVr"),
    $d93d7b4d49065b88$var$load("joJy8"),
    $d93d7b4d49065b88$var$load("aHE9G"),
    $d93d7b4d49065b88$var$load("c6MKV"),
    $d93d7b4d49065b88$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("28Yts", function(module, exports) {

let $18fb3d09e97a89d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $18fb3d09e97a89d1$var$load("1ISAt"),
    $18fb3d09e97a89d1$var$load("mKoWX"),
    $18fb3d09e97a89d1$var$load("1m9tW"),
    $18fb3d09e97a89d1$var$load("7J7Dl"),
    $18fb3d09e97a89d1$var$load("jqXtk"),
    $18fb3d09e97a89d1$var$load("6vzdH"),
    $18fb3d09e97a89d1$var$load("8DoxJ"),
    $18fb3d09e97a89d1$var$load("hRWmb"),
    $18fb3d09e97a89d1$var$load("hmhwB"),
    $18fb3d09e97a89d1$var$load("fS2SK"),
    $18fb3d09e97a89d1$var$load("afNiU"),
    $18fb3d09e97a89d1$var$load("FNKrB"),
    $18fb3d09e97a89d1$var$load("1SiRe"),
    $18fb3d09e97a89d1$var$load("lnKog"),
    $18fb3d09e97a89d1$var$load("gCIfF"),
    $18fb3d09e97a89d1$var$load("koo1l"),
    $18fb3d09e97a89d1$var$load("ifr0h"),
    $18fb3d09e97a89d1$var$load("ikem6"),
    $18fb3d09e97a89d1$var$load("5Smk7"),
    $18fb3d09e97a89d1$var$load("h4Nf7"),
    $18fb3d09e97a89d1$var$load("lfEn7"),
    $18fb3d09e97a89d1$var$load("2BIkk"),
    $18fb3d09e97a89d1$var$load("lJxwk"),
    $18fb3d09e97a89d1$var$load("7VwsU"),
    $18fb3d09e97a89d1$var$load("fsZ6i"),
    $18fb3d09e97a89d1$var$load("hKqxh"),
    $18fb3d09e97a89d1$var$load("7sseo"),
    $18fb3d09e97a89d1$var$load("45SdR"),
    $18fb3d09e97a89d1$var$load("dTsOE"),
    $18fb3d09e97a89d1$var$load("6gqpV"),
    $18fb3d09e97a89d1$var$load("g9CVe"),
    $18fb3d09e97a89d1$var$load("6qah4"),
    $18fb3d09e97a89d1$var$load("aZinD"),
    $18fb3d09e97a89d1$var$load("hIYCb"),
    $18fb3d09e97a89d1$var$load("fNL1b"),
    $18fb3d09e97a89d1$var$load("iAaum"),
    $18fb3d09e97a89d1$var$load("ffEVr"),
    $18fb3d09e97a89d1$var$load("joJy8"),
    $18fb3d09e97a89d1$var$load("aHE9G"),
    $18fb3d09e97a89d1$var$load("c6MKV"),
    $18fb3d09e97a89d1$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("lO3Qr", function(module, exports) {

let $fe013ffd68fca619$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fe013ffd68fca619$var$load("1ISAt"),
    $fe013ffd68fca619$var$load("mKoWX"),
    $fe013ffd68fca619$var$load("1m9tW"),
    $fe013ffd68fca619$var$load("7J7Dl"),
    $fe013ffd68fca619$var$load("jqXtk"),
    $fe013ffd68fca619$var$load("6vzdH"),
    $fe013ffd68fca619$var$load("8DoxJ"),
    $fe013ffd68fca619$var$load("hRWmb"),
    $fe013ffd68fca619$var$load("hmhwB"),
    $fe013ffd68fca619$var$load("fS2SK"),
    $fe013ffd68fca619$var$load("afNiU"),
    $fe013ffd68fca619$var$load("FNKrB"),
    $fe013ffd68fca619$var$load("1SiRe"),
    $fe013ffd68fca619$var$load("lnKog"),
    $fe013ffd68fca619$var$load("gCIfF"),
    $fe013ffd68fca619$var$load("koo1l"),
    $fe013ffd68fca619$var$load("ifr0h"),
    $fe013ffd68fca619$var$load("ikem6"),
    $fe013ffd68fca619$var$load("5Smk7"),
    $fe013ffd68fca619$var$load("h4Nf7"),
    $fe013ffd68fca619$var$load("lfEn7"),
    $fe013ffd68fca619$var$load("2BIkk"),
    $fe013ffd68fca619$var$load("lJxwk"),
    $fe013ffd68fca619$var$load("7VwsU"),
    $fe013ffd68fca619$var$load("fsZ6i"),
    $fe013ffd68fca619$var$load("hKqxh"),
    $fe013ffd68fca619$var$load("7sseo"),
    $fe013ffd68fca619$var$load("45SdR"),
    $fe013ffd68fca619$var$load("dTsOE"),
    $fe013ffd68fca619$var$load("6gqpV"),
    $fe013ffd68fca619$var$load("g9CVe"),
    $fe013ffd68fca619$var$load("6qah4"),
    $fe013ffd68fca619$var$load("aZinD"),
    $fe013ffd68fca619$var$load("hIYCb"),
    $fe013ffd68fca619$var$load("fNL1b"),
    $fe013ffd68fca619$var$load("iAaum"),
    $fe013ffd68fca619$var$load("ffEVr"),
    $fe013ffd68fca619$var$load("joJy8"),
    $fe013ffd68fca619$var$load("aHE9G"),
    $fe013ffd68fca619$var$load("c6MKV"),
    $fe013ffd68fca619$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("7rx6L", function(module, exports) {

let $56b4bc966821187a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $56b4bc966821187a$var$load("1ISAt"),
    $56b4bc966821187a$var$load("mKoWX"),
    $56b4bc966821187a$var$load("1m9tW"),
    $56b4bc966821187a$var$load("7J7Dl"),
    $56b4bc966821187a$var$load("jqXtk"),
    $56b4bc966821187a$var$load("6vzdH"),
    $56b4bc966821187a$var$load("fS2SK"),
    $56b4bc966821187a$var$load("afNiU"),
    $56b4bc966821187a$var$load("FNKrB"),
    $56b4bc966821187a$var$load("gCIfF"),
    $56b4bc966821187a$var$load("ikem6"),
    $56b4bc966821187a$var$load("5Smk7"),
    $56b4bc966821187a$var$load("h4Nf7"),
    $56b4bc966821187a$var$load("lfEn7"),
    $56b4bc966821187a$var$load("7VwsU"),
    $56b4bc966821187a$var$load("fsZ6i"),
    $56b4bc966821187a$var$load("hKqxh"),
    $56b4bc966821187a$var$load("7sseo"),
    $56b4bc966821187a$var$load("45SdR"),
    $56b4bc966821187a$var$load("6gqpV"),
    $56b4bc966821187a$var$load("g9CVe"),
    $56b4bc966821187a$var$load("6qah4"),
    $56b4bc966821187a$var$load("aZinD"),
    $56b4bc966821187a$var$load("hIYCb"),
    $56b4bc966821187a$var$load("fNL1b"),
    $56b4bc966821187a$var$load("iAaum"),
    $56b4bc966821187a$var$load("ffEVr"),
    $56b4bc966821187a$var$load("joJy8"),
    $56b4bc966821187a$var$load("aHE9G"),
    $56b4bc966821187a$var$load("c6MKV"),
    $56b4bc966821187a$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("1ypVK", function(module, exports) {

let $121d14af7cdd1219$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $121d14af7cdd1219$var$load("1ISAt"),
    $121d14af7cdd1219$var$load("mKoWX"),
    $121d14af7cdd1219$var$load("1m9tW"),
    $121d14af7cdd1219$var$load("7J7Dl"),
    $121d14af7cdd1219$var$load("jqXtk"),
    $121d14af7cdd1219$var$load("6vzdH"),
    $121d14af7cdd1219$var$load("fS2SK"),
    $121d14af7cdd1219$var$load("afNiU"),
    $121d14af7cdd1219$var$load("FNKrB"),
    $121d14af7cdd1219$var$load("1SiRe"),
    $121d14af7cdd1219$var$load("lnKog"),
    $121d14af7cdd1219$var$load("gCIfF"),
    $121d14af7cdd1219$var$load("ikem6"),
    $121d14af7cdd1219$var$load("5Smk7"),
    $121d14af7cdd1219$var$load("h4Nf7"),
    $121d14af7cdd1219$var$load("lfEn7"),
    $121d14af7cdd1219$var$load("7VwsU"),
    $121d14af7cdd1219$var$load("fsZ6i"),
    $121d14af7cdd1219$var$load("hKqxh"),
    $121d14af7cdd1219$var$load("7sseo"),
    $121d14af7cdd1219$var$load("45SdR"),
    $121d14af7cdd1219$var$load("6gqpV"),
    $121d14af7cdd1219$var$load("g9CVe"),
    $121d14af7cdd1219$var$load("6qah4"),
    $121d14af7cdd1219$var$load("aZinD"),
    $121d14af7cdd1219$var$load("hIYCb"),
    $121d14af7cdd1219$var$load("fNL1b"),
    $121d14af7cdd1219$var$load("iAaum"),
    $121d14af7cdd1219$var$load("ffEVr"),
    $121d14af7cdd1219$var$load("joJy8"),
    $121d14af7cdd1219$var$load("aHE9G"),
    $121d14af7cdd1219$var$load("c6MKV"),
    $121d14af7cdd1219$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("a4nuc", function(module, exports) {

let $754c7ef43bfa0d4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $754c7ef43bfa0d4c$var$load("1ISAt"),
    $754c7ef43bfa0d4c$var$load("mKoWX"),
    $754c7ef43bfa0d4c$var$load("1m9tW"),
    $754c7ef43bfa0d4c$var$load("7J7Dl"),
    $754c7ef43bfa0d4c$var$load("jqXtk"),
    $754c7ef43bfa0d4c$var$load("6vzdH"),
    $754c7ef43bfa0d4c$var$load("fS2SK"),
    $754c7ef43bfa0d4c$var$load("afNiU"),
    $754c7ef43bfa0d4c$var$load("FNKrB"),
    $754c7ef43bfa0d4c$var$load("1SiRe"),
    $754c7ef43bfa0d4c$var$load("lnKog"),
    $754c7ef43bfa0d4c$var$load("gCIfF"),
    $754c7ef43bfa0d4c$var$load("ikem6"),
    $754c7ef43bfa0d4c$var$load("5Smk7"),
    $754c7ef43bfa0d4c$var$load("h4Nf7"),
    $754c7ef43bfa0d4c$var$load("lfEn7"),
    $754c7ef43bfa0d4c$var$load("7VwsU"),
    $754c7ef43bfa0d4c$var$load("fsZ6i"),
    $754c7ef43bfa0d4c$var$load("hKqxh"),
    $754c7ef43bfa0d4c$var$load("7sseo"),
    $754c7ef43bfa0d4c$var$load("45SdR"),
    $754c7ef43bfa0d4c$var$load("6gqpV"),
    $754c7ef43bfa0d4c$var$load("g9CVe"),
    $754c7ef43bfa0d4c$var$load("6qah4"),
    $754c7ef43bfa0d4c$var$load("aZinD"),
    $754c7ef43bfa0d4c$var$load("hIYCb"),
    $754c7ef43bfa0d4c$var$load("fNL1b"),
    $754c7ef43bfa0d4c$var$load("iAaum"),
    $754c7ef43bfa0d4c$var$load("ffEVr"),
    $754c7ef43bfa0d4c$var$load("joJy8"),
    $754c7ef43bfa0d4c$var$load("aHE9G"),
    $754c7ef43bfa0d4c$var$load("c6MKV"),
    $754c7ef43bfa0d4c$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("i3uiK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2500301d11eaf38$var$_react = $d2500301d11eaf38$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $d2500301d11eaf38$var$_baseNew = $d2500301d11eaf38$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d2500301d11eaf38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2500301d11eaf38$var$CreditCardIcon = (props)=>/*#__PURE__*/ $d2500301d11eaf38$var$_react.default.createElement($d2500301d11eaf38$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$d2500301d11eaf38$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $d2500301d11eaf38$var$_default = module.exports.default = $d2500301d11eaf38$var$CreditCardIcon;

});

parcelRegister("jypE9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b10c2aaa76d32294bc7ed1c0a1888df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3c5162d320d5390$var$_react = $e3c5162d320d5390$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $e3c5162d320d5390$var$_baseNew = $e3c5162d320d5390$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e3c5162d320d5390$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3c5162d320d5390$var$PanelRightIcon = (props)=>/*#__PURE__*/ $e3c5162d320d5390$var$_react.default.createElement($e3c5162d320d5390$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$e3c5162d320d5390$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $e3c5162d320d5390$var$_default = module.exports.default = $e3c5162d320d5390$var$PanelRightIcon;

});

parcelRegister("fEibl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::149b2cd6a95881a63bc7d331a2f52240>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b648b1fca232e343$var$_react = $b648b1fca232e343$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $b648b1fca232e343$var$_baseNew = $b648b1fca232e343$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b648b1fca232e343$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b648b1fca232e343$var$CompassIcon = (props)=>/*#__PURE__*/ $b648b1fca232e343$var$_react.default.createElement($b648b1fca232e343$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$b648b1fca232e343$var$CompassIcon.displayName = 'CompassIcon';
var $b648b1fca232e343$var$_default = module.exports.default = $b648b1fca232e343$var$CompassIcon;

});

parcelRegister("g8gEr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbea4f50c576ae56$var$_react = $bbea4f50c576ae56$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $bbea4f50c576ae56$var$_baseNew = $bbea4f50c576ae56$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bbea4f50c576ae56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbea4f50c576ae56$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $bbea4f50c576ae56$var$_react.default.createElement($bbea4f50c576ae56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$bbea4f50c576ae56$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $bbea4f50c576ae56$var$_default = module.exports.default = $bbea4f50c576ae56$var$LobbyBellIcon;

});

parcelRegister("cDMVr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $933f141c99b2ec32$var$_react = $933f141c99b2ec32$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $933f141c99b2ec32$var$_baseNew = $933f141c99b2ec32$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $933f141c99b2ec32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $933f141c99b2ec32$var$PersonAddIcon = (props)=>/*#__PURE__*/ $933f141c99b2ec32$var$_react.default.createElement($933f141c99b2ec32$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$933f141c99b2ec32$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $933f141c99b2ec32$var$_default = module.exports.default = $933f141c99b2ec32$var$PersonAddIcon;

});

parcelRegister("jK29N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5f3fc87e4383614$var$_react = $e5f3fc87e4383614$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $e5f3fc87e4383614$var$_baseNew = $e5f3fc87e4383614$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e5f3fc87e4383614$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5f3fc87e4383614$var$LogOutIcon = (props)=>/*#__PURE__*/ $e5f3fc87e4383614$var$_react.default.createElement($e5f3fc87e4383614$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$e5f3fc87e4383614$var$LogOutIcon.displayName = 'LogOutIcon';
var $e5f3fc87e4383614$var$_default = module.exports.default = $e5f3fc87e4383614$var$LogOutIcon;

});

parcelRegister("hMVuE", function(module, exports) {

$parcel$export(module.exports, "HubRendererWrapper", () => $5ae33af279ac01b5$export$1a063b7cda785385);
/* HubRendererWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $5ae33af279ac01b5$export$1a063b7cda785385 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1p9midpf _1awjidpf _1o1jckbl _1bweckbl _tnsdidpf _127midpf _128sckbl _s8ydckbl _utchidpf _ovodidpf _rtpd1uiu _1c211uiu _qndeidpf _1k6kidpf _tjcw1uiu _mctt1uiu _1cw71ihj _yqhm1ihj _1a031ssb _1fd01ssb _x0t7zr6s _ato1zr6s _14cj147o _13rb147o _1gygjo1l _78a5jo1l _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("idqcs", function(module, exports) {

$parcel$export(module.exports, "TooltipWithShortcut", () => $8613291bce8a20c4$export$21d6e57c6980d82a);

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $ljm2R = parcelRequire("ljm2R");
class $8613291bce8a20c4$export$21d6e57c6980d82a extends (0, $gwFzn.Component) {
    render() {
        const { children: children, description: description, shortcutAccelerator: shortcutAccelerator, shortcutAllowInDialog: shortcutAllowInDialog, shortcutListener: shortcutListener, isDisabled: isDisabled, ...otherTooltipProps } = this.props;
        const shortcutContent = shortcutAccelerator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: shortcutAccelerator,
            contentBefore: description,
            isTooltip: true
        }) : description;
        return isDisabled ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: shortcutContent,
            ...otherTooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: {
                display: 'inline-block'
            }
        }, children, !shortcutListener ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutListener), {
            accelerator: shortcutAccelerator,
            allowInDialog: shortcutAllowInDialog,
            listener: shortcutListener
        })));
    }
}
$8613291bce8a20c4$export$21d6e57c6980d82a.defaultProps = {
    isDisabled: false,
    description: ''
};

});

parcelRegister("kdgty", function(module, exports) {

$parcel$export(module.exports, "TemplateBreadcrumbs", () => $beb955d6331b0470$export$e6d2e961e20b418f);
$parcel$export(module.exports, "TemplateBreadcrumbsComponent", () => $beb955d6331b0470$export$e33498af6e3f3f27);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $jmjWc = parcelRequire("jmjWc");
const $beb955d6331b0470$var$EmptyArea = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _4t3izwfg",
            __cmplp.className
        ])
    });
});

const $beb955d6331b0470$export$e6d2e961e20b418f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bxg6z",
    name: "TemplateBreadcrumbs",
    loader: async ()=>(await (parcelRequire("8qIdn"))).TemplateBreadcrumbsWithActions,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($beb955d6331b0470$var$EmptyArea, null)
});

const $beb955d6331b0470$export$e33498af6e3f3f27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JKRVk",
    name: "TemplateBreadcrumbsComponent",
    loader: async ()=>(await (parcelRequire("5j2tk"))).TemplateBreadcrumbs
});

});
parcelRegister("8qIdn", function(module, exports) {

let $62330c8d32c7dfc9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $62330c8d32c7dfc9$var$load("lLBCb"),
    $62330c8d32c7dfc9$var$load("iAaum"),
    $62330c8d32c7dfc9$var$load("kHBkS"),
    $62330c8d32c7dfc9$var$load("joJy8"),
    $62330c8d32c7dfc9$var$load("aHE9G"),
    $62330c8d32c7dfc9$var$load("ffEVr"),
    $62330c8d32c7dfc9$var$load("ftJgg"),
    $62330c8d32c7dfc9$var$load("3QilQ")
]).then(()=>parcelRequire('7KYYZ'));

});

parcelRegister("5j2tk", function(module, exports) {

let $3dd0a4fa5ddf08d7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3dd0a4fa5ddf08d7$var$load("iAaum"),
    $3dd0a4fa5ddf08d7$var$load("joJy8"),
    $3dd0a4fa5ddf08d7$var$load("aHE9G"),
    $3dd0a4fa5ddf08d7$var$load("kHBkS")
]).then(()=>parcelRequire('1sMjA'));

});


parcelRegister("9MXHA", function(module, exports) {

$parcel$export(module.exports, "EditHubButton", () => $5f914146beb2cf63$export$ced3b39c9a52ddac);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7p4As = parcelRequire("7p4As");

var $69PnT = parcelRequire("69PnT");

var $1NBp8 = parcelRequire("1NBp8");
const $5f914146beb2cf63$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    editHubButtonLabel: {
        id: "company-hub.hub-settings.general.dashboard.edit-hub-button-label",
        defaultMessage: "Edit hub"
    }
});
const $5f914146beb2cf63$export$ced3b39c9a52ddac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($69PnT))),
        href: (0, $1NBp8.COMPANY_HUB_EDIT).toUrl(),
        analyticsContext: {
            source: 'dashboardEditHubButton'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5f914146beb2cf63$export$a7357cdd1f0b0168.editHubButtonLabel));

});

parcelRegister("jBtIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68a7235b47b3a0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $eEA8O = parcelRequire("eEA8O");

var $hPd3F = parcelRequire("hPd3F");

var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");

var $8LYja = parcelRequire("8LYja");
const $b68a7235b47b3a0b$var$rootStyles = null;
const $b68a7235b47b3a0b$var$iconColor = {
    connectivity: "_x5v9bku0",
    confirmation: "_x5v91yjp",
    info: "_x5v9kakq",
    warning: "_x5v91392",
    error: "_x5v9s4qr"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $b68a7235b47b3a0b$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const toggleDialog = (0, $gwFzn.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $gwFzn.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $b68a7235b47b3a0b$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPd3F.default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`,
            fallbackPlacements: fallbackPlacements,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                "data-ds--inline-message--button": true,
                appearance: "subtle-link",
                onClick: toggleDialog,
                spacing: "none",
                testId: testId && `${testId}--button`,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8LYja.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $b68a7235b47b3a0b$export$2e2bcd8739ae039 = $b68a7235b47b3a0b$var$InlineMessage;

});
parcelRegister("8LYja", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae17877acce5881a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kbsDd = parcelRequire("kbsDd");
const $ae17877acce5881a$var$iconColor = {
    connectivity: "_1b3ibku0",
    confirmation: "_1b3i1yjp",
    info: "_1b3ikakq",
    warning: "_1b3i1392",
    error: "_1b3is4qr"
};
const $ae17877acce5881a$var$iconWrapperStyles = null;
const $ae17877acce5881a$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $ae17877acce5881a$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $kbsDd.typesMapping);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $35pXk.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $ae17877acce5881a$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: spacing
        })
    });
};
var $ae17877acce5881a$export$2e2bcd8739ae039 = $ae17877acce5881a$var$SelectedIcon;

});
parcelRegister("kbsDd", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $7d03302d66e9e0e8$export$4d111645c0b39d5d);

var $5L38b = parcelRequire("5L38b");

var $lpHGz = parcelRequire("lpHGz");

var $bAfMd = parcelRequire("bAfMd");

var $6hqEj = parcelRequire("6hqEj");
const $7d03302d66e9e0e8$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bAfMd))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lpHGz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5L38b))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("eFm27", function(module, exports) {

$parcel$export(module.exports, "PageStarButton", () => $75a2d6647cc04503$export$369212709d95b58d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $3gadb = parcelRequire("3gadb");

var $inPa6 = parcelRequire("inPa6");

var $ljm2R = parcelRequire("ljm2R");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $clKWq = parcelRequire("clKWq");

var $cf6nm = parcelRequire("cf6nm");

var $77a1U = parcelRequire("77a1U");
const $75a2d6647cc04503$export$369212709d95b58d = ({ size: size, outlineAppearance: outlineAppearance, tooltipPosition: tooltipPosition, shortcut: shortcut, label: label, labelledBy: labelledBy, id: id, ...props })=>{
    const intl = (0, $dBxQj.default)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const spacing = size === 'small' ? 'compact' : 'default';
    const tooltipLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const tooltipContent = shortcut ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
        shortcut: shortcut,
        contentBefore: tooltipLabel,
        isTooltip: true
    }) : tooltipLabel;
    const buttonLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const handleClick = (0, $gwFzn.useCallback)((starHandler, triggeredByKeyboardShortcut)=>(e)=>{
            starHandler(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        action: props.isStarred ? 'unstar' : 'star'
                    },
                    source: 'PageStarButton'
                }
            }).fire();
        }, [
        createAnalyticsEvent,
        props.isStarred
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $77a1U.PageStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: tooltipPosition || 'top',
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $clKWq.ConditionalHiddenAction), {
            isHidden: !props.isStarred
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $clKWq.ConditionalSubtleHoverButton), {
            id: id,
            isSubtle: outlineAppearance === 'subtle',
            "data-id": props.isStarred ? 'page-unstar-button' : 'page-star-button',
            testId: props.isStarred ? 'page-unstar-button' : 'page-star-button',
            spacing: spacing,
            appearance: "subtle",
            onClick: handleClick(toggleStar, false),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            "aria-label": buttonLabel,
            "aria-labelledby": labelledBy,
            "aria-pressed": props.isStarred,
            isDisabled: props.isDisabled
        }))), shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
            deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.STAR_BUTTON_SHORTCUT) : undefined,
            accelerator: (0, $ljm2R.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleClick(toggleStar, true)
        })));
};
const $75a2d6647cc04503$var$i18n = (0, $2nPZH.defineMessages)({
    starContent: {
        id: "action-buttons.content.starContent.label",
        defaultMessage: "Star this content"
    },
    unstarContent: {
        id: "action-buttons.content.unstarContent.label",
        defaultMessage: "Unstar this content"
    }
});

});
parcelRegister("clKWq", function(module, exports) {

$parcel$export(module.exports, "FilledIconButton", () => $c778e820ae925f4a$export$51d63fc44de8b04c);
$parcel$export(module.exports, "UnfilledIconButton", () => $c778e820ae925f4a$export$d4589334c0881f2b);
$parcel$export(module.exports, "HoverButton", () => $c778e820ae925f4a$export$7099540c149f2cd6);
$parcel$export(module.exports, "HiddenAction", () => $c778e820ae925f4a$export$4fba02bb1c3a731d);
$parcel$export(module.exports, "ConditionalHiddenAction", () => $c778e820ae925f4a$export$e74173003a1ed83f);
$parcel$export(module.exports, "ConditionalSubtleHoverButton", () => $c778e820ae925f4a$export$bba53dc78bc0e0ef);
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $eEA8O = parcelRequire("eEA8O");
const $c778e820ae925f4a$var$buttonStyle = null;
const $c778e820ae925f4a$export$51d63fc44de8b04c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itglyw _2rko1l7b _11q71w7a _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _19lc166n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$d4589334c0881f2b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itglyw _2rko1l7b _11q71w7a _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _syaz173l _19lc166n _1fh1wdcn",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$7099540c149f2cd6 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1t4p1dad _ll8pwdcn",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$4fba02bb1c3a731d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_bgrb1eg2 _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$5df393b96cc674b9 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itglyw _2rko1l7b _11q71w7a _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _bgrb1eg2 _yfoxkb7n _19lc166n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$e74173003a1ed83f = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dgtmw9": (0, $iAWao.default)(__cmplp.isHidden ? 'var(--show-action)' : '1')
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_bgrb1dxe _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$bba53dc78bc0e0ef = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            __cmplp.isSubtle && "_1s9r1dad _ewrdwdcn",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9KHdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7199ee42b1f8996e$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $7199ee42b1f8996e$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6Z3KL.default)(2, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var dateToCompare = (0, $4YLNd.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("6ld6a", function(module, exports) {

$parcel$export(module.exports, "useWebItemLocation", () => $f64809aa9d8f3ca2$export$13a30d244c53e90d);

var $diswb = parcelRequire("diswb");

var $jV49M = parcelRequire("jV49M");

var $jIQq0 = parcelRequire("jIQq0");

var $fjiOd = parcelRequire("fjiOd");

var $62BfR = parcelRequire("62BfR");
const $f64809aa9d8f3ca2$export$13a30d244c53e90d = ({ location: location, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, fetchPolicy: fetchPolicy = 'cache-and-network', allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fjiOd.WebItemLocationQuery), {
        fetchPolicy: fetchPolicy,
        variables: {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        skip: skipQuery
    });
    if (!data) return {
        loading: loading,
        error: error,
        webItems: [],
        webSections: []
    };
    // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
    // with the atlToken in all section items
    const webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
        allowedWebItems: allowedWebItems,
        notAllowedWebItems: notAllowedWebItems
    });
    const webSections = (0, (/*@__PURE__*/$parcel$interopDefault($jIQq0)))(webItems.map((webItem)=>webItem.section));
    webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
    return {
        // Since the default fetchPolicy is cache-and-network
        // loading field will be true, false, true (background refetch), false
        // Query is refreshing when data not empty but loading is true
        // Padding loading false to avoid reverting back to the empty state or loading skeleton.
        // This aligns with confluence/next/packages/web-item-location/src/WebItemLocation.tsx
        loading: false,
        error: error,
        webItems: webItems,
        webSections: webSections
    };
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (item === null || item.completeKey === null) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};

});

parcelRegister("8zMP3", function(module, exports) {

$parcel$export(module.exports, "SuspenseWithDataFetcher", () => $5cfe2edd168ef31e$export$553ede96e278ba94);

var $gwFzn = parcelRequire("gwFzn");

var $eS4vC = parcelRequire("eS4vC");
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    if (window.__SSR_REACT_STREAMING__) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}

});

parcelRegister("5ozYM", function(module, exports) {

$parcel$export(module.exports, "DocumentSpaceTitle", () => $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $5hAil = parcelRequire("5hAil");

var $dIouf = parcelRequire("dIouf");

var $cEgMD = parcelRequire("cEgMD");

var $d5RCH = parcelRequire("d5RCH");

var $1ytiN = parcelRequire("1ytiN");

var $3zetf = parcelRequire("3zetf");
const $080ccb5c9f312cd0$var$i18n = (0, $2nPZH.defineMessages)({
    companyHubDefaultTitle: {
        id: "document-title.document-space-title.company-hub.title",
        defaultMessage: "Company hub"
    }
});
function $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17({ spaceKey: spaceKey, titlePrefix: titlePrefix }) {
    const { siteTitle: siteTitle, companyHubName: companyHubName } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    //In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__']) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).INHERIT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5hAil.QueryGroup), {
        queryProps: (0, $3zetf.getSpaceNameQueryProps)(spaceKey)
    }, ({ results: results, loading: loading })=>{
        if (loading) return null;
        const companyHubSpaceName = companyHubName || formatMessage($080ccb5c9f312cd0$var$i18n.companyHubDefaultTitle);
        const spaceName = isCompanyHub ? companyHubSpaceName : (0, $3zetf.getSpaceNameFromResults)(results);
        const title = [
            titlePrefix,
            spaceName,
            siteTitle
        ].filter((part)=>part).join(' - ');
        // set for SSR document title
        window.__DOCUMENT_TITLE_TAG__ = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d5RCH.PageTitle), {
            title: title
        });
    }));
}

});

parcelRegister("47oMq", function(module, exports) {

$parcel$export(module.exports, "SPACE_ANALYTICS_SCREEN_ANALYTICS_SOURCE", () => $0b6eea8d15b259ac$export$b2108000ddb1b8ac);
$parcel$export(module.exports, "SPACE_ANALYTICS_SCREEN_ANALYTICS_LEVEL", () => $0b6eea8d15b259ac$export$a53f7de0051b8c9a);
$parcel$export(module.exports, "SPACE_ANALYTICS_POPULAR_CONTENT_CARD_ACTION_KEY", () => $0b6eea8d15b259ac$export$eaa06cc5d15faf13);
$parcel$export(module.exports, "SPACE_ANALYTICS_ACTIVE_CONTRIBUTION_CARD_ACTION_KEY", () => $0b6eea8d15b259ac$export$c8f7d794c38dc11c);
$parcel$export(module.exports, "SPACE_ANALYTICS_ACTIVE_READERS_CARD_ACTION_KEY", () => $0b6eea8d15b259ac$export$26507f2286cc9ef9);
$parcel$export(module.exports, "SPACE_ANALYTICS_TABS_UI_ID", () => $0b6eea8d15b259ac$export$4e15b97c10866035);
$parcel$export(module.exports, "SpaceAnalyticsTab", () => $0b6eea8d15b259ac$export$b904736ca947a1e7);
$parcel$export(module.exports, "OVERVIEW_CHART_TEST_ID", () => $0b6eea8d15b259ac$export$71a916b05c2345e8);
$parcel$export(module.exports, "POPULAR_CONTENT_CARD_TEST_ID", () => $0b6eea8d15b259ac$export$a69c9d799673f806);
$parcel$export(module.exports, "MOST_ACTIVE_READERS_CARD_TEST_ID", () => $0b6eea8d15b259ac$export$4daaaf7ccc6ce432);
$parcel$export(module.exports, "MOST_ACTIVE_CONTRIBUTORS_CARD_TEST_ID", () => $0b6eea8d15b259ac$export$dcdf37d380261ea4);
$parcel$export(module.exports, "CONTENT_TABLE_TEST_ID", () => $0b6eea8d15b259ac$export$67b08a6e5ecb3f48);
$parcel$export(module.exports, "USER_TABLE_TEST_ID", () => $0b6eea8d15b259ac$export$a7b9d6d50ba9a286);
$parcel$export(module.exports, "SpaceAnalyticsSubExperiences", () => $0b6eea8d15b259ac$export$808f9f53c37afc38);
$parcel$export(module.exports, "POLL_INTERVAL_MS", () => $0b6eea8d15b259ac$export$ee14340141c11674);

var $irVI7 = parcelRequire("irVI7");
const $0b6eea8d15b259ac$export$b2108000ddb1b8ac = 'analyticsPageScreen';
const $0b6eea8d15b259ac$export$a53f7de0051b8c9a = 'space';
const $0b6eea8d15b259ac$export$eaa06cc5d15faf13 = 'popularContent';
const $0b6eea8d15b259ac$export$c8f7d794c38dc11c = 'mostActiveContributors';
const $0b6eea8d15b259ac$export$26507f2286cc9ef9 = 'activeReaders';
const $0b6eea8d15b259ac$export$4e15b97c10866035 = 'space-analytics-tabs';
var $0b6eea8d15b259ac$export$b904736ca947a1e7 = /*#__PURE__*/ function(SpaceAnalyticsTab) {
    SpaceAnalyticsTab[SpaceAnalyticsTab["Overview"] = 0] = "Overview";
    SpaceAnalyticsTab[SpaceAnalyticsTab["Content"] = 1] = "Content";
    SpaceAnalyticsTab[SpaceAnalyticsTab["Users"] = 2] = "Users";
    return SpaceAnalyticsTab;
}({});
const $0b6eea8d15b259ac$export$569010ea5f619c6d = 'Anonymous';
const $0b6eea8d15b259ac$export$71a916b05c2345e8 = 'space-analytics-overview-chart';
const $0b6eea8d15b259ac$export$a69c9d799673f806 = 'space-analytics-popular-content-card';
const $0b6eea8d15b259ac$export$4daaaf7ccc6ce432 = 'space-analytics-active-readers-card';
const $0b6eea8d15b259ac$export$dcdf37d380261ea4 = 'space-analytics-active-contributors-card';
const $0b6eea8d15b259ac$export$67b08a6e5ecb3f48 = 'space-analytics-content-table';
const $0b6eea8d15b259ac$export$a7b9d6d50ba9a286 = 'space-analytics-user-table';
const $0b6eea8d15b259ac$export$808f9f53c37afc38 = {
    [0]: [
        (0, $irVI7.SPACE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE),
        (0, $irVI7.SPACE_ANALYTICS_POPULAR_CONTENT_CARD_EXPERIENCE),
        (0, $irVI7.SPACE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE),
        (0, $irVI7.SPACE_ANALYTICS_ACTIVE_CONTRIBUTORS_CARD_EXPERIENCE)
    ],
    [1]: [
        (0, $irVI7.SPACE_ANALYTICS_CONTENT_ACTIVITY_TABLE_EXPERIENCE)
    ],
    [2]: [
        (0, $irVI7.SPACE_ANALYTICS_USER_ACTIVITY_TABLE_EXPERIENCE)
    ]
};
const $0b6eea8d15b259ac$export$ee14340141c11674 = 1000;

});

parcelRegister("6MasF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eef5729992b06bb$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $4eef5729992b06bb$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $6Z3KL.default)(2, arguments);
    var dateLeft = (0, $4YLNd.default)(dirtyLeftDate);
    var dateRight = (0, $4YLNd.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("83xKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd8c913ffd92d34$export$2e2bcd8739ae039);

var $4eQbn = parcelRequire("4eQbn");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $5dd8c913ffd92d34$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $6Z3KL.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $4eQbn.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $4YLNd.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("3sMdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0affb4f68c8513c7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $3scmi = parcelRequire("3scmi");

var $56M4r = parcelRequire("56M4r");

var $hmRr5 = parcelRequire("hmRr5");

var $4cUZH = parcelRequire("4cUZH");

var $dhBFe = parcelRequire("dhBFe");

var $2xX3M = parcelRequire("2xX3M");

var $3mTvL = parcelRequire("3mTvL");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $0affb4f68c8513c7$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $3mTvL;
    const [selected, setSelected] = (0, $4cUZH.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $gwFzn.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3scmi.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $56M4r.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hmRr5.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: (0, $2xX3M.default)() ? 'radio' : 'menuitemradio',
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            // Thanks to spread props, this attribute are passed to ButtonItem, even though
            // it's not in the component's prop types.
            // @ts-expect-error
            title: title,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $0affb4f68c8513c7$export$2e2bcd8739ae039 = $0affb4f68c8513c7$var$DropdownItemRadio;

});
parcelRegister("hmRr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $01850bf21ecc815c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $01850bf21ecc815c$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6Fdl.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $6fnsQ.B400})` : `var(--ds-background-input, ${0, $6fnsQ.N10})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $6fnsQ.N10})` : 'transparent',
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7.5",
                        fill: "currentColor",
                        stroke: checked ? `var(--ds-border-selected, ${0, $6fnsQ.B400})` : `var(--ds-border-input, ${0, $6fnsQ.N100})`,
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                        fill: "currentColor",
                        cx: "12",
                        cy: "12",
                        r: "6",
                        stroke: checked ? `var(--ds-border-selected, ${0, $6fnsQ.B400})` : `var(--ds-border-input, ${0, $6fnsQ.N100})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                        fill: "inherit",
                        cx: "12",
                        cy: "12",
                        r: "2"
                    })
                ]
            })
        })
    });
};
var $01850bf21ecc815c$export$2e2bcd8739ae039 = $01850bf21ecc815c$var$RadioIcon;

});

parcelRegister("4cUZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1119aafb00a8a88b$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $al7hi = parcelRequire("al7hi");

var $nVQ0B = parcelRequire("nVQ0B");

var $6VVpF = parcelRequire("6VVpF");
function $1119aafb00a8a88b$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $gwFzn.useContext)((0, $nVQ0B.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $gwFzn.useContext)((0, $al7hi.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $gwFzn.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $gwFzn.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $gwFzn.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
	 * Set the initial state of the context provider's store,
	 * if it doesn't already have a persisted value for this id.
	 */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = (0, $dh538.fg)('platform_dst_dropdown_radio_default_selected_fix') ? {
            ...existing,
            [id]: defaultSelected || false
        } : {
            ...(0, $6VVpF.default)(existing || {}),
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $1119aafb00a8a88b$export$2e2bcd8739ae039 = $1119aafb00a8a88b$var$useRadioState;

});
parcelRegister("al7hi", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $e4983ebd720c0bde$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $e4983ebd720c0bde$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");

var $c0qxy = parcelRequire("c0qxy");

var $7rvPL = parcelRequire("7rvPL");

var $2UQGL = parcelRequire("2UQGL");

var $nVQ0B = parcelRequire("nVQ0B");

var $6VVpF = parcelRequire("6VVpF");
const $e4983ebd720c0bde$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $ee7An.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $e4983ebd720c0bde$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $gwFzn.useContext)((0, $nVQ0B.SelectionStoreContext));
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $gwFzn.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $6VVpF.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)($e4983ebd720c0bde$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $e4983ebd720c0bde$export$2e2bcd8739ae039 = $e4983ebd720c0bde$var$DropdownItemRadioGroup;

});
parcelRegister("6VVpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $109bffbad6ce930e$export$2e2bcd8739ae039);
const $109bffbad6ce930e$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $109bffbad6ce930e$export$2e2bcd8739ae039 = $109bffbad6ce930e$var$resetOptionsInGroup;

});



parcelRegister("2xX3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $9622b29e24d39b42$export$2e2bcd8739ae039);
const $9622b29e24d39b42$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ const $9622b29e24d39b42$var$isVoiceOverSupported = ()=>/Mac OS X/.test($9622b29e24d39b42$var$canUseDOM() ? navigator.userAgent : '');
var $9622b29e24d39b42$export$2e2bcd8739ae039 = $9622b29e24d39b42$var$isVoiceOverSupported;

});


parcelRegister("5LtQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $43287cb8b6fb7c3d$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $43287cb8b6fb7c3d$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $6Z3KL.default)(2, arguments);
    var time = (0, $4YLNd.default)(dirtyDate).getTime();
    var startTime = (0, $4YLNd.default)(interval.start).getTime();
    var endTime = (0, $4YLNd.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("jrqRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e275611d5fc28149$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $e275611d5fc28149$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6Z3KL.default)(1, arguments);
    return (0, $4YLNd.default)(dirtyDate).getTime() > Date.now();
}

});

parcelRegister("lxyQ2", function(module, exports) {

$parcel$export(module.exports, "SITE_ANALYTICS_SCREEN_ANALYTICS_SOURCE", () => $829fd8e029366927$export$8f5092a35000d0fd);
$parcel$export(module.exports, "SITE_ANALYTICS_SEARCH_ANALYTICS_SOURCE", () => $829fd8e029366927$export$7d4a741bc8a8e084);
$parcel$export(module.exports, "SITE_ANALYTICS_SCREEN_ANALYTICS_LEVEL", () => $829fd8e029366927$export$718591836cad1ed8);
$parcel$export(module.exports, "SITE_ANALYTICS_TABS_UI_ID", () => $829fd8e029366927$export$35932a8133da6919);
$parcel$export(module.exports, "SiteAnalyticsTab", () => $829fd8e029366927$export$b37a6ebf0f3a7689);
$parcel$export(module.exports, "MOST_ACTIVE_READERS_CARD_TEST_ID", () => $829fd8e029366927$export$4daaaf7ccc6ce432);
$parcel$export(module.exports, "OVERVIEW_CHART_TEST_ID", () => $829fd8e029366927$export$71a916b05c2345e8);
$parcel$export(module.exports, "POPULAR_SEARCHES_CARD_TEST_ID", () => $829fd8e029366927$export$b73f2210e9d2eef2);
$parcel$export(module.exports, "POPULAR_SPACES_CARD_TEST_ID", () => $829fd8e029366927$export$2e2f0952f7f9fd73);
$parcel$export(module.exports, "SEARCH_PANEL_CTR_CARD_TEST_ID", () => $829fd8e029366927$export$ba6665eb2c047b16);
$parcel$export(module.exports, "SEARCH_PANEL_MOST_CLICKED_CONTENT_CARD_TEST_ID", () => $829fd8e029366927$export$93679d1eeb6e3798);
$parcel$export(module.exports, "SEARCH_PANEL_MOST_CLICKED_SPACES_CARD_TEST_ID", () => $829fd8e029366927$export$21716d3d57c7a6c8);
$parcel$export(module.exports, "SEARCH_PANEL_SEARCHES_CARD_TEST_ID", () => $829fd8e029366927$export$b411c56a03d140f8);
$parcel$export(module.exports, "SEARCH_PANEL_TEST_ID", () => $829fd8e029366927$export$40cd470a4aa2f106);
$parcel$export(module.exports, "SEARCH_TABLE_TEST_ID", () => $829fd8e029366927$export$1f830a2c5ce62517);
$parcel$export(module.exports, "SPACES_TABLE_TEST_ID", () => $829fd8e029366927$export$5119e0141b046a7b);
$parcel$export(module.exports, "USER_TABLE_TEST_ID", () => $829fd8e029366927$export$a7b9d6d50ba9a286);
$parcel$export(module.exports, "SiteAnalyticsSubExperiences", () => $829fd8e029366927$export$e4b0600052c25d67);
$parcel$export(module.exports, "SearchPanelSubExperiences", () => $829fd8e029366927$export$ed5650d37f0ec06d);

var $irVI7 = parcelRequire("irVI7");
const $829fd8e029366927$export$8f5092a35000d0fd = 'analyticsPageScreen';
const $829fd8e029366927$export$7d4a741bc8a8e084 = 'analyticsSearchScreen';
const $829fd8e029366927$export$718591836cad1ed8 = 'instance';
const $829fd8e029366927$export$35932a8133da6919 = 'site-analytics-tabs';
var $829fd8e029366927$export$b37a6ebf0f3a7689 = /*#__PURE__*/ function(SiteAnalyticsTab) {
    SiteAnalyticsTab[SiteAnalyticsTab["Overview"] = 0] = "Overview";
    SiteAnalyticsTab[SiteAnalyticsTab["Spaces"] = 1] = "Spaces";
    SiteAnalyticsTab[SiteAnalyticsTab["Users"] = 2] = "Users";
    SiteAnalyticsTab[SiteAnalyticsTab["Search"] = 3] = "Search";
    return SiteAnalyticsTab;
}({});
const $829fd8e029366927$export$4daaaf7ccc6ce432 = 'site-analytics-active-readers-card';
const $829fd8e029366927$export$71a916b05c2345e8 = 'site-analytics-overview-chart';
const $829fd8e029366927$export$b73f2210e9d2eef2 = 'site-analytics-popular-searches-card';
const $829fd8e029366927$export$2e2f0952f7f9fd73 = 'site-analytics-popular-spaces-card';
const $829fd8e029366927$export$ba6665eb2c047b16 = 'site-analytics-search-panel-ctr-card';
const $829fd8e029366927$export$93679d1eeb6e3798 = 'site-analytics-search-panel-most-clicked-content-card';
const $829fd8e029366927$export$21716d3d57c7a6c8 = 'site-analytics-search-panel-most-clicked-spaces-card';
const $829fd8e029366927$export$b411c56a03d140f8 = 'site-analytics-search-panel-searches-card';
const $829fd8e029366927$export$40cd470a4aa2f106 = 'site-analytics-search-panel';
const $829fd8e029366927$export$1f830a2c5ce62517 = 'site-analytics-search-table';
const $829fd8e029366927$export$5119e0141b046a7b = 'site-analytics-spaces-table';
const $829fd8e029366927$export$a7b9d6d50ba9a286 = 'site-analytics-user-table';
const $829fd8e029366927$export$e4b0600052c25d67 = {
    [0]: [
        (0, $irVI7.SITE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE),
        (0, $irVI7.SITE_ANALYTICS_POPULAR_SPACES_CARD_EXPERIENCE),
        (0, $irVI7.SITE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE),
        (0, $irVI7.SITE_ANALYTICS_POPULAR_SEARCHES_CARD_EXPERIENCE)
    ],
    [1]: [
        (0, $irVI7.SITE_ANALYTICS_SPACES_TABLE_EXPERIENCE)
    ],
    [2]: [
        (0, $irVI7.SITE_ANALYTICS_USERS_TABLE_EXPERIENCE)
    ],
    [3]: [
        (0, $irVI7.SITE_ANALYTICS_SEARCH_TABLE_EXPERIENCE)
    ]
};
const $829fd8e029366927$export$ed5650d37f0ec06d = [
    (0, $irVI7.SITE_ANALYTICS_SEARCH_PANEL_GRAPH_EXPERIENCE),
    (0, $irVI7.SITE_ANALYTICS_SEARCH_PANEL_CONTENT_LIST_EXPERIENCE),
    (0, $irVI7.SITE_ANALYTICS_SEARCH_PANEL_SPACES_LIST_EXPERIENCE)
];

});

parcelRegister("7LBmH", function(module, exports) {

$parcel$export(module.exports, "showChangeboardingSpotlight", () => $5a79e81cb9c10517$export$eddeff633c83e707);
$parcel$export(module.exports, "setChangeboardingTargetReady", () => $5a79e81cb9c10517$export$325fbed683e9dd6e);
$parcel$export(module.exports, "dismissChangeboarding", () => $5a79e81cb9c10517$export$74e1a9caf8929c3a);
$parcel$export(module.exports, "getNextChangeboardingSpotlight", () => $5a79e81cb9c10517$export$4d9c7647cd4e0350);
$parcel$export(module.exports, "getPrevChangeboardingSpotlight", () => $5a79e81cb9c10517$export$a9dcdff0118b3c6a);

var $5cBWV = parcelRequire("5cBWV");
const $5a79e81cb9c10517$export$eddeff633c83e707 = (0, $5cBWV.commonActionCreator)('CHANGEBOARDING_INVOKE');
const $5a79e81cb9c10517$export$325fbed683e9dd6e = (0, $5cBWV.commonActionCreator)('CHANGEBOARDING_TARGET_READY');
const $5a79e81cb9c10517$export$74e1a9caf8929c3a = (0, $5cBWV.commonActionCreator)('CHANGEBOARDING_DISMISS');
const $5a79e81cb9c10517$export$4d9c7647cd4e0350 = (0, $5cBWV.commonActionCreator)('CHANGEBOARDING_NEXT');
const $5a79e81cb9c10517$export$a9dcdff0118b3c6a = (0, $5cBWV.commonActionCreator)('CHANGEBOARDING_PREV');
const $5a79e81cb9c10517$export$73b00ac61369f022 = (0, $5cBWV.commonActionCreator)('CHANGEBOARDING_SET_SPOTLIGHT_ATTRIBUTES');

});

parcelRegister("hSrtZ", function(module, exports) {

$parcel$export(module.exports, "useWithUserType", () => $6167c0a57aca8c76$export$13f2301b4347c3b4);

var $gwFzn = parcelRequire("gwFzn");

var $gXrHX = parcelRequire("gXrHX");
const $6167c0a57aca8c76$export$13f2301b4347c3b4 = ()=>{
    const { userType: userType } = (0, $gwFzn.useContext)((0, $gXrHX.ExternalShareContext));
    return {
        userType: userType
    };
};

});

parcelRegister("ikHMQ", function(module, exports) {

$parcel$export(module.exports, "getRedirectLink", () => $8c2b29a8946b9313$export$ca7f8b3f442d6426);
$parcel$export(module.exports, "getJoinLink", () => $8c2b29a8946b9313$export$3112defea7bd69aa);
$parcel$export(module.exports, "getWacDomain", () => $8c2b29a8946b9313$export$c6fc9a05082a2f3b);

var $jEeDd = parcelRequire("jEeDd");

var $1NBp8 = parcelRequire("1NBp8");

var $2NTzE = parcelRequire("2NTzE");
function $8c2b29a8946b9313$var$toViewContentURL(contentId, spaceKey, contentType) {
    if (contentType === 'whiteboard') return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        contentId: contentId,
        spaceKey: spaceKey
    });
    else {
        // contentType === "page" as default
        if (spaceKey) return (0, $1NBp8.VIEW_PAGE).toUrl({
            contentId: contentId,
            spaceKey: spaceKey
        });
        else return (0, $1NBp8.VIEW_PAGE_ACTION_LEGACY).toUrl({}, {
            query: {
                pageId: contentId
            }
        });
    }
}
const $8c2b29a8946b9313$export$ca7f8b3f442d6426 = (contentId, spaceKey, contentType)=>$8c2b29a8946b9313$var$toViewContentURL(contentId, spaceKey, contentType);
const $8c2b29a8946b9313$export$3112defea7bd69aa = (contentId, cloudId, spaceKey, contentType)=>$8c2b29a8946b9313$var$getRequestAccessLink($8c2b29a8946b9313$var$toViewContentURL(contentId, spaceKey, contentType), cloudId);
const $8c2b29a8946b9313$var$getRequestAccessLink = (requestAccessContinueUrl, cloudId)=>(0, $jEeDd.getLoginLink)((identity)=>`https://${identity}/join/user-access?resource=ari:cloud:confluence::site/${cloudId}&continue=${requestAccessContinueUrl}`);
const $8c2b29a8946b9313$export$c6fc9a05082a2f3b = (environment)=>{
    return environment === 'PRODUCTION' ? (0, $2NTzE.PRODUCTION_WAC_DOMAIN) : (0, $2NTzE.STAGING_WAC_DOMAIN);
};

});
parcelRegister("2NTzE", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $e1865188b7911064$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "LEARN_MORE_URL", () => $e1865188b7911064$export$af6d68522cb370b8);
$parcel$export(module.exports, "TRY_CONFLUENCE_ROUTE", () => $e1865188b7911064$export$e4a5416c4daa6dc2);
$parcel$export(module.exports, "PRODUCTION_WAC_DOMAIN", () => $e1865188b7911064$export$a8ccf616fee64f42);
$parcel$export(module.exports, "STAGING_WAC_DOMAIN", () => $e1865188b7911064$export$bf2725be8ae1cb90);
/* eslint-disable check-file/filename-blocklist */ const $e1865188b7911064$export$f7109619a5e9e0d6 = 'externalSharePageScreen';
const $e1865188b7911064$export$af6d68522cb370b8 = `https://www.atlassian.com/software/confluence?utm_source=in-product-banner&utm_medium=in-product&utm_campaign=P:confluence|O:confluence-permissions|F:evaluation|C:signup|H:fy23q2|I:public-links|E:cloud|`;
const $e1865188b7911064$export$e4a5416c4daa6dc2 = `/try/cloud/signup?bundle=confluence&edition=free&utm_source=in-product-banner&utm_medium=in-product&utm_campaign=P:confluence|O:confluence-permissions|F:evaluation|C:signup|H:fy23q2|I:public-links|E:cloud|`;
const $e1865188b7911064$export$a8ccf616fee64f42 = 'https://www.atlassian.com';
const $e1865188b7911064$export$bf2725be8ae1cb90 = 'https://wac.stg.internal.atlassian.com';

});


parcelRegister("d3Q0p", function(module, exports) {

$parcel$export(module.exports, "getSpaceByKey", () => $9823e560bfabdad0$export$749364fb998943fd);
$parcel$export(module.exports, "markFeatureDiscovered", () => $9823e560bfabdad0$export$4051c10a0875396c);
$parcel$export(module.exports, "getEditorContentMetadata", () => $9823e560bfabdad0$export$93649e21139a1a8c);

var $fY9o0 = parcelRequire("fY9o0");

var $dBMlu = parcelRequire("dBMlu");
var $5cBWV = parcelRequire("5cBWV");
const $9823e560bfabdad0$export$749364fb998943fd = (0, $5cBWV.restActionCreator)('SPACE_INFO', (0, $fY9o0.space), {
    schema: (0, $dBMlu.spaces)
});
const $9823e560bfabdad0$export$4051c10a0875396c = (0, $5cBWV.restActionCreator)('FEATURE_DISCOVERED_MARK', (0, $fY9o0.markDiscovered));
const $9823e560bfabdad0$export$93649e21139a1a8c = (0, $5cBWV.restActionCreator)('EDITOR_CONTENT_METADATA', (0, $fY9o0.editPageMetadata), {
    schema: (0, $dBMlu.content)
});

});

parcelRegister("iwGvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7cc3138c9f76cf4$export$2e2bcd8739ae039);
/**
 * Create an editor code split to optimize bundle size.
 *
 * @param cb
 */ 
const $d7cc3138c9f76cf4$var$LazyEditor = (cb)=>{
    // This MUST NOT be ./Editor - it would bypass the package.json->container.js, therefore stripping the component of the container.
    (parcelRequire("vuzyR")).then((Editor)=>cb(Editor.default));
};
var $d7cc3138c9f76cf4$export$2e2bcd8739ae039 = $d7cc3138c9f76cf4$var$LazyEditor;

});
parcelRegister("vuzyR", function(module, exports) {

let $05ea9c70b70b9b5c$var$load = (parcelRequire("lhnSv"))(5);






module.exports = Promise.all([
    $05ea9c70b70b9b5c$var$load("iAaum"),
    $05ea9c70b70b9b5c$var$load("1ISAt"),
    $05ea9c70b70b9b5c$var$load("mKoWX"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("eFHnz"), 5)),
    $05ea9c70b70b9b5c$var$load("b5BOL"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("5P6wM"), 5)),
    $05ea9c70b70b9b5c$var$load("8MJT8"),
    $05ea9c70b70b9b5c$var$load("k1w8t"),
    $05ea9c70b70b9b5c$var$load("35VQy"),
    $05ea9c70b70b9b5c$var$load("65NsZ"),
    $05ea9c70b70b9b5c$var$load("h3oGa"),
    $05ea9c70b70b9b5c$var$load("aZinD"),
    $05ea9c70b70b9b5c$var$load("hIYCb"),
    $05ea9c70b70b9b5c$var$load("fNL1b"),
    $05ea9c70b70b9b5c$var$load("6vzdH"),
    $05ea9c70b70b9b5c$var$load("cLdVP")
]).then(()=>parcelRequire('8D8HM'));

});
parcelRegister("di5rn", function(module, exports) {
"use strict";

var $jDpSy = parcelRequire("jDpSy");
module.exports = $jDpSy(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jDpSy", function(module, exports) {
"use strict";
let $e4b5bbdb98dce921$var$cachedBundles = {};
let $e4b5bbdb98dce921$var$cachedPreloads = {};
let $e4b5bbdb98dce921$var$cachedPrefetches = {};
function $e4b5bbdb98dce921$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e4b5bbdb98dce921$var$cachedPreloads;
        case 'prefetch':
            return $e4b5bbdb98dce921$var$cachedPrefetches;
        default:
            return $e4b5bbdb98dce921$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $e4b5bbdb98dce921$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("avhSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5aa9cf4b0c7420$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");

var $7a5aa9cf4b0c7420$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YdjJc",
    name: "packages.confluence-classic-shared-components.src.EditorTeamCreatedFlag.EditorTeamCreatedFlagLoader",
    loader: ()=>(parcelRequire("evXoe"))
});

});
parcelRegister("evXoe", function(module, exports) {

let $a912078233c0a74d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a912078233c0a74d$var$load("i5s5V").then(()=>parcelRequire('2AfkR'));

});


parcelRegister("bZSBk", function(module, exports) {

$parcel$export(module.exports, "extract", () => $8bbfbedbd033001e$export$f9380c9a627682d3, (v) => $8bbfbedbd033001e$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $8bbfbedbd033001e$export$98e6a39c04603d36, (v) => $8bbfbedbd033001e$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $8bbfbedbd033001e$export$fac44ee5b035f737, (v) => $8bbfbedbd033001e$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $8bbfbedbd033001e$export$7a5253c0f62e0150, (v) => $8bbfbedbd033001e$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $8bbfbedbd033001e$export$a8c1621ea79325d3, (v) => $8bbfbedbd033001e$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $8bbfbedbd033001e$export$357523c63a2253b9, (v) => $8bbfbedbd033001e$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $8bbfbedbd033001e$export$44c361b8ec72ef7f, (v) => $8bbfbedbd033001e$export$44c361b8ec72ef7f = v);
var $8bbfbedbd033001e$export$f9380c9a627682d3;
var $8bbfbedbd033001e$export$98e6a39c04603d36;
var $8bbfbedbd033001e$export$fac44ee5b035f737;
var $8bbfbedbd033001e$export$7a5253c0f62e0150;
var $8bbfbedbd033001e$export$a8c1621ea79325d3;
var $8bbfbedbd033001e$export$357523c63a2253b9;
var $8bbfbedbd033001e$export$44c361b8ec72ef7f;
'use strict';

var $9CzV6 = parcelRequire("9CzV6");

var $gs5az = parcelRequire("gs5az");

var $fR0YA = parcelRequire("fR0YA");

var $4VWo6 = parcelRequire("4VWo6");
const $8bbfbedbd033001e$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $8bbfbedbd033001e$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8bbfbedbd033001e$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8bbfbedbd033001e$var$encode(key, options),
                            '[',
                            $8bbfbedbd033001e$var$encode(index, options),
                            ']=',
                            $8bbfbedbd033001e$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8bbfbedbd033001e$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8bbfbedbd033001e$var$encode(key, options),
                            '[]=',
                            $8bbfbedbd033001e$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $8bbfbedbd033001e$var$encode(key, options),
                            '=',
                            $8bbfbedbd033001e$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $8bbfbedbd033001e$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $8bbfbedbd033001e$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $8bbfbedbd033001e$var$encode(key, options),
                            '=',
                            $8bbfbedbd033001e$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $8bbfbedbd033001e$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $8bbfbedbd033001e$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $8bbfbedbd033001e$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$8bbfbedbd033001e$var$decode(item, options)) : value === null ? value : $8bbfbedbd033001e$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $8bbfbedbd033001e$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $8bbfbedbd033001e$var$encode(value, options) {
    if (options.encode) return options.strict ? $9CzV6(value) : encodeURIComponent(value);
    return value;
}
function $8bbfbedbd033001e$var$decode(value, options) {
    if (options.decode) return $gs5az(value);
    return value;
}
function $8bbfbedbd033001e$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $8bbfbedbd033001e$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $8bbfbedbd033001e$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $8bbfbedbd033001e$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $8bbfbedbd033001e$var$extract(input) {
    input = $8bbfbedbd033001e$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $8bbfbedbd033001e$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $8bbfbedbd033001e$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $8bbfbedbd033001e$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $8bbfbedbd033001e$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $fR0YA(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $8bbfbedbd033001e$var$decode(value, options);
        formatter($8bbfbedbd033001e$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $8bbfbedbd033001e$var$parseValue(value[k], options);
        else ret[key] = $8bbfbedbd033001e$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $8bbfbedbd033001e$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$8bbfbedbd033001e$export$f9380c9a627682d3 = $8bbfbedbd033001e$var$extract;
$8bbfbedbd033001e$export$98e6a39c04603d36 = $8bbfbedbd033001e$var$parse;
$8bbfbedbd033001e$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $8bbfbedbd033001e$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $8bbfbedbd033001e$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $8bbfbedbd033001e$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $8bbfbedbd033001e$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $8bbfbedbd033001e$var$encode(key, options) + '=' + $8bbfbedbd033001e$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$8bbfbedbd033001e$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $fR0YA(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $8bbfbedbd033001e$var$parse($8bbfbedbd033001e$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $8bbfbedbd033001e$var$decode(hash, options)
    } : {});
};
$8bbfbedbd033001e$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $8bbfbedbd033001e$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $8bbfbedbd033001e$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $8bbfbedbd033001e$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $8bbfbedbd033001e$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $8bbfbedbd033001e$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$8bbfbedbd033001e$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$8bbfbedbd033001e$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $8bbfbedbd033001e$export$7a5253c0f62e0150(input, options);
    return $8bbfbedbd033001e$export$a8c1621ea79325d3({
        url: url,
        query: $4VWo6(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$8bbfbedbd033001e$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $8bbfbedbd033001e$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("4NZXC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9875595fe1109f3e22750943d295221a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37fbcd1eaffadc0f$var$_react = $37fbcd1eaffadc0f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $37fbcd1eaffadc0f$var$_baseNew = $37fbcd1eaffadc0f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $37fbcd1eaffadc0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37fbcd1eaffadc0f$var$TasksIcon = (props)=>/*#__PURE__*/ $37fbcd1eaffadc0f$var$_react.default.createElement($37fbcd1eaffadc0f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm6.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L6 8.086z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$37fbcd1eaffadc0f$var$TasksIcon.displayName = 'TasksIcon';
var $37fbcd1eaffadc0f$var$_default = module.exports.default = $37fbcd1eaffadc0f$var$TasksIcon;

});

parcelRegister("fFc6D", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $1487a997836a60f3$export$49e55ae2c03d6045);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $bNwbD = parcelRequire("bNwbD");

var $bWLcG = parcelRequire("bWLcG");
const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $gwFzn.useRef)(listener);
    (0, $gwFzn.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $d8F95.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("bNwbD", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $95c4b21f9fd4bea1$export$e5c5a5f917a5871c);

var $gwFzn = parcelRequire("gwFzn");
const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect);

});


parcelRegister("1w55j", function(module, exports) {

$parcel$export(module.exports, "AppNavigationBaseLoader", () => $4091cc7c98ecb0e6$export$b28750cb7fe7eee);
$parcel$export(module.exports, "AppNavigationBase", () => $4091cc7c98ecb0e6$export$22d0a9aee43f07d7);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $7d2Nc = parcelRequire("7d2Nc");

var $8w1c1 = parcelRequire("8w1c1");

var $34WJV = parcelRequire("34WJV");

const $4091cc7c98ecb0e6$export$b28750cb7fe7eee = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pQYq4",
    name: "AppNavigationBaseLoader",
    loader: async ()=>(await (parcelRequire("jrQGB"))).AppNavigation,
    loading: (0, $34WJV.NavSkeleton)
});
const $4091cc7c98ecb0e6$var$AppNavigationBaseComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $8w1c1.APP_NAVIGATION_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4091cc7c98ecb0e6$export$b28750cb7fe7eee, props));
const $4091cc7c98ecb0e6$export$22d0a9aee43f07d7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo($4091cc7c98ecb0e6$var$AppNavigationBaseComponent);

});
parcelRegister("34WJV", function(module, exports) {

$parcel$export(module.exports, "NavSkeleton", () => $6036c1accea2b6a5$export$52352b3c9f328940);
/* NavSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $6036c1accea2b6a5$export$52352b3c9f328940 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bsb1osq _4t3i8vuz _bfhkn82g _16r2h3tw _aetrb3bt _18postnw _19doidpf _32rxidpf _15l21osq _1qdg1y44",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jrQGB", function(module, exports) {

let $e289685071544082$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e289685071544082$var$load("jqXtk"),
    $e289685071544082$var$load("6vzdH"),
    $e289685071544082$var$load("bEnB5"),
    $e289685071544082$var$load("9WWVF"),
    $e289685071544082$var$load("lfEn7"),
    $e289685071544082$var$load("2BIkk"),
    $e289685071544082$var$load("lJxwk"),
    $e289685071544082$var$load("hIYCb"),
    $e289685071544082$var$load("fNL1b"),
    $e289685071544082$var$load("cLErX"),
    $e289685071544082$var$load("hkGfe"),
    $e289685071544082$var$load("fKO1l"),
    $e289685071544082$var$load("hLeHa"),
    $e289685071544082$var$load("iOXIX"),
    $e289685071544082$var$load("frVov"),
    $e289685071544082$var$load("76oYl"),
    $e289685071544082$var$load("g1nDL"),
    $e289685071544082$var$load("lWnKf"),
    $e289685071544082$var$load("bdLqi"),
    $e289685071544082$var$load("gPhf6"),
    $e289685071544082$var$load("juVlo"),
    $e289685071544082$var$load("kmhnK"),
    $e289685071544082$var$load("deXSb"),
    $e289685071544082$var$load("bgLDW"),
    $e289685071544082$var$load("1epse"),
    $e289685071544082$var$load("gkMTK"),
    $e289685071544082$var$load("7lGj4"),
    $e289685071544082$var$load("c6MKV"),
    $e289685071544082$var$load("aZinD"),
    $e289685071544082$var$load("kjZZD"),
    $e289685071544082$var$load("zogKQ"),
    $e289685071544082$var$load("knC27"),
    $e289685071544082$var$load("6qah4"),
    $e289685071544082$var$load("iAaum"),
    $e289685071544082$var$load("ffEVr"),
    $e289685071544082$var$load("joJy8"),
    $e289685071544082$var$load("aHE9G"),
    $e289685071544082$var$load("1ISAt"),
    $e289685071544082$var$load("mKoWX"),
    $e289685071544082$var$load("7pZ0V"),
    $e289685071544082$var$load("jfTrX")
]).then(()=>parcelRequire('kA4n2'));

});


parcelRegister("cvtof", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityState", () => $6e62a89b3ae4c955$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $6e62a89b3ae4c955$export$f6b496b07d1ea493);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $6e62a89b3ae4c955$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $6e62a89b3ae4c955$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ee7An.default));

});

parcelRegister("9ZCby", function(module, exports) {

$parcel$export(module.exports, "NOTES_PANEL_ID", () => $da8db4b4b092aebd$export$6a60ddbd7f64aa47);
$parcel$export(module.exports, "NOTES_SIDEBAR_WIDTH", () => $da8db4b4b092aebd$export$a88ce0cc51c65c22);
const $da8db4b4b092aebd$export$6a60ddbd7f64aa47 = 'notes-sidebar';
const $da8db4b4b092aebd$export$a88ce0cc51c65c22 = 368; // same as HELP_PANEL_WIDTH

});

parcelRegister("2yFMK", function(module, exports) {

$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $ec6571ee54ae36da$export$30fa7cc5f2690a43);
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", () => $ec6571ee54ae36da$export$4033a111ca79977d);
$parcel$export(module.exports, "CREATE_BREAKPOINT", () => $ec6571ee54ae36da$export$24ec62cee78b7042);
const $ec6571ee54ae36da$export$30fa7cc5f2690a43 = 56;
const $ec6571ee54ae36da$export$4033a111ca79977d = 1280;
const $ec6571ee54ae36da$export$24ec62cee78b7042 = 1130;
const $ec6571ee54ae36da$export$d8bde68ac946124f = '--ds--ans--fbc';
const $ec6571ee54ae36da$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $ec6571ee54ae36da$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $ec6571ee54ae36da$export$d81606c1fc5119bc = '--ds--ans--c';
const $ec6571ee54ae36da$export$65f656ad520ea71 = '--ds--ans--bc';

});

parcelRegister("ahT8g", function(module, exports) {

$parcel$export(module.exports, "atlassianTheme", () => $245571a50d5c46d4$export$eeee8619e1b91cb0);
$parcel$export(module.exports, "defaultTheme", () => $245571a50d5c46d4$export$164de7ab8df77ef0);

var $6fnsQ = parcelRequire("6fnsQ");

var $lCH0w = parcelRequire("lCH0w");

var $jeF0t = parcelRequire("jeF0t");
const $245571a50d5c46d4$export$eeee8619e1b91cb0 = (0, $jeF0t.generateTheme)({
    name: (0, $lCH0w.DEFAULT_THEME_NAME),
    backgroundColor: (0, $6fnsQ.N0),
    highlightColor: (0, $6fnsQ.B400)
});
const $245571a50d5c46d4$export$164de7ab8df77ef0 = $245571a50d5c46d4$export$eeee8619e1b91cb0;

});
parcelRegister("lCH0w", function(module, exports) {

$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $08762123b36e773e$export$77823bc9863eaa03);
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $08762123b36e773e$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $08762123b36e773e$export$2e2bcd8739ae039);

var $6fnsQ = parcelRequire("6fnsQ");

var $3cLqS = parcelRequire("3cLqS");
const $08762123b36e773e$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B400), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $6fnsQ.B400)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B400), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $6fnsQ.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $6fnsQ.B400)})`,
            color: `var(--ds-text, ${(0, $6fnsQ.N700)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.N200), 0.3)})`}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: `var(--ds-text, ${(0, $6fnsQ.N700)})`
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $6fnsQ.B400)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $6fnsQ.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $3cLqS.hexToRGBA)((0, $6fnsQ.B50), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $6fnsQ.B400)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
                color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
                borderColor: `var(--ds-border-input, ${(0, $6fnsQ.N100)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $6fnsQ.B200)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $6fnsQ.N0)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $08762123b36e773e$var$defaultThemeCopy = JSON.parse(JSON.stringify($08762123b36e773e$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $08762123b36e773e$export$77823bc9863eaa03 = $08762123b36e773e$var$defaultThemeCopy;
const $08762123b36e773e$export$2491e13b198e597d = 'atlassian';
var $08762123b36e773e$export$2e2bcd8739ae039 = $08762123b36e773e$var$defaultTheme;

});
parcelRegister("3cLqS", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $6a9c68de2b00e336$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $6a9c68de2b00e336$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $6a9c68de2b00e336$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $6a9c68de2b00e336$export$77a1051494882576);

var $8yWYz = parcelRequire("8yWYz");
const $6a9c68de2b00e336$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $8yWYz.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $6a9c68de2b00e336$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $6a9c68de2b00e336$var$hex = '[a-z0-9]';
const $6a9c68de2b00e336$var$shortHandHexColorPattern = new RegExp(`#(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})`, 'i');
const $6a9c68de2b00e336$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $6a9c68de2b00e336$var$isShortHexColor = (color)=>color && color.length === 4;
const $6a9c68de2b00e336$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$6a9c68de2b00e336$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $6a9c68de2b00e336$var$completeTriplet = (colors)=>`#${$6a9c68de2b00e336$var$repeat(colors[1], 6)}`;
const $6a9c68de2b00e336$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $6a9c68de2b00e336$export$db8d2130677f868c = (color)=>{
    if ($6a9c68de2b00e336$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($6a9c68de2b00e336$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($6a9c68de2b00e336$var$isTriplet(colors)) return $6a9c68de2b00e336$var$completeTriplet(colors);
            else return $6a9c68de2b00e336$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $6a9c68de2b00e336$export$10a10e7cd1193377 = (color)=>{
    const converted = $6a9c68de2b00e336$export$db8d2130677f868c(color);
    return (0, $8yWYz.default).contrastRatio(converted).hex;
};
const $6a9c68de2b00e336$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$6a9c68de2b00e336$export$7229be6d7219ee6a((0, $8yWYz.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("jeF0t", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $1ebbdfb973eaad0e$export$2e4ecffaca289a18);

var $dh538 = parcelRequire("dh538");

var $lCH0w = parcelRequire("lCH0w");

var $3cLqS = parcelRequire("3cLqS");
const $1ebbdfb973eaad0e$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $1ebbdfb973eaad0e$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $1ebbdfb973eaad0e$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.65) : (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.8) : (0, $3cLqS.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        }
    };
};
const $1ebbdfb973eaad0e$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $3cLqS.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $1ebbdfb973eaad0e$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $3cLqS.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $lCH0w.DEFAULT_THEME_NAME)) return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? (0, $lCH0w.defaultThemeBrandRefresh) : (0, $lCH0w.default);
    return {
        mode: {
            create: $1ebbdfb973eaad0e$var$generateButtonCSSStates($1ebbdfb973eaad0e$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                textColor: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $3cLqS.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $3cLqS.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $3cLqS.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $3cLqS.getBoxShadow)((0, $3cLqS.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $3cLqS.getContrastColor)(0.1, $1ebbdfb973eaad0e$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});


parcelRegister("8K0Og", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $64b78fb356e75cc1$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $64b78fb356e75cc1$export$d8964aec282183a3);

var $gwFzn = parcelRequire("gwFzn");

var $ahT8g = parcelRequire("ahT8g");
const $64b78fb356e75cc1$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ahT8g.defaultTheme));
const $64b78fb356e75cc1$export$d8964aec282183a3 = $64b78fb356e75cc1$export$2c657da244d00bd6.Provider;

});

parcelRegister("4qrTW", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $14a2b16d436ce3a5$export$93d4e7f90805808f);

var $gwFzn = parcelRequire("gwFzn");

var $8K0Og = parcelRequire("8K0Og");
const $14a2b16d436ce3a5$export$93d4e7f90805808f = ()=>(0, $gwFzn.useContext)((0, $8K0Og.ThemeContext));

});

parcelRegister("1NxpI", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $d260874c410d6e1a$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $4KS7f = parcelRequire("4KS7f");

var $3gadb = parcelRequire("3gadb");

var $4qrTW = parcelRequire("4qrTW");

var $drbbL = parcelRequire("drbbL");
const $d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $d260874c410d6e1a$var$buttonBaseStyles = (0, $3jLHL.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
const $d260874c410d6e1a$var$buttonHighlightedStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $d260874c410d6e1a$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const themeFromContext = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        style: {
            [$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $d260874c410d6e1a$var$buttonBaseStyles,
            isHighlighted && $d260874c410d6e1a$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4KS7f.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $drbbL.getPrimaryButtonTheme)(themeFromContext),
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("drbbL", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $8b859f9800f72dd2$export$14dd6915caf431fe);
const $8b859f9800f72dd2$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("7O4kd", function(module, exports) {

$parcel$export(module.exports, "AbstractCompanyHubItem", () => $d3915af5fe8217ec$export$40e9528e11a75d6b);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $7aRa9 = parcelRequire("7aRa9");

var $1ytiN = parcelRequire("1ytiN");

var $7zgzO = parcelRequire("7zgzO");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $63PsI = parcelRequire("63PsI");

var $8NC5Z = parcelRequire("8NC5Z");

var $9wGTI = parcelRequire("9wGTI");

var $1NBp8 = parcelRequire("1NBp8");

var $1kHsc = parcelRequire("1kHsc");

var $eqNP8 = parcelRequire("eqNP8");

const $d3915af5fe8217ec$var$lazyOnClick = async (args)=>{
    const { companyHubItemCallback: companyHubItemCallback } = await (parcelRequire("f2I5O"));
    await companyHubItemCallback(args);
};
const $d3915af5fe8217ec$export$40e9528e11a75d6b = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, flags: flags, navVersion: navVersion })=>{
    const { frontCoverState: frontCoverState } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const { match: match, push: push } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const mayBeFirstTimeVisit = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET && !(0, $9wGTI.fg)('company-hub-pseudo-app');
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !mayBeFirstTimeVisit
    });
    // The link/namedRoute of this PrimaryItem not being ready means that the
    // space doesn't exist yet and is to be created first:
    const namedRoute = mayBeFirstTimeVisit && !shouldShowPremiumUpsell ? undefined : (0, $1NBp8.COMPANY_HUB);
    const routeName = match?.name;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const onClick = (0, $gwFzn.useCallback)(async ()=>{
        const isFirstTimeVisit = !namedRoute;
        const args = {
            createAnalyticsEvent: createAnalyticsEvent,
            experienceTracker: experienceTracker,
            flags: flags,
            isFirstTimeVisit: isFirstTimeVisit,
            push: push,
            routeName: routeName,
            navVersion: navVersion
        };
        if (isFirstTimeVisit) {
            // There's no route to navigate to, it needs to be created first. This
            // may take a noticeably long time so a loading state visible to the
            // user is necessary:
            setIsLoading(true);
            try {
                await $d3915af5fe8217ec$var$lazyOnClick(args);
            } catch  {
            // Not much can be done about a JS bundle failing to load even if the
            // failure were reported.
            } finally{
                setIsLoading(false);
            }
        } else // There's a route to navigate to already, what's left is processing not
        // visible to the user. So there's no need for a loading state visible
        // to the user here:
        $d3915af5fe8217ec$var$lazyOnClick(args);
    }, [
        createAnalyticsEvent,
        experienceTracker,
        flags,
        namedRoute,
        navVersion,
        push,
        routeName
    ]);
    const isSelected = routeName === (0, $1NBp8.COMPANY_HUB).name || routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && routeName !== (0, $1NBp8.COMPANY_HUB_ANALYTICS).name && routeName !== (0, $1NBp8.COMPANY_HUB_SETTINGS).name && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children({
        companyHubName: companyHubName,
        isSelected: isSelected,
        namedRoute: namedRoute,
        onClick: onClick
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null) : null);
}));

});
parcelRegister("f2I5O", function(module, exports) {

let $af393ece069647cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $af393ece069647cf$var$load("1ISAt"),
    $af393ece069647cf$var$load("mKoWX"),
    $af393ece069647cf$var$load("6vzdH"),
    $af393ece069647cf$var$load("aGsq7")
]).then(()=>parcelRequire('eXmLL'));

});


parcelRegister("epLE5", function(module, exports) {

$parcel$export(module.exports, "createLazyCallbackHook", () => $dfceb6b0f6d6cccb$export$729b27bc0f344ffe);

var $gwFzn = parcelRequire("gwFzn");
const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $gwFzn.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};

});

parcelRegister("9vJRo", function(module, exports) {

$parcel$export(module.exports, "HomeOnboardingTakeoverV2HomeNudge", () => $4ac6d1a639d952f5$export$7f711697718dffe7);

var $gwFzn = parcelRequire("gwFzn");

var $aDe4X = parcelRequire("aDe4X");

var $1OJav = parcelRequire("1OJav");
const $4ac6d1a639d952f5$export$7f711697718dffe7 = ({ children: children })=>{
    const { isEligible: v2NthUserEligible, loading: v2NthUserLoading } = (0, $aDe4X.useNthUserHomeOnboardingTakeoverV2Eligibility)();
    if (v2NthUserLoading) return children;
    if (v2NthUserEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1OJav.NthUserHomeOnboardingTakeoverV2HomeNudge), {
        position: "bottom-start"
    }, children);
    return children;
};

});
parcelRegister("1OJav", function(module, exports) {

$parcel$export(module.exports, "NthUserHomeOnboardingTakeoverV2HomeNudge", () => $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1s5hv = parcelRequire("1s5hv");

var $inPa6 = parcelRequire("inPa6");

var $1cuAd = parcelRequire("1cuAd");

var $9Yv8Z = parcelRequire("9Yv8Z");

var $ivb8S = parcelRequire("ivb8S");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $lsxnT = parcelRequire("lsxnT");

var $b4VFP = parcelRequire("b4VFP");

var $c0tZa = parcelRequire("c0tZa");
const $d3cc8422fc7cecaf$var$i18n = (0, $2nPZH.defineMessages)({
    homeSpotlightHeader: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.header",
        defaultMessage: "Get started with Confluence"
    },
    homeSpotlightText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.text",
        defaultMessage: "Quickly learn about Confluence and become a Confluence expert"
    },
    homeSpotlightCloseButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-dismiss",
        defaultMessage: "Dismiss"
    },
    homeSpotlightTryItButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-try-it",
        defaultMessage: "Try it"
    }
});
const $d3cc8422fc7cecaf$var$NudgeFixer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        direction: "column",
        justifyContent: "center"
    }, children);
};
const $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5 = ({ children: children, position: position = 'bottom-start' })=>{
    const [isHomeNudgeHidden, setIsHomeNudgeHidden] = (0, $gwFzn.useState)(true);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    // This is the onboarding state hidden
    const { isEligibleForHomeNudge: isEligibleForHomeNudge, isOnHome: isOnHome, error: error } = (0, $c0tZa.useIsEligibleForNthUserHomeOnboardingTakeoverV2HomeNudge)();
    const wasEligibleForOnboardingNudgeRef = (0, $gwFzn.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const expandSideNav = (0, $1cuAd.useExpandSideNav)();
    const homeNudgeChoreographer = useChoreographer('nth-user-home-onboarding-takeover-v2-home-nudge', {
        start: ()=>setIsHomeNudgeHidden(false),
        stop: ()=>setIsHomeNudgeHidden(true)
    });
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                action: 'viewed',
                name: 'nthUserHomeOnboardingTakeoverV2HomeNudge'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        setIsHomeNudgeHidden(true);
        homeNudgeChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeDismiss',
                source: 'onboarding'
            }
        }).fire();
    };
    const handleGoHome = ()=>{
        push((0, $1NBp8.HOME).toUrl());
        homeNudgeChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeGoHome',
                source: 'onboarding'
            }
        }).fire();
    };
    (0, $gwFzn.useEffect)(()=>{
        if (isEligibleForHomeNudge && isHomeNudgeHidden && !wasEligibleForOnboardingNudgeRef.current) {
            setOnboardingState({
                key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenHomeNudge,
                value: 'true'
            });
            homeNudgeChoreographer.startMessage();
            expandSideNav();
            wasEligibleForOnboardingNudgeRef.current = true;
        }
    }, [
        isEligibleForHomeNudge,
        isHomeNudgeHidden,
        setOnboardingState,
        homeNudgeChoreographer,
        expandSideNav
    ]);
    const isNudgeHidden = !isHomeNudgeHidden && (wasEligibleForOnboardingNudgeRef.current || isEligibleForHomeNudge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Yv8Z.OnboardingNudge), {
        hidden: !isNudgeHidden || isOnHome,
        setHidden: ()=>homeNudgeChoreographer.stopMessage(),
        position: position,
        wrapper: $d3cc8422fc7cecaf$var$NudgeFixer,
        heading: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightHeader),
        actions: [
            {
                onClick: handleGoHome,
                text: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightTryItButtonText)
            },
            {
                onClick: handleDismiss,
                text: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightCloseButtonText)
            }
        ],
        actionSubjectId: "nth-user-home-onboarding-takeover-v2-home-nav-item",
        key: "nth-user-home-onboarding-takeover-v2-home-nav-item",
        width: 275,
        source: "onboarding",
        content: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightText),
        renderChildrenWhileLoading: true
    }, children, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("1cuAd", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $63281e74cccc9d52$export$e44b4744d8ff971a);

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");

var $cvtof = parcelRequire("cvtof");
function $63281e74cccc9d52$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $gwFzn.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const expandSideNav = (0, $gwFzn.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $5Uzw3.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $5Uzw3.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("c0tZa", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForNthUserHomeOnboardingTakeoverV2HomeNudge", () => $996603fe96782b8b$export$8f136d122118bae4);

var $ivb8S = parcelRequire("ivb8S");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $dN1MH = parcelRequire("dN1MH");

var $6mKj3 = parcelRequire("6mKj3");

var $b4VFP = parcelRequire("b4VFP");
const $996603fe96782b8b$export$8f136d122118bae4 = ({ skip: skip = false } = {})=>{
    const isOnHomeOrWikiRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.WIKI).name || routeName === (0, $1NBp8.HOME).name;
        }
    };
    const isOnHome = (0, $dPJCf.useRouteName)(isOnHomeOrWikiRouteArgs);
    const { isSpaceGettingStartedTourExperimentCohort: isSpaceGettingStartedTourExperimentCohort, loading: isSpaceGettingStartedTourExperimentCohortLoading } = (0, $dN1MH.useIsSpaceGettingStartedTourEligible)();
    const localSkip = skip || isOnHome || !(0, $6mKj3.expValEqualsNoExposure)('cc_onboarding_nth_user_home_takeover', 'cohort', 'experiment') || isSpaceGettingStartedTourExperimentCohortLoading || isSpaceGettingStartedTourExperimentCohort;
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)), localSkip);
    const { hasSeenHomeNudge: hasSeenHomeNudge, takeoverSeenAt: takeoverSeenAt, hasDismissedTakeover: hasDismissedTakeover } = (0, $ivb8S.deserializeState)(data);
    if (localSkip || loading || error) return {
        isEligibleForHomeNudge: false,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
    return {
        isEligibleForHomeNudge: Boolean(!hasSeenHomeNudge && !takeoverSeenAt && !hasDismissedTakeover && !isSpaceGettingStartedTourExperimentCohortLoading && !isSpaceGettingStartedTourExperimentCohort),
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
};

});
parcelRegister("dN1MH", function(module, exports) {

$parcel$export(module.exports, "useIsSpaceGettingStartedTourEligible", () => $e0112b4b5678390a$export$1acf677bd8c1a068);
// import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';
// import { isMobileUserAgent, shouldShowMobileWeb } from '@confluence/mobile-detection';
// import { useSessionData, AccessStatus } from '@confluence/session-data';
// import { Cohorts } from '@confluence/onboarding-helpers/entry-points/constants/cohorts';
// ^ note this file is deprecated due to CONFONBO-5541
// import { ONBOARDING_EXPERIENCES } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';
// import { useIsXflowUser } from '@confluence/onboarding-helpers/entry-points/hooks/useIsXflowUser';
// import {
// 	useGetOnboardingState,
// 	deserializeState,
// } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
/**
 * Eligiblity check
 * 1. Desktop only
 * 2. user is new
 * 3. user is a licensed admin
 * 4. user is a founding admin

 *
 * Results
 * 1. isEligibleForSpaceGettingStartedTour = user meets Eligiblity check and is not in "NOT_ENROLLED"
 * 2. isSpaceGettingStartedTourExperimentCohort = user meets Eligiblity check and is in "EXPERIMENT"
 *
 */ const $e0112b4b5678390a$export$1acf677bd8c1a068 = ()=>{
    // const { accessStatus, isLoggedIn } = useSessionData();
    // // const [xflowExperiment] = UNSAFE_noExposureExp('cc_getting_started_tour_xflow');
    // // const cohortXflow = xflowExperiment.get<'experiment' | 'not-enrolled' | 'control'>(
    // // 	'cohort',
    // // 	'not-enrolled',
    // // );
    // const [landExperiment] = UNSAFE_noExposureExp('cc_getting_started_tour');
    // const cohortLandAndOther = landExperiment.get<'experiment' | 'not-enrolled' | 'control'>(
    // 	'cohort',
    // 	'not-enrolled',
    // );
    // //1. Experiment eligbile for desktop only
    // const isDesktopUser = !(isMobileUserAgent() || shouldShowMobileWeb());
    // //2. user is new - For experiment add FG filter on activation date
    // // [TODO] Productionize ticket https://hello.jira.atlassian.cloud/browse/CONFONBO-4575
    // //3. user is a licensed admin
    // const isLicensedAdmin = isLoggedIn && accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;
    // /**
    //  * skip = true when both land/xflow experiment flag is not enrolled
    //  */
    // const skipConditionsForQueries =
    // 	!isDesktopUser || !isLicensedAdmin || cohortLandAndOther === Cohorts.NOT_ENROLLED;
    // //4. user is a founding admin
    // const {
    // 	data: onboardingStateData,
    // 	loading: onboardingStateLoading,
    // 	error: onboardingStateError,
    // } = useGetOnboardingState(
    // 	Object.values({
    // 		...ONBOARDING_EXPERIENCES,
    // 	}),
    // 	skipConditionsForQueries,
    // );
    // const { isFoundingAdmin } = deserializeState(onboardingStateData);
    // //5. land users belong to land experiment; xflow users belong to crossflow experiment
    // const {
    // 	isXflowUser,
    // 	isLoading: isXflowUserLoading,
    // 	error: isXflowUserError,
    // } = useIsXflowUser({
    // 	skip: skipConditionsForQueries || !isFoundingAdmin,
    // });
    // //  Check overall eligibility criteria
    // const meetsExperimentTargetingCriteria = isFoundingAdmin && isDesktopUser;
    // //---------------------------------
    // // To know final result, all query has to finished
    // const hasAllQueryFinished =
    // 	!onboardingStateLoading && !onboardingStateError && !isXflowUserLoading && !isXflowUserError;
    return {
        isLandAndOtherEligibleForSpaceGettingStartedTour: false,
        isXflowEligibleForSpaceGettingStartedTour: false,
        isSpaceGettingStartedTourExperimentCohort: false,
        loading: false,
        error: false
    };
};

});




parcelRegister("1Bkar", function(module, exports) {

$parcel$export(module.exports, "useOnboardingEligible", () => $d20dec8c76f488ae$export$6c9dd585f167518e);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $1ytiN = parcelRequire("1ytiN");

var $9wGTI = parcelRequire("9wGTI");

var $ivb8S = parcelRequire("ivb8S");

var $5cryL = parcelRequire("5cryL");

var $dBcar = parcelRequire("dBcar");

var $1amdO = parcelRequire("1amdO");

var $2FNNv = parcelRequire("2FNNv");

var $4kvYv = parcelRequire("4kvYv");
const $d20dec8c76f488ae$export$6c9dd585f167518e = ()=>{
    const { isNewUser: isNewUser } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { isMigratedUser: isMigratedUser, isMigratedUserReady: isMigratedUserReady } = (0, $1amdO.useMigratedUser)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const eligibleNewUser = isLicensed && isNewUser;
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    /**
	 * Skip the query for checking whether the user is an established user if:
	 * 1. The master onboarding FF is OFF
	 * 2. The user is not licensed
	 * 3. The user is not logged in (anonymous)
	 * 4. The user is not new (hasn't viewed a confluence page)
	 */ const skipQuery = !eligibleNewUser || !(0, $9wGTI.fg)('cc_onboarding_experience');
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $4kvYv.UserPersonalizationQuery), {
        variables: {
            userId: userId
        },
        skip: skipQuery
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    // if we skip querying for personalization,
    // we can assume that user should be establishedUser and skip over onboarding
    const isEstablishedUser = skipQuery || attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)),
        ...Object.values((0, $dBcar.ONBOARDING_INTENT_EXPERIENCES))
    ], !isLicensed || !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, isOnboardingExperienceEligibleUser: isOnboardingExperienceEligibleUser } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const checkAndSetOnboardingEligibility = (0, $gwFzn.useCallback)(({ onboardingStateEligibleValue: onboardingStateEligibleValue, featureFlagEnabled: featureFlagEnabled, onboardingStateEligibleKey: onboardingStateEligibleKey })=>{
        if (!isEstablishedUser && isEstablishedUserReady && onboardingStateData && featureFlagEnabled && !onboardingStateEligibleValue) setOnboardingState({
            key: onboardingStateEligibleKey,
            value: 'true'
        });
    }, [
        isEstablishedUser,
        onboardingStateData,
        setOnboardingState,
        isEstablishedUserReady
    ]);
    // IBO Tagging
    (0, $gwFzn.useEffect)(()=>{
        checkAndSetOnboardingEligibility({
            onboardingStateEligibleValue: isOnboardingExperienceEligibleUser,
            featureFlagEnabled: true,
            onboardingStateEligibleKey: (0, $dBcar.ONBOARDING_INTENT_EXPERIENCES).ONBOARDING_EXPERIENCE_ELIGIBLE
        });
    }, [
        isOnboardingExperienceEligibleUser,
        checkAndSetOnboardingEligibility
    ]);
    // Editor Onboarding Experiment
    (0, $gwFzn.useEffect)(()=>{
        if (userPersonalizationQueryData && onboardingStateData && (0, $9wGTI.fg)('cc_onboarding_experience')) // only check for users with Eligibility not set
        {
            if (editorOnboardingEligiblity === null || editorOnboardingEligiblity === undefined) {
                if (isMigratedUserReady && isMigratedUser || isEstablishedUser) // Set EDITOR_ONBOARDING_ELIGIBLE_NEW: false for migrated users and established users
                setOnboardingState({
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).EDITOR_ONBOARDING_ELIGIBLE_NEW,
                    value: 'false'
                });
                else // Set EDITOR_ONBOARDING_ELIGIBLE_NEW: true for users that are new to confluence
                setOnboardingState({
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).EDITOR_ONBOARDING_ELIGIBLE_NEW,
                    value: 'true'
                });
            }
        }
    }, [
        eligibleNewUser,
        isEstablishedUser,
        isMigratedUserReady,
        isMigratedUser,
        editorOnboardingEligiblity,
        userPersonalizationQueryData,
        onboardingStateData,
        onboardingStateLoading,
        onboardingStateError,
        setOnboardingState
    ]);
    return {
        isEstablishedUser: isEstablishedUser,
        isEstablishedUserReady: isEstablishedUserReady,
        loading: userPersonalizationQueryLoading,
        error: userPersonalizationQueryError,
        skipQuery: skipQuery,
        eligibleNewUser: eligibleNewUser
    };
};

});

parcelRegister("g6zY9", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $388a803502193d4e$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $388a803502193d4e$export$130340d16a670190);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4kTI0 = parcelRequire("4kTI0");

var $4iF3c = parcelRequire("4iF3c");

var $ay82t = parcelRequire("ay82t");

var $bGdnm = parcelRequire("bGdnm");
const $388a803502193d4e$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ay82t.DEFAULT_CONTEXT));
const $388a803502193d4e$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $bGdnm.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $4iF3c.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($388a803502193d4e$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $ay82t.DEFAULT_CONTEXT),
        children: children
    });
};
const $388a803502193d4e$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4kTI0.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($388a803502193d4e$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $388a803502193d4e$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($388a803502193d4e$export$8a37839ac1e08b25);

});
parcelRegister("4iF3c", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $db3d1eeeab1c870c$export$233293b7afb7b362);

var $gwFzn = parcelRequire("gwFzn");

var $4kTI0 = parcelRequire("4kTI0");

var $dJyK1 = parcelRequire("dJyK1");
const $db3d1eeeab1c870c$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $db3d1eeeab1c870c$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $gwFzn.useMemo)(()=>({
            ...(0, $dJyK1.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $4kTI0.useFlightDeckArtifact)((0, $dJyK1.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $gwFzn.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $db3d1eeeab1c870c$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("dJyK1", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $323cb1b03fbc7278$export$c270c412a04ff3e6);

var $lzcvT = parcelRequire("lzcvT");
const $323cb1b03fbc7278$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $323cb1b03fbc7278$export$71f196808ce40e60 = 'prod';
const $323cb1b03fbc7278$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $323cb1b03fbc7278$export$e836203c1e95eac3 = 'commercial';
const $323cb1b03fbc7278$export$c270c412a04ff3e6 = {
    name: $323cb1b03fbc7278$export$953923d576277fd6,
    dimensions: {
        environmentType: $323cb1b03fbc7278$export$71f196808ce40e60,
        perimeter: (0, $lzcvT.isFedRamp)() ? $323cb1b03fbc7278$export$6392ca3738ed1e9 : $323cb1b03fbc7278$export$e836203c1e95eac3
    }
};

});


parcelRegister("ay82t", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $1b2ab48db02b5584$export$9c542858adf7dcd0);
const $1b2ab48db02b5584$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("bGdnm", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $0bdd48c7faa20aa6$export$66d7d96ce076bcd6);

var $3jKGE = parcelRequire("3jKGE");

var $2LwsB = parcelRequire("2LwsB");
const $0bdd48c7faa20aa6$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $3jKGE.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $2LwsB.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $2LwsB.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("2LwsB", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $f3d73af2348a66b1$export$c6e6fe52d34907dc);
var $f3d73af2348a66b1$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});

});



parcelRegister("2iK1S", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", () => $658e2436a5b89740$export$c616dd7f2557d148);
$parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", () => $658e2436a5b89740$export$aecb6ab9d1724228);

var $g6zY9 = parcelRequire("g6zY9");
var $aZrQL = parcelRequire("aZrQL");
const $658e2436a5b89740$var$KEY = 'people-menu';
const $658e2436a5b89740$export$c616dd7f2557d148 = ()=>{
    const configuration = (0, $g6zY9.usePeopleAndTeamsConfigurationContext)();
    return configuration[$658e2436a5b89740$var$KEY];
};
const $658e2436a5b89740$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, $aZrQL.withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $658e2436a5b89740$var$KEY);

});
parcelRegister("aZrQL", function(module, exports) {

$parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", () => $f571bac52abdc380$export$aead0eac38c797a5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $g6zY9 = parcelRequire("g6zY9");
function $f571bac52abdc380$var$isMandatoryPeopleAndTeamsConfiguration(context) {
    return Boolean(context);
}
const $f571bac52abdc380$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
        const remoteConfig = (0, $g6zY9.usePeopleAndTeamsConfigurationContext)();
        if (!remoteConfig) return null;
        const keyedConfig = remoteConfig[key];
        if (!$f571bac52abdc380$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            remoteConfig: keyedConfig,
            ...props
        });
    };

});


parcelRegister("4Hqhn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cea8cfd29428997d16ab57b549672759>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36bf9011bd11cb83$var$_react = $36bf9011bd11cb83$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $36bf9011bd11cb83$var$_baseNew = $36bf9011bd11cb83$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $36bf9011bd11cb83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36bf9011bd11cb83$var$NoteIcon = (props)=>/*#__PURE__*/ $36bf9011bd11cb83$var$_react.default.createElement($36bf9011bd11cb83$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$36bf9011bd11cb83$var$NoteIcon.displayName = 'NoteIcon';
var $36bf9011bd11cb83$var$_default = module.exports.default = $36bf9011bd11cb83$var$NoteIcon;

});

parcelRegister("i1Nyn", function(module, exports) {

$parcel$export(module.exports, "useChatContextStoreActions", () => $3527ba50fc1c4fde$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $3527ba50fc1c4fde$export$9465f65715425f1b);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $3527ba50fc1c4fde$var$store = (0, $4ZoIm.createStore)({
    initialState: {
        editorContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        chatContext: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getChatContext: ()=>({ getState: getState })=>getState().chatContext,
        setChatContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentChatContext = getState().chatContext;
                if (chatContextData.contextKey) setState({
                    chatContext: {
                        ...currentChatContext,
                        [chatContextData.contextKey]: chatContextData.context
                    }
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            }
    }
});
const $3527ba50fc1c4fde$export$53bf948a400e8426 = (0, $iFWZA.createActionsHook)($3527ba50fc1c4fde$var$store);
const $3527ba50fc1c4fde$export$9465f65715425f1b = (0, $iFWZA.createHook)($3527ba50fc1c4fde$var$store, {
    selector: (state)=>state.editorContext
});

});

parcelRegister("ay6Zz", function(module, exports) {

$parcel$export(module.exports, "navigateToTeamsApp", () => $633b38b742596343$export$cd99a4ca8e852372);

var $lMHuO = parcelRequire("lMHuO");
const $633b38b742596343$export$cd99a4ca8e852372 = (action)=>{
    const { shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $lMHuO.isTeamsAppEnabled)(action) : shouldOpenInSameTab
    };
    const { path: path, query: query } = (0, $lMHuO.getPathAndQuery)(actionWithDefaults);
    const href = (0, $lMHuO.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $lMHuO.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};

});
parcelRegister("lMHuO", function(module, exports) {

$parcel$export(module.exports, "generatePath", () => $60149519f75ae663$export$82476f982757e71e);
$parcel$export(module.exports, "isTeamsAppEnabled", () => $60149519f75ae663$export$5921b2a93a401547);
$parcel$export(module.exports, "onNavigateBase", () => $60149519f75ae663$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $60149519f75ae663$export$b406f12e2156b3fe);

var $dedJV = parcelRequire("dedJV");
var $lzcvT = parcelRequire("lzcvT");

var $dh538 = parcelRequire("dh538");

var $eGWfI = parcelRequire("eGWfI");
function $60149519f75ae663$export$82476f982757e71e(path, config, query = new URLSearchParams()) {
    if ($60149519f75ae663$export$5921b2a93a401547(config) || config.hostProduct === 'home' || !config.hostProduct) {
        if (config.cloudId) query.set('cloudId', config.cloudId);
        // URLSearchParams.size doesn't work in jest
        const queryString = [
            ...new Set(query.keys())
        ].length > 0 ? `?${query.toString()}` : '';
        // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
        // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
        // but for now, we need to generate a different URL for FedRamp.
        if ((0, $lzcvT.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
        return `https://teams${$60149519f75ae663$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com/${path}${queryString}`;
        const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
        return `${(0, $dedJV.getATLContextUrl)('home')}${orgIdString}/people/${path}${queryString}`;
    }
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $dedJV.getATLContextUrl)(config.hostProduct)}/people/${path}${queryString}`;
}
const $60149519f75ae663$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ($60149519f75ae663$export$5921b2a93a401547(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $eGWfI.redirect)(href);
                return;
            }
            (0, $eGWfI.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $eGWfI.redirect)(href);
            return;
        } else {
            (0, $eGWfI.openInNewTab)(href);
            return;
        }
    };
function $60149519f75ae663$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            return {
                path: `${action.payload.userId}`
            };
        case 'TEAM':
            return {
                path: `team/${action.payload.teamId}`
            };
        case 'AGENT':
            return {
                path: `agent/${action.payload.agentId}`
            };
        case 'KUDOS':
            return {
                path: `kudos/${action.payload.kudosId}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        default:
            return {
                path: ''
            };
    }
}
function $60149519f75ae663$export$a9f2c34176fff494() {
    const host = (0, $eGWfI.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $60149519f75ae663$export$5921b2a93a401547(config) {
    if (!(0, $dh538.fg)('should-redirect-directory-to-teams-app')) // This is the base switch, without it, teams app is not enabled
    return false;
    if ((0, $lzcvT.isFedRamp)()) // In FedRamp, we are ignoring the Nav4 dependency
    return true;
    // We have a hard dependency on Nav4 being enabled in order to use the teams app
    return config.userHasNav4Enabled === undefined ? true : config.userHasNav4Enabled;
}

});
parcelRegister("eGWfI", function(module, exports) {

$parcel$export(module.exports, "redirect", () => $2e7a339812265d41$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $2e7a339812265d41$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $2e7a339812265d41$export$640106f6dc7d2706);
function $2e7a339812265d41$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $2e7a339812265d41$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $2e7a339812265d41$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;

});



parcelRegister("5MWHu", function(module, exports) {

$parcel$export(module.exports, "default", () => $042f04d028540227$export$2e2bcd8739ae039);
/* inline-editable-textfield.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $5L38b = parcelRequire("5L38b");

var $hPd3F = parcelRequire("hPd3F");

var $gdv5Z = parcelRequire("gdv5Z");

var $4noo5 = parcelRequire("4noo5");

var $lUjjs = parcelRequire("lUjjs");
const $042f04d028540227$var$errorIconContainerStyles = {
    root: "_vwz41osq _y4ti12x7"
};
const $042f04d028540227$var$readViewForTextFieldStyles = {
    root: "_11c82smr _1rjcu2gc _18zr12x7 _1e0c1txw _p12f1osq _1nmz1hna"
};
const $042f04d028540227$var$compactStyles = {
    root: "_1rjc1b66 _18zr12x7"
};
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Inline editable textfield__
 *
 * An inline editable textfield {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $042f04d028540227$var$InlineEditableTextfield = (props)=>{
    const { isCompact: isCompact = false, defaultValue: defaultValue, placeholder: placeholder, testId: testId, onCancel: providedOnCancel } = props;
    const textFieldRef = (0, $gwFzn.useRef)();
    const onCancel = (0, $gwFzn.useCallback)(()=>{
        if (textFieldRef.current) textFieldRef.current.value = defaultValue || '';
        providedOnCancel?.();
    }, [
        defaultValue,
        providedOnCancel
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lUjjs.default), {
        ...props,
        onCancel: onCancel,
        defaultValue: defaultValue,
        editView: ({ errorMessage: errorMessage, isInvalid: isInvalid, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPd3F.default), {
                isOpen: isInvalid,
                content: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    id: "error-message",
                    children: errorMessage
                }),
                placement: "right",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                    ...props,
                    ref: textFieldRef,
                    elemAfterInput: isInvalid && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $042f04d028540227$var$errorIconContainerStyles.root,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                            label: "error",
                            LEGACY_primaryColor: "var(--ds-icon-danger, #C9372C)",
                            color: "var(--ds-icon-danger, #C9372C)",
                            size: "small"
                        })
                    }),
                    testId: testId,
                    isCompact: isCompact,
                    autoFocus: true
                })
            }),
        readView: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($042f04d028540227$var$readViewForTextFieldStyles.root, isCompact && $042f04d028540227$var$compactStyles.root),
                "data-compact": isCompact,
                testId: testId && `read-view-${testId}`,
                children: defaultValue || placeholder
            })
    });
};
var $042f04d028540227$export$2e2bcd8739ae039 = $042f04d028540227$var$InlineEditableTextfield;

});

parcelRegister("2aF5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb4d7212f435cd8a$export$2e2bcd8739ae039);
/* bleed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $cb4d7212f435cd8a$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g1i6y",
    'inline.space.050': "_195gr5cr",
    'inline.space.100': "_195gx0bf",
    'inline.space.150': "_195gxmi2",
    'inline.space.200': "_195gmgjw",
    'block.space.025': "_1mou1i6y",
    'block.space.050': "_1mour5cr",
    'block.space.100': "_1moux0bf",
    'block.space.150': "_1mouxmi2",
    'block.space.200': "_1moumgjw"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $cb4d7212f435cd8a$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $cb4d7212f435cd8a$var$styles.root,
            all && $cb4d7212f435cd8a$var$styles[`inline.${all}`],
            inline && $cb4d7212f435cd8a$var$styles[`inline.${inline}`],
            all && $cb4d7212f435cd8a$var$styles[`block.${all}`],
            block && $cb4d7212f435cd8a$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$cb4d7212f435cd8a$var$Bleed.displayName = 'Bleed';
var $cb4d7212f435cd8a$export$2e2bcd8739ae039 = $cb4d7212f435cd8a$var$Bleed;

});

parcelRegister("2HmqS", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $1f70ff8c8e4a6ab6$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $1f70ff8c8e4a6ab6$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    resultLastModifiedContent: {
        id: "entity-view.content.lastmodified",
        defaultMessage: "Updated"
    },
    resultLastModifiedAttachment: {
        id: "entity-view.attachment.lastmodified",
        defaultMessage: "Uploaded"
    },
    contentDraft: {
        id: "entity-view.content.draft",
        defaultMessage: "Draft"
    },
    contentArchived: {
        id: "entity-view.content.archived",
        defaultMessage: "Archived"
    },
    contentUnpublished: {
        id: "entity-view.content.unpublishes",
        defaultMessage: "Unpublished changes"
    },
    contentUntitled: {
        id: "entity-view.content.untitled",
        defaultMessage: "Untitled"
    },
    spaceArchived: {
        id: "entity-view.content.spaceArchived",
        defaultMessage: "archived"
    },
    spaceStarred: {
        id: "entity-view.content.spaceStarred",
        defaultMessage: "starred"
    },
    contentScheduled: {
        id: "entity-view.content.scheduled",
        defaultMessage: "Publish scheduled"
    }
});

});

parcelRegister("4lHoW", function(module, exports) {

$parcel$export(module.exports, "useCustomContentConnectModules", () => $732f39947d6ebe8e$export$584503ef793eb8d0);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dSi57 = parcelRequire("dSi57");
const $732f39947d6ebe8e$export$584503ef793eb8d0 = ({ skip: skip } = {
    skip: false
})=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $dSi57.ConnectCustomContentModulesQuery), {
        skip: skip
    });
    return (0, $gwFzn.useMemo)(()=>({
            modules: data?.experimentalCustomContentConnectModules?.modules || [],
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("dSi57", function(module, exports) {

$parcel$export(module.exports, "ConnectCustomContentModulesQuery", () => $03e78d5a0adb0169$export$fc1a100129edd752);

var $d2LG0 = parcelRequire("d2LG0");
const $03e78d5a0adb0169$export$fc1a100129edd752 = (0, $d2LG0.default)`query ConnectCustomContentModulesQuery@experimental{experimentalCustomContentConnectModules{modules}}`;

});


parcelRegister("cQuKk", function(module, exports) {

$parcel$export(module.exports, "getAtlassianContextUrl", () => $bd19baeafe03b771$export$9986ff99701c314f);
$parcel$export(module.exports, "getAtlassianContextDomain", () => $bd19baeafe03b771$export$50f0d77e468746eb);

var $dedJV = parcelRequire("dedJV");

var $fSNb6 = parcelRequire("fSNb6");
function $bd19baeafe03b771$export$9986ff99701c314f(domainKey) {
    if ((0, $fSNb6.isFedramp)()) return (0, $dedJV.getATLContextUrl)(domainKey);
    else return `https://${domainKey}.atlassian.com`;
}
function $bd19baeafe03b771$export$50f0d77e468746eb(domainKey) {
    if ((0, $fSNb6.isFedramp)()) return (0, $dedJV.getATLContextDomain)(domainKey);
    else return `${domainKey}.atlassian.com`;
}

});
parcelRegister("fSNb6", function(module, exports) {

$parcel$export(module.exports, "isFedramp", () => $23c58483533ad0ac$export$634ecc602a6871aa);
$parcel$export(module.exports, "getConfig", () => $23c58483533ad0ac$export$44487a86467333c3);

var $lwdd5 = parcelRequire("lwdd5");

var $lzcvT = parcelRequire("lzcvT");

var $4IhTl = parcelRequire("4IhTl");

var $7gB19 = parcelRequire("7gB19");

var $7LErD = parcelRequire("7LErD");
// default configs is also config for production env
const $23c58483533ad0ac$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $23c58483533ad0ac$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $23c58483533ad0ac$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $23c58483533ad0ac$var$environmentOverrides = {
    'prod-east': $23c58483533ad0ac$var$productionConfig,
    local: {
        ...(0, $7LErD.LOCAL_PRODUCTION_BACKEND) ? $23c58483533ad0ac$var$productionConfig : $23c58483533ad0ac$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.hostname}:3000`
        }
    },
    test: {
        ...$23c58483533ad0ac$var$localAndTestConfig
    },
    adev: $23c58483533ad0ac$var$devAndStagingConfig,
    'stg-east': $23c58483533ad0ac$var$devAndStagingConfig,
    fedramp: $23c58483533ad0ac$var$fedrampConfig
};
const $23c58483533ad0ac$var$cachedConfig = {};
function $23c58483533ad0ac$export$634ecc602a6871aa() {
    return (0, $lzcvT.isFedRamp)();
}
function $23c58483533ad0ac$export$44487a86467333c3() {
    const env = $23c58483533ad0ac$export$634ecc602a6871aa() ? 'fedramp' : (0, $7gB19.getEnv)();
    const appName = (0, $4IhTl.getAppName)();
    const key = `${env}_${appName}`;
    if (!$23c58483533ad0ac$var$cachedConfig[key]) {
        if ($23c58483533ad0ac$var$EnvOverrideKeys.includes(env)) $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides['prod-east']
        };
    }
    return $23c58483533ad0ac$var$cachedConfig[key];
}

});
parcelRegister("4IhTl", function(module, exports) {

$parcel$export(module.exports, "AppNames", () => $e50b5a5f7ee21567$export$b767e803e7ca9563);
$parcel$export(module.exports, "getAppName", () => $e50b5a5f7ee21567$export$dcecb2dbc7fe753c);
var $e50b5a5f7ee21567$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $e50b5a5f7ee21567$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}

});

parcelRegister("7gB19", function(module, exports) {

$parcel$export(module.exports, "setEnv", () => $c1805fedb6ad58a9$export$84bc02d3c7a6b55f);
$parcel$export(module.exports, "getEnv", () => $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e);

var $lwdd5 = parcelRequire("lwdd5");

var $7LErD = parcelRequire("7LErD");
var $c1805fedb6ad58a9$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $c1805fedb6ad58a9$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $c1805fedb6ad58a9$var$presetEnv;
const $c1805fedb6ad58a9$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $c1805fedb6ad58a9$var$presetEnv = envOverride;
};
function $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e() {
    if ($c1805fedb6ad58a9$var$presetEnv) return $c1805fedb6ad58a9$var$presetEnv;
    if (0, $7LErD.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).__env__;
}
function $c1805fedb6ad58a9$export$15b8d8b1ba394f55() {
    return $c1805fedb6ad58a9$export$d76bdf9f4281ae1b[$c1805fedb6ad58a9$export$4bd44a2aa29d3d6e()];
}

});
parcelRegister("7LErD", function(module, exports) {

$parcel$export(module.exports, "DEV", () => $015647182f1a27ed$export$404582bc18fe4d9e);
$parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", () => $015647182f1a27ed$export$771a63345d182ddd);
// @ts-ignore
const $015647182f1a27ed$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $015647182f1a27ed$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;

});




parcelRegister("iW6Go", function(module, exports) {

$parcel$export(module.exports, "getSlackConsentUrl", () => $506ff8243b974394$export$cc6a5a2d00c6e3ad);
$parcel$export(module.exports, "openPopup", () => $506ff8243b974394$export$c70811ece640d3a1);
const $506ff8243b974394$var$CHATS_HOSTNAME_PROD = 'https://confluence-chats-integr.services.atlassian.com';
const $506ff8243b974394$var$CHATS_HOSTNAME_STAGING = 'https://confluence-chats-integr.dev.services.atlassian.com';
const $506ff8243b974394$var$POPUP_WIDTH = 500;
const $506ff8243b974394$var$POPUP_HEIGHT = 900;
const $506ff8243b974394$var$POPUP_OPTIONS = {
    toolbar: 0,
    menubar: 0,
    location: 0,
    status: 0,
    scrollbars: 1,
    resizable: 0,
    chrome: 'yes'
};
const $506ff8243b974394$export$cc6a5a2d00c6e3ad = (source, win = window)=>{
    const isProd = !(win.location.hostname.endsWith('jira-dev.com') || win.location.hostname === 'localhost');
    const hostname = isProd ? $506ff8243b974394$var$CHATS_HOSTNAME_PROD : $506ff8243b974394$var$CHATS_HOSTNAME_STAGING;
    return `${hostname}/api/slack/teams/login?source=${source}`;
};
const $506ff8243b974394$export$c70811ece640d3a1 = (url, win = window)=>{
    const width = Math.min($506ff8243b974394$var$POPUP_WIDTH, win.screen.availWidth);
    const height = Math.min($506ff8243b974394$var$POPUP_HEIGHT, win.screen.availHeight);
    const opts = Object.entries({
        ...$506ff8243b974394$var$POPUP_OPTIONS,
        width: width,
        height: height,
        left: Math.round((win.innerWidth - width) / 2 + win.screenX),
        top: Math.round((win.innerHeight - height) / 3 + win.screenY)
    }).map(([key, value])=>`${key}=${value}`).join(',');
    win.open(url, '_blank', opts);
};

});

parcelRegister("apTqJ", function(module, exports) {

$parcel$export(module.exports, "useIntegrationsDiscoveryQuery", () => $f5dc9771b4483b1e$export$43a5e2ed2417f32c);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $6niaW = parcelRequire("6niaW");

var $d9SC7 = parcelRequire("d9SC7");

var $9Z847 = parcelRequire("9Z847");
const $f5dc9771b4483b1e$export$43a5e2ed2417f32c = (source, integrations = (0, $9Z847.promotedIntegrations), skip = false, sortFunction = ()=>1)=>{
    const { data: installedAppsData, loading: isInstalledAppsLoading, error: installedAppsError } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $d9SC7.IntegrationsDiscoveryInstalledApps), {
        variables: {
            appKeys: integrations.map(({ key: key })=>key)
        },
        skip: skip,
        fetchPolicy: 'no-cache'
    });
    // Separate request so that this one can be fetched from cache
    const { data: adminData, loading: isAdminLoading } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6niaW.IntegrationsDiscoveryIsAdmin));
    const isAdmin = adminData?.isSiteAdmin || false;
    const isSlackEnabled = installedAppsData?.experimentalIntegrationsInstalled?.isSlackEnabled ?? true;
    const isSlackConnected = installedAppsData?.experimentalIntegrationsInstalled?.isSlackConnected ?? false;
    const integrationsToShow = (0, $gwFzn.useMemo)(()=>{
        const installedIntegrations = new Set((installedAppsData?.experimentalIntegrationsInstalled?.integrations || []).filter((app)=>app.isInstalled).map((app)=>app.appKey));
        return integrations.filter(({ key: key })=>key === (0, $9Z847.slackIntegration).key ? isSlackEnabled && !isSlackConnected : !installedIntegrations.has(key)).sort(sortFunction).slice(0, 3).map((integration)=>({
                ...integration,
                url: integration.getUrl(source, isAdmin),
                marketplaceUrl: integration.getMarketplaceUrl(source, isAdmin)
            }));
    }, [
        isSlackEnabled,
        isSlackConnected,
        source,
        integrations,
        installedAppsData,
        isAdmin,
        sortFunction
    ]);
    return {
        isLoading: isInstalledAppsLoading || isAdminLoading,
        error: installedAppsError,
        integrationsToShow: integrationsToShow,
        isSlackEnabled: isSlackEnabled,
        isSlackConnected: isSlackConnected
    };
};

});
parcelRegister("6niaW", function(module, exports) {

$parcel$export(module.exports, "IntegrationsDiscoveryIsAdmin", () => $c7e1058b3760f775$export$a63e07d4737b9fe);

var $d2LG0 = parcelRequire("d2LG0");
const $c7e1058b3760f775$export$a63e07d4737b9fe = (0, $d2LG0.default)`query IntegrationsDiscoveryIsAdmin{isSiteAdmin}`;

});

parcelRegister("d9SC7", function(module, exports) {

$parcel$export(module.exports, "IntegrationsDiscoveryInstalledApps", () => $df3c21d25ea36d15$export$c668575881f96654);

var $d2LG0 = parcelRequire("d2LG0");
const $df3c21d25ea36d15$export$c668575881f96654 = (0, $d2LG0.default)`query IntegrationsDiscoveryInstalledApps($appKeys:[String!])@experimental{experimentalIntegrationsInstalled(appKeys:$appKeys){isSlackEnabled isSlackConnected integrations{appKey isInstalled}}}`;

});

parcelRegister("9Z847", function(module, exports) {

$parcel$export(module.exports, "slackIntegration", () => $bdd064356f801689$export$26f4b39cd325630e);
$parcel$export(module.exports, "promotedIntegrations", () => $bdd064356f801689$export$8fff4554cabe0b90);

var $f5mfa = parcelRequire("f5mfa");

var $lAX4m = parcelRequire("lAX4m");

var $gTM9o = parcelRequire("gTM9o");

var $hhxd1 = parcelRequire("hhxd1");

var $aMiRj = parcelRequire("aMiRj");

var $iW6Go = parcelRequire("iW6Go");
const $bdd064356f801689$var$SLACK = 'confluence-slack-integration';
const $bdd064356f801689$var$GOOGLE_DRIVE = 'confluence-google-drive';
const $bdd064356f801689$var$LUCID_CHART = 'com.lucidchart.confluence.plugins.lucid-confluence';
const $bdd064356f801689$var$MIRO = 'com.realtimeboard.plugins.confluence-server-plugin';
const $bdd064356f801689$var$INVISON = 'confluence-invisionapp-addon';
const $bdd064356f801689$var$marketplaceUrlFactory = (key, openInstallDialog, hasInstallDialog = true)=>(source, isAdmin)=>`/wiki/plugins/servlet/ac/com.atlassian.confluence.emcee/enduser-discover#!/discover/app/${key}?${new URLSearchParams({
            source: source,
            ...openInstallDialog ? isAdmin ? hasInstallDialog ? {
                installDialogOpen: 'true'
            } : undefined : {
                requestDialogOpen: 'true'
            } : undefined
        }).toString()}`;
const $bdd064356f801689$export$26f4b39cd325630e = {
    key: `${$bdd064356f801689$var$SLACK}-key`,
    actionSubjectId: 'slackForAtlassianApp',
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($lAX4m))),
    label: 'Slack',
    getUrl: (source)=>(0, $iW6Go.getSlackConsentUrl)(source),
    shouldOpenPopup: true,
    getMarketplaceUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$SLACK, false)
};
const $bdd064356f801689$export$8fff4554cabe0b90 = [
    $bdd064356f801689$export$26f4b39cd325630e,
    {
        key: `${$bdd064356f801689$var$GOOGLE_DRIVE}-key`,
        actionSubjectId: 'googleDriveApp',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hhxd1))),
        label: 'Google Drive',
        getUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$GOOGLE_DRIVE, true),
        getMarketplaceUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$GOOGLE_DRIVE, false)
    },
    {
        key: `${$bdd064356f801689$var$LUCID_CHART}-key`,
        actionSubjectId: 'lucidchartApp',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMiRj))),
        label: 'Lucidchart',
        getUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$LUCID_CHART, true, false),
        getMarketplaceUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$LUCID_CHART, false, false)
    },
    {
        key: `${$bdd064356f801689$var$MIRO}-key`,
        actionSubjectId: 'miroApp',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f5mfa))),
        label: 'Miro',
        getUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$MIRO, true),
        getMarketplaceUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$MIRO, false)
    },
    {
        key: `${$bdd064356f801689$var$INVISON}-key`,
        actionSubjectId: 'invisonApp',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gTM9o))),
        label: 'InVision',
        getUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$INVISON, true),
        getMarketplaceUrl: $bdd064356f801689$var$marketplaceUrlFactory($bdd064356f801689$var$INVISON, false)
    }
];

});
parcelRegister("f5mfa", function(module, exports) {
module.exports = new URL("miro.cb595030.png", import.meta.url).toString();

});

parcelRegister("lAX4m", function(module, exports) {
module.exports = new URL("slack.ba8f92ff.png", import.meta.url).toString();

});

parcelRegister("gTM9o", function(module, exports) {
module.exports = new URL("invision.8f2e37e4.png", import.meta.url).toString();

});

parcelRegister("hhxd1", function(module, exports) {
module.exports = new URL("google-drive.d0028a0e.png", import.meta.url).toString();

});

parcelRegister("aMiRj", function(module, exports) {
module.exports = new URL("lucidchart.8807407a.png", import.meta.url).toString();

});



parcelRegister("7akaY", function(module, exports) {

$parcel$export(module.exports, "CustomLinkIcon", () => $09c687850fb62739$export$5efe8561ca252843);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1fe685f4bd7b17faabb90b57d60c4dd>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7JAtv = parcelRequire("7JAtv");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $09c687850fb62739$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75" clip-rule="evenodd"/>
</svg>
`;
function $09c687850fb62739$export$5efe8561ca252843({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7JAtv.IconWrapper), {
        svg: $09c687850fb62739$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lfQiY", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $d96a3db7fec61911$export$c2095165ae2bdcda);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1cfhF = parcelRequire("1cfhF");

var $kfKKN = parcelRequire("kfKKN");
function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $gwFzn.useRef)();
    const firedViewedUIEventId = (0, $gwFzn.useRef)();
    const mapToCcpProductKeys = (0, $gwFzn.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $gwFzn.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $gwFzn.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $gwFzn.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("1cfhF", function(module, exports) {

$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $bd349f0afc0f2270$export$54e3fc09a2a3347a);
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("kfKKN", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $f3fd7ff29ab4c819$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $f3fd7ff29ab4c819$export$285f3d0989f9023f);
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});


parcelRegister("tnUQ6", function(module, exports) {

$parcel$export(module.exports, "collectAll", () => $82c920fb08270e6b$export$feb7963ae429f97f);

var $4HdGj = parcelRequire("4HdGj");
function $82c920fb08270e6b$export$feb7963ae429f97f(experienceNames) {
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')));
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $4HdGj.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
}
function $82c920fb08270e6b$export$79dbdd3e43727beb(experienceNames) {
    return (events, experience)=>experience.stopOn(events.find((event)=>(0, $4HdGj.isStop)(event) && (0, $4HdGj.hasName)(event, ...experienceNames)));
}

});

parcelRegister("6g41Q", function(module, exports) {

$parcel$export(module.exports, "EngagementInlineDialogLoaderNav3", () => $14f8b7ba4c44a126$export$5389b57fe2014013);
$parcel$export(module.exports, "EngagementInlineDialogLoader", () => $14f8b7ba4c44a126$export$96098f07afe80f94);

var $jmjWc = parcelRequire("jmjWc");

const $14f8b7ba4c44a126$export$5389b57fe2014013 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "grVUL",
    name: "EngagementInlineDialogLoaderNav3",
    loader: async ()=>(await (parcelRequire("hczRH"))).EngagementInlineDialogWrapper
});

const $14f8b7ba4c44a126$export$96098f07afe80f94 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xXIQx",
    name: "EngagementInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("hczRH"))).EngagementInlineDialogWrapper
});

});
parcelRegister("hczRH", function(module, exports) {

let $c85f60bb4ed2b078$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c85f60bb4ed2b078$var$load("iAaum"),
    $c85f60bb4ed2b078$var$load("ftJgg"),
    $c85f60bb4ed2b078$var$load("b8oHe")
]).then(()=>parcelRequire('1Q21q'));

});


parcelRegister("7yPTi", function(module, exports) {

$parcel$export(module.exports, "preloadHelpMenu", () => $6717acae2688f481$export$e89f639882b1384b);

var $4vyfK = parcelRequire("4vyfK");
var $eSLr0 = parcelRequire("eSLr0");

var $bBQPT = parcelRequire("bBQPT");

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");
const $6717acae2688f481$export$e89f639882b1384b = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.SYSTEM_HELP)
        }),
        (0, $dYU3e.query)({
            query: (0, $bBQPT.HelpPanelQuery)
        })
    ]);
};

});

parcelRegister("kJsRi", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $e6b26cca3d43530b$export$5b689ca7b019e89f);

var $4u5NT = parcelRequire("4u5NT");
function $e6b26cca3d43530b$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $4u5NT.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("gBQBJ", function(module, exports) {

$parcel$export(module.exports, "AutocorrectionText", () => $02100814775b6148$export$67c8b43f41ede17a);
$parcel$export(module.exports, "Autocorrection", () => $02100814775b6148$export$20554bfec541828d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1o86H = parcelRequire("1o86H");

var $dwp40 = parcelRequire("dwp40");

var $eEbYb = parcelRequire("eEbYb");

var $bF0iL = parcelRequire("bF0iL");

var $3S0fp = parcelRequire("3S0fp");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $USdFJ = parcelRequire("USdFJ");

var $5TmpD = parcelRequire("5TmpD");
const $02100814775b6148$export$67c8b43f41ede17a = ({ label: label, onClick: onClick, corrections: corrections })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eEbYb.TextLabelWrapper), {
                children: [
                    label,
                    ": "
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEbYb.TextCorrectionWrapper), {
                onClick: onClick,
                children: corrections.map(({ distance: distance, term: term }, index)=>{
                    const space = index === corrections.length - 1 ? '' : ' ';
                    if (distance === 0) return term.concat(space);
                    else return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                                children: term
                            }),
                            space
                        ]
                    });
                })
            })
        ]
    });
};
const $02100814775b6148$var$AutocorrectionComponent = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, query: query, label: label, lang: lang, onCorrectionSelect: onCorrectionSelect, source: source = '', searchSessionId: searchSessionId = '', productId: productId = '', debounce: debounce = (0, $5TmpD.DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS), noCorrectionPlaceholder: noCorrectionPlaceholder })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const [corrections, setCorrections] = (0, $gwFzn.useState)([]);
    const correction = corrections.map((word)=>word.term).join(' ');
    const shouldFetchCorrections = (0, $5TmpD.shouldFetchAutocorrection)(query);
    const getCorrection = (0, $gwFzn.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($1o86H)))((query)=>{
        return (0, $dwp40.utils).requestService({
            url: aggregatorUrl
        }, {
            path: `${(0, $5TmpD.AUTOCORRECT_API_PATH)}`,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: query,
                    language: lang,
                    cloudId: cloudId
                })
            }
        });
    }, debounce)).current;
    const onClick = (0, $gwFzn.useCallback)(()=>{
        setCorrections([]);
        onCorrectionSelect(correction);
        fireAnalyticsEvent((0, $5dFS9.onAutocorrectClicked)({
            source: source,
            attributes: {
                searchSessionId: searchSessionId,
                correctionHash: (0, $3S0fp.sha256Hash)(correction),
                language: lang,
                productId: productId
            }
        }));
    }, [
        onCorrectionSelect,
        correction,
        fireAnalyticsEvent,
        lang,
        productId,
        searchSessionId,
        source
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setCorrections([]);
        if (shouldFetchCorrections) getCorrection(query).then((result)=>{
            if (!!result.termCorrections) setCorrections(result.termCorrections);
        });
    }, [
        shouldFetchCorrections,
        query,
        getCorrection
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (corrections.length > 0 && shouldFetchCorrections) fireAnalyticsEvent((0, $5dFS9.onAutocorrectShown)({
            source: source,
            attributes: {
                searchSessionId: searchSessionId,
                correction: (0, $3S0fp.sha256Hash)(correction),
                language: lang,
                productId: productId
            }
        }));
    }, [
        shouldFetchCorrections,
        corrections,
        correction,
        fireAnalyticsEvent,
        lang,
        productId,
        query,
        searchSessionId,
        source
    ]);
    if (corrections.length === 0 || !query) return !!noCorrectionPlaceholder ? noCorrectionPlaceholder : null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($02100814775b6148$export$67c8b43f41ede17a, {
        label: label,
        onClick: onClick,
        corrections: corrections
    });
};
const $02100814775b6148$export$20554bfec541828d = ({ lang: propsLang, aggregatorUrl: aggregatorUrl = (0, $USdFJ.AGGREGATOR_URL), container: container, ...rest })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const intlLang = (0, $5TmpD.sanitizeLanguage)(locale);
    const lang = propsLang || intlLang;
    if (!(0, $5TmpD.isSupportedLanguage)(lang)) return null;
    const Wrapper = !!container ? container : (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            ...props
        });
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        "data-testid": "autocorrect-wrapper",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($02100814775b6148$var$AutocorrectionComponent, {
            label: formatMessage((0, $bF0iL.messages).common_autocorrection_label),
            lang: lang,
            aggregatorUrl: aggregatorUrl,
            ...rest
        })
    });
};

});

parcelRegister("1z61g", function(module, exports) {

$parcel$export(module.exports, "autoSuggestionQuery", () => $c535aa85cd05bb48$export$aa1032c480f72e0d);

var $4qT1X = parcelRequire("4qT1X");
const $c535aa85cd05bb48$var$operationName = 'AutoSuggestionQuery';
const $c535aa85cd05bb48$var$AutoSuggestionQuery = `
query ${$c535aa85cd05bb48$var$operationName}($query: String, $limit: Int!, $filters: QuerySuggestionFilterInput!) {
  suggest {
    suggest(query: $query, limit: $limit, filters: $filters) {
      nodes {
        title
        type
      }
      totalCount
    }
  }
}
`;
const $c535aa85cd05bb48$export$aa1032c480f72e0d = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>(0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $c535aa85cd05bb48$var$AutoSuggestionQuery,
        operationName: $c535aa85cd05bb48$var$operationName
    });

});

parcelRegister("l5Hqz", function(module, exports) {

$parcel$export(module.exports, "getLeapQuery", () => $3c85391cc375b41f$export$3a4b7d0cd0a11cfc);

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");
const $3c85391cc375b41f$var$cache = (0, $hw4j5.inMemoryCache)();
const $3c85391cc375b41f$export$3a4b7d0cd0a11cfc = ({ query: query, product: product })=>{
    const relativeLeapQueryUrl = `/gateway/api/assist/api/ai/v2/ai-feature/leapquery`;
    const body = {
        ai_feature_input: {
            query: query
        }
    };
    return $3c85391cc375b41f$var$cache.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)({
        query: query
    }), ()=>fetch(relativeLeapQueryUrl, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'X-Product': product,
                'X-Experience-Id': 'query-suggestion'
            }
        }).then((response)=>{
            if (response.ok) return response.json();
        }).then((data)=>{
            // return empty skeleton response if response is not ok
            // UI will treat this response as no results
            return data?.ai_feature_output || {
                title: 0,
                candidates: []
            };
        }).catch(()=>{
            // return empty skeleton response if response is not ok
            // UI will treat this response as no results
            return {
                title: 0,
                candidates: []
            };
        }));
};

});

parcelRegister("7YExv", function(module, exports) {

$parcel$export(module.exports, "fetchTeamsBulk", () => $4d0ef623e71fa6bc$export$eb16261a2bb165d4);

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");
const $4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $4d0ef623e71fa6bc$var$cache = (0, $hw4j5.inMemoryCache)();
const $4d0ef623e71fa6bc$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
const $4d0ef623e71fa6bc$export$eb16261a2bb165d4 = async (request, onError)=>{
    return $4d0ef623e71fa6bc$var$cache.inMemoryDecorator($4d0ef623e71fa6bc$export$a4f9b7f788f9e71f(request), ()=>fetch($4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            const errorMessage = `Unable to fetch ${$4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL}. ${response.statusText}`;
            onError?.(errorMessage);
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((error)=>{
            const errorMessage = `Unable to fetch ${$4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL}. ${error.message}`;
            onError?.(errorMessage);
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};

});

parcelRegister("9QyHN", function(module, exports) {

$parcel$export(module.exports, "useTenantContext", () => $47afc3154aae3c6d$export$28e7c557f4d454d9);

var $gwFzn = parcelRequire("gwFzn");

var $dwp40 = parcelRequire("dwp40");

var $f7lNm = parcelRequire("f7lNm");
const $47afc3154aae3c6d$var$SearchTenantContextQuery = `
  query SearchTenantContextQuery($cloudId: ID!) {
    tenantContexts(cloudIds: [$cloudId]) {
      cloudUrl
    }
	}
`;
const $47afc3154aae3c6d$var$fetchTenantContext = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $47afc3154aae3c6d$var$SearchTenantContextQuery,
                variables: variables
            })
        }
    };
    return (0, $dwp40.utils).requestService({
        url: (0, $f7lNm.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};
const $47afc3154aae3c6d$export$28e7c557f4d454d9 = (cloudId)=>{
    const [tenantContext, setTenantContext] = (0, $gwFzn.useState)({});
    const [hasError, setHasError] = (0, $gwFzn.useState)(false);
    const fetchContext = (0, $gwFzn.useCallback)(async ()=>{
        try {
            const { data: data } = await $47afc3154aae3c6d$var$fetchTenantContext({
                cloudId: cloudId
            });
            if (data?.tenantContexts && data.tenantContexts.length > 0) setTenantContext(data.tenantContexts[0]);
            else setHasError(true);
        } catch (e) {
            setHasError(true);
        }
    }, [
        cloudId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fetchContext();
    }, [
        fetchContext
    ]);
    return {
        tenantContext: tenantContext,
        hasError: hasError
    };
};

});

parcelRegister("amPd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c3aeb4ad2a36cb$export$2e2bcd8739ae039);

var $lhh8E = parcelRequire("lhh8E");

var $6Z3KL = parcelRequire("6Z3KL");
function $78c3aeb4ad2a36cb$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6Z3KL.default)(1, arguments);
    return (0, $lhh8E.default)(dirtyDate, Date.now(), options);
}

});
parcelRegister("lhh8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d87ae1dcc8227c$export$2e2bcd8739ae039);

var $gfYwW = parcelRequire("gfYwW");

var $6msfI = parcelRequire("6msfI");

var $1ZRpX = parcelRequire("1ZRpX");

var $4YLNd = parcelRequire("4YLNd");

var $9uKf8 = parcelRequire("9uKf8");

var $hmjRW = parcelRequire("hmjRW");

var $13IX4 = parcelRequire("13IX4");

var $6Z3KL = parcelRequire("6Z3KL");
var $f7d87ae1dcc8227c$var$MILLISECONDS_IN_MINUTE = 60000;
var $f7d87ae1dcc8227c$var$MINUTES_IN_DAY = 1440;
var $f7d87ae1dcc8227c$var$MINUTES_IN_MONTH = $f7d87ae1dcc8227c$var$MINUTES_IN_DAY * 30;
var $f7d87ae1dcc8227c$var$MINUTES_IN_YEAR = $f7d87ae1dcc8227c$var$MINUTES_IN_DAY * 365;
function $f7d87ae1dcc8227c$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, $6Z3KL.default)(2, arguments);
    var defaultOptions = (0, $gfYwW.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $13IX4.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain localize.formatDistance property');
    var comparison = (0, $1ZRpX.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $hmjRW.default)((0, $9uKf8.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $4YLNd.default)(dirtyBaseDate);
        dateRight = (0, $4YLNd.default)(dirtyDate);
    } else {
        dateLeft = (0, $4YLNd.default)(dirtyDate);
        dateRight = (0, $4YLNd.default)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
    var roundingMethodFn;
    if (roundingMethod === 'floor') roundingMethodFn = Math.floor;
    else if (roundingMethod === 'ceil') roundingMethodFn = Math.ceil;
    else if (roundingMethod === 'round') roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / $f7d87ae1dcc8227c$var$MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, $6msfI.default)(dateRight) - (0, $6msfI.default)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / $f7d87ae1dcc8227c$var$MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = 'second';
        else if (minutes < 60) unit = 'minute';
        else if (minutes < $f7d87ae1dcc8227c$var$MINUTES_IN_DAY) unit = 'hour';
        else if (dstNormalizedMinutes < $f7d87ae1dcc8227c$var$MINUTES_IN_MONTH) unit = 'day';
        else if (dstNormalizedMinutes < $f7d87ae1dcc8227c$var$MINUTES_IN_YEAR) unit = 'month';
        else unit = 'year';
    } else unit = String(defaultUnit);
    // 0 up to 60 seconds
    if (unit === 'second') {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance('xSeconds', seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === 'minute') {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === 'hour') {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance('xHours', hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === 'day') {
        var days = roundingMethodFn(dstNormalizedMinutes / $f7d87ae1dcc8227c$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === 'month') {
        var months = roundingMethodFn(dstNormalizedMinutes / $f7d87ae1dcc8227c$var$MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);
    // 1 year up to max Date
    } else if (unit === 'year') {
        var years = roundingMethodFn(dstNormalizedMinutes / $f7d87ae1dcc8227c$var$MINUTES_IN_YEAR);
        return locale.formatDistance('xYears', years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

});


parcelRegister("kLRO8", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $a12fcbbfbeaca916$export$5120f2d0b8d4cab8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $8MTIk = parcelRequire("8MTIk");
const $a12fcbbfbeaca916$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$a12fcbbfbeaca916$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("41c4c", function(module, exports) {

$parcel$export(module.exports, "preloadProfileMenu", () => $c0dbaa4ed1720915$export$5ca34e43e28ce619);

var $4vyfK = parcelRequire("4vyfK");
var $eSLr0 = parcelRequire("eSLr0");
const $c0dbaa4ed1720915$export$5ca34e43e28ce619 = ()=>{
    return (0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER)
    });
};

});

parcelRegister("BHGIm", function(module, exports) {

$parcel$export(module.exports, "useTrialPlanComparisonModalActions", () => $2d7c1ebdd99982dc$export$9babf328a7e7b769);
$parcel$export(module.exports, "useTrialPlanComparisonModal", () => $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $2d7c1ebdd99982dc$var$initialState = {
    isOpen: false
};
const $2d7c1ebdd99982dc$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
const $2d7c1ebdd99982dc$var$store = (0, $4ZoIm.createStore)({
    initialState: $2d7c1ebdd99982dc$var$initialState,
    actions: $2d7c1ebdd99982dc$var$actions,
    name: 'trialPlanComparisonModalStore'
});
const $2d7c1ebdd99982dc$export$9babf328a7e7b769 = (0, $iFWZA.createActionsHook)($2d7c1ebdd99982dc$var$store);
const $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e = (0, $iFWZA.createHook)($2d7c1ebdd99982dc$var$store);

});

parcelRegister("b27jz", function(module, exports) {

$parcel$export(module.exports, "useNav4FeedbackCollectorStore", () => $acfe3bc378806851$export$d8a25ad3c2a8c716);
$parcel$export(module.exports, "useNav4FeedbackCollectorActions", () => $acfe3bc378806851$export$a13977ba7a45bade);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $acfe3bc378806851$var$initialState = {
    isOpen: false,
    optingOut: false
};
const $acfe3bc378806851$var$actions = {
    openFeedbackCollector: ()=>({ setState: setState })=>{
            setState({
                isOpen: true,
                optingOut: false
            });
        },
    openOptOutModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: true,
                optingOut: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false,
                optingOut: false
            });
        }
};
const $acfe3bc378806851$var$store = (0, $4ZoIm.createStore)({
    initialState: $acfe3bc378806851$var$initialState,
    actions: $acfe3bc378806851$var$actions,
    name: 'Nav4FeedbackCollectorStore'
});
const $acfe3bc378806851$export$d8a25ad3c2a8c716 = (0, $iFWZA.createHook)($acfe3bc378806851$var$store);
const $acfe3bc378806851$export$a13977ba7a45bade = (0, $iFWZA.createActionsHook)($acfe3bc378806851$var$store);

});

parcelRegister("8BsHU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64380c1becb6a83e$var$_react = $64380c1becb6a83e$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $64380c1becb6a83e$var$_shrinkDiagonal = $64380c1becb6a83e$var$_interopRequireDefault((parcelRequire("heJQp")));

var $64380c1becb6a83e$var$_fitToPage = $64380c1becb6a83e$var$_interopRequireDefault((parcelRequire("01szy")));
function $64380c1becb6a83e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64380c1becb6a83e$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $64380c1becb6a83e$var$_react.default.createElement($64380c1becb6a83e$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $64380c1becb6a83e$var$_fitToPage.default
    }, props));
$64380c1becb6a83e$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $64380c1becb6a83e$var$_default = module.exports.default = $64380c1becb6a83e$var$ShrinkDiagonalIcon;

});

parcelRegister("5Zy5P", function(module, exports) {

$parcel$export(module.exports, "useIsNthUserContentTypePageEnabled", () => $6042df0f71a4b560$export$6b2614ec3ee4f7e8);

var $6mKj3 = parcelRequire("6mKj3");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $ivb8S = parcelRequire("ivb8S");

var $dBcar = parcelRequire("dBcar");
var $6042df0f71a4b560$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
function $6042df0f71a4b560$export$6b2614ec3ee4f7e8({ hasValidContinueUrl: hasValidContinueUrl = false } = {}) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isFreeEdition = edition === "FREE";
    const isPaidEdition = !isFreeEdition;
    const isIneligibleUser = !isLicensed || // user already has a landing path
    hasValidContinueUrl || // skip queries if flag is not serving any cohorts
    isFreeEdition && // Note: expValEqualsNoExposure does not have the same behavior as below conditions
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.expValNoExposure)('cc_onboarding_content_type_nth_user_screen_free', 'cohort', 'not-enrolled') === 'not-enrolled' || isPaidEdition && // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.expValNoExposure)('cc_onboarding_content_type_nth_user_screen_paid', 'cohort', 'not-enrolled') === 'not-enrolled';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_SELECTED_CONTENT_TYPE,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID
    ], // skip query condition
    isIneligibleUser);
    const { nthUserSelectedContentType: nthUserSelectedContentType, nthUserContentTypeSpotlightSeen: nthUserContentTypeSpotlightSeen, nthUserContentTypePopularContentFound: nthUserContentTypePopularContentFound, nthUserContentTypeLandingContentId: nthUserContentTypeLandingContentId } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const loading = onboardingStateLoading;
    const error = onboardingStateError;
    if (loading || error || isIneligibleUser) return {
        showContentTypeScreen: false,
        hasSeenContentSpotlight: true,
        selectedContentType: nthUserSelectedContentType,
        popularContentFound: false,
        landingContentId: '',
        loading: loading,
        error: error
    };
    // we'll fire the exposure directly in `useCurrentStep` in Account Setup Modal
    const showContentTypeScreen = isFreeEdition && (0, $6mKj3.expValEqualsNoExposure)('cc_onboarding_content_type_nth_user_screen_free', 'cohort', 'experiment') || isPaidEdition && (0, $6mKj3.expValEqualsNoExposure)('cc_onboarding_content_type_nth_user_screen_paid', 'cohort', 'experiment');
    return {
        showContentTypeScreen: showContentTypeScreen,
        hasSeenContentSpotlight: Boolean(nthUserContentTypeSpotlightSeen),
        selectedContentType: nthUserSelectedContentType,
        popularContentFound: Boolean(nthUserContentTypePopularContentFound),
        landingContentId: nthUserContentTypeLandingContentId,
        loading: loading,
        error: error
    };
}

});

parcelRegister("4A6OA", function(module, exports) {

$parcel$export(module.exports, "PersistentInvitePeopleButton", () => $151af91674f1daf6$export$443aeffdf2d81fe6);

var $jmjWc = parcelRequire("jmjWc");


const $151af91674f1daf6$export$443aeffdf2d81fe6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "lQpMa",
    name: "PersistentInvitePeopleButton",
    loader: async ()=>(await (parcelRequire("1tTVI"))).PersistentInvitePeopleButton
});

});
parcelRegister("1tTVI", function(module, exports) {

let $1143e2686e54c6f4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1143e2686e54c6f4$var$load("iAaum"),
    $1143e2686e54c6f4$var$load("6vzdH"),
    $1143e2686e54c6f4$var$load("7sZmN"),
    $1143e2686e54c6f4$var$load("ffEVr"),
    $1143e2686e54c6f4$var$load("h2810")
]).then(()=>parcelRequire('ctZ6E'));

});


parcelRegister("fadJK", function(module, exports) {

$parcel$export(module.exports, "Nav3SpaceNavigationContent", () => $645e6ce7c101e8d7$export$bc73fcb5b19302e5);
$parcel$export(module.exports, "SpaceNavigationContent", () => $645e6ce7c101e8d7$export$ec7f7d400376dc53);

var $jmjWc = parcelRequire("jmjWc");

const $645e6ce7c101e8d7$export$bc73fcb5b19302e5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Brz4w",
    name: "Nav3SpaceNavigationContent",
    loader: async ()=>(await (parcelRequire("h7F20"))).Nav3SpaceNavigationContent
});

const $645e6ce7c101e8d7$export$ec7f7d400376dc53 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fQj-o",
    name: "SpaceNavigationContent",
    loader: async ()=>(await (parcelRequire("3Iuju"))).SpaceNavigationContent
});

});
parcelRegister("h7F20", function(module, exports) {

let $c772eb19c18c5244$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c772eb19c18c5244$var$load("iAaum"),
    $c772eb19c18c5244$var$load("1ISAt"),
    $c772eb19c18c5244$var$load("mKoWX"),
    $c772eb19c18c5244$var$load("dbZJz"),
    $c772eb19c18c5244$var$load("y4DZg"),
    $c772eb19c18c5244$var$load("agpqg"),
    $c772eb19c18c5244$var$load("7sZmN"),
    $c772eb19c18c5244$var$load("lfEn7"),
    $c772eb19c18c5244$var$load("19XET"),
    $c772eb19c18c5244$var$load("ctZCD"),
    $c772eb19c18c5244$var$load("c6MKV"),
    $c772eb19c18c5244$var$load("ioILr"),
    $c772eb19c18c5244$var$load("dkU9O"),
    $c772eb19c18c5244$var$load("fin0L"),
    $c772eb19c18c5244$var$load("cOK8C"),
    $c772eb19c18c5244$var$load("ffEVr"),
    $c772eb19c18c5244$var$load("8DoxJ"),
    $c772eb19c18c5244$var$load("6vzdH"),
    $c772eb19c18c5244$var$load("joJy8"),
    $c772eb19c18c5244$var$load("aHE9G"),
    $c772eb19c18c5244$var$load("cJHFd")
]).then(()=>parcelRequire('egHHW'));

});

parcelRegister("3Iuju", function(module, exports) {

let $2b4cfec4b08da8f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2b4cfec4b08da8f6$var$load("iAaum"),
    $2b4cfec4b08da8f6$var$load("1ISAt"),
    $2b4cfec4b08da8f6$var$load("mKoWX"),
    $2b4cfec4b08da8f6$var$load("dbZJz"),
    $2b4cfec4b08da8f6$var$load("byezT"),
    $2b4cfec4b08da8f6$var$load("kdcrE"),
    $2b4cfec4b08da8f6$var$load("7sZmN"),
    $2b4cfec4b08da8f6$var$load("c6MKV"),
    $2b4cfec4b08da8f6$var$load("fwbht"),
    $2b4cfec4b08da8f6$var$load("lfEn7"),
    $2b4cfec4b08da8f6$var$load("ioILr"),
    $2b4cfec4b08da8f6$var$load("cOK8C"),
    $2b4cfec4b08da8f6$var$load("ffEVr"),
    $2b4cfec4b08da8f6$var$load("joJy8"),
    $2b4cfec4b08da8f6$var$load("aHE9G"),
    $2b4cfec4b08da8f6$var$load("6vzdH"),
    $2b4cfec4b08da8f6$var$load("hFtKc")
]).then(()=>parcelRequire('2rynm'));

});


parcelRegister("j2aYM", function(module, exports) {

$parcel$export(module.exports, "usePersistentInviteButtonEligible", () => $463b48fb68db8bff$export$b3cda0b328199f72);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $dFDVW = parcelRequire("dFDVW");
function $463b48fb68db8bff$export$b3cda0b328199f72() {
    const { edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const { data: licenseDetailsData, loading: licenseDetailsLoading, error: licenseDetailsDataError } = (0, $diswb.useQuery)((0, $d2LG0.default)`query usePersistentInviteButtonEligibleLicenseDetailsQuery{license{licenseConsumingUserCount trialEndDate}}`, {
        skip: isFreeEdition || !isLoggedIn || !isLicensed
    });
    const trialDaysLeft = (0, $dFDVW.getTrialDaysLeft)(licenseDetailsData?.license?.trialEndDate);
    const isInTrial = trialDaysLeft ? trialDaysLeft > 0 : false;
    return {
        loading: licenseDetailsLoading,
        error: licenseDetailsDataError,
        isEligible: isInTrial || isFreeEdition
    };
}

});

parcelRegister("j3kZx", function(module, exports) {

$parcel$export(module.exports, "useSpacePersistentExpansion", () => $748c02fb00e52ac9$export$a0aa95d2fbef03e8);

var $gwFzn = parcelRequire("gwFzn");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $gwFzn.useState)();
    const isDefaultExpanded = (0, $gwFzn.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $gwFzn.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $e9zUf.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    const sideNavExpansionStates = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};

});

parcelRegister("80xJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f66106aaf642270$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $cGtPE = parcelRequire("cGtPE");

var $h49AA = parcelRequire("h49AA");
const $3f66106aaf642270$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l31gjq _irr3166n _ppn21gjq _183j1dty",
    selectedStyles: "_bfhkfg4m _syazaqb7 _1053aqb7 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7"
}; /**
    * __Link item__
    *
    * Renders an item wrapped in an anchor tag, useful when you have an item that
    * should change routes using native browser navigation. For SPA transitions use
    * a [custom item](https://atlassian.design/components/side-navigation/examples#custom-item)
    * with the respective router logic.
    *
    * - [Examples](https://atlassian.design/components/side-navigation/examples#link-item)
    * - [Code](https://atlassian.design/components/side-navigation/code)
    */ 
const $3f66106aaf642270$var$LinkItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(// Type needed on props to extract types with extract react types.
({ href: href, children: children, className: className, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $h49AA.useShouldNestedElementRender)();
    if (!shouldRender) return null;
     // Anchor content will be handled by LinkItem
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGtPE.default), {
        ref: ref,
        href: href,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $35pXk.default)([
            $3f66106aaf642270$var$styles.root,
            rest.isSelected && $3f66106aaf642270$var$styles.selectedStyles,
            className
        ]),
        ...rest,
        children: children
    });
});
var $3f66106aaf642270$export$2e2bcd8739ae039 = $3f66106aaf642270$var$LinkItem;

});

parcelRegister("jZ5jt", function(module, exports) {

$parcel$export(module.exports, "ForgeRestrictedPage", () => $a7f0fcb68f000ab0$export$6c9f8409a092cb96);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");
parcelRequire("gllul");
var $auKqk = parcelRequire("auKqk");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $iXdNs = parcelRequire("iXdNs");

var $8d7Iy = parcelRequire("8d7Iy");
const $a7f0fcb68f000ab0$var$i18n = (0, $2nPZH.defineMessages)({
    errorTitle: {
        id: "forge-ui.components.restricted-page.errorTitle",
        defaultMessage: "An admin has blocked this app"
    },
    errorBodyWithTitle: {
        id: "forge-ui.components.restricted-page.errorBodyWithTitle",
        defaultMessage: "<b>{appName}</b> has been blocked by your administrator in this space through a data security policy.{br}{br} For any questions, reach out to your organization admin."
    },
    errorBodyWithoutTitle: {
        id: "forge-ui.components.restricted-page.errorBodyWithoutTitle",
        defaultMessage: "<b>This app</b> has been blocked by your administrator in this space through a data security policy.{br}{br} For any questions, reach out to your organization admin."
    },
    goHome: {
        id: "forge-ui.components.restricted-page.goHomeLink",
        defaultMessage: "Go home"
    }
});
const $a7f0fcb68f000ab0$export$6c9f8409a092cb96 = ({ appName: appName })=>{
    const intl = (0, $dBxQj.default)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const errorMessageSharedArguments = {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                style: {
                    fontWeight: "var(--ds-font-weight-semibold, 600)"
                }
            }, chunks),
        br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("br", null)
    };
    const formattedErrorMessage = appName ? intl.formatMessage($a7f0fcb68f000ab0$var$i18n.errorBodyWithTitle, {
        appName: appName,
        ...errorMessageSharedArguments
    }) : intl.formatMessage($a7f0fcb68f000ab0$var$i18n.errorBodyWithoutTitle, errorMessageSharedArguments);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($iXdNs))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($8d7Iy))),
        errorTitle: intl.formatMessage($a7f0fcb68f000ab0$var$i18n.errorTitle),
        errorMessage: formattedErrorMessage,
        primaryButtonProps: {
            children: intl.formatMessage($a7f0fcb68f000ab0$var$i18n.goHome),
            onClick: ()=>push((0, $1NBp8.HOME).toUrl())
        }
    });
};

});
parcelRegister("iXdNs", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("8d7Iy", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();

});


parcelRegister("i28ZW", function(module, exports) {

$parcel$export(module.exports, "useSpaceManagementOperations", () => $981a614bc39b93a3$export$f8731d5631669ee8);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $7Sm4c = parcelRequire("7Sm4c");
const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $d2LG0.default)`query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}operations{operation targetType}}}`;
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey })=>{
    const { data: data, loading: loading } = (0, $diswb.useQuery)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey || !(0, $9wGTI.fg)('cc_perms_exp_rbac_fe_milestone_2'),
        onError: (error)=>{
            if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $gwFzn.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        loading: loading
    };
};

});

parcelRegister("2MNkP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7a328a080dfaea504a9ff81805adb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2076555da7727269$var$_react = $2076555da7727269$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2076555da7727269$var$_baseNew = $2076555da7727269$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2076555da7727269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EditBulk".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing multiple objects in bulk.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2076555da7727269$var$EditBulkIcon = (props)=>/*#__PURE__*/ $2076555da7727269$var$_react.default.createElement($2076555da7727269$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 4.25zm1.5.75v1h1v-1zm9.836.104a2 2 0 0 1 2.828 0l.232.232a2 2 0 0 1 0 2.828l-4.848 4.849a2 2 0 0 1-1.022.547l-2.129.425a.75.75 0 0 1-.882-.882l.425-2.129a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.708 0L13.061 4l.939.94.336-.336a.5.5 0 0 0 0-.708zM12.939 6 12 5.06 8.548 8.514a.5.5 0 0 0-.137.255l-.205 1.026 1.026-.205a.5.5 0 0 0 .255-.137zM1 6.75A.75.75 0 0 1 1.75 6h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 9.25zm1.5.75v1h1v-1zM1 11.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75zm1.5.75v1h1v-1z" clip-rule="evenodd"/>`
    }, props));
$2076555da7727269$var$EditBulkIcon.displayName = 'EditBulkIcon';
var $2076555da7727269$var$_default = module.exports.default = $2076555da7727269$var$EditBulkIcon;

});

parcelRegister("16fjt", function(module, exports) {

$parcel$export(module.exports, "LivePagesBetaAdminBanner", () => $2acfd415af2e2d52$export$ab6b6b53e1deef10);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $2Nwuj = parcelRequire("2Nwuj");

var $7hXDW = parcelRequire("7hXDW");

var $7p4As = parcelRequire("7p4As");

var $gj7hi = parcelRequire("gj7hi");

var $5ijTm = parcelRequire("5ijTm");

var $epXar = parcelRequire("epXar");

var $1NBp8 = parcelRequire("1NBp8");
const $2acfd415af2e2d52$var$LIVE_PAGES_OPEN_BETA_USER_DOC_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $2acfd415af2e2d52$var$bannerStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-discovery-hovered, #DFD8FD)"}`,
    borderRadius: 'border.radius.200',
    background: `linear-gradient(90deg, ${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"}, ${"var(--ds-background-discovery, #F3F0FF)"})`
});
const $2acfd415af2e2d52$var$contentStyles = (0, $ecnYn.xcss)({
    marginBlock: 'space.300'
});
const $2acfd415af2e2d52$var$i18n = (0, $2nPZH.defineMessages)({
    bannerHeading: {
        id: "admin-center.live-pages-admin-info-banner.beta.heading",
        defaultMessage: "Live docs are now available"
    },
    bannerBody: {
        id: "admin-center.live-pages-admin-info-banner.beta.body",
        defaultMessage: "Create and edit without having to publish. <link>Find out more about live docs</link>"
    },
    enableLivePages: {
        id: "admin-center.live-pages-admin-info-banner.beta.enable-live-pages",
        defaultMessage: "Try live docs now"
    }
});
const $2acfd415af2e2d52$var$BannerTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $2acfd415af2e2d52$var$i18n.bannerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5ijTm.LivePagesBetaLozenge), {
        bold: true
    })));
const $2acfd415af2e2d52$var$BannerBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$2acfd415af2e2d52$var$i18n.bannerBody,
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: $2acfd415af2e2d52$var$LIVE_PAGES_OPEN_BETA_USER_DOC_URL,
                    target: "_blank"
                }, chunks)
        }
    }));
const $2acfd415af2e2d52$var$BannerFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "primary",
        href: (0, $1NBp8.ADMIN_NEW_FEATURES).toUrl()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $2acfd415af2e2d52$var$i18n.enableLivePages));
const $2acfd415af2e2d52$var$BannerContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100",
        alignInline: "start",
        xcss: $2acfd415af2e2d52$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2acfd415af2e2d52$var$BannerTitle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2acfd415af2e2d52$var$BannerBody, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2acfd415af2e2d52$var$BannerFooter, null));
const $2acfd415af2e2d52$export$ab6b6b53e1deef10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $2acfd415af2e2d52$var$bannerStyles,
        paddingInline: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        alignBlock: "center",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2acfd415af2e2d52$var$BannerContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($epXar))),
        alt: ""
    })));

});
parcelRegister("epXar", function(module, exports) {
module.exports = new URL("LivePagesInProductPromptBannerImage.a00fdba6.svg", import.meta.url).toString();

});


parcelRegister("4pxSG", function(module, exports) {

$parcel$export(module.exports, "SpaceRolesOnboardingModal", () => $e8c5eab172936953$export$3649be6824ee3368);
$parcel$export(module.exports, "InProductOnboardingFlag", () => $e8c5eab172936953$export$ab994981e3ec36b7);

var $jmjWc = parcelRequire("jmjWc");

const $e8c5eab172936953$export$3649be6824ee3368 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "u8EJc",
    name: "SpaceRolesOnboardingModal",
    loader: async ()=>(await (parcelRequire("byzxM"))).SpaceRolesOnboardingModal
});

const $e8c5eab172936953$export$ab994981e3ec36b7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "reIQN",
    name: "InProductOnboardingFlag",
    loader: async ()=>(await (parcelRequire("23v5y"))).InProductOnboardingFlag
});

});
parcelRegister("byzxM", function(module, exports) {

let $869e70f218635315$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $869e70f218635315$var$load("iAaum"),
    $869e70f218635315$var$load("e1z0Z"),
    $869e70f218635315$var$load("aZinD"),
    $869e70f218635315$var$load("YlVRj"),
    $869e70f218635315$var$load("joJy8"),
    $869e70f218635315$var$load("aHE9G"),
    $869e70f218635315$var$load("1kY5y")
]).then(()=>parcelRequire('8SUGu'));

});

parcelRegister("23v5y", function(module, exports) {

let $17f3fa1b4db4afdb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $17f3fa1b4db4afdb$var$load("iAaum"),
    $17f3fa1b4db4afdb$var$load("6XHqm"),
    $17f3fa1b4db4afdb$var$load("8zPpH")
]).then(()=>parcelRequire('35hhf'));

});


parcelRegister("amNhW", function(module, exports) {

$parcel$export(module.exports, "SinglePageFormSkeleton", () => $ca7835b7fa16988f$export$8435f65559266c81);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");
// Skeleton
const $ca7835b7fa16988f$var$baseSkeletonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius.200'
});
const $ca7835b7fa16988f$var$headerSkeletonStyles = (0, $ecnYn.xcss)({
    height: '20px',
    width: '100px'
});
const $ca7835b7fa16988f$var$descriptionSkeletonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150',
    height: '12px',
    width: '720px'
});
const $ca7835b7fa16988f$var$subheadingSkeletonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.500',
    height: '8px',
    width: '100px'
});
const $ca7835b7fa16988f$var$bodySkeletonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.050',
    height: '36px',
    width: '240px',
    borderRadius: 'border.radius.100'
});
const $ca7835b7fa16988f$var$SkeletonTemplate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $ca7835b7fa16988f$var$baseSkeletonStyles,
            $ca7835b7fa16988f$var$headerSkeletonStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $ca7835b7fa16988f$var$baseSkeletonStyles,
            $ca7835b7fa16988f$var$descriptionSkeletonStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $ca7835b7fa16988f$var$baseSkeletonStyles,
            $ca7835b7fa16988f$var$subheadingSkeletonStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $ca7835b7fa16988f$var$baseSkeletonStyles,
            $ca7835b7fa16988f$var$bodySkeletonStyles
        ]
    })));
const $ca7835b7fa16988f$export$8435f65559266c81 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.500",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ca7835b7fa16988f$var$SkeletonTemplate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ca7835b7fa16988f$var$SkeletonTemplate, null));
};

});

parcelRegister("gYcFg", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $01c5618b03605886$export$2e0a83ec2e27ecbb);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $01c5618b03605886$var$DividerStyles = (0, $ecnYn.xcss)({
    width: 'calc(100% - 12px)',
    minHeight: "var(--ds-space-025, 2px)",
    marginBlock: 'space.500',
    marginInline: 'space.075',
    background: "var(--ds-border, #091E4224)",
    borderRadius: 'border.radius.100'
});
const $01c5618b03605886$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $01c5618b03605886$var$DividerStyles
    });

});

parcelRegister("44ITj", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $6ce568cf7b585251$export$b5c4b0e7cd7f148b);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $6ce568cf7b585251$var$getFieldContainerStyles = (width)=>(0, $ecnYn.xcss)({
        width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width
    });
const $6ce568cf7b585251$export$b5c4b0e7cd7f148b = ({ width: width, children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6ce568cf7b585251$var$getFieldContainerStyles(width)
    }, children);
};

});

parcelRegister("9Vk6I", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $a08ddf475ebbad44$export$8fbe3c7d0ed2c683);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");
const $a08ddf475ebbad44$var$HelperMessageStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    textAlign: 'start'
});
const $a08ddf475ebbad44$export$8fbe3c7d0ed2c683 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.025",
        xcss: $a08ddf475ebbad44$var$HelperMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small"
    }, children));

});

parcelRegister("53yZv", function(module, exports) {

$parcel$export(module.exports, "SiteSettingsFormLockout", () => $6486b98ae5f74bc1$export$5e07a0bb929a62b);

var $gwFzn = parcelRequire("gwFzn");

var $2ZJmt = parcelRequire("2ZJmt");
const $6486b98ae5f74bc1$export$5e07a0bb929a62b = ({ formState: formState })=>{
    const hasSubmit = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (formState?.submitting) hasSubmit.current = true;
    }, [
        formState
    ]);
    // If the form has not submitted yet, we use the "dirty" state.
    // If the form has been submitted, "dirty" state persists so we'll use "dirtySinceLastSubmit".
    if (!hasSubmit.current && formState?.dirty || formState?.dirtySinceLastSubmit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2ZJmt.NavigationLockout), null);
    return null;
};

});

parcelRegister("0SVjp", function(module, exports) {

$parcel$export(module.exports, "ContainerErrorMessage", () => $9a73ff1fa8968a5c$export$e795a0fe9cd0c768);
/* ContainerErrorMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $2Nwuj = parcelRequire("2Nwuj");

var $iEKnc = parcelRequire("iEKnc");

var $9wGTI = parcelRequire("9wGTI");
const $9a73ff1fa8968a5c$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $9a73ff1fa8968a5c$var$i18n = (0, $2nPZH.defineMessages)({
    errorTitle: {
        id: "admin-center.error.title",
        defaultMessage: "Loading error"
    },
    errorTitleIconLabel: {
        id: "admin-center.error.title.icon-label",
        defaultMessage: "Error icon"
    },
    errorDescription: {
        id: "admin-center.error.description",
        defaultMessage: "Refresh the page. <a>Contact support</a> if this persists."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a73ff1fa8968a5c$var$ErrorTitle = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o _syaz1tmw",
            __cmplp.className
        ])
    });
});
const $9a73ff1fa8968a5c$var$ErrorDescription = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _syaz131l _19pk1b66",
            __cmplp.className
        ])
    });
});
const $9a73ff1fa8968a5c$export$e795a0fe9cd0c768 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9a73ff1fa8968a5c$var$ErrorTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
        label: formatMessage($9a73ff1fa8968a5c$var$i18n.errorTitleIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9a73ff1fa8968a5c$var$i18n.errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9a73ff1fa8968a5c$var$ErrorDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$9a73ff1fa8968a5c$var$i18n.errorDescription,
        values: {
            a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__admin-experien') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: $9a73ff1fa8968a5c$var$SUPPORT_LINK
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                    href: $9a73ff1fa8968a5c$var$SUPPORT_LINK
                }, chunks)
        }
    })));
};

});

parcelRegister("9SSvq", function(module, exports) {

$parcel$export(module.exports, "HeaderBase", () => $fa7ab9e77d7b5aba$export$b44c9ac862d08ed2);
/* HeaderBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4vzBZ = parcelRequire("4vzBZ");

var $3gadb = parcelRequire("3gadb");

var $eEA8O = parcelRequire("eEA8O");

var $9hlns = parcelRequire("9hlns");

var $7hXDW = parcelRequire("7hXDW");

var $iIzOU = parcelRequire("iIzOU");
const $fa7ab9e77d7b5aba$var$HeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $fa7ab9e77d7b5aba$var$TitleWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o _m4nrtlke _wkrh1gjq",
            __cmplp.className
        ])
    });
});
const $fa7ab9e77d7b5aba$export$b44c9ac862d08ed2 = ({ title: title, tooltip: tooltip, loading: loading, cta: cta, yAxisSelectProps: yAxisSelectProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($fa7ab9e77d7b5aba$var$HeaderWrapper, {
        "data-testid": "header-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($fa7ab9e77d7b5aba$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        as: "h3",
        size: "small"
    }, title), tooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: tooltip.text,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
        label: tooltip.iconLabel,
        spacing: "spacious",
        testId: "infoIcon"
    }))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "small"
    }), typeof yAxisSelectProps !== 'undefined' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iIzOU.YAxisSelect), {
        onYAxisValueChange: yAxisSelectProps.onYAxisValueChange,
        yAxisValue: yAxisSelectProps.yAxisValue,
        yAxisActionSubjectPrefix: yAxisSelectProps.yAxisActionSubjectPrefix,
        analyticsSource: yAxisSelectProps.analyticsSource
    }), !!cta && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "link",
        spacing: "none",
        href: cta.href,
        onClick: cta.onClick
    }, cta.text));

});
parcelRegister("iIzOU", function(module, exports) {

$parcel$export(module.exports, "YAxisSelect", () => $6bc4358d0eb93517$export$1bbc527c9c99aa25);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $3hOY6 = parcelRequire("3hOY6");
var $2gD2K = parcelRequire("2gD2K");
const $6bc4358d0eb93517$var$Y_AXIS_CHART_OPTIONS = [
    'number',
    'percentage'
];
const $6bc4358d0eb93517$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    spacing: 'compact',
    styles: {
        control: (base, state)=>({
                ...base,
                backgroundColor: "var(--ds-background-neutral, #091E420F)",
                borderColor: state.isFocused ? "var(--ds-border-selected, #0C66E4)" : 'transparent',
                ':hover': {
                    backgroundColor: state.isFocused ? "var(--ds-background-neutral, #091E420F)" : "var(--ds-background-neutral-hovered, #091E4224)",
                    borderColor: state.isFocused ? "var(--ds-border-selected, #0C66E4)" : 'transparent'
                }
            }),
        menu: (styles)=>({
                ...styles,
                width: '125px',
                position: 'absolute',
                right: 0
            }),
        option: (styles)=>({
                ...styles,
                paddingLeft: "var(--ds-space-200, 16px)"
            })
    }
};
const $6bc4358d0eb93517$var$i18n = (0, $2nPZH.defineMessages)({
    yAxisDropdownNumberValue: {
        id: "admin-center.y-axis-chart.value.number",
        defaultMessage: "# Number"
    },
    yAxisDropdownNumberAbbrevation: {
        id: "admin-center.y-axis-chart.value.number.abbrevation",
        defaultMessage: "# Num."
    },
    yAxisDropdownPercentValue: {
        id: "admin-center.y-axis-chart.value.percent",
        defaultMessage: "% Percentage"
    },
    yAxisDropdownPercentAbbrevation: {
        id: "admin-center.y-axis-chart.value.percent.abbreviation",
        defaultMessage: "% Pct."
    },
    ariaLabel: {
        id: "admin-center.y-axis-chart.value.aria-label",
        defaultMessage: "Select y-axis value for chart"
    }
});
const $6bc4358d0eb93517$var$createYAxisChartOptionsObject = (yAxisChartType)=>{
    if (yAxisChartType === 'percentage') return {
        labelMessage: $6bc4358d0eb93517$var$i18n.yAxisDropdownPercentValue,
        inputValueMessage: $6bc4358d0eb93517$var$i18n.yAxisDropdownPercentAbbrevation
    };
    else // In this case, yAxisChartType should be "number".
    // Although it should not happen, if yAxisChartType is an unexpected value, then we default to number.
    return {
        labelMessage: $6bc4358d0eb93517$var$i18n.yAxisDropdownNumberValue,
        inputValueMessage: $6bc4358d0eb93517$var$i18n.yAxisDropdownNumberAbbrevation
    };
};
const $6bc4358d0eb93517$export$1bbc527c9c99aa25 = ({ onYAxisValueChange: onYAxisValueChange, yAxisValue: yAxisValue, yAxisActionSubjectPrefix: yAxisActionSubjectPrefix, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const yAxisOptions = (0, $gwFzn.useMemo)(()=>$6bc4358d0eb93517$var$Y_AXIS_CHART_OPTIONS.map((value)=>({
                label: formatMessage($6bc4358d0eb93517$var$createYAxisChartOptionsObject(value)?.labelMessage),
                value: value,
                inputValueMessage: formatMessage($6bc4358d0eb93517$var$createYAxisChartOptionsObject(value)?.inputValueMessage)
            })), [
        formatMessage
    ]);
    const fireDropdownAnalyticsEvent = (0, $gwFzn.useCallback)(({ actionSubjectId: actionSubjectId, value: value })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: actionSubjectId,
                source: analyticsSource,
                ...value && {
                    attributes: {
                        value: value
                    }
                }
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        ...$6bc4358d0eb93517$var$SELECT_STYLE_PROPS,
        label: formatMessage($6bc4358d0eb93517$var$i18n.ariaLabel),
        options: yAxisOptions,
        components: {
            SingleValue: $6bc4358d0eb93517$var$SingleValue
        },
        value: yAxisOptions.find((option)=>option.value === yAxisValue),
        onMenuOpen: ()=>{
            fireDropdownAnalyticsEvent({
                actionSubjectId: `${yAxisActionSubjectPrefix}YAxisMenu`
            });
        },
        onChange: (option)=>{
            if (option) {
                const newYAxisValue = option.value;
                fireDropdownAnalyticsEvent({
                    actionSubjectId: `${yAxisActionSubjectPrefix}YAxisMenuItem`,
                    value: newYAxisValue
                });
                onYAxisValueChange(newYAxisValue);
            }
        }
    });
};
const $6bc4358d0eb93517$var$SingleValue = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).SingleValue, props, props.data.inputValueMessage);
};

});


parcelRegister("kUhXy", function(module, exports) {

$parcel$export(module.exports, "useDeleteModal", () => $471cb3bceb84d9ec$export$a07e39361a42e78d);
$parcel$export(module.exports, "useRestoreModal", () => $471cb3bceb84d9ec$export$17544aaed7e8e5ec);

var $gwFzn = parcelRequire("gwFzn");

var $8aF6s = parcelRequire("8aF6s");

var $jmjWc = parcelRequire("jmjWc");
const $471cb3bceb84d9ec$var$createModalHook = (Modal)=>(props1)=>{
        const { showModal: showModal } = (0, $8aF6s.useDialogs)();
        const props1Ref = (0, $gwFzn.useRef)();
        props1Ref.current = props1;
        return (0, $gwFzn.useCallback)((props2)=>showModal(Modal, // @ts-ignore
            {
                ...props1Ref.current,
                ...props2
            }), [
            showModal
        ]);
    };

const $471cb3bceb84d9ec$var$DeleteModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "sMyxR",
    name: "DeleteModal",
    loader: async ()=>(await (parcelRequire("lCPrW"))).DeleteModal
});
const $471cb3bceb84d9ec$export$a07e39361a42e78d = $471cb3bceb84d9ec$var$createModalHook($471cb3bceb84d9ec$var$DeleteModal);

const $471cb3bceb84d9ec$var$RestoreModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "oPFHc",
    name: "RestoreModal",
    loader: async ()=>(await (parcelRequire("12MOH"))).RestoreModal
});
const $471cb3bceb84d9ec$export$17544aaed7e8e5ec = $471cb3bceb84d9ec$var$createModalHook($471cb3bceb84d9ec$var$RestoreModal);

});
parcelRegister("lCPrW", function(module, exports) {

let $fbe50e67ff380a7e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fbe50e67ff380a7e$var$load("ikem6"),
    $fbe50e67ff380a7e$var$load("1xV57"),
    $fbe50e67ff380a7e$var$load("3QAHI"),
    $fbe50e67ff380a7e$var$load("dTVzs"),
    $fbe50e67ff380a7e$var$load("ifr0h"),
    $fbe50e67ff380a7e$var$load("joJy8"),
    $fbe50e67ff380a7e$var$load("aHE9G"),
    $fbe50e67ff380a7e$var$load("ffEVr"),
    $fbe50e67ff380a7e$var$load("lRPe0")
]).then(()=>parcelRequire('fB9y2'));

});

parcelRegister("12MOH", function(module, exports) {

let $0c2bd8552ad310a0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0c2bd8552ad310a0$var$load("53Cb8").then(()=>parcelRequire('lQYGl'));

});


parcelRegister("9oezN", function(module, exports) {

$parcel$export(module.exports, "popOnboardingConfetti", () => $6b7b6fc399a60c96$export$47e445a2288f991);

var $6fnsQ = parcelRequire("6fnsQ");

const $6b7b6fc399a60c96$export$47e445a2288f991 = async ({ resetAfter: resetAfter = 3000 } = {})=>{
    let confetti = null;
    try {
        confetti = (await (parcelRequire("lr7wI"))).default;
    } catch (error) {
        return;
    }
    if (!confetti) return;
    // mirrors the confetti animation in Atlas
    const baseProps = {
        particleCount: 120,
        spread: 55,
        ticks: 225,
        zIndex: 2000,
        scalar: 1.5,
        startVelocity: 100,
        colors: [
            (0, $6fnsQ.P300),
            (0, $6fnsQ.B300),
            (0, $6fnsQ.T300),
            (0, $6fnsQ.R300),
            (0, $6fnsQ.Y300),
            (0, $6fnsQ.G300)
        ]
    };
    // right corner
    confetti({
        ...baseProps,
        origin: {
            x: 1,
            y: 1
        },
        angle: 120
    });
    // left corner
    confetti({
        ...baseProps,
        origin: {
            x: 0,
            y: 1
        },
        angle: 60
    });
    if (resetAfter) setTimeout(()=>{
        confetti?.reset();
    }, resetAfter);
};

});
parcelRegister("lr7wI", function(module, exports) {

let $f9b1f5389c600e3c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f9b1f5389c600e3c$var$load("4aw15").then(()=>parcelRequire('1R8sa'));

});


parcelRegister("avfdU", function(module, exports) {

$parcel$export(module.exports, "useProgressLoading", () => $1d02fa7934574815$export$f44332911535d459);

var $gwFzn = parcelRequire("gwFzn");
const $1d02fa7934574815$export$f44332911535d459 = (initialState = true)=>{
    const [progressLoading, setProgressLoading] = (0, $gwFzn.useState)(initialState);
    (0, $gwFzn.useEffect)(()=>{
        if (progressLoading) // not essential data, used "*" as a targetOrigin
        window.postMessage({
            eventType: 'start_progress_bar',
            startDuration: 2000,
            delayDuration: 10000
        }, '*');
        else // not essential data, used "*" as a targetOrigin
        window.postMessage({
            eventType: 'finish_progress_bar'
        }, '*');
    }, [
        progressLoading
    ]);
    return [
        progressLoading,
        setProgressLoading
    ];
};

});

parcelRegister("hAEvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d2fc6a2ba42645$export$2e2bcd8739ae039);

var $ii7bW = parcelRequire("ii7bW");


var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$01d2fc6a2ba42645$export$2e2bcd8739ae039 = (0, $ii7bW.default);

});
parcelRegister("ii7bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b8984252ebb4a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $5HzPi = parcelRequire("5HzPi");
const $14b8984252ebb4a3$var$bannerStyles = (0, $3jLHL.css)({
    width: '100%',
    position: 'fixed'
});
const $14b8984252ebb4a3$var$bannerContainerStyles = (0, $3jLHL.css)({
    width: '100%',
    position: 'relative',
    zIndex: 3,
    flex: '1 0 auto',
    transition: 'height 0.25s ease-in-out'
});
const $14b8984252ebb4a3$var$pageContentStyles = (0, $3jLHL.css)({
    minWidth: 0,
    position: 'relative',
    zIndex: 1,
    flex: '1 1 auto'
});
const $14b8984252ebb4a3$var$wrapperStyles = (0, $3jLHL.css)({
    display: 'flex',
    width: '100%',
    minHeight: '100%',
    flexDirection: 'column'
});
const $14b8984252ebb4a3$var$mainContainerStyles = (0, $3jLHL.css)({
    display: 'flex',
    flex: '1 1 auto'
});
const $14b8984252ebb4a3$var$navigationStyles = (0, $3jLHL.css)({
    position: 'relative',
    zIndex: 2
});
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $14b8984252ebb4a3$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $5HzPi.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $14b8984252ebb4a3$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $14b8984252ebb4a3$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $14b8984252ebb4a3$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $14b8984252ebb4a3$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $14b8984252ebb4a3$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $14b8984252ebb4a3$var$pageContentStyles
    }, children)));
};
var $14b8984252ebb4a3$export$2e2bcd8739ae039 = $14b8984252ebb4a3$var$Page;

});
parcelRegister("5HzPi", function(module, exports) {

$parcel$export(module.exports, "defaultBannerHeight", () => $b0fb8a837909ab80$export$d77f83c3d17a7b8a);
const $b0fb8a837909ab80$var$defaultGridSize = 8;
const $b0fb8a837909ab80$export$74797698e12f8baa = 12;
const $b0fb8a837909ab80$export$b8241a1616ab1b96 = $b0fb8a837909ab80$var$defaultGridSize * 10;
const $b0fb8a837909ab80$export$2a89a65a43bab52d = {
    comfortable: $b0fb8a837909ab80$var$defaultGridSize * 5,
    cosy: $b0fb8a837909ab80$var$defaultGridSize * 2,
    compact: $b0fb8a837909ab80$var$defaultGridSize * 0.5
};
const $b0fb8a837909ab80$export$8ec7372efd74b753 = 'cosy';
const $b0fb8a837909ab80$export$d77f83c3d17a7b8a = 52;
const $b0fb8a837909ab80$export$f8725d21f81f3e01 = 0;
const $b0fb8a837909ab80$export$2303d2bd9eeff99a = 'fixed';
const $b0fb8a837909ab80$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $b0fb8a837909ab80$export$8b7e31f391e6e681 = '--ds-column-span';
const $b0fb8a837909ab80$export$936829b4511db3e4 = '--ds-grid-spacing';

});



parcelRegister("gvlfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04006bf6574f73b$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $c04006bf6574f73b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6Z3KL.default)(1, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("1SZMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fac19719d41d3c$export$2e2bcd8739ae039);

var $gfYwW = parcelRequire("gfYwW");

var $4YLNd = parcelRequire("4YLNd");

var $7IxPz = parcelRequire("7IxPz");

var $6Z3KL = parcelRequire("6Z3KL");
function $15fac19719d41d3c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6Z3KL.default)(1, arguments);
    var defaultOptions = (0, $gfYwW.getDefaultOptions)();
    var weekStartsOn = (0, $7IxPz.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $4YLNd.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("cvNQg", function(module, exports) {

$parcel$export(module.exports, "LivePageComponentLoader", () => $c515f218eec63c09$export$8f5a21cf0975ea0d);
$parcel$export(module.exports, "LivePagesChangeboardingManagerLoader", () => $c515f218eec63c09$export$8183fb28742a5035);

var $jmjWc = parcelRequire("jmjWc");


const $c515f218eec63c09$export$8f5a21cf0975ea0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4PAnw",
    name: "LivePageComponentLoader",
    loader: async ()=>(await (parcelRequire("hkL7V"))).LivePageComponent
});

const $c515f218eec63c09$export$8183fb28742a5035 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "XGTP6",
    name: "LivePagesChangeboardingManagerLoader",
    loader: async ()=>{
        return (await (parcelRequire("9D2H9"))).LivePagesChangeboardingManager;
    }
});

});
parcelRegister("hkL7V", function(module, exports) {

let $c9e8dc55229ee932$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c9e8dc55229ee932$var$load("iAaum"),
    $c9e8dc55229ee932$var$load("1ISAt"),
    $c9e8dc55229ee932$var$load("mKoWX"),
    $c9e8dc55229ee932$var$load("jqXtk"),
    $c9e8dc55229ee932$var$load("6vzdH"),
    $c9e8dc55229ee932$var$load("9u4sz"),
    $c9e8dc55229ee932$var$load("jRzT2"),
    $c9e8dc55229ee932$var$load("hIYCb"),
    $c9e8dc55229ee932$var$load("fNL1b"),
    $c9e8dc55229ee932$var$load("fW5Fh"),
    $c9e8dc55229ee932$var$load("cLErX"),
    $c9e8dc55229ee932$var$load("hkGfe"),
    $c9e8dc55229ee932$var$load("fKOLx"),
    $c9e8dc55229ee932$var$load("1Zo7q"),
    $c9e8dc55229ee932$var$load("32ARE"),
    $c9e8dc55229ee932$var$load("2F69B"),
    $c9e8dc55229ee932$var$load("fwbht"),
    $c9e8dc55229ee932$var$load("cdEjw"),
    $c9e8dc55229ee932$var$load("lViCt"),
    $c9e8dc55229ee932$var$load("1F4Et"),
    $c9e8dc55229ee932$var$load("c6MKV"),
    $c9e8dc55229ee932$var$load("6gqpV"),
    $c9e8dc55229ee932$var$load("6qah4"),
    $c9e8dc55229ee932$var$load("aZinD"),
    $c9e8dc55229ee932$var$load("6qiXX"),
    $c9e8dc55229ee932$var$load("fz1VH")
]).then(()=>parcelRequire('egCae'));

});

parcelRegister("9D2H9", function(module, exports) {

let $7029d8c0fb3f7602$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7029d8c0fb3f7602$var$load("fKOLx").then(()=>parcelRequire('aUp3o'));

});


parcelRegister("2uohk", function(module, exports) {

$parcel$export(module.exports, "useInviteLink", () => $257c04334e5a82b8$export$e8f5b5377c65c712);

var $gwFzn = parcelRequire("gwFzn");

var $2eTVt = parcelRequire("2eTVt");

var $kMPuh = parcelRequire("kMPuh");

var $jIlZN = parcelRequire("jIlZN");
const $257c04334e5a82b8$export$e8f5b5377c65c712 = ({ skip: skip, allowGenerateNewLink: allowGenerateNewLink })=>{
    const { existingInviteLink: existingInviteLink, existingInviteLinkStatus: existingInviteLinkStatus, loading: queryInviteLoading, error: queryInviteError } = (0, $2eTVt.useQueryInvitationUrl)({
        skipQuery: skip
    });
    const { createNewInviteLink: createNewInviteLink, newInviteLink: newInviteLink, error: createInviteError, loading: createInviteLoading, called: createInviteCalled } = (0, $kMPuh.useCreateInvitationUrl)();
    (0, $gwFzn.useEffect)(()=>{
        // If we have an existing invite link (after fetching) and if it is expired, create a new one
        if (!skip && !queryInviteLoading && !queryInviteError && (allowGenerateNewLink && !existingInviteLink || existingInviteLinkStatus === (0, $jIlZN.InvitationUrlsStatus).EXPIRED) && !createInviteCalled) createNewInviteLink();
    }, [
        skip,
        queryInviteLoading,
        createNewInviteLink,
        createInviteCalled,
        queryInviteError,
        allowGenerateNewLink,
        existingInviteLink,
        existingInviteLinkStatus
    ]);
    const inviteLink = existingInviteLinkStatus === (0, $jIlZN.InvitationUrlsStatus).ACTIVE && existingInviteLink || newInviteLink;
    const error = queryInviteError || createInviteError;
    const loading = queryInviteLoading || createInviteLoading;
    return {
        inviteLink: inviteLink,
        error: error,
        loading: loading
    };
};

});
parcelRegister("2eTVt", function(module, exports) {

$parcel$export(module.exports, "useQueryInvitationUrl", () => $3b5b1d9e3bdf3647$export$834f62bb15aa25c7);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $8Lx5S = parcelRequire("8Lx5S");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $1ytiN = parcelRequire("1ytiN");
const $3b5b1d9e3bdf3647$export$834f62bb15aa25c7 = ({ skipQuery: skipQuery = false })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { isSiteAdmin: isSiteAdmin, loading: spaViewContextLoading, error: spaViewContextError } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const isAdmin = isSiteAdmin && !spaViewContextLoading && !spaViewContextError;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useQueryInvitationUrlCreateInvitationUrlQuery{invitationUrls{urls{id url status}}}`, {
        skip: skipQuery || !isLicensed || !isAdmin
    });
    // check if url already created and active,
    const existingInviteLink = data?.invitationUrls?.urls?.[0]?.url || '';
    const existingInviteLinkStatus = data?.invitationUrls?.urls?.[0]?.status;
    (0, $gwFzn.useEffect)(()=>{
        if (error) {
            if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        existingInviteLink: existingInviteLink,
        existingInviteLinkStatus: existingInviteLinkStatus,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kMPuh", function(module, exports) {

$parcel$export(module.exports, "useCreateInvitationUrl", () => $9d434232f127a7b6$export$27640c56e4bed0dd);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");
const $9d434232f127a7b6$export$27640c56e4bed0dd = ()=>{
    const [createNewInviteLink, { data: data, loading: loading, error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $d2LG0.default)`mutation useCreateInvitationUrlCreateInvitationMutation{createInvitationUrl{id url}}`);
    (0, $gwFzn.useEffect)(()=>{
        if (error) {
            if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    const newInviteLink = data?.createInvitationUrl?.url;
    return {
        createNewInviteLink: createNewInviteLink,
        newInviteLink: newInviteLink,
        called: called,
        loading: loading,
        error: error
    };
};

});

parcelRegister("jIlZN", function(module, exports) {

$parcel$export(module.exports, "InvitationUrlsStatus", () => $5e47882eb43da044$export$7d32434dce2c8cf0);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $5e47882eb43da044$export$7d32434dce2c8cf0 = /*#__PURE__*/ function(InvitationUrlsStatus) {
    InvitationUrlsStatus["ACTIVE"] = "ACTIVE";
    InvitationUrlsStatus["DELETED"] = "DELETED";
    InvitationUrlsStatus["EXPIRED"] = "EXPIRED";
    return InvitationUrlsStatus;
}({});

});


parcelRegister("dgzja", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $409791b4c9af5100$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $409791b4c9af5100$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useGlobalContextActions", () => $409791b4c9af5100$export$8a9eff51cb8da29e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
var $bd25s = parcelRequire("bd25s");

var $3LyKD = parcelRequire("3LyKD");
const $409791b4c9af5100$export$390f32400eaf98c9 = (0, $4ZoIm.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $3LyKD
});
const $409791b4c9af5100$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($409791b4c9af5100$var$OriginalGlobalContextContainer, {
        config: config,
        reporter: reporter,
        isGlobal: true,
        flagService: flagService,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
            locale: locale,
            messages: messages && messages[locale],
            children: children
        })
    });
};
const $409791b4c9af5100$var$OriginalGlobalContextContainer = (0, $2S0Fz.createContainer)($409791b4c9af5100$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        },
    onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        }
});
const $409791b4c9af5100$export$2041a7a7b51b1fce = (0, $bd25s.createSubscriber)($409791b4c9af5100$export$390f32400eaf98c9);
const $409791b4c9af5100$export$6b9ad8a324c94098 = (0, $iFWZA.createHook)($409791b4c9af5100$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $409791b4c9af5100$export$fe8707b58c509543 = (handlerClass)=>{
    const [{ handler: handler, context: context }] = $409791b4c9af5100$var$useSendMessageInternal(handlerClass);
    return (params)=>{
        return handler(params, context);
    };
};
const $409791b4c9af5100$var$useSendMessageInternal = (0, $iFWZA.createHook)($409791b4c9af5100$export$390f32400eaf98c9, {
    selector: (state, arg)=>{
        if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
            handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
            context: state.config.context
        };
        throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
    }
});
const $409791b4c9af5100$export$8a9eff51cb8da29e = (0, $iFWZA.createActionsHook)($409791b4c9af5100$export$390f32400eaf98c9);

});
parcelRegister("3LyKD", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $1b537c291f24eafa$export$f3910000817a36c2);
$parcel$export(module.exports, "getHorizontalNav", () => $1b537c291f24eafa$export$7c79a3553de2e8e7);
const $1b537c291f24eafa$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };
const $1b537c291f24eafa$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
        return config?.isNewNavigation || false;
    };

});


parcelRegister("7ixRW", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $9d0c853ce5e8b44d$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $9d0c853ce5e8b44d$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $9d0c853ce5e8b44d$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $9d0c853ce5e8b44d$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $9d0c853ce5e8b44d$export$476aa014e2fd89d5);

var $b9cVv = parcelRequire("b9cVv");
class $9d0c853ce5e8b44d$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $9d0c853ce5e8b44d$export$aa9d629c530f62a7 extends $9d0c853ce5e8b44d$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $b9cVv.ERROR_NAMES).HTTPError);
        this.response = void 0;
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $9d0c853ce5e8b44d$export$c30b5b02747d791c extends $9d0c853ce5e8b44d$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $b9cVv.ERROR_NAMES).StreamedHTTPError;
    }
}
const $9d0c853ce5e8b44d$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $9d0c853ce5e8b44d$export$aa9d629c530f62a7 || [
        (0, $b9cVv.ERROR_NAMES).HTTPError,
        (0, $b9cVv.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $9d0c853ce5e8b44d$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $9d0c853ce5e8b44d$export$bae979e68e4dc802 || [
        (0, $b9cVv.ERROR_NAMES).NetworkError,
        (0, $b9cVv.ERROR_NAMES).HTTPError,
        (0, $b9cVv.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $9d0c853ce5e8b44d$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $9d0c853ce5e8b44d$export$c30b5b02747d791c || candidate?.name === (0, $b9cVv.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("b9cVv", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $00bc410d8eef1229$export$daceac3b97803ce1);
var $00bc410d8eef1229$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("9vhR0", function(module, exports) {

var $1aect = parcelRequire("1aect");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $6eb4dbb9b34b4e96$var$flow = $1aect();
module.exports = $6eb4dbb9b34b4e96$var$flow;

});
parcelRegister("1aect", function(module, exports) {

var $kaknv = parcelRequire("kaknv");

var $c6NmG = parcelRequire("c6NmG");

var $gEFSA = parcelRequire("gEFSA");

var $8PwYW = parcelRequire("8PwYW");

var $7k59M = parcelRequire("7k59M");

var $c36Ez = parcelRequire("c36Ez");
/** Error message constants. */ var $0d91bd76078f0878$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $0d91bd76078f0878$var$WRAP_CURRY_FLAG = 8, $0d91bd76078f0878$var$WRAP_PARTIAL_FLAG = 32, $0d91bd76078f0878$var$WRAP_ARY_FLAG = 128, $0d91bd76078f0878$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $0d91bd76078f0878$var$createFlow(fromRight) {
    return $c6NmG(function(funcs) {
        var length = funcs.length, index = length, prereq = $kaknv.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($0d91bd76078f0878$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $8PwYW(func) == 'wrapper') var wrapper = new $kaknv([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $8PwYW(func), data = funcName == 'wrapper' ? $gEFSA(func) : undefined;
            if (data && $c36Ez(data[0]) && data[1] == ($0d91bd76078f0878$var$WRAP_ARY_FLAG | $0d91bd76078f0878$var$WRAP_CURRY_FLAG | $0d91bd76078f0878$var$WRAP_PARTIAL_FLAG | $0d91bd76078f0878$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$8PwYW(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $c36Ez(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $7k59M(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $0d91bd76078f0878$var$createFlow;

});
parcelRegister("kaknv", function(module, exports) {

var $g7CFj = parcelRequire("g7CFj");

var $bJwE2 = parcelRequire("bJwE2");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $eae48c7905caf49e$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$eae48c7905caf49e$var$LodashWrapper.prototype = $g7CFj($bJwE2.prototype);
$eae48c7905caf49e$var$LodashWrapper.prototype.constructor = $eae48c7905caf49e$var$LodashWrapper;
module.exports = $eae48c7905caf49e$var$LodashWrapper;

});
parcelRegister("bJwE2", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $88ad3844934fbd0d$var$baseLodash() {
// No operation performed.
}
module.exports = $88ad3844934fbd0d$var$baseLodash;

});


parcelRegister("gEFSA", function(module, exports) {

var $fiIV2 = parcelRequire("fiIV2");

var $jP4Hx = parcelRequire("jP4Hx");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $c200de23a6844b0d$var$getData = !$fiIV2 ? $jP4Hx : function(func) {
    return $fiIV2.get(func);
};
module.exports = $c200de23a6844b0d$var$getData;

});
parcelRegister("fiIV2", function(module, exports) {

var $1Fc9l = parcelRequire("1Fc9l");
/** Used to store function metadata. */ var $b23b616ab9c25130$var$metaMap = $1Fc9l && new $1Fc9l;
module.exports = $b23b616ab9c25130$var$metaMap;

});


parcelRegister("8PwYW", function(module, exports) {

var $k0T5f = parcelRequire("k0T5f");
/** Used for built-in method references. */ var $66dcaba6b7e4f0e0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $66dcaba6b7e4f0e0$var$hasOwnProperty = $66dcaba6b7e4f0e0$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $66dcaba6b7e4f0e0$var$getFuncName(func) {
    var result = func.name + '', array = $k0T5f[result], length = $66dcaba6b7e4f0e0$var$hasOwnProperty.call($k0T5f, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $66dcaba6b7e4f0e0$var$getFuncName;

});
parcelRegister("k0T5f", function(module, exports) {
/** Used to lookup unminified function names. */ var $e91e8935c0fa6440$var$realNames = {};
module.exports = $e91e8935c0fa6440$var$realNames;

});


parcelRegister("c36Ez", function(module, exports) {

var $48Cs6 = parcelRequire("48Cs6");

var $gEFSA = parcelRequire("gEFSA");

var $8PwYW = parcelRequire("8PwYW");

var $2ZLAK = parcelRequire("2ZLAK");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $8c5aed1301c7d9ea$var$isLaziable(func) {
    var funcName = $8PwYW(func), other = $2ZLAK[funcName];
    if (typeof other != 'function' || !(funcName in $48Cs6.prototype)) return false;
    if (func === other) return true;
    var data = $gEFSA(other);
    return !!data && func === data[0];
}
module.exports = $8c5aed1301c7d9ea$var$isLaziable;

});
parcelRegister("48Cs6", function(module, exports) {

var $g7CFj = parcelRequire("g7CFj");

var $bJwE2 = parcelRequire("bJwE2");
/** Used as references for the maximum length and index of an array. */ var $3035bc97e43be9e4$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $3035bc97e43be9e4$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $3035bc97e43be9e4$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$3035bc97e43be9e4$var$LazyWrapper.prototype = $g7CFj($bJwE2.prototype);
$3035bc97e43be9e4$var$LazyWrapper.prototype.constructor = $3035bc97e43be9e4$var$LazyWrapper;
module.exports = $3035bc97e43be9e4$var$LazyWrapper;

});

parcelRegister("2ZLAK", function(module, exports) {

var $48Cs6 = parcelRequire("48Cs6");

var $kaknv = parcelRequire("kaknv");

var $bJwE2 = parcelRequire("bJwE2");

var $7k59M = parcelRequire("7k59M");

var $7k9Pj = parcelRequire("7k9Pj");

var $fn0E6 = parcelRequire("fn0E6");
/** Used for built-in method references. */ var $22e631fc0a4dd324$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $22e631fc0a4dd324$var$hasOwnProperty = $22e631fc0a4dd324$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $22e631fc0a4dd324$var$lodash(value) {
    if ($7k9Pj(value) && !$7k59M(value) && !(value instanceof $48Cs6)) {
        if (value instanceof $kaknv) return value;
        if ($22e631fc0a4dd324$var$hasOwnProperty.call(value, '__wrapped__')) return $fn0E6(value);
    }
    return new $kaknv(value);
}
// Ensure wrappers are instances of `baseLodash`.
$22e631fc0a4dd324$var$lodash.prototype = $bJwE2.prototype;
$22e631fc0a4dd324$var$lodash.prototype.constructor = $22e631fc0a4dd324$var$lodash;
module.exports = $22e631fc0a4dd324$var$lodash;

});
parcelRegister("fn0E6", function(module, exports) {

var $48Cs6 = parcelRequire("48Cs6");

var $kaknv = parcelRequire("kaknv");

var $7UtRP = parcelRequire("7UtRP");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $b309814344327f19$var$wrapperClone(wrapper) {
    if (wrapper instanceof $48Cs6) return wrapper.clone();
    var result = new $kaknv(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $7UtRP(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $b309814344327f19$var$wrapperClone;

});






//# sourceMappingURL=es.ed6b705d.js.map
